/*
 * @license
 * Palo Alto Theme (c)
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
!(function (t, e, i, s) {
    "use strict";
    function o(t, e) {
        let i;
        return function () {
            if (t) {
                const s = () => t.apply(this, arguments);
                clearTimeout(i), (i = setTimeout(s, e));
            }
        };
    }
    !(function () {
        const t = { NODE_ENV: "production" };
        try {
            if (process) return (process.env = Object.assign({}, process.env)), void Object.assign(process.env, t);
        } catch (t) {}
        globalThis.process = { env: t };
    })(),
        (window.theme = window.theme || {}),
        (window.theme.sizes = { mobile: 480, small: 768, large: 1024, widescreen: 1440 }),
        (window.theme.keyboardKeys = {
            TAB: "Tab",
            ENTER: "Enter",
            NUMPADENTER: "NumpadEnter",
            ESCAPE: "Escape",
            SPACE: "Space",
            LEFTARROW: "ArrowLeft",
            RIGHTARROW: "ArrowRight",
        }),
        (window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    const n = "body",
        r = "[data-main]",
        a = "[data-site-header]",
        l = "[data-prevent-transparent-header]",
        c = "supports-transparent-header",
        h = "site-header--transparent",
        d = "is-first-section-transparent",
        u = "data-transparent",
        p = () => {
            const t = document.querySelector(n),
                e = t.querySelector(a);
            if (!e) return;
            const i = "true" === e.getAttribute(u),
                s = t.querySelector(r).children[0];
            if (!s) return;
            const o = s.querySelector(`${l}:first-of-type`);
            window.isHeaderTransparent = i && s.classList.contains(c) && !o;
            CSS.supports("(selector(:has(*)))") ||
                (t.classList.toggle(d, window.isHeaderTransparent), e.classList.toggle(h, window.isHeaderTransparent));
        },
        m = ".section-footer--parallax",
        g = "[data-section-type]",
        f = ":scope > [data-wave]",
        y = ".wavy:not(.site-footer)",
        v = ".parallax-shadow:not(.site-footer)",
        b = "wavy",
        w = "parallax-shadow",
        S = "parallax-rounded-corners",
        E = "section-footer--parallax",
        L = "body--rounded-corners-large",
        k = "data-parallax-wavy",
        A = (t) => {
            const e = t,
                i = document.querySelectorAll(y),
                s = document.querySelectorAll(v);
            i.forEach((t) => {
                t.classList.remove(b);
                [...t.querySelectorAll(f)].map((t) => t.remove());
            }),
                s.forEach((t) => {
                    t.classList.remove(w), t.classList.remove(S), document.body.classList.remove(L);
                    [...t.querySelectorAll(f)].map((t) => t.remove());
                });
            const o = document.querySelectorAll(m);
            if (o.length > 0) {
                const t = o[0].querySelector(g);
                t.hasAttribute(k) && t.classList.add(b);
            }
            e.classList.contains(E) || document.dispatchEvent(new CustomEvent("theme:footer:unload"));
        };
    (window.Shopify = window.Shopify || {}),
        (window.Shopify.theme = window.Shopify.theme || {}),
        (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
        (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}),
        (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);
    const C = window.Shopify.theme.sections.registered,
        q = window.Shopify.theme.sections.instances,
        T = { id: "data-section-id", type: "data-section-type" };
    let P = class {
            getStack() {
                return this.callStack;
            }
            constructor(t = null, e = []) {
                (this.type = t),
                    (this.components = (function (t) {
                        if ((void 0 !== t && "object" != typeof t) || null === t)
                            throw new TypeError("Theme Sections: The components object provided is not a valid");
                        return t;
                    })(e)),
                    (this.callStack = {
                        onLoad: [],
                        onUnload: [],
                        onSelect: [],
                        onDeselect: [],
                        onBlockSelect: [],
                        onBlockDeselect: [],
                        onReorder: [],
                    }),
                    e.forEach((t) => {
                        for (const [e, i] of Object.entries(t)) {
                            const t = this.callStack[e];
                            Array.isArray(t) && "function" == typeof i
                                ? t.push(i)
                                : (console.warn(`Unregisted function: '${e}' in component: '${this.type}'`),
                                  console.warn(i));
                        }
                    });
            }
        },
        x = class {
            callFunctions(t, e = null) {
                this.callStack[t].forEach((t) => {
                    const i = { id: this.id, type: this.type, container: this.container };
                    e ? t.call(i, e) : t.call(i);
                });
            }
            onLoad() {
                this.callFunctions("onLoad");
            }
            onUnload() {
                this.callFunctions("onUnload");
            }
            onSelect(t) {
                this.callFunctions("onSelect", t);
            }
            onDeselect(t) {
                this.callFunctions("onDeselect", t);
            }
            onBlockSelect(t) {
                this.callFunctions("onBlockSelect", t);
            }
            onBlockDeselect(t) {
                this.callFunctions("onBlockDeselect", t);
            }
            onReorder(t) {
                this.callFunctions("onReorder", t);
            }
            constructor(t, e) {
                (this.container = (function (t) {
                    if (!(t instanceof Element))
                        throw new TypeError(
                            "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
                        );
                    if (null === t.getAttribute(T.id))
                        throw new Error(
                            "Theme Sections: The section container provided does not have an id assigned to the " +
                                T.id +
                                " attribute."
                        );
                    return t;
                })(t)),
                    (this.id = t.getAttribute(T.id)),
                    (this.type = e.type),
                    (this.callStack = e.getStack());
                try {
                    this.onLoad();
                } catch (t) {
                    console.warn(`Error in section: ${this.id}`), console.warn(this), console.warn(t);
                }
            }
        };
    function I(t, e) {
        if ("string" != typeof t)
            throw new TypeError(
                "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
            );
        if (void 0 !== C[t])
            throw new Error(
                'Theme Sections: A section of type "' +
                    t +
                    '" has already been registered. You cannot register the same section type twice'
            );
        Array.isArray(e) || (e = [e]);
        const i = new P(t, e);
        return (C[t] = i), C;
    }
    function H(t, e) {
        (t = O(t)),
            void 0 === e && (e = document.querySelectorAll("[" + T.type + "]")),
            (e = B(e)),
            t.forEach(function (t) {
                const i = C[t];
                void 0 !== i &&
                    (e = e.filter(function (e) {
                        return (
                            !(M(e).length > 0) &&
                            null !== e.getAttribute(T.type) &&
                            (e.getAttribute(T.type) !== t || (q.push(new x(e, i)), !1))
                        );
                    }));
            });
    }
    function F(t) {
        M(t).forEach(function (t) {
            var e = q
                .map(function (t) {
                    return t.id;
                })
                .indexOf(t.id);
            q.splice(e, 1), t.onUnload();
        });
    }
    function M(t) {
        var e = [];
        if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var i = t[0];
        if (t instanceof Element || i instanceof Element)
            B(t).forEach(function (t) {
                e = e.concat(
                    q.filter(function (e) {
                        return e.container === t;
                    })
                );
            });
        else if ("string" == typeof t || "string" == typeof i) {
            O(t).forEach(function (t) {
                e = e.concat(
                    q.filter(function (e) {
                        return e.type === t;
                    })
                );
            });
        }
        return e;
    }
    function D(t) {
        for (var e, i = 0; i < q.length; i++)
            if (q[i].id === t) {
                e = q[i];
                break;
            }
        return e;
    }
    function O(t) {
        return (
            "*" === t
                ? (t = Object.keys(C))
                : "string" == typeof t
                  ? (t = [t])
                  : t.constructor === x
                    ? (t = [t.prototype.type])
                    : Array.isArray(t) &&
                      t[0].constructor === x &&
                      (t = t.map(function (t) {
                          return t.type;
                      })),
            (t = t.map(function (t) {
                return t.toLowerCase();
            }))
        );
    }
    function B(t) {
        return (
            NodeList.prototype.isPrototypeOf(t) && t.length > 0
                ? (t = Array.prototype.slice.call(t))
                : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
                  ? (t = [])
                  : !Array.isArray(t) && t instanceof Element && (t = [t]),
            t
        );
    }
    window.Shopify.designMode &&
        (document.addEventListener("shopify:section:load", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + T.id + '="' + e + '"]');
            !0 === window.Shopify.visualPreviewMode && null === i && (i = t.target.querySelector(`[${T.id}]`)),
                null !== i && H(i.getAttribute(T.type), i);
        }),
        document.addEventListener("shopify:section:reorder", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + T.id + '="' + e + '"]');
            "object" == typeof M(i)[0] &&
                M(i).forEach(function (t) {
                    t.onReorder();
                });
        }),
        document.addEventListener("shopify:section:unload", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + T.id + '="' + e + '"]');
            "object" == typeof M(i)[0] && F(i);
        }),
        document.addEventListener("shopify:section:select", function (t) {
            var e = D(t.detail.sectionId);
            "object" == typeof e && e.onSelect(t);
        }),
        document.addEventListener("shopify:section:deselect", function (t) {
            var e = D(t.detail.sectionId);
            "object" == typeof e && e.onDeselect(t);
        }),
        document.addEventListener("shopify:block:select", function (t) {
            var e = D(t.detail.sectionId);
            "object" == typeof e && e.onBlockSelect(t);
        }),
        document.addEventListener("shopify:block:deselect", function (t) {
            var e = D(t.detail.sectionId);
            "object" == typeof e && e.onBlockDeselect(t);
        }));
    const z = '[data-parallax="card-scrolling"]',
        _ = () => {
            setTimeout(() => {
                window.Shopify.theme.sections.instances
                    .filter((t) => {
                        const e = "slider" === t.type,
                            i = "banner-image" === t.type,
                            s = t.container.matches(z);
                        return (e && s) || (i && s);
                    })
                    .forEach((t) => {
                        F(t.id), setTimeout(() => H(t.id));
                    });
            });
        };
    let $ = X();
    const R = {
            body: "body",
            main: "[data-main]",
            collectionFilters: "[data-collection-filters]",
            footer: '[data-section-type*="footer"]',
            header: "[data-header-height]",
            stickyHeader: '[data-site-header][data-position="fixed"]',
            announcementBar: "[data-announcement-bar]",
            collectionStickyBar: "[data-collection-sticky-bar]",
            logoTextLink: "[data-logo-text-link]",
        },
        V = {
            templateCollection: "template-collection",
            templateSearch: "template-search",
            supportsTransparentHeader: "supports-transparent-header",
        };
    function N() {
        var t, e;
        const i = {};
        return (
            (i.windowHeight = Math.min(window.screen.height, window.innerHeight)),
            (i.footerHeight = K(R.footer)),
            (i.headerHeight = K(R.header)),
            (i.stickyHeaderHeight = Q() ? window.stickyHeaderHeight : 0),
            (i.headerInitialHeight =
                parseInt(
                    (null === (t = document.querySelector(R.header)) || void 0 === t ? void 0 : t.dataset.height) ||
                        (null === (e = document.querySelector(R.header)) || void 0 === e ? void 0 : e.offsetHeight)
                ) || 0),
            (i.announcementBarHeight = K(R.announcementBar)),
            (i.collectionStickyBarHeight = K(R.collectionStickyBar)),
            i
        );
    }
    function W() {
        document.addEventListener("theme:resize", j),
            U(),
            document.dispatchEvent(new CustomEvent("theme:vars"), { bubbles: !1 });
    }
    function U() {
        G();
    }
    function j() {
        G(!0);
    }
    function G(t = !1) {
        const e = document.querySelector(R.body),
            i = document.querySelector(R.collectionFilters),
            s = null !== document.querySelector(R.logoTextLink);
        let {
            windowHeight: o,
            headerHeight: n,
            headerInitialHeight: r,
            announcementBarHeight: a,
            footerHeight: l,
            collectionStickyBarHeight: c,
        } = N();
        s &&
            (n = (function () {
                document.documentElement.style.setProperty("--header-height", "auto"),
                    document.documentElement.style.setProperty("--header-sticky-height", "auto");
                const t = document.querySelector(R.header).offsetHeight;
                return (
                    requestAnimationFrame(() => {
                        document.documentElement.style.setProperty("--header-height", `${t}px`),
                            document.documentElement.style.setProperty("--header-sticky-height", `${t}px`);
                    }),
                    t
                );
            })());
        const h =
            window.isHeaderTransparent &&
            document.querySelector(R.main).firstElementChild.classList.contains(V.supportsTransparentHeader)
                ? o - a
                : o - r - a;
        let d = Q() ? o - window.stickyHeaderHeight : o;
        const u = e.classList.contains(V.templateCollection),
            p = e.classList.contains(V.templateSearch),
            m = (u && i) || (p && i);
        if (
            (document.documentElement.style.setProperty("--footer-height", `${l}px`),
            document.documentElement.style.setProperty("--content-full", `${h}px`),
            document.documentElement.style.setProperty("--content-min", o - n - l + "px"),
            document.documentElement.style.setProperty("--collection-sticky-bar-height", `${c}px`),
            m && (d = o),
            !t)
        )
            return void document.documentElement.style.setProperty("--full-height", `${d}px`);
        const g = X();
        g !== $ && (document.documentElement.style.setProperty("--full-height", `${d}px`), ($ = g));
    }
    function K(t) {
        const e = document.querySelector(t);
        return e ? e.clientHeight : 0;
    }
    function Q() {
        return document.querySelector(R.stickyHeader);
    }
    function X() {
        return window.matchMedia("(orientation: portrait)").matches
            ? "portrait"
            : window.matchMedia("(orientation: landscape)").matches
              ? "landscape"
              : void 0;
    }
    const Y = {
        overflowBackground: "[data-overflow-background]",
        overflowFrame: "[data-overflow-frame]",
        overflowContent: "[data-overflow-content]",
        overflowContainer: "[data-overflow-container]",
        overflowWrapper: "[data-overflow-wrapper]",
    };
    function J(t, e) {
        let i = 0;
        e.forEach((t) => {
            i = t.offsetHeight > i ? t.offsetHeight : i;
        });
        const s = t.querySelectorAll(Y.overflowBackground);
        [t, ...s].forEach((t) => {
            t.style.setProperty("min-height", `calc(${i}px + var(--header-height))`);
        });
    }
    function Z(t) {
        if (window.innerWidth < window.theme.sizes.small) {
            return void t.querySelectorAll(Y.overflowFrame).forEach((t) => {
                const e = t.querySelectorAll(Y.overflowContent);
                J(t, e);
            });
        }
        let e = 0;
        const i = t.querySelectorAll(Y.overflowFrame);
        t.querySelectorAll(Y.overflowContent).forEach((t) => {
            t.offsetHeight > e && (e = t.offsetHeight);
        });
        [...i, ...t.querySelectorAll(Y.overflowBackground)].forEach((t) => {
            t.style.setProperty("min-height", `${e}px`);
        }),
            t.style.setProperty("min-height", `${e}px`);
    }
    function tt(t) {
        const e = t.querySelectorAll(Y.overflowContainer);
        e &&
            e.forEach((t) => {
                const e = t.querySelectorAll(Y.overflowContent);
                J(t, e),
                    document.addEventListener("theme:resize", () => {
                        J(t, e);
                    });
            });
        const i = t.querySelectorAll(Y.overflowWrapper);
        i &&
            i.forEach((t) => {
                Z(t),
                    document.addEventListener("theme:resize", () => {
                        Z(t);
                    });
            });
    }
    function et() {
        document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 })),
            window.lastWindowWidth !== window.innerWidth &&
                (document.dispatchEvent(new CustomEvent("theme:resize:width", { bubbles: !0 })),
                (window.lastWindowWidth = window.innerWidth));
    }
    window.lastWindowWidth = window.innerWidth;
    let it = window.pageYOffset,
        st = null,
        ot = null,
        nt = null,
        rt = null,
        at = 0;
    const lt = { quickViewVisible: "js-quick-view-visible", cartDrawerOpen: "js-drawer-open-cart" };
    function ct(e) {
        setTimeout(() => {
            at && clearTimeout(at),
                t.disablePageScroll(e.detail, { allowTouchMove: (t) => "TEXTAREA" === t.tagName }),
                document.documentElement.setAttribute("data-scroll-locked", "");
        });
    }
    function ht(t) {
        const e = t.detail;
        e ? (at = setTimeout(dt, e)) : dt();
    }
    function dt() {
        document.body.classList.contains(lt.quickViewVisible) ||
            document.body.classList.contains(lt.cartDrawerOpen) ||
            (t.clearQueueScrollLocks(),
            t.enablePageScroll(),
            document.documentElement.removeAttribute("data-scroll-locked"));
    }
    const ut = (t, e = "", i) => {
        const s = i || document.createElement("div");
        return (
            s.classList.add(e),
            s.setAttribute("data-scroll-lock-scrollable", ""),
            t.parentNode.insertBefore(s, t),
            s.appendChild(t)
        );
    };
    function pt(t) {
        t.querySelectorAll("table").forEach((t) => {
            ut(t, "table-wrapper");
        });
    }
    const mt = { loading: "is-loading", imgIn: "img-in" },
        gt = { img: "img.is-loading", section: "[data-section-type]" };
    function ft(t) {
        t.querySelectorAll(gt.img).forEach((t) => {
            if (t.complete) {
                t.classList.remove(mt.loading), t.parentNode.classList.remove(mt.loading);
                const e = t.closest(gt.section);
                e && e.classList.add(mt.imgIn);
            }
        });
    }
    const yt = "img",
        vt = "template",
        bt = ".shopify-section",
        wt = "[data-deferred-content]",
        St = "[data-product-image]",
        Et = "srcset",
        Lt = "data-loaded",
        kt = "data-deferred-container";
    let At = class extends HTMLElement {
        connectedCallback() {
            0 != this.deferredTriggers.length
                ? this.deferredTriggers.forEach((t) => {
                      t.addEventListener(
                          "mouseenter",
                          () => {
                              this.hasAttribute(Lt) || this.loadTemplate();
                          },
                          { once: !0 }
                      );
                  })
                : this.container.addEventListener(
                      "mouseenter",
                      () => {
                          this.hasAttribute(Lt) || this.loadTemplate();
                      },
                      { once: !0 }
                  );
        }
        loadTemplate() {
            var t;
            const e = document.createElement("div"),
                i = this.querySelector(vt);
            if (!i || !(null == i || null === (t = i.content) || void 0 === t ? void 0 : t.firstElementChild)) return;
            e.appendChild(i.content.firstElementChild.cloneNode(!0));
            const s = e.querySelector(wt);
            if (!s) return;
            this.append(s), this.setAttribute(Lt, !0);
            s.querySelectorAll(yt).length > 0 && this.reloadSrcset(this);
        }
        reloadSrcset(t) {
            t &&
                t.querySelectorAll(yt).forEach((t) => {
                    if (!t.parentNode.matches(St)) {
                        const e = t.getAttribute(Et);
                        t.setAttribute(Et, ""), t.setAttribute(Et, e);
                    }
                });
        }
        constructor() {
            super(),
                (this.container = this),
                this.hasAttribute(kt) && (this.container = this.closest(this.getAttribute(kt)) || this.closest(bt)),
                (this.deferredTriggers = this.container.querySelectorAll(this.dataset.deferredTriggers));
        }
    };
    const Ct = "[data-aos]",
        qt = "[data-has-highlight]",
        Tt = "[data-highlight-holder]",
        Pt = "path",
        xt = "sup",
        It = ".flickity-enabled",
        Ht = "[data-slide].is-selected",
        Ft = "[data-sticky-text]",
        Mt = "text-count-up",
        Dt = ".text-reveal__cropper",
        Ot = "data-highlight-type",
        Bt = "data-is-active",
        zt = "is-active",
        _t = "overflow-hidden",
        $t = {
            "circle-hand-drawn": {
                keyframes: [
                    { strokeDashoffset: "1", opacity: "0" },
                    { opacity: "1", offset: 0.01 },
                    { strokeDashoffset: "0", opacity: "1" },
                ],
                timing: {
                    duration: 1e3,
                    delay: 0,
                    iterations: 1,
                    fill: "forwards",
                    easing: "cubic-bezier(0.7, 0, 0.3, 1)",
                },
            },
            circle: {
                keyframes: [
                    { strokeDashoffset: "506", opacity: "0" },
                    { opacity: "1", offset: 0.01 },
                    { strokeDashoffset: "0", opacity: "1" },
                ],
                timing: {
                    duration: 800,
                    delay: 0,
                    iterations: 1,
                    fill: "forwards",
                    easing: "cubic-bezier(0.6, 0, 0.4, 1)",
                },
            },
            highlight: {
                keyframes: [{ transform: "scaleX(0)" }, { transform: "scaleX(1)" }],
                timing: {
                    duration: 600,
                    delay: 200,
                    iterations: 1,
                    fill: "forwards",
                    easing: "ease",
                    pseudoElement: "::before",
                },
                keyframesHover: [{ transform: "scaleY(0.1)" }, { transform: "scaleY(1)" }],
            },
            "highlight-color": {
                keyframes: [
                    { backgroundSize: "200% 100%", backgroundPosition: "100% 0" },
                    { backgroundSize: "200% 100%", backgroundPosition: "0 0", offset: 0.2 },
                    { backgroundSize: "1100% 100%", backgroundPosition: "0 0" },
                ],
                timing: {
                    duration: 2e3,
                    delay: 200,
                    iterations: 1,
                    fill: "forwards",
                    easing: "cubic-bezier(0, 0, 0.9, 0.4)",
                },
            },
            squiggle: {
                keyframes: [{ maskPosition: "100% 0" }, { maskPosition: "0 0" }],
                timing: {
                    duration: 1200,
                    delay: 200,
                    iterations: 1,
                    fill: "forwards",
                    easing: "cubic-bezier(0.6, 0, 0.4, 1)",
                },
            },
            stroke: {
                keyframes: [{ backgroundPosition: "100% 0" }, { backgroundPosition: "0 0" }],
                timing: {
                    duration: 1200,
                    delay: 0,
                    iterations: 1,
                    fill: "forwards",
                    easing: "cubic-bezier(0.25, 0.1, 0.9, 0.3)",
                },
            },
            underline: {
                keyframes: [{ transform: "scaleX(0)" }, { transform: "scaleX(1)" }],
                timing: {
                    duration: 900,
                    delay: 200,
                    iterations: 1,
                    fill: "forwards",
                    easing: "ease",
                    pseudoElement: "::before",
                },
            },
            "underline-hand-drawn": {
                keyframes: [
                    { strokeDashoffset: "1", opacity: "0" },
                    { opacity: "1", offset: 0.01 },
                    { strokeDashoffset: "0", opacity: "1" },
                ],
                timing: {
                    duration: 1e3,
                    delay: 0,
                    iterations: 1,
                    fill: "forwards",
                    easing: "cubic-bezier(0.7, 0, 0.3, 1)",
                },
            },
        };
    let Rt = class extends HTMLElement {
        connectedCallback() {
            (this.timeout = null),
                (this.controller = new AbortController()),
                this.type &&
                    this.target &&
                    ((this.animation = this.target.animate($t[this.type].keyframes, $t[this.type].timing)),
                    this.animation.pause(),
                    this.bindAnimation("init"),
                    this.bindAnimation("pause"),
                    this.modifyDefaults("slider"),
                    this.animation &&
                        (this.link && this.listen(),
                        theme.settings.animationsEnabled || (this.animation.play(), this.bindAnimation("play"))));
        }
        disconnectedCallback() {
            this.controller.abort();
        }
        attributeChangedCallback(t, e, i) {
            const s = t === Bt,
                o = null === e && s,
                n = "true" === i;
            s && n && this.triggerAnimation(), o || n || this.reset();
        }
        triggerAnimation() {
            const t = this.closest(Ct);
            var e, i;
            t
                ? (null === (e = this.textRevealCropper) || void 0 === e || e.classList.add(_t),
                  this.textCountUp
                      ? (clearTimeout(this.timeout),
                        (this.timeout = setTimeout(() => {
                            var t;
                            null === (t = this.textRevealCropper) || void 0 === t || t.classList.remove(_t),
                                this.setAnimationDelay(0),
                                this.animate();
                        }, 100)))
                      : ((i = t),
                        new Promise((t) => {
                            function e(s) {
                                s.target == i &&
                                    (i.removeEventListener("animationend", e),
                                    i.removeEventListener("transitionend", e),
                                    t());
                            }
                            null == i || i.addEventListener("animationend", e),
                                null == i || i.addEventListener("transitionend", e);
                        })).then(() => {
                            var e;
                            const i =
                                    1e3 *
                                    (window.getComputedStyle(t).getPropertyValue("animation-delay") || 0).replace(
                                        "s",
                                        ""
                                    ),
                                s = Math.max(i - 250, 0);
                            null === (e = this.textRevealCropper) || void 0 === e || e.classList.remove(_t),
                                this.setAnimationDelay(s),
                                this.animate();
                        }))
                : this.animate();
        }
        listen() {
            this.link.addEventListener("mouseenter", (t) => this.onMouseenter(t), { signal: this.controller.signal }),
                this.link.addEventListener("mouseleave", (t) => this.onMouseleave(t), {
                    signal: this.controller.signal,
                });
        }
        animate() {
            this.animation &&
                (this.animation.play(), this.bindAnimation("play"), (this.animation.onfinish = () => this.onFinish()));
        }
        shouldAnimate() {
            requestAnimationFrame(() => {
                let t = !0;
                Boolean(this.closest(It)) && (t = Boolean(this.closest(Ht)));
                const e = this.closest(Ft);
                e && (t = Boolean(e.classList.contains(zt))), this.setTriggerAttribute(t);
            });
        }
        setTriggerAttribute(t = !0) {
            this.setAttribute(Bt, t);
        }
        reset() {
            this.animation &&
                (this.animation.cancel(),
                this.bindAnimation("cancel"),
                this.setAnimationDelay($t[this.type].timing.delay));
        }
        onMouseenter(t) {
            t.stopImmediatePropagation(),
                this.setAnimationDelay(0),
                this.modifyDefaults("mouseenter"),
                this.animation.reverse(),
                this.bindAnimation("mouseenter");
        }
        onMouseleave(t) {
            t.stopImmediatePropagation(),
                this.modifyDefaults("mouseleave"),
                this.animation.reverse(),
                this.bindAnimation("mouseleave");
        }
        onFinish() {
            if (this.hasAttribute(Bt)) {
                const t = "true" === this.getAttribute(Bt) ? 0 : $t[this.type].timing.delay;
                this.setAnimationDelay(t);
            } else this.setAnimationDelay(0);
        }
        setAnimationDelay(t = 0) {
            this.animation.effect.getTiming().delay !== t &&
                (this.animation.effect.updateTiming({ delay: t }), this.bindAnimation("delay"));
        }
        modifyDefaults(t = "mouseenter", e) {
            if ((e || (e = this.animation), "mouseenter" === t))
                return (
                    $t[this.type].keyframesHover && e.effect.setKeyframes($t[this.type].keyframesHover),
                    "highlight" === this.type && e.effect.updateTiming({ duration: 350, fill: "both" }),
                    "highlight-color" === this.type && e.effect.updateTiming({ duration: 800 }),
                    void ("underline" === this.type && e.effect.updateTiming({ duration: 400 }))
                );
            if ("mouseleave" === t)
                return (
                    $t[this.type].keyframesHover && e.effect.setKeyframes($t[this.type].keyframes),
                    void (
                        ("highlight" !== this.type && "highlight-color" !== this.type && "underline" !== this.type) ||
                        e.effect.updateTiming({ duration: $t[this.type].timing.duration })
                    )
                );
            if (
                "slider" === t &&
                (theme.settings.animationsEnabled ||
                    (($t[this.type].timing.delay = 300), e.effect.updateTiming({ delay: $t[this.type].timing.delay })),
                this.closest(It))
            ) {
                const t = $t[this.type].timing.delay + 200;
                "highlight" === this.type && e.effect.updateTiming({ delay: t });
            }
        }
        bindAnimation(t = !1) {
            if (
                this.bind &&
                t &&
                ("init" === t &&
                    (this.boundAnimation = this.bind.animate($t[this.type].keyframes, $t[this.type].timing)),
                "pause" === t && this.boundAnimation.pause(),
                "play" === t && this.boundAnimation.play(),
                "cancel" === t && this.boundAnimation.cancel(),
                "mouseenter" === t &&
                    (this.modifyDefaults("mouseenter", this.boundAnimation), this.boundAnimation.reverse()),
                "mouseleave" === t &&
                    (this.modifyDefaults("mouseleave", this.boundAnimation), this.boundAnimation.reverse()),
                "delay" === t)
            ) {
                const t = this.animation.effect.getTiming().delay;
                this.boundAnimation.effect.getTiming().delay !== t &&
                    this.boundAnimation.effect.updateTiming({ delay: t });
            }
        }
        constructor() {
            super(),
                (this.animation = null),
                (this.bind = null),
                (this.boundAnimation = null),
                (this.link = this.closest(qt)),
                (this.type = this.getAttribute(Ot)),
                (this.highlightHolder = this.querySelector(Tt)),
                (this.textCountUp = this.closest(Mt)),
                (this.sup = this.querySelector(xt)),
                (this.textRevealCropper = this.closest(Dt)),
                (this.target = this.highlightHolder),
                ("circle-hand-drawn" !== this.type && "circle" !== this.type && "underline-hand-drawn" !== this.type) ||
                    (this.target = this.querySelector(Pt)),
                ("highlight-color" !== this.type && "stroke" !== this.type) || (this.sup && (this.bind = this.sup));
        }
    };
    var Vt, Nt, Wt;
    (Wt = [Bt]),
        (Nt = "observedAttributes") in (Vt = Rt)
            ? Object.defineProperty(Vt, Nt, { value: Wt, enumerable: !0, configurable: !0, writable: !0 })
            : (Vt[Nt] = Wt);
    const Ut = {
            inputSearch: 'input[type="search"]',
            inputType: 'input[name="type"]',
            form: "form",
            allVisibleElements: '[role="option"]',
            ariaSelected: '[aria-selected="true"]',
            selectedOption: '[aria-selected="true"] a, button[aria-selected="true"]',
            popularSearches: "[data-popular-searches]",
            popdownBody: "[data-popdown-body]",
            mainInputSearch: "[data-main-input-search]",
            predictiveSearchResults: "[data-predictive-search-results]",
            predictiveSearch: "predictive-search",
            searchForm: "search-form",
        },
        jt = "is-searched",
        Gt = "template-search";
    let Kt = class extends HTMLElement {
        getQuery() {
            return this.input.value.trim();
        }
        onFocus() {
            this.currentSearchTerm = this.getQuery();
        }
        onChange() {
            this.classList.toggle(jt, !this.isFormCleared()), (this.searchTerm = this.getQuery());
        }
        isFormCleared() {
            return 0 === this.input.value.length;
        }
        submit() {
            this.form.submit();
        }
        reset() {
            this.input.val = "";
        }
        onFormSubmit(t) {
            (this.getQuery().length && !this.querySelector(Ut.selectedLink)) || t.preventDefault();
        }
        onKeydown(t) {
            ("ArrowUp" !== t.code && "ArrowDown" !== t.code) || t.preventDefault();
        }
        onKeyup(t) {
            switch ((!this.getQuery().length && this.predictiveSearch && this.close(!0), t.preventDefault(), t.code)) {
                case "ArrowUp":
                    this.switchOption("up");
                    break;
                case "ArrowDown":
                    this.switchOption("down");
                    break;
                case "Enter":
                    this.selectOption();
            }
        }
        switchOption(t) {
            const e = "up" === t,
                i =
                    this.classList.contains(jt) && this.predictiveSearchResults
                        ? this.predictiveSearchResults
                        : this.popularSearches;
            if (!i) return;
            this.selectedElement = i.querySelector(Ut.ariaSelected);
            const s = Array.from(i.querySelectorAll(Ut.allVisibleElements)).filter((t) => null !== t.offsetParent);
            let o = 0;
            if (e && !this.selectedElement) return;
            let n = -1,
                r = 0;
            for (; -1 === n && r <= s.length; ) s[r] === this.selectedElement && (n = r), r++;
            !e && this.selectedElement
                ? (o = n === s.length - 1 ? 0 : n + 1)
                : e && (o = 0 === n ? s.length - 1 : n - 1),
                o !== n && ((this.activeElement = s[o]), this.handleFocusableDescendants());
        }
        selectOption() {
            const t = this.querySelector(Ut.selectedOption);
            t && t.click();
        }
        handleFocusableDescendants(t = !1) {
            const e = this.selectedElement ? this.selectedElement : this.querySelector(Ut.ariaSelected);
            var i;
            if ((e && e.setAttribute("aria-selected", !1), !this.activeElement || t))
                return (
                    (this.selectedElement = null),
                    null === (i = this.activeElement) || void 0 === i || i.setAttribute("aria-selected", !1),
                    this.input.setAttribute("aria-expanded", !1),
                    void this.input.setAttribute("aria-activedescendant", "")
                );
            this.activeElement.setAttribute("aria-selected", !0),
                this.input.setAttribute("aria-activedescendant", this.activeElement.id);
        }
        constructor() {
            var t;
            super(),
                (this.input = this.querySelector(Ut.inputSearch)),
                (this.form = this.querySelector(Ut.form)),
                (this.popdownBody = this.closest(Ut.popdownBody)),
                (this.popularSearches =
                    null === (t = this.popdownBody) || void 0 === t ? void 0 : t.querySelector(Ut.popularSearches)),
                (this.predictiveSearchResults = this.querySelector(Ut.predictiveSearchResults)),
                (this.predictiveSearch = this.matches(Ut.predictiveSearch)),
                (this.searchForm = this.matches(Ut.searchForm)),
                (this.selectedElement = null),
                (this.activeElement = null),
                (this.searchTerm = ""),
                (this.currentSearchTerm = ""),
                (this.isSearchPage = document.body.classList.contains(Gt)),
                this.input.addEventListener(
                    "input",
                    o((t) => {
                        this.onChange(t);
                    }, 300).bind(this)
                ),
                this.input.addEventListener("focus", this.onFocus.bind(this)),
                this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)),
                this.addEventListener("keyup", this.onKeyup.bind(this)),
                this.addEventListener("keydown", this.onKeydown.bind(this)),
                this.isSearchPage &&
                    ((this.mainInputType = document.querySelector(`${Ut.mainInputSearch} ${Ut.inputType}`)),
                    (this.inputType = this.querySelector(Ut.inputType)),
                    (this.inputType.value = this.mainInputType.value));
        }
    };
    customElements.define("search-form", Kt);
    const Qt = "predictive-search",
        Xt = "#shopify-section-api-predictive-search",
        Yt = "[data-predictive-search-results]",
        Jt = "[data-predictive-search-status]",
        Zt = "[data-predictive-search-live-region-count-value]",
        te = "[data-search-results-wrapper]",
        ee = "reset",
        ie = "data-aos-anchor",
        se = "aria-hidden",
        oe = "open",
        ne = "loading",
        re = "data-loading-text",
        ae = "results";
    customElements.define(
        "predictive-search",
        class extends Kt {
            connectedCallback() {
                this.predictiveSearchResults.addEventListener("transitionend", (t) => {
                    t.target !== this.predictiveSearchResults ||
                        this.getQuery().length ||
                        (this.classList.remove(ee), requestAnimationFrame(() => this.clearResultsHTML()));
                });
            }
            onChange() {
                super.onChange(),
                    this.classList.remove(ee),
                    this.searchTerm.length
                        ? requestAnimationFrame(() => this.getSearchResults(this.searchTerm))
                        : this.classList.add(ee);
            }
            onFocus() {
                super.onFocus(),
                    this.currentSearchTerm.length &&
                        (this.searchTerm !== this.currentSearchTerm
                            ? this.onChange()
                            : "true" === this.getAttribute(ae)
                              ? this.open()
                              : this.getSearchResults(this.searchTerm));
            }
            getSearchResults(t) {
                const e = t.replace(" ", "-").toLowerCase(),
                    i = parseInt(window.theme.settings.suggestionsResultsLimit);
                let s = "query";
                (s += window.theme.settings.suggestArticles ? ",article" : ""),
                    (s += window.theme.settings.suggestCollections ? ",collection" : ""),
                    (s += window.theme.settings.suggestProducts ? ",product" : ""),
                    (s += window.theme.settings.suggestPages ? ",page" : ""),
                    this.setLiveRegionLoadingState(),
                    this.cachedResults[e]
                        ? this.renderSearchResults(this.cachedResults[e])
                        : fetch(
                              `${theme.routes.predictiveSearchUrl}?q=${encodeURIComponent(t)}&resources[type]=${s}&resources[limit]=${i}&section_id=api-predictive-search`,
                              { signal: this.abortController.signal }
                          )
                              .then((t) => {
                                  if (!t.ok) {
                                      var e = new Error(t.status);
                                      throw (this.close(), e);
                                  }
                                  return t.text();
                              })
                              .then((t) => {
                                  const i = new DOMParser().parseFromString(t, "text/html").querySelector(Xt).innerHTML;
                                  this.allPredictiveSearchInstances.forEach((t) => {
                                      t.cachedResults[e] = i;
                                  }),
                                      this.renderSearchResults(i);
                              })
                              .catch((t) => {
                                  if (20 !== (null == t ? void 0 : t.code)) throw (this.close(), t);
                              });
            }
            switchOption(t) {
                super.switchOption(t), this.statusElement && (this.statusElement.textContent = "");
            }
            setLiveRegionLoadingState() {
                (this.statusElement = this.statusElement || this.querySelector(Jt)),
                    (this.loadingText = this.loadingText || this.getAttribute(re)),
                    this.setLiveRegionText(this.loadingText),
                    this.setAttribute(ne, !0);
            }
            setLiveRegionText(t) {
                this.statusElement.setAttribute(se, "false"),
                    (this.statusElement.textContent = t),
                    setTimeout(() => {
                        this.statusElement.setAttribute(se, "true");
                    }, 1e3);
            }
            renderSearchResults(t) {
                this.predictiveSearchResults.innerHTML = t;
                const e = this.predictiveSearchResults.parentElement.id,
                    i = this.predictiveSearchResults.querySelector(te),
                    s = i.id;
                (i.id = `${s}--${e}`),
                    i.setAttribute(ie, `#${i.id}`),
                    this.setAttribute(ae, !0),
                    this.setLiveRegionResults(),
                    this.open();
            }
            setLiveRegionResults() {
                this.removeAttribute(ne), this.setLiveRegionText(this.querySelector(Zt).textContent);
            }
            open() {
                this.setAttribute(oe, !0);
            }
            close(t = !1) {
                this.closeResults(t);
            }
            closeResults(t = !1) {
                t && (this.reset(), this.removeAttribute(ae), this.classList.remove(ee)),
                    this.removeAttribute(ne),
                    this.removeAttribute(oe);
            }
            clearResultsHTML() {
                this.predictiveSearchResults.innerHTML = "";
            }
            constructor() {
                super(),
                    (this.abortController = new AbortController()),
                    (this.allPredictiveSearchInstances = document.querySelectorAll(Qt)),
                    (this.predictiveSearchResults = this.querySelector(Yt)),
                    (this.cachedResults = {});
            }
        }
    );
    let le = class extends HTMLElement {
        constructor() {
            super(),
                document.addEventListener("DOMContentLoaded", () => {
                    document.documentElement.classList.remove("page-loading");
                });
        }
    };
    function ce() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
    function he() {
        return ce() >= window.theme.sizes.small;
    }
    function de() {
        return ce() < window.theme.sizes.small;
    }
    const ue = {
            aos: "[data-aos]:not(.aos-animate)",
            aosAnchor: "[data-aos-anchor]",
            animatable: "[data-aos], [data-aos-anchor]",
            watchMutations:
                '[id^="api-cart-items-"], [data-collection-filters], [data-collection-products], #AjaxinateLoop, [data-tab="resultsProducts"]',
            skeletonLoading: ".skeleton-loading",
            textHighlight: "text-highlight",
            counterUps: "text-count-up",
            flickitySlider: ".flickity-slider",
            slide: "[data-slide]",
            carouselMobile: ".carousel--mobile",
        },
        pe = { aosAnimate: "aos-animate", isLoading: "is-loading", isSelected: ".is-selected" },
        me = {
            aos: "data-aos",
            aosAnchor: "data-aos-anchor",
            aosIntersection: "data-aos-intersection",
            aosDebounce: "data-aos-debounce",
            aosCustomInit: "data-aos-custom-init",
            aosWatchAnchors: "data-aos-watch-anchors",
            aosTrigger: "data-aos-trigger",
            aosCarouselMobile: "data-aos-carousel-mobile",
            aosCarouselDesktop: "data-aos-carousel-desktop",
        },
        ge = 0.1,
        fe = 0;
    let ye = new Set();
    function ve(t) {
        t.length &&
            (t.forEach((t) => {
                const e = t.dataset.aosAnchor;
                let i;
                "" != e && (i = document.querySelector(e)), i && !ye.has(t) && ye.add(i);
            }),
            ye.forEach((t) => {
                be.observe(t);
            }));
    }
    const be = new IntersectionObserver(
        (t, e) => {
            t.forEach((t) => {
                const i = t.target,
                    s = t.intersectionRatio,
                    o = t.isIntersecting;
                let n,
                    r = ge;
                i.hasAttribute(me.aosIntersection) && (r = Number(i.getAttribute(me.aosIntersection)));
                let a = fe;
                i.hasAttribute(me.aosDebounce) && (a = Number(i.getAttribute(me.aosDebounce))),
                    o &&
                        s > r &&
                        (0 !== a ? (n && clearTimeout(n), (n = setTimeout(() => we(i), a))) : we(i),
                        e.unobserve(i),
                        ye.delete(i));
            });
        },
        { root: null, rootMargin: "0px", threshold: [0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.5, 0.75, 1] }
    );
    function we(t) {
        if (!t) return;
        Se(t);
        const e = t.closest(ue.skeletonLoading);
        if (
            (e &&
                e.querySelectorAll("img").forEach((t) => {
                    t.classList.contains(pe.isLoading) && t.setAttribute("loading", "eager");
                }),
            t.hasAttribute(me.aosCarouselDesktop) && he())
        ) {
            if (t.querySelector(ue.flickitySlider)) {
                const e = t.querySelectorAll(ue.slide),
                    i = [...e].filter((t) => {
                        if (t.matches(pe.isSelected)) return t;
                    }),
                    s = [...e].filter((t) => {
                        if (!t.matches(pe.isSelected)) return t;
                    });
                if (i.length > 0) {
                    const t = i[i.length - 1].id;
                    i[i.length - 1].setAttribute(me.aosTrigger, `#${t}`),
                        s.forEach((e) => {
                            e.querySelectorAll(ue.animatable).forEach((e) => {
                                e.setAttribute(me.aosAnchor, `#${t}`);
                            });
                        });
                }
            }
        }
        if (t.hasAttribute(me.aosCarouselMobile) && de()) {
            const e = t.querySelector(ue.carouselMobile);
            if (e) {
                const t = [...e.children],
                    i = t[0].id;
                t.length > 1 &&
                    (t[0].setAttribute(me.aosTrigger, `#${i}`),
                    t.forEach((t) => {
                        t.querySelectorAll(ue.animatable).forEach((t) => {
                            t.setAttribute(me.aosAnchor, `#${i}`);
                        });
                    }));
            }
        }
        if (t.hasAttribute(me.aosTrigger)) {
            const e = t.getAttribute(me.aosTrigger);
            document.querySelectorAll(`[${me.aosAnchor}="${e}"]`).forEach((t) => Se(t));
        }
        let i = t.querySelectorAll(ue.aos);
        if (t.hasAttribute(me.aosWatchAnchors)) {
            i = [...i].filter((e) => {
                const i = !!e.hasAttribute(me.aosAnchor) && e.getAttribute(me.aosAnchor);
                if (i && `#${t.id}` === i) return e;
            });
        }
        i.forEach((e) => {
            e.hasAttribute(me.aosCustomInit)
                ? t.dispatchEvent(new CustomEvent("theme:target:animate", { bubbles: !0, detail: e }))
                : Se(e);
        });
    }
    function Se(t) {
        requestAnimationFrame(() => t.classList.add(pe.aosAnimate)),
            (function (t) {
                const e = t.querySelectorAll(ue.textHighlight);
                e.forEach((t) => t.shouldAnimate());
            })(t),
            (function (t) {
                const e = t.querySelectorAll(ue.counterUps);
                e.forEach((t) => t.shouldAnimate());
            })(t);
    }
    function Ee() {
        ve(document.querySelectorAll(ue.aosAnchor)),
            (function () {
                const t = (t) => t instanceof HTMLElement;
                new MutationObserver((e) => {
                    for (const i of e) {
                        if ("childList" === !i.type) return;
                        const e = i.target,
                            s = [...i.addedNodes],
                            o = [...i.removedNodes],
                            n =
                                e.matches(ue.watchMutations) ||
                                s.some((e) => !!t(e) && e.matches(ue.watchMutations)) ||
                                o.some((e) => !!t(e) && e.matches(ue.watchMutations)),
                            r = e.matches(ue.animatable) || s.some((e) => !!t(e) && e.matches(ue.animatable)),
                            a = null !== e.querySelector(`[${me.aosAnchor}="#${e.id}"]`);
                        (r || a || n) && ve(e.querySelectorAll(ue.aosAnchor));
                    }
                }).observe(document.body, { attributes: !1, childList: !0, subtree: !0 });
            })();
    }
    const Le = (t) => {
            clearTimeout(t.countUpTimeout),
                t._countUpOrigInnerHTML &&
                    ((t.innerHTML = t._countUpOrigInnerHTML), (t._countUpOrigInnerHTML = void 0)),
                (t.style.visibility = "");
        },
        ke = (t, e = {}) => {
            const { duration: i = 1e3, delay: s = 16 } = e,
                o = i / s,
                n = t.toString().split(/(<[^>]+>|[0-9.][,.0-9]*[0-9]*)/),
                r = [];
            for (let t = 0; t < o; t++) r.push("");
            for (let t = 0; t < n.length; t++)
                if (/([0-9.][,.0-9]*[0-9]*)/.test(n[t]) && !/<[^>]+>/.test(n[t])) {
                    let e = n[t];
                    const i = [...e.matchAll(/[.,]/g)]
                        .map((t) => ({ char: t[0], i: e.length - t.index - 1 }))
                        .sort((t, e) => t.i - e.i);
                    e = e.replace(/[.,]/g, "");
                    let s = r.length - 1;
                    for (let t = o; t >= 1; t--) {
                        let n = parseInt((e / o) * t, 10);
                        (n = i.reduce(
                            (t, { char: e, i: i }) => (t.length <= i ? t : t.slice(0, -i) + e + t.slice(-i)),
                            n.toString()
                        )),
                            (r[s--] += n);
                    }
                } else for (let e = 0; e < o; e++) r[e] += n[t];
            return (r[r.length] = t.toString()), r;
        };
    const Ae = "data-count-up-duration",
        Ce = "data-count-up-init";
    let qe = class extends HTMLElement {
        connectedCallback() {
            theme.settings.animationsEnabled || this.startCountUp();
        }
        attributeChangedCallback(t, e, i) {
            null === e && t === Ce && "true" === i && this.startCountUp();
        }
        shouldAnimate() {
            requestAnimationFrame(() => this.setTriggerAttribute());
        }
        setTriggerAttribute(t = !0) {
            this.setAttribute(Ce, t);
        }
        startCountUp() {
            ((t, e = {}) => {
                const { action: i = "start", duration: s = 1e3, delay: o = 16 } = e;
                if ("stop" === i) return void Le(t);
                if ((Le(t), !/[0-9]/.test(t.innerHTML))) return;
                const n = ke(t.innerHTML, {
                    duration: s || t.getAttribute("data-duration"),
                    delay: o || t.getAttribute("data-delay"),
                });
                (t._countUpOrigInnerHTML = t.innerHTML),
                    (t.innerHTML = n[0] || "&nbsp;"),
                    (t.style.visibility = "visible");
                const r = function () {
                    (t.innerHTML = n.shift() || "&nbsp;"),
                        n.length
                            ? (clearTimeout(t.countUpTimeout), (t.countUpTimeout = setTimeout(r, o)))
                            : (t._countUpOrigInnerHTML = void 0);
                };
                t.countUpTimeout = setTimeout(r, o);
            })(this, { duration: this.duration, delay: 0.016 * this.duration });
        }
        constructor() {
            super(),
                (this.container = this),
                (this.countUpDuration = this.getAttribute(Ae)),
                (this.duration = (100 / parseInt(this.countUpDuration, 10)) * 1e3);
        }
    };
    !(function (t, e, i) {
        e in t ? Object.defineProperty(t, e, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : (t[e] = i);
    })(qe, "observedAttributes", [Ce]),
        (window.requestIdleCallback =
            window.requestIdleCallback ||
            function (t) {
                var e = Date.now();
                return setTimeout(function () {
                    t({
                        didTimeout: !1,
                        timeRemaining: function () {
                            return Math.max(0, 50 - (Date.now() - e));
                        },
                    });
                }, 1);
            }),
        (window.cancelIdleCallback =
            window.cancelIdleCallback ||
            function (t) {
                clearTimeout(t);
            }),
        window.addEventListener("resize", o(et, 50)),
        (function () {
            let t;
            window.addEventListener(
                "scroll",
                function () {
                    t && window.cancelAnimationFrame(t),
                        (t = window.requestAnimationFrame(function () {
                            !(function () {
                                const t = window.pageYOffset;
                                t > it
                                    ? ((ot = !0), (st = !1))
                                    : t < it
                                      ? ((ot = !1), (st = !0))
                                      : ((st = null), (ot = null)),
                                    (it = t),
                                    document.dispatchEvent(
                                        new CustomEvent("theme:scroll", {
                                            detail: { up: st, down: ot, position: t },
                                            bubbles: !1,
                                        })
                                    ),
                                    st &&
                                        !nt &&
                                        document.dispatchEvent(
                                            new CustomEvent("theme:scroll:up", { detail: { position: t }, bubbles: !1 })
                                        ),
                                    ot &&
                                        !rt &&
                                        document.dispatchEvent(
                                            new CustomEvent("theme:scroll:down", {
                                                detail: { position: t },
                                                bubbles: !1,
                                            })
                                        ),
                                    (rt = ot),
                                    (nt = st);
                            })();
                        }));
                },
                { passive: !0 }
            ),
                window.addEventListener("theme:scroll:lock", ct),
                window.addEventListener("theme:scroll:unlock", ht);
        })(),
        "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
            ? ((document.documentElement.className = document.documentElement.className.replace(
                  "no-touch",
                  "supports-touch"
              )),
              (window.theme.touch = !0))
            : (window.theme.touch = !1),
        document.addEventListener(
            "load",
            (t) => {
                if ("img" == t.target.tagName.toLowerCase() && t.target.classList.contains(mt.loading)) {
                    t.target.classList.remove(mt.loading), t.target.parentNode.classList.remove(mt.loading);
                    const e = t.target.closest(gt.section);
                    e && e.classList.add(mt.imgIn);
                }
            },
            !0
        );
    const Te = o(() => {
        p();
    }, 300);
    window.addEventListener("DOMContentLoaded", () => {
        W(), tt(document), pt(document), ft(document), window.theme.settings.animationsEnabled && Ee();
    }),
        document.addEventListener("shopify:section:load", (t) => {
            const e = t.target;
            window.dispatchEvent(new Event("resize"), { bubbles: !0 }),
                tt(e),
                pt(e),
                W(),
                Te(),
                A(e),
                _(),
                window.theme.settings.animationsEnabled && Ee();
        }),
        document.addEventListener("shopify:section:reorder", (t) => {
            const e = t.target;
            Te(), A(e), _(), window.theme.settings.animationsEnabled && Ee();
        }),
        document.addEventListener("shopify:section:unload", (t) => {
            const e = t.target;
            Te(), A(e), _();
        }),
        customElements.get("text-highlight") || customElements.define("text-highlight", Rt),
        customElements.get("deferred-loading") || customElements.define("deferred-loading", At),
        customElements.get("loading-overlay") || customElements.define("loading-overlay", le),
        customElements.get("text-count-up") || customElements.define("text-count-up", qe),
        (function () {
            function t(t) {
                var e = window.innerWidth || document.documentElement.clientWidth,
                    i = window.innerHeight || document.documentElement.clientHeight,
                    s = t.getBoundingClientRect();
                return s.top >= 0 && s.bottom <= i && s.left >= 0 && s.right <= e;
            }
            function e(t) {
                var e = window.innerWidth || document.documentElement.clientWidth,
                    i = window.innerHeight || document.documentElement.clientHeight,
                    s = t.getBoundingClientRect(),
                    o = (s.left >= 0 && s.left <= e) || (s.right >= 0 && s.right <= e),
                    n = (s.top >= 0 && s.top <= i) || (s.bottom >= 0 && s.bottom <= i);
                return o && n;
            }
            window.visibilityHelper = {
                isElementTotallyVisible: t,
                isElementPartiallyVisible: e,
                inViewportPartially: function (t, i) {
                    function s() {
                        var s = e(t);
                        s != o && ((o = s), "function" == typeof i && i(s, t));
                    }
                    var o = e(t);
                    window.addEventListener("load", s),
                        window.addEventListener("resize", s),
                        window.addEventListener("scroll", s);
                },
                inViewportTotally: function (e, i) {
                    function s() {
                        var s = t(e);
                        s != o && ((o = s), "function" == typeof i && i(s, e));
                    }
                    var o = t(e);
                    window.addEventListener("load", s),
                        window.addEventListener("resize", s),
                        window.addEventListener("scroll", s);
                },
            };
        })();
    const Pe = (t, e) => {
        let i, s;
        return function o(...n) {
            const r = Date.now();
            (s = clearTimeout(s)),
                !i || r - i >= e ? (t.apply(null, n), (i = r)) : (s = setTimeout(o.bind(null, ...n), e - (r - i)));
        };
    };
    function xe(t) {
        (this.status = t.status || null),
            (this.headers = t.headers || null),
            (this.json = t.json || null),
            (this.body = t.body || null);
    }
    xe.prototype = Error.prototype;
    const Ie = "[data-collapsible-single]",
        He = "[data-collapsible-trigger]",
        Fe = "[data-collapsible-content]",
        Me = "is-expanded",
        De = "aria-expanded",
        Oe = "aria-controls",
        Be = "data-collapsible-trigger-mobile",
        ze = "data-collapsible-transition-override",
        _e = 500,
        $e = {};
    let Re = class {
        init() {
            this.triggers.forEach((t) => {
                t.addEventListener("click", this.collapsibleToggleEvent),
                    t.addEventListener("keyup", this.collapsibleToggleEvent);
            });
        }
        collapsibleToggle(t) {
            t.preventDefault();
            const e = t.target.matches(He) ? t.target : t.target.closest(He),
                i = e.getAttribute(Oe),
                s = document.getElementById(i),
                o = e.hasAttribute(Be),
                n = e.classList.contains(Me),
                r = t.code === theme.keyboardKeys.SPACE,
                a = t.code === theme.keyboardKeys.ESCAPE,
                l = window.innerWidth < theme.sizes.small;
            (this.isTransitioning && !this.transitionOverride) ||
                ((!t.code || r || a) &&
                    ((!n && a) ||
                        (o && !l) ||
                        ((this.isTransitioning = !0),
                        (e.disabled = !0),
                        this.single &&
                            this.triggers.forEach((t) => {
                                const i = t.classList.contains(Me);
                                if (e == t || !i) return;
                                const s = t.getAttribute(Oe),
                                    o = document.getElementById(s);
                                requestAnimationFrame(() => {
                                    this.closeItem(o, t);
                                });
                            }),
                        n
                            ? requestAnimationFrame(() => {
                                  this.closeItem(s, e);
                              })
                            : requestAnimationFrame(() => {
                                  this.openItem(s, e);
                              }))));
        }
        openItem(t, e) {
            let i = t.querySelector(Fe).offsetHeight;
            this.setDropdownHeight(t, i, e, !0),
                e.classList.add(Me),
                e.setAttribute(De, !0),
                e.dispatchEvent(
                    new CustomEvent("theme:form:sticky", { bubbles: !0, detail: { element: "accordion" } })
                );
        }
        closeItem(t, e) {
            let i = t.querySelector(Fe).offsetHeight;
            requestAnimationFrame(() => {
                (i = 0), this.setDropdownHeight(t, i, e, !1), e.classList.remove(Me);
            }),
                this.setDropdownHeight(t, i, e, !1),
                e.classList.remove(Me),
                e.setAttribute(De, !1);
        }
        setDropdownHeight(t, e, i, s) {
            (t.style.height = `${e}px`),
                t.setAttribute(De, s),
                t.classList.toggle(Me, s),
                this.resetHeightTimer && clearTimeout(this.resetHeightTimer),
                0 == e &&
                    (this.resetHeightTimer = setTimeout(() => {
                        t.style.height = "";
                    }, _e)),
                s
                    ? (this.resetHeightTimer = setTimeout(() => {
                          (t.style.height = "auto"), (this.isTransitioning = !1);
                      }, _e))
                    : (this.isTransitioning = !1),
                setTimeout(() => {
                    i.disabled = !1;
                }, _e);
        }
        onUnload() {
            this.triggers.forEach((t) => {
                t.removeEventListener("click", this.collapsibleToggleEvent),
                    t.removeEventListener("keyup", this.collapsibleToggleEvent);
            });
        }
        constructor(t) {
            (this.container = t),
                (this.single = this.container.querySelector(Ie)),
                (this.triggers = this.container.querySelectorAll(He)),
                (this.resetHeightTimer = 0),
                (this.isTransitioning = !1),
                (this.transitionOverride = this.container.hasAttribute(ze)),
                (this.collapsibleToggleEvent = (t) => Pe(this.collapsibleToggle(t), 1250)),
                this.init();
        }
    };
    const Ve = {
            onLoad() {
                $e[this.id] = new Re(this.container);
            },
            onUnload() {
                $e[this.id].onUnload();
            },
        },
        Ne = "[data-quantity-holder]",
        We = "[data-quantity-field]",
        Ue = "[data-quantity-button]",
        je = "[data-quantity-minus]",
        Ge = "[data-quantity-plus]",
        Ke = "read-only",
        Qe = "is-disabled";
    let Xe = class {
        init() {
            (this.quantity = this.holder.querySelector(Ne)),
                this.quantity &&
                    ((this.field = this.quantity.querySelector(We)),
                    (this.buttons = this.quantity.querySelectorAll(Ue)),
                    (this.increaseButton = this.quantity.querySelector(Ge)),
                    (this.quantityValue = Number(this.field.value || 0)),
                    (this.cartItemID = this.field.getAttribute("data-id")),
                    (this.maxValue =
                        Number(this.field.getAttribute("max")) > 0 ? Number(this.field.getAttribute("max")) : null),
                    (this.minValue =
                        Number(this.field.getAttribute("min")) > 0 ? Number(this.field.getAttribute("min")) : 0),
                    (this.disableIncrease = this.disableIncrease.bind(this)),
                    (this.emptyField = !1),
                    (this.updateQuantity = this.updateQuantity.bind(this)),
                    (this.decrease = this.decrease.bind(this)),
                    (this.increase = this.increase.bind(this)),
                    this.disableIncrease(),
                    this.quantity.classList.contains(Ke) || (this.changeValueOnClick(), this.changeValueOnInput()));
        }
        changeValueOnClick() {
            this.buttons.forEach((t) => {
                t.addEventListener("click", (t) => {
                    t.preventDefault(), (this.quantityValue = Number(this.field.value || 0));
                    const e = t.target,
                        i = e.matches(je) || e.closest(je),
                        s = e.matches(Ge) || e.closest(Ge);
                    i && this.decrease(), s && this.increase(), this.updateQuantity();
                });
            });
        }
        changeValueOnInput() {
            this.field.addEventListener("input", () => {
                (this.quantityValue = this.field.value), this.updateQuantity();
            });
        }
        updateQuantity() {
            this.maxValue < this.quantityValue && null !== this.maxValue && (this.quantityValue = this.maxValue),
                this.minValue > this.quantityValue && (this.quantityValue = this.minValue),
                (this.field.value = this.quantityValue),
                this.disableIncrease(),
                this.quantityUpdateCart
                    ? (document.dispatchEvent(new CustomEvent("theme:cart:update")), this.updateCart())
                    : this.triggerInputChange();
        }
        decrease() {
            this.quantityValue > this.minValue ? this.quantityValue-- : (this.quantityValue = 0);
        }
        increase() {
            this.quantityValue++;
        }
        disableIncrease() {
            this.increaseButton.classList.toggle(Qe, this.quantityValue >= this.maxValue && null !== this.maxValue);
        }
        updateCart() {
            if ("" === this.quantityValue) return;
            const t = new CustomEvent("theme:cart:update", {
                bubbles: !0,
                detail: { id: this.cartItemID, quantity: this.quantityValue },
            });
            this.holder.dispatchEvent(t);
        }
        triggerInputChange() {
            this.field.dispatchEvent(new Event("change"));
        }
        constructor(t, e = !1) {
            (this.holder = t), (this.quantityUpdateCart = e);
        }
    };
    const Ye = {
        state: { firstFocusable: null, lastFocusable: null, trigger: null },
        trapFocus: function (t) {
            var e = Array.from(
                t.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])')
            ).filter(function (t) {
                var e = t.offsetWidth,
                    i = t.offsetHeight;
                return 0 !== e && 0 !== i && "none" !== getComputedStyle(t).getPropertyValue("display");
            });
            (e = e.filter(function (t) {
                return !t.classList.contains("deferred-media__poster");
            })),
                (this.state.firstFocusable = e[0]),
                (this.state.lastFocusable = e[e.length - 1]),
                t.elementToFocus || (t.elementToFocus = this.state.firstFocusable || t.container),
                this._setupHandlers(),
                document.addEventListener("focusin", this._onFocusInHandler),
                document.addEventListener("focusout", this._onFocusOutHandler),
                t.container.setAttribute("tabindex", "-1"),
                t.elementToFocus.focus();
        },
        removeTrapFocus: function (t) {
            const e = !document.body.classList.contains("no-outline");
            t && t.container && t.container.removeAttribute("tabindex"),
                document.removeEventListener("focusin", this._onFocusInHandler),
                this.state.trigger && e && this.state.trigger.focus();
        },
        _manageFocus: function (t) {
            t.code === theme.keyboardKeys.TAB &&
                (t.target !== this.state.lastFocusable ||
                    t.shiftKey ||
                    (t.preventDefault(), this.state.firstFocusable.focus()),
                t.target === this.state.firstFocusable &&
                    t.shiftKey &&
                    (t.preventDefault(), this.state.lastFocusable.focus()));
        },
        _onFocusOut: function () {
            document.removeEventListener("keydown", this._manageFocusHandler);
        },
        _onFocusIn: function (t) {
            (t.target !== this.state.lastFocusable && t.target !== this.state.firstFocusable) ||
                document.addEventListener("keydown", this._manageFocusHandler);
        },
        _setupHandlers: function () {
            this._onFocusInHandler || (this._onFocusInHandler = this._onFocusIn.bind(this)),
                this._onFocusOutHandler || (this._onFocusOutHandler = this._onFocusIn.bind(this)),
                this._manageFocusHandler || (this._manageFocusHandler = this._manageFocus.bind(this));
        },
    };
    const Je = {};
    function Ze(t = {}) {
        if ((t.type || (t.type = "json"), t.url))
            return Je[t.url]
                ? Je[t.url]
                : (function (t, e) {
                      const i = new Promise((i, s) => {
                          "text" === e
                              ? fetch(t)
                                    .then((t) => t.text())
                                    .then((t) => {
                                        i(t);
                                    })
                                    .catch((t) => {
                                        s(t);
                                    })
                              : (function (t, e, i) {
                                    let s = document.getElementsByTagName("head")[0],
                                        o = !1,
                                        n = document.createElement("script");
                                    (n.src = t),
                                        (n.onload = n.onreadystatechange =
                                            function () {
                                                o ||
                                                (this.readyState &&
                                                    "loaded" != this.readyState &&
                                                    "complete" != this.readyState)
                                                    ? i()
                                                    : ((o = !0), e());
                                            }),
                                        s.appendChild(n);
                                })(
                                    t,
                                    function () {
                                        i();
                                    },
                                    function () {
                                        s();
                                    }
                                );
                      });
                      return (Je[t] = i), i;
                  })(t.url, t.type);
        if (t.json)
            return Je[t.json]
                ? Promise.resolve(Je[t.json])
                : window
                      .fetch(t.json)
                      .then((t) => t.json())
                      .then((e) => ((Je[t.json] = e), e));
        if (t.name) {
            const e = "".concat(t.name, t.version);
            return Je[e]
                ? Je[e]
                : (function (t) {
                      const e = "".concat(t.name, t.version),
                          i = new Promise((e, i) => {
                              try {
                                  window.Shopify.loadFeatures([
                                      {
                                          name: t.name,
                                          version: t.version,
                                          onLoad: (t) => {
                                              !(function (t, e, i) {
                                                  i ? e(i) : t();
                                              })(e, i, t);
                                          },
                                      },
                                  ]);
                              } catch (t) {
                                  i(t);
                              }
                          });
                      return (Je[e] = i), i;
                  })(t);
        }
        return Promise.reject();
    }
    (window.isYoutubeAPILoaded = !1), (window.isVimeoAPILoaded = !1);
    const ti = "[data-video-id]",
        ei = "loaded",
        ii = "data-enable-sound",
        si = "data-enable-background",
        oi = "data-enable-autoplay",
        ni = "data-enable-loop",
        ri = "data-video-id",
        ai = "data-video-type";
    const li = {
            videoIframe: "[data-video-id]",
            videoWrapper: ".video-wrapper",
            youtubeWrapper: "[data-youtube-wrapper]",
        },
        ci = "data-section-id",
        hi = "data-enable-sound",
        di = "data-check-player-visibility",
        ui = "data-video-id",
        pi = "data-video-type",
        mi = "loaded",
        gi = [];
    const fi = "[data-notification-form]",
        yi = "[data-notification]",
        vi = "[data-popup-close]",
        bi = "pswp--success",
        wi = "notification-popup-visible";
    function Si(t) {
        const i = e.data(t);
        i &&
            (i.on("dragStart", (t, e) => {
                document.ontouchmove = function (t) {
                    t.preventDefault();
                };
            }),
            i.on("dragEnd", (t, e) => {
                document.ontouchmove = function (t) {
                    return !0;
                };
            }));
    }
    const Ei = "html5",
        Li = "youtube",
        ki = "vimeo",
        Ai = "[data-deferred-media]",
        Ci = "[data-deferred-media-button]",
        qi = "[data-product-single-media-wrapper]",
        Ti = "[data-video]",
        Pi = ".media--hidden",
        xi = "media--hidden",
        Ii = "loaded",
        Hi = "data-section-id",
        Fi = "data-autoplay-video",
        Mi = "data-media-id";
    let Di = class {
        init() {
            this.container.querySelectorAll(Ti).forEach((t) => {
                const e = t.querySelector(Ci);
                e && e.addEventListener("click", this.loadContent.bind(this, t)),
                    this.autoplayVideo && this.loadContent(t);
            });
        }
        loadContent(t) {
            if (t.querySelector(Ai).getAttribute(Ii)) return;
            const e = document.createElement("div");
            e.appendChild(t.querySelector("template").content.firstElementChild.cloneNode(!0));
            const i = t.dataset.mediaId,
                s = e.querySelector("video, iframe"),
                o = this.hostFromVideoElement(s),
                n = t.querySelector(Ai);
            n.appendChild(s),
                n.setAttribute("loaded", !0),
                (this.players[i] = {
                    mediaId: i,
                    sectionId: this.id,
                    container: t,
                    element: s,
                    host: o,
                    ready: () => {
                        this.createPlayer(i);
                    },
                });
            const r = this.players[i];
            switch (r.host) {
                case Ei:
                    this.loadVideo(r, Ei);
                    break;
                case ki:
                    window.isVimeoAPILoaded
                        ? this.loadVideo(r, ki)
                        : Ze({ url: "https://player.vimeo.com/api/player.js" }).then(() => this.loadVideo(r, ki));
                    break;
                case Li:
                    window.isYoutubeAPILoaded
                        ? this.loadVideo(r, Li)
                        : Ze({ url: "https://www.youtube.com/iframe_api" }).then(() => this.loadVideo(r, Li));
            }
        }
        hostFromVideoElement(t) {
            if ("VIDEO" === t.tagName) return Ei;
            if ("IFRAME" === t.tagName) {
                if (/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(t.src))
                    return Li;
                if (t.src.includes("vimeo.com")) return ki;
            }
            return null;
        }
        loadVideo(t, e) {
            t.host === e && t.ready();
        }
        createPlayer(t) {
            const e = this.players[t];
            switch (e.host) {
                case Ei:
                    e.element.addEventListener("play", () => {
                        e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
                    }),
                        e.element.addEventListener("pause", () => {
                            e.container.dispatchEvent(new CustomEvent("theme:media:pause"), { bubbles: !0 });
                        }),
                        this.autoplayVideo && this.observeVideo(e, t);
                    break;
                case ki:
                    (e.player = new Vimeo.Player(e.element)),
                        e.player.play(),
                        e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 }),
                        (window.isVimeoAPILoaded = !0),
                        e.player.on("play", () => {
                            e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
                        }),
                        e.player.on("pause", () => {
                            e.container.dispatchEvent(new CustomEvent("theme:media:pause"), { bubbles: !0 });
                        }),
                        this.autoplayVideo && this.observeVideo(e, t);
                    break;
                case Li:
                    if (e.host == Li && e.player) return;
                    YT.ready(() => {
                        const i = e.container.dataset.videoId;
                        (e.player = new YT.Player(e.element, {
                            videoId: i,
                            events: {
                                onReady: (t) => {
                                    t.target.playVideo(),
                                        e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
                                },
                                onStateChange: (t) => {
                                    1 == t.data &&
                                        e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 }),
                                        2 == t.data &&
                                            e.container.dispatchEvent(new CustomEvent("theme:media:pause"), {
                                                bubbles: !0,
                                            }),
                                        0 == t.data &&
                                            e.container.dispatchEvent(new CustomEvent("theme:media:pause"), {
                                                bubbles: !0,
                                            });
                                },
                            },
                        })),
                            (window.isYoutubeAPILoaded = !0),
                            this.autoplayVideo && this.observeVideo(e, t);
                    });
            }
            e.container.addEventListener("theme:media:visible", (t) => this.onVisible(t)),
                e.container.addEventListener("theme:media:hidden", (t) => this.onHidden(t)),
                e.container.addEventListener("xrLaunch", (t) => this.onHidden(t));
        }
        observeVideo(t) {
            new IntersectionObserver(
                (e, i) => {
                    e.forEach((e) => {
                        const i = 0 == e.intersectionRatio,
                            s = !t.element.closest(Pi);
                        i ? this.pauseVideo(t) : s && this.playVideo(t);
                    });
                },
                { rootMargin: "200px", threshold: [0, 0.25, 0.75, 1] }
            ).observe(t.element);
        }
        playVideo(t) {
            t.player && t.player.playVideo
                ? t.player.playVideo()
                : t.element && t.element.play
                  ? t.element.play()
                  : t.player && t.player.play && t.player.play(),
                t.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
        }
        pauseVideo(t) {
            if (t.player && t.player.pauseVideo) "1" == t.player.playerInfo.playerState && t.player.pauseVideo();
            else if (t.player && t.player.pause) t.player.pause();
            else if (t.element && !t.element.paused) {
                var e;
                if ("function" == typeof t.element.pause) null === (e = t.element) || void 0 === e || e.pause();
            }
        }
        onHidden(t) {
            if (void 0 !== t.target.dataset.mediaId) {
                const e = t.target.dataset.mediaId,
                    i = this.players[e];
                this.pauseVideo(i);
            }
        }
        onVisible(t) {
            if (void 0 !== t.target.dataset.mediaId) {
                const e = t.target.dataset.mediaId,
                    i = this.players[e];
                setTimeout(() => {
                    this.playVideo(i);
                }, 50),
                    this.pauseContainerMedia(e);
            }
        }
        pauseOtherMedia(t, e) {
            const i = `[${Mi}="${t}"]`,
                s = e.querySelectorAll(`${qi}:not(${i})`);
            s.length &&
                s.forEach((t) => {
                    t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), t.classList.add(xi);
                });
        }
        constructor(t) {
            (this.container = t),
                (this.id = this.container.getAttribute(Hi)),
                (this.autoplayVideo = "true" === this.container.getAttribute(Fi)),
                (this.players = {}),
                (this.pauseContainerMedia = (t, e = this.container) => this.pauseOtherMedia(t, e)),
                this.init();
        }
    };
    function Oi(t, e, i = [], s = !1) {
        const o = new FormData(t),
            n = new URLSearchParams(o);
        if (!e) return n.toString();
        const r = new FormData(e),
            a = new URLSearchParams(r),
            l = [];
        for (const t of o.entries()) "" === t[1] && l.push(t[0]);
        for (const t of r.entries()) "" === t[1] && l.push(t[0]);
        for (let t = 0; t < l.length; t++) {
            const e = l[t];
            n.has(e) && n.delete(e), a.has(e) && a.delete(e);
        }
        for (const t of n.keys()) a.has(t) && a.delete(t);
        if (i.length > 0)
            for (let t = 0; t < i.length; t++) {
                const e = i[t];
                n.has(e) && n.delete(e), a.has(e) && a.delete(e);
            }
        return s && (a.has("type") && a.delete("type"), n.set("type", s)), `${n.toString()}&${a.toString()}`;
    }
    const Bi = "[data-custom-scrollbar]",
        zi = "[data-custom-scrollbar-items]",
        _i = "[data-custom-scrollbar-thumb]",
        $i = ".current";
    let Ri = class {
        calculateTrack(t) {
            if (!t)
                return (
                    this.scrollbar.style.setProperty("--thumb-scale", 0),
                    void this.scrollbar.style.setProperty("--thumb-position", "0px")
                );
            const e = t.clientWidth / this.scrollbarThumb.parentElement.clientWidth,
                i = t.offsetLeft / this.scrollbarThumb.parentElement.clientWidth;
            this.scrollbar.style.setProperty("--thumb-scale", e),
                this.scrollbar.style.setProperty("--thumb-position", this.trackWidth * i + "px");
        }
        calculateScrollbar() {
            if (this.scrollbarItems.children.length) {
                const t = [...this.scrollbarItems.children];
                (this.trackWidth = 0),
                    t.forEach((t) => {
                        this.trackWidth +=
                            t.getBoundingClientRect().width + parseInt(window.getComputedStyle(t).marginRight);
                    }),
                    this.scrollbar.style.setProperty("--track-width", `${this.trackWidth}px`);
            }
        }
        onScrollbarChange(t) {
            t &&
                t.detail &&
                t.detail.element &&
                this.container.contains(t.detail.element) &&
                this.calculateTrack(t.detail.element);
        }
        events() {
            document.addEventListener("theme:resize:width", this.calcScrollbarEvent),
                document.addEventListener("theme:custom-scrollbar:change", this.onScrollbarChangeEvent);
        }
        unload() {
            document.removeEventListener("theme:resize:width", this.calcScrollbarEvent),
                document.removeEventListener("theme:custom-scrollbar:change", this.onScrollbarChangeEvent);
        }
        constructor(t) {
            (this.container = t),
                (this.scrollbarItems = t.querySelector(zi)),
                (this.scrollbar = t.querySelector(Bi)),
                (this.scrollbarThumb = t.querySelector(_i)),
                (this.trackWidth = 0),
                (this.calcScrollbarEvent = () => this.calculateScrollbar()),
                (this.onScrollbarChangeEvent = (t) => this.onScrollbarChange(t)),
                this.scrollbar &&
                    this.scrollbarItems &&
                    (this.events(),
                    this.calculateScrollbar(),
                    this.scrollbarItems.children.length && this.calculateTrack(this.scrollbarItems.querySelector($i)));
        }
    };
    const Vi = "[data-tooltip]",
        Ni = "[data-tooltip-container]",
        Wi = "[data-tooltip-arrow]",
        Ui = "[data-aos]",
        ji = "tooltip-default",
        Gi = "is-animating",
        Ki = "is-visible",
        Qi = "is-hiding",
        Xi = "data-aos",
        Yi = "data-tooltip",
        Ji = "data-tooltip-container",
        Zi = "data-tooltip-stop-mouseenter",
        ts = {};
    let es = class {
        init() {
            if (!document.querySelector(Ni)) {
                const t = `<div class="${this.rootClass}__inner"><div class="${this.rootClass}__arrow" data-tooltip-arrow></div><div class="${this.rootClass}__text label-typography"></div></div>`,
                    e = document.createElement("div");
                (e.className = `${this.rootClass} ${this.isAnimatingClass}`),
                    e.setAttribute(Ji, ""),
                    (e.innerHTML = t),
                    document.body.appendChild(e);
            }
            this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent),
                this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent),
                this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent),
                document.addEventListener("theme:tooltip:close", this.removePinEvent);
            const t = document.querySelector(Ni);
            theme.settings.animationsEnabled &&
                this.animatedContainer &&
                ("hero" === this.animatedContainer.getAttribute(Xi)
                    ? this.animatedContainer.addEventListener("animationend", () => {
                          t.classList.remove(Gi);
                      })
                    : this.animatedContainer.addEventListener("transitionend", (e) => {
                          "transform" === e.propertyName && t.classList.remove(Gi);
                      }));
        }
        addPin(t = !1) {
            const e = document.querySelector(Ni),
                i = e.querySelector(Wi);
            if (e && ((t && !this.tooltip.hasAttribute(Zi)) || !t)) {
                const t = e.querySelector(`.${this.rootClass}__inner`);
                e.querySelector(`.${this.rootClass}__text`).textContent = this.label;
                const s = t.offsetWidth,
                    o = this.tooltip.getBoundingClientRect(),
                    n = o.top,
                    r = o.width,
                    a = n + o.height + window.scrollY;
                let l = o.left - s / 2 + r / 2,
                    c = "50%";
                const h = l + s - window.innerWidth;
                h > 0 && (l -= h),
                    l < 0 && ((c = `calc(50% + ${l}px)`), (l = 0)),
                    (i.style.left = c),
                    (e.style.transform = `translate(${l}px, ${a}px)`),
                    e.classList.remove(Qi);
                const d = (i) => {
                    i.target === t &&
                        (("transform" !== i.propertyName && "opacity" !== i.propertyName) ||
                            requestAnimationFrame(() => (e.style.transform = "translate(0, -100%)")),
                        e.removeEventListener("transitionend", d));
                };
                e.addEventListener("transitionend", d),
                    e.classList.add(Ki),
                    document.addEventListener("theme:scroll", this.removePinEvent);
            }
        }
        removePin(t, e = !1, i = !1) {
            const s = document.querySelector(Ni),
                o = s.classList.contains(Ki);
            s &&
                ((e && !this.tooltip.hasAttribute(Zi)) || !e) &&
                (o &&
                    (i || t.detail.hideTransition) &&
                    (s.classList.add(Qi),
                    this.hideTransitionTimeout && clearTimeout(this.hideTransitionTimeout),
                    (this.hideTransitionTimeout = setTimeout(() => {
                        s.classList.remove(Qi);
                    }, this.transitionSpeed))),
                s.classList.remove(Ki),
                document.removeEventListener("theme:scroll", this.removePinEvent));
        }
        unload() {
            this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent),
                this.tooltip.removeEventListener("mouseleave", this.removePinMouseEvent),
                this.tooltip.removeEventListener("theme:tooltip:init", this.addPinEvent),
                document.removeEventListener("theme:tooltip:close", this.removePinEvent),
                document.removeEventListener("theme:scroll", this.removePinEvent);
        }
        constructor(t) {
            (this.tooltip = t),
                this.tooltip.hasAttribute(Yi) &&
                    ((this.rootClass = ji),
                    (this.isAnimatingClass = Gi),
                    (this.label = this.tooltip.getAttribute(Yi)),
                    (this.transitionSpeed = 200),
                    (this.hideTransitionTimeout = 0),
                    (this.animatedContainer = this.tooltip.closest(Ui)),
                    (this.addPinEvent = () => this.addPin()),
                    (this.addPinMouseEvent = () => this.addPin(!0)),
                    (this.removePinEvent = (t) => Pe(this.removePin(t), 50)),
                    (this.removePinMouseEvent = (t) => this.removePin(t, !0, !0)),
                    this.init());
        }
    };
    const is = {
            onLoad() {
                ts[this.id] = [];
                this.container.querySelectorAll(Vi).forEach((t) => {
                    ts[this.id].push(new es(t));
                });
            },
            onUnload() {
                ts[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        ss = "[data-range-slider]",
        os = "[data-range-left]",
        ns = "[data-range-right]",
        rs = "[data-range-line]",
        as = "[data-range-holder]",
        ls = "data-se-min",
        cs = "data-se-max",
        hs = "data-se-min-value",
        ds = "data-se-max-value",
        us = "data-se-step",
        ps = "data-range-filter-update",
        ms = "[data-field-price-min]",
        gs = "[data-field-price-max]",
        fs = "is-initialized";
    function ys() {
        this.entries = [];
    }
    function vs(t, e) {
        bs(t);
        var i = (function (t, e) {
            bs(t),
                (function (t) {
                    if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
                    if (0 === t.length) throw new Error(t + " is empty.");
                    if (!t[0].hasOwnProperty("name")) throw new Error(t[0] + "does not contain name key.");
                    if ("string" != typeof t[0].name)
                        throw new TypeError(
                            "Invalid value type passed for name of option " + t[0].name + ". Value should be string."
                        );
                })(e);
            var i = [];
            return (
                e.forEach(function (e) {
                    for (var s = 0; s < t.options.length; s++) {
                        if ((t.options[s].name || t.options[s]).toLowerCase() === e.name.toLowerCase()) {
                            i[s] = e.value;
                            break;
                        }
                    }
                }),
                i
            );
        })(t, e);
        return (function (t, e) {
            bs(t),
                (function (t) {
                    if (Array.isArray(t) && "object" == typeof t[0])
                        throw new Error(t + "is not a valid array of options.");
                })(e);
            var i = t.variants.filter(function (t) {
                return e.every(function (e, i) {
                    return t.options[i] === e;
                });
            });
            return i[0] || null;
        })(t, i);
    }
    function bs(t) {
        if ("object" != typeof t) throw new TypeError(t + " is not an object.");
        if (0 === Object.keys(t).length && t.constructor === Object) throw new Error(t + " is empty.");
    }
    (ys.prototype.add = function (t, e, i) {
        this.entries.push({ element: t, event: e, fn: i }), t.addEventListener(e, i);
    }),
        (ys.prototype.removeAll = function () {
            this.entries = this.entries.filter(function (t) {
                return t.element.removeEventListener(t.event, t.fn), !1;
            });
        });
    var ws = '[name="id"]',
        Ss = '[name="selling_plan"]',
        Es = '[name^="options"]',
        Ls = '[name="quantity"]',
        ks = '[name^="properties"]';
    const As = { color: "ash" },
        Cs = "[data-swatch]",
        qs = "[data-product-block]",
        Ts = "[data-product-image-hover]",
        Ps = "[data-button-quick-view]",
        xs = "[data-grid-image]",
        Is = "[data-grid-link]",
        Hs = "[data-swatches-more]",
        Fs = "[data-section-type]",
        Ms = "[data-swatches-container]",
        Ds = "[data-swatches-label]",
        Os = "[data-swatches-button]",
        Bs = "[data-option-position]",
        zs = "[data-slider]",
        _s = ".variant__labels--hide",
        $s = {
            mediaVisible: "product__media--featured-visible",
            mediaHoverVisible: "product__media__hover-img--visible",
            noImage: "swatch__link--no-image",
            noOutline: "no-outline",
            isVisible: "is-visible",
            selectorLarge: "selector-wrapper--large",
        },
        Rs = "data-swatch",
        Vs = "data-swatch-handle",
        Ns = "data-swatch-label",
        Ws = "data-swatch-image",
        Us = "data-swatch-image-id",
        js = "data-swatch-variant",
        Gs = "data-variant-id",
        Ks = "data-variant-secondary-id";
    let Qs = {};
    const Xs = {};
    let Ys = class {
            init() {
                this.setStyles(),
                    this.variant && this.outer && this.handleClicks(),
                    !this.image && this.swatchLink && this.swatchLink.classList.add($s.noImage);
            }
            setStyles() {
                "native" == window.theme.settings.colorSwatchesType ||
                    (this.colorMatch &&
                        this.colorMatch.hex &&
                        this.element.style.setProperty("--swatch", `${this.colorMatch.hex}`),
                    this.colorMatch &&
                        this.colorMatch.path &&
                        this.element.style.setProperty("background-image", `url(${this.colorMatch.path})`));
            }
            handleClicks() {
                this.swatchLink.addEventListener("click", (t) => {
                    const e = !document.body.classList.contains($s.noOutline),
                        i = this.swatchLink.getAttribute(js);
                    e || (t.preventDefault(), this.updateImagesAndLinksOnEvent(i));
                }),
                    this.swatchLink.addEventListener("keyup", (t) => {
                        const e = !document.body.classList.contains($s.noOutline),
                            i = this.swatchLink.getAttribute(js);
                        (t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.NUMPADENTER) ||
                            e ||
                            (t.preventDefault(),
                            this.swatchLink.dispatchEvent(new Event("mouseenter", { bubbles: !0 })),
                            this.updateImagesAndLinksOnEvent(i));
                    });
            }
            updateImagesAndLinksOnEvent(t) {
                this.updateLinks(), this.replaceImages(t);
            }
            updateLinks() {
                (this.linkElements = this.outer.querySelectorAll(Is)),
                    (this.quickView = this.outer.querySelector(Ps)),
                    this.linkElements.length &&
                        this.linkElements.forEach((t) => {
                            const e =
                                ((i = t.getAttribute("href")),
                                (s = this.variant),
                                /variant=/.test(i)
                                    ? i.replace(/(variant=)[^&]+/, "$1" + s)
                                    : /\?/.test(i)
                                      ? i.concat("&variant=").concat(s)
                                      : i.concat("?variant=").concat(s));
                            var i, s;
                            t.setAttribute("href", e);
                        }),
                    this.quickView &&
                        "quick_buy" === theme.settings.quickBuy &&
                        this.quickView.setAttribute(Gs, this.variant);
            }
            replaceImages(t) {
                const e = this.outer.querySelector(`[${Ks}="${t}"]`),
                    i = this.outer.querySelector(`[${Gs}="${t}"]`),
                    s = [...this.outer.querySelectorAll(xs)].find((t) => t.classList.contains($s.mediaVisible));
                if (i && this.imageId) {
                    if (!e || !s) return;
                    const t = () => {
                        requestAnimationFrame(() => {
                            s.classList.remove($s.mediaVisible),
                                i.classList.add($s.mediaVisible),
                                requestAnimationFrame(() => {
                                    e.classList.remove($s.mediaVisible);
                                });
                        }),
                            e.removeEventListener("animationend", t);
                    };
                    requestAnimationFrame(() => {
                        e.classList.add($s.mediaVisible);
                    }),
                        e.addEventListener("animationend", t);
                }
                "image" === theme.settings.productGridHover && (this.hoverImages = this.outer.querySelectorAll(Ts)),
                    this.hoverImages.length > 1 &&
                        this.hoverImages.forEach((t) => {
                            t.classList.remove($s.mediaHoverVisible),
                                t.getAttribute(Gs) === this.variant
                                    ? t.classList.add($s.mediaHoverVisible)
                                    : this.hoverImages[0].classList.add($s.mediaHoverVisible);
                        });
            }
            constructor(t) {
                (this.element = t),
                    (this.swatchLink = this.element.nextElementSibling),
                    (this.colorString = t.getAttribute(Rs)),
                    (this.image = this.element.getAttribute(Ws)),
                    (this.imageId = this.element.getAttribute(Us)),
                    (this.variant = this.element.getAttribute(js)),
                    (this.outer = this.element.closest(qs)),
                    (this.hoverImages = []);
                const e = new (class {
                    getColor() {
                        return this.match;
                    }
                    init() {
                        return Ze({ json: theme.assets.swatches })
                            .then((t) => this.matchColors(t, this.settings.color))
                            .catch((t) => {
                                console.log("failed to load swatch colors script"), console.log(t);
                            });
                    }
                    matchColors(t, e) {
                        let i = "#E5E5E5",
                            s = null;
                        const o = theme.assets.base || "/",
                            n = e.toLowerCase().replace(/\s/g, ""),
                            r = t.colors;
                        if (r) {
                            let t = null;
                            if (
                                r.filter((e, i) => {
                                    if (Object.keys(e).toString().toLowerCase().replace(/\s/g, "") === n)
                                        return (t = i), e;
                                }).length &&
                                null !== t
                            ) {
                                const e = Object.values(r[t])[0];
                                (i = e),
                                    (e.includes(".jpg") ||
                                        e.includes(".jpeg") ||
                                        e.includes(".png") ||
                                        e.includes(".svg")) &&
                                        ((s = `${o}${e}`), (i = "#888888"));
                            }
                        }
                        return { color: this.settings.color, path: s, hex: i };
                    }
                    constructor(t = {}) {
                        (this.settings = { ...As, ...t }), (this.match = this.init());
                    }
                })({ color: this.colorString });
                e.getColor().then((t) => {
                    (this.colorMatch = t), this.init();
                });
            }
        },
        Js = class extends HTMLElement {
            init() {
                (this.swatchElements = this.querySelectorAll(Cs)),
                    this.swatchElements.forEach((t) => {
                        new Ys(t);
                    }),
                    this.handleShowMore();
            }
            handleShowMore() {
                (this.initialHeight = this.offsetHeight), (this.expandedHeight = this.initialHeight);
                const t = this.closest(Fs),
                    e = this.querySelector(Hs);
                e &&
                    (null == e ||
                        e.addEventListener("click", () => {
                            this.classList.add($s.isVisible);
                        }),
                    null == t ||
                        t.addEventListener("touchstart", (t) => {
                            this.contains(t.target) ||
                                (this.classList.remove($s.isVisible),
                                this.dispatchEvent(new Event("mouseleave", { bubbles: !0 })));
                        }),
                    this.addEventListener("mouseenter", () => {
                        const t = (e) => {
                            this.expandedHeight = this.offsetHeight;
                            const i = e.target.closest(zs);
                            this.expandedHeight > this.initialHeight &&
                                i &&
                                requestAnimationFrame(() =>
                                    i.dispatchEvent(new CustomEvent("theme:slider:resize", { bubbles: !1 }))
                                ),
                                this.removeEventListener("animationstart", t);
                        };
                        this.addEventListener("animationstart", t);
                    }),
                    this.addEventListener("mouseleave", () => {
                        const t = (e) => {
                            const i = e.target.closest(zs);
                            this.expandedHeight > this.initialHeight &&
                                i &&
                                requestAnimationFrame(() =>
                                    i.dispatchEvent(new CustomEvent("theme:slider:resize", { bubbles: !1 }))
                                ),
                                this.removeEventListener("animationstart", t);
                        };
                        this.addEventListener("animationstart", t);
                    }));
            }
            constructor() {
                super(),
                    (this.handle = this.getAttribute(Vs)),
                    (this.label = this.getAttribute(Ns).trim().toLowerCase()),
                    (function (t) {
                        const e = `${theme.routes.root}products/${t}.js`;
                        return window
                            .fetch(e)
                            .then((t) => t.json())
                            .catch((t) => {
                                console.error(t);
                            });
                    })(this.handle).then((t) => {
                        (this.product = t),
                            (this.colorOption = t.options.find((t) => t.name.toLowerCase() === this.label || null)),
                            this.colorOption && ((this.swatches = this.colorOption.values), this.init());
                    });
            }
        },
        Zs = class {
            checkSwatchesHeight(t) {
                const e = t.querySelector(Ds),
                    i = Boolean(e.closest(_s)),
                    s = i ? 1 : e.offsetHeight,
                    o = t.querySelector(Os),
                    n = parseInt(window.getComputedStyle(t).getPropertyValue("padding-top")),
                    r = i ? 0 : parseInt(window.getComputedStyle(e).getPropertyValue("margin-bottom")),
                    a = parseInt(window.getComputedStyle(o).getPropertyValue("margin-bottom")),
                    l = t.closest(Bs);
                l.classList.remove($s.selectorLarge, $s.selectorVisible),
                    t.style.removeProperty("--swatches-max-height"),
                    requestAnimationFrame(() => {
                        t.offsetHeight - n > s + r + 2 * o.offsetHeight + 2 * a &&
                            (t.style.setProperty("--swatches-max-height", `${t.offsetHeight}px`),
                            l.classList.add($s.selectorLarge));
                    });
            }
            onUnload() {
                this.swatchesContainers.forEach((t) => {
                    document.removeEventListener("theme:resize:width", this.checkSwatchesHeightOnResize);
                });
            }
            constructor(t) {
                (this.container = t),
                    (this.swatchesContainers = this.container.querySelectorAll(Ms)),
                    this.swatchesContainers.forEach((t) => {
                        (this.checkSwatchesHeightOnResize = () => this.checkSwatchesHeight(t)),
                            this.checkSwatchesHeight(t),
                            document.addEventListener("theme:resize:width", this.checkSwatchesHeightOnResize);
                    });
            }
        };
    const to = (t) => {
            Qs = [];
            t.querySelectorAll(Cs).forEach((t) => {
                Qs.push(new Ys(t));
            });
        },
        eo = {
            onLoad() {
                to(this.container);
            },
        },
        io = {
            onLoad() {
                Xs[this.id] = new Zs(this.container);
            },
            onUnload() {
                Xs[this.id].onUnload();
            },
        },
        so = "[data-slider]",
        oo = "[data-product-media-container]",
        no = "[data-product-media-slideshow]",
        ro = "[data-product-media-slideshow-slide]",
        ao = "[data-product-slideshow-progress]",
        lo = ".flickity-button",
        co = "[data-product]",
        ho = "[data-popup-close]",
        uo = "fill",
        po = "js-quick-view-visible",
        mo = {};
    let go = class {
        productGridSlideshow() {
            const t = this.container.querySelectorAll(no),
                i = this.container.querySelectorAll(oo);
            t.length &&
                t.forEach((t) => {
                    const i = t.closest(oo),
                        s = i.querySelector(ao),
                        o = t.querySelectorAll(ro).length,
                        n = 2200,
                        r = !this.sliders.length;
                    let a = new e.data(t),
                        l = 0,
                        c = ro;
                    !a.isActive &&
                        o > 1 &&
                        ((a = new e(t, {
                            draggable: r,
                            cellSelector: c,
                            contain: !0,
                            wrapAround: !0,
                            imagesLoaded: !0,
                            pageDots: !1,
                            prevNextButtons: !1,
                            adaptiveHeight: !1,
                            pauseAutoPlayOnHover: !1,
                            selectedAttraction: 0.2,
                            friction: 1,
                            on: {
                                ready: () => {
                                    this.container.style.setProperty("--autoplay-speed", "2200ms");
                                },
                                change: () => {
                                    l && clearTimeout(l),
                                        s.classList.remove(uo),
                                        s.offsetWidth,
                                        requestAnimationFrame(() => {
                                            s.classList.add(uo);
                                        }),
                                        (l = setTimeout(() => {
                                            s.classList.remove(uo);
                                        }, n));
                                },
                                dragEnd: () => {
                                    a.playPlayer();
                                },
                            },
                        })),
                        window.theme.touch ||
                            (i.addEventListener("mouseenter", () => {
                                s.classList.add(uo),
                                    l && clearTimeout(l),
                                    (l = setTimeout(() => {
                                        s.classList.remove(uo);
                                    }, n)),
                                    (a.options.autoPlay = n),
                                    a.playPlayer();
                            }),
                            i.addEventListener("mouseleave", () => {
                                a.stopPlayer(), l && clearTimeout(l), s.classList.remove(uo);
                            })));
                }),
                i.length &&
                    i.forEach((t) => {
                        t.addEventListener("click", (t) => {
                            t.target.matches(lo) && t.preventDefault();
                        });
                    });
        }
        popupClose() {
            const t = document.querySelector(co);
            if (t) {
                t.querySelector(ho).dispatchEvent(new Event("click"));
            }
        }
        onBlockSelect() {
            this.body.classList.contains(po) && this.popupClose();
        }
        onDeselect() {
            this.body.classList.contains(po) && this.popupClose();
        }
        onUnload() {
            this.body.classList.contains(po) && this.popupClose();
        }
        constructor(t) {
            (this.container = t),
                (this.body = document.body),
                (this.sliders = this.container.querySelectorAll(so)),
                "slideshow" !== theme.settings.productGridHover || window.theme.touch || this.productGridSlideshow(),
                new Zc(this.container);
        }
    };
    const fo = {
            onLoad() {
                mo[this.id] = new go(this.container);
            },
            onBlockSelect() {
                mo[this.id].onBlockSelect();
            },
            onDeselect() {
                mo[this.id].onDeselect();
            },
            onUnload() {
                mo[this.id].onUnload();
            },
        },
        yo = "#AjaxinateLoop",
        vo = "#AjaxinatePagination",
        bo = "[data-product-block]",
        wo = "[data-promo]",
        So = "data-ajaxinate-id",
        Eo = "data-columns-tablet",
        Lo = "data-columns-mobile",
        ko = "is-loaded",
        Ao = "loaded-item",
        Co = "collection-promo--full",
        qo = "collection-promo--two-columns",
        To = "collection-promo--grid-second",
        Po = "collection-promo--grid-third",
        xo = "collection-promo--grid-even",
        Io = "collection-promo--one-column";
    let Ho = {},
        Fo = class {
            init() {
                this.loadMoreFix(),
                    (this.ajaxinateContainer = this.container.querySelectorAll(yo)),
                    this.ajaxinateContainer.forEach((t) => {
                        const e = `${yo}[${So}="${t.dataset.ajaxinateId}"]`,
                            i = `${vo}[${So}="${t.dataset.ajaxinateId}"]`;
                        if (t.children.length > 0) {
                            const o = new s({ container: e, pagination: i, method: "scroll" }),
                                n = t.querySelectorAll(wo),
                                r = Number(t.getAttribute(Eo)),
                                a = Number(t.getAttribute(Lo));
                            if (r >= 3) {
                                let e = 0;
                                if (
                                    (n.forEach((t) => {
                                        t.classList.contains(Co)
                                            ? t.classList.contains(Po)
                                                ? (e += 1)
                                                : t.classList.contains(To)
                                                  ? (e += 2)
                                                  : (e += 3)
                                            : t.classList.contains(qo)
                                              ? t.classList.contains(Po)
                                                  ? (e += 1)
                                                  : (e += 2)
                                              : (e += 1);
                                    }),
                                    e > 0)
                                ) {
                                    let i = r - (e % r);
                                    i === r && (i = 0), t.classList.add(`grid--empty-items-tablet-${i}`);
                                }
                            }
                            if (2 === a) {
                                let e = 0;
                                if (
                                    (n.forEach((t) => {
                                        (t.classList.contains(xo) || t.classList.contains(Io)) && (e += 1);
                                    }),
                                    e > 0)
                                ) {
                                    let i = a - (e % a);
                                    i === a && (i = 0), t.classList.add(`grid--empty-items-mobile-${i}`);
                                }
                            }
                            t.classList.add(ko), this.endlessScroll.push(o);
                        }
                    });
            }
            update(t) {
                this.ajaxinateContainer = this.container.querySelectorAll(yo);
                const e = (e) => e.settings.container === t,
                    i = this.endlessScroll.find(e);
                if (i) {
                    const t = this.endlessScroll.findIndex(e);
                    this.endlessScroll.splice(t, 1), (i.settings.method = "scroll"), i.destroy();
                }
                const o = [...this.ajaxinateContainer].find((e) => `${yo}[${So}="${e.dataset.ajaxinateId}"]` === t);
                if (!o) return;
                const n = `${yo}[${So}="${o.dataset.ajaxinateId}"]`,
                    r = `${vo}[${So}="${o.dataset.ajaxinateId}"]`;
                if (!(o.children.length > 0)) return;
                const a = new s({ container: n, pagination: r, method: "scroll" });
                o.classList.add(ko), this.endlessScroll.push(a);
            }
            loadMoreFix() {
                s.prototype.loadMore = function () {
                    (this.request = new XMLHttpRequest()),
                        (this.request.onreadystatechange = function () {
                            if (!this.request.responseXML) return;
                            if (4 === !this.request.readyState || 200 === !this.request.status) return;
                            const t = this.request.responseXML.querySelector(this.settings.container),
                                e = this.request.responseXML.querySelector(this.settings.pagination);
                            t.querySelectorAll(bo).forEach((t) => t.classList.add(Ao)),
                                this.containerElement.insertAdjacentHTML("beforeend", t.innerHTML),
                                null == e
                                    ? this.removePaginationElement()
                                    : ((this.paginationElement.innerHTML = e.innerHTML),
                                      this.settings.callback &&
                                          "function" == typeof this.settings.callback &&
                                          this.settings.callback(this.request.responseXML),
                                      this.initialize());
                        }.bind(this)),
                        this.request.open("GET", this.nextPageUrl, !0),
                        (this.request.responseType = "document"),
                        this.request.send();
                };
            }
            unload() {
                this.endlessScroll.length > 0 &&
                    (this.endlessScroll.forEach((t) => {
                        (t.settings.method = "scroll"), t.destroy();
                    }),
                    this.ajaxinateContainer.forEach((t) => t.classList.remove(ko)));
            }
            constructor(t) {
                (this.container = t), (this.endlessScroll = []), theme.settings.enableInfinityScroll && this.init();
            }
        };
    const Mo = {
            onLoad() {
                Ho = new Fo(this.container);
            },
            onUnload: function () {
                "function" == typeof Ho.unload && Ho.unload();
            },
        },
        Do = 300,
        Oo = "[data-toggle-filters]",
        Bo = "[data-close-filters]",
        zo = "[data-open-filters]",
        _o = "[data-collection-wrapper]",
        $o = "[data-collapsible-trigger]",
        Ro = "[data-sort-toggle]",
        Vo = "[data-collection-sort-options]",
        No = "[data-input-sort]",
        Wo = "[data-collection-filters]",
        Uo = "[data-collection-filters-list]",
        jo = "[data-collection-sticky-bar]",
        Go = "[data-collection-filter]",
        Ko = "[data-collection-filter-tag]",
        Qo = "[data-collection-filter-tag-button]",
        Xo = "[data-collection-filters-form]",
        Yo = "[data-filter-reset-button]",
        Jo = "[data-filter-tag-reset-button]",
        Zo = '[data-section-type="popups"]',
        tn = "[data-collection-products]",
        en = "[data-products-count]",
        sn = "[data-field-price-min]",
        on = "[data-field-price-max]",
        nn = "[data-se-min-value]",
        rn = "[data-se-max-value]",
        an = "data-se-min-value",
        ln = "data-se-max-value",
        cn = "data-se-min",
        hn = "data-se-max",
        dn = "[data-tooltip]",
        un = "[data-tooltip-container]",
        pn = "[data-show-more]",
        mn = "[data-show-more-actions]",
        gn = "[data-show-more-container]",
        fn = "[data-show-more-trigger]",
        yn = "[data-search-performed]",
        vn = "[data-search-form]",
        bn = "[data-custom-scrollbar]",
        wn = "is-active",
        Sn = "is-expanded",
        En = "is-visible",
        Ln = "is-loading",
        kn = "popup--visible",
        An = "collection__filters--visible",
        Cn = "collection__sort__option-wrapper--visible",
        qn = "data-filter-active",
        Tn = "data-prevent-scroll-lock",
        Pn = "data-filters-default-state",
        xn = "tabindex",
        In = "aria-expanded",
        Hn = "data-current-type",
        Fn = {};
    let Mn = class {
        initFacetedFilters() {
            "tag" != this.filterMode &&
                "group" != this.filterMode &&
                this.enableFilters &&
                (this.rangeSlider = new (class {
                    init() {
                        if (((this.slider = this.container.querySelector(ss)), !this.slider)) return;
                        (this.resizeFilters = o(this.reset.bind(this), 50)),
                            (this.onMoveEvent = (t) => this.onMove(t)),
                            (this.onStopEvent = (t) => this.onStop(t)),
                            (this.onStartEvent = (t) => this.onStart(t)),
                            (this.startX = 0),
                            (this.x = 0),
                            (this.touchLeft = this.slider.querySelector(os)),
                            (this.touchRight = this.slider.querySelector(ns)),
                            (this.lineSpan = this.slider.querySelector(rs)),
                            (this.min = parseFloat(this.slider.getAttribute(ls))),
                            (this.max = parseFloat(this.slider.getAttribute(cs))),
                            (this.step = 0),
                            (this.normalizeFact = 20);
                        let t = this.min;
                        this.slider.hasAttribute(hs) && (t = parseFloat(this.slider.getAttribute(hs)));
                        let e = this.max;
                        this.slider.hasAttribute(ds) && (e = parseFloat(this.slider.getAttribute(ds))),
                            t < this.min && (t = this.min),
                            e > this.max && (e = this.max),
                            t > e && (t = e),
                            this.slider.getAttribute(us) &&
                                (this.step = Math.abs(parseFloat(this.slider.getAttribute(us)))),
                            this.reset(),
                            window.addEventListener("theme:resize", this.resizeFilters),
                            (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
                            (this.selectedTouch = null),
                            (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
                            this.setMinValue(t),
                            this.setMaxValue(e),
                            this.touchLeft.addEventListener("mousedown", this.onStartEvent),
                            this.touchRight.addEventListener("mousedown", this.onStartEvent),
                            this.touchLeft.addEventListener("touchstart", this.onStartEvent, { passive: !0 }),
                            this.touchRight.addEventListener("touchstart", this.onStartEvent, { passive: !0 }),
                            this.slider.classList.add(fs);
                    }
                    reset() {
                        (this.touchLeft.style.left = "0px"),
                            (this.touchRight.style.left = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                            (this.lineSpan.style.marginLeft = "0px"),
                            (this.lineSpan.style.width = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                            (this.startX = 0),
                            (this.x = 0),
                            (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
                            (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact);
                    }
                    setMinValue(t) {
                        const e = (t - this.min) / (this.max - this.min);
                        (this.touchLeft.style.left =
                            Math.ceil(
                                e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))
                            ) + "px"),
                            (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                            (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                            this.slider.setAttribute(hs, t);
                    }
                    setMaxValue(t) {
                        const e = (t - this.min) / (this.max - this.min);
                        (this.touchRight.style.left =
                            Math.ceil(
                                e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) +
                                    this.normalizeFact
                            ) + "px"),
                            (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                            (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                            this.slider.setAttribute(ds, t);
                    }
                    onStart(t) {
                        t.preventDefault();
                        let e = t;
                        t.touches && (e = t.touches[0]),
                            t.currentTarget === this.touchLeft
                                ? (this.x = this.touchLeft.offsetLeft)
                                : t.currentTarget === this.touchRight && (this.x = this.touchRight.offsetLeft),
                            (this.startX = e.pageX - this.x),
                            (this.selectedTouch = t.currentTarget),
                            document.addEventListener("mousemove", this.onMoveEvent),
                            document.addEventListener("mouseup", this.onStopEvent),
                            document.addEventListener("touchmove", this.onMoveEvent, { passive: !0 }),
                            document.addEventListener("touchend", this.onStopEvent, { passive: !0 });
                    }
                    onMove(t) {
                        let e = t;
                        t.touches && (e = t.touches[0]),
                            (this.x = e.pageX - this.startX),
                            this.selectedTouch === this.touchLeft
                                ? (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10
                                      ? (this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10)
                                      : this.x < 0 && (this.x = 0),
                                  (this.selectedTouch.style.left = this.x + "px"))
                                : this.selectedTouch === this.touchRight &&
                                  (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10
                                      ? (this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10)
                                      : this.x > this.maxX && (this.x = this.maxX),
                                  (this.selectedTouch.style.left = this.x + "px")),
                            (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                            (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                            this.calculateValue(),
                            this.slider.getAttribute("on-change") &&
                                new Function("min, max", this.slider.getAttribute("on-change"))(
                                    this.slider.getAttribute(hs),
                                    this.slider.getAttribute(ds)
                                ),
                            this.onChange(this.slider.getAttribute(hs), this.slider.getAttribute(ds));
                    }
                    onStop(t) {
                        document.removeEventListener("mousemove", this.onMoveEvent),
                            document.removeEventListener("mouseup", this.onStopEvent),
                            document.removeEventListener("touchmove", this.onMoveEvent, { passive: !0 }),
                            document.removeEventListener("touchend", this.onStopEvent, { passive: !0 }),
                            (this.selectedTouch = null),
                            this.calculateValue(),
                            this.onChanged(this.slider.getAttribute(hs), this.slider.getAttribute(ds));
                    }
                    onChange(t, e) {
                        const i = this.slider.closest(as);
                        if (i) {
                            const s = i.querySelector(ms),
                                o = i.querySelector(gs);
                            s && o && ((s.value = parseInt(t)), (o.value = parseInt(e)));
                        }
                    }
                    onChanged(t, e) {
                        this.slider.hasAttribute(ps) &&
                            this.slider.dispatchEvent(new CustomEvent("theme:filter:range-update", { bubbles: !0 }));
                    }
                    calculateValue() {
                        const t = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
                        let e = this.lineSpan.offsetLeft / this.initialValue,
                            i = e + t;
                        if (
                            ((e = e * (this.max - this.min) + this.min),
                            (i = i * (this.max - this.min) + this.min),
                            0 !== this.step)
                        ) {
                            let t = Math.floor(e / this.step);
                            (e = this.step * t), (t = Math.floor(i / this.step)), (i = this.step * t);
                        }
                        this.selectedTouch === this.touchLeft && this.slider.setAttribute(hs, e),
                            this.selectedTouch === this.touchRight && this.slider.setAttribute(ds, i);
                    }
                    unload() {
                        document.removeEventListener("theme:filters:init", this.initListener),
                            window.removeEventListener("theme:resize", this.resizeFilters);
                    }
                    constructor(t) {
                        (this.container = t),
                            this.init(),
                            (this.initListener = () => this.init()),
                            document.addEventListener("theme:filters:init", this.initListener);
                    }
                })(this.container));
        }
        initTooltips() {
            var t, e;
            ((this.tooltips = this.container.querySelectorAll(dn)), window.innerWidth < theme.sizes.small) &&
                (this.tooltips = null === (e = this.productGrid) || void 0 === e ? void 0 : e.querySelectorAll(dn));
            null === (t = this.tooltips) ||
                void 0 === t ||
                t.forEach((t) => {
                    new es(t);
                }),
                this.handleVisibleTooltips();
        }
        handleVisibleTooltips() {
            if (this.tooltips.length > 0) {
                const t = document.querySelector(un);
                t.classList.contains(En) && t.classList.remove(En);
            }
        }
        updateRange() {
            const t = this.filtersForm.querySelector(nn),
                e = this.filtersForm.querySelector(rn),
                i = this.filtersForm.querySelector(sn),
                s = this.filtersForm.querySelector(on);
            if (t.hasAttribute(an) && e.hasAttribute(ln)) {
                const o = parseFloat(i.placeholder, 10),
                    n = parseFloat(s.placeholder, 10),
                    r = parseFloat(t.getAttribute(an), 10),
                    a = parseFloat(e.getAttribute(ln), 10);
                (o === r && n === a) ||
                    ((i.value = parseInt(r)),
                    (s.value = parseInt(a)),
                    this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 })));
            }
        }
        onSubmitHandler(t) {
            t.preventDefault();
            const e = new FormData(this.filtersForm),
                i = new URLSearchParams(e),
                s = [];
            let o = "";
            this.isSearchPage &&
                ((this.searchForm = this.container.querySelector(vn)),
                (this.currentType = this.container.getAttribute(Hn)));
            const n = this.filtersForm.querySelector(nn),
                r = this.filtersForm.querySelector(rn),
                a = this.filtersForm.querySelector(sn),
                l = this.filtersForm.querySelector(on);
            if (n && r && a && l && n.hasAttribute(cn) && r.hasAttribute(hn)) {
                const t = parseFloat(n.getAttribute(cn), 10),
                    e = parseFloat(r.getAttribute(hn), 10),
                    o = a.value ? parseFloat(a.value, 10) : t,
                    c = l.value ? parseFloat(l.value, 10) : e;
                o <= t &&
                    c >= e &&
                    (s.push("filter.v.price.gte"),
                    s.push("filter.v.price.lte"),
                    i.delete("filter.v.price.gte"),
                    i.delete("filter.v.price.lte"));
            }
            if (((o = i.toString()), this.isSearchPage)) {
                o = Oi(this.searchForm, this.filtersForm, s);
                let t = "";
                "all" === this.currentType && (t = "&type=product"),
                    o.indexOf("&type=product") > -1 && (t = ""),
                    (o += t);
            }
            this.renderSection(o, t);
        }
        onHistoryChange(t) {
            var e;
            if (!this.filters) return;
            let i = (null === (e = t.state) || void 0 === e ? void 0 : e.searchParams) || "";
            if (this.isSearchPage) {
                t.state || (i = window.location.search);
                if (!(i.indexOf("type=product") > -1)) return;
            }
            this.renderSection(i, null, !1);
        }
        renderSection(t, e, i = !0) {
            this.startLoading();
            const s = `${window.location.pathname}?section_id=${this.sectionId}&${t}`,
                o = (t) => t.url === s;
            this.filterData.some(o) ? this.renderSectionFromCache(o, e) : this.renderSectionFromFetch(s, e),
                i && this.updateURLHash(t);
        }
        renderSectionFromFetch(t) {
            fetch(t)
                .then((t) => t.text())
                .then((e) => {
                    const i = e;
                    (this.filterData = [...this.filterData, { html: i, url: t }]),
                        (this.inputSort = this.container.querySelectorAll(No)),
                        this.renderFilters(i),
                        this.bindFilterButtonsEvents(),
                        this.hideFiltersOnMobile(),
                        this.renderProductGrid(i),
                        this.updateProductsCount(i),
                        this.finishLoading(),
                        this.handleSearchPageActiveTab();
                });
        }
        renderSectionFromCache(t, e) {
            const i = this.filterData.find(t).html;
            this.renderFilters(i, e),
                this.hideFiltersOnMobile(),
                this.renderProductGrid(i),
                this.updateProductsCount(i),
                this.finishLoading(),
                this.mobileFiltersScrollLock(),
                this.handleSearchPageActiveTab();
        }
        handleSearchPageActiveTab() {
            this.isSearchPage &&
                ((this.scrollable = this.container.querySelector(bn)),
                this.scrollable && !this.customScrollbar && (this.customScrollbar = new Ri(this.container)));
        }
        renderProductGrid(t) {
            const e = new DOMParser().parseFromString(t, "text/html").querySelector(tn);
            e &&
                ((this.productGrid.innerHTML = e.innerHTML),
                this.initProductGridEvents(theme.settings.enableInfinityScroll),
                this.filterShowMore());
        }
        updateProductsCount(t) {
            const e = new DOMParser().parseFromString(t, "text/html").querySelector(en);
            e && (this.productsCount.innerHTML = e.innerHTML);
        }
        renderFilters(t) {
            const e = new DOMParser().parseFromString(t, "text/html").querySelector(Wo);
            e &&
                ((this.filters.innerHTML = e.innerHTML),
                (this.filtersForm = document.querySelector(Xo)),
                this.bindFilterButtonsEvents(),
                this.bindToggleButtonsEvents(),
                to(this.container),
                (this.collapsible = new Re(this.container)),
                document.dispatchEvent(new CustomEvent("theme:filters:init", { bubbles: !0 })));
        }
        updateURLHash(t) {
            history.pushState({ searchParams: t }, "", `${window.location.pathname}${t && "?".concat(t)}`);
        }
        bindFilterButtonsEvents() {
            this.inputSort.length > 0 &&
                this.inputSort.forEach((t) => {
                    t.addEventListener("change", this.updateCollectionFormSortEvent);
                }),
                this.filtersForm &&
                    (this.filtersForm.addEventListener("input", this.debouncedSubmitEvent.bind(this)),
                    this.filtersForm.addEventListener("theme:filter:range-update", this.updateRangeEvent)),
                this.collectionSortOptions &&
                    this.collectionSortOptions.addEventListener("keyup", this.onTabHandlerEvent),
                "tag" != this.filterMode &&
                    "group" != this.filterMode &&
                    this.enableFilters &&
                    this.container.querySelectorAll(Yo).forEach((t) => {
                        t.addEventListener("click", this.onFilterResetClick, { once: !0 });
                    });
        }
        onFilterResetClick(t) {
            t.preventDefault(), this.renderSection(new URL(t.currentTarget.href).searchParams.toString());
        }
        bindToggleButtonsEvents() {
            var t;
            this.container.querySelectorAll(Oo).forEach((t) => {
                t.addEventListener("click", this.onFilterToggleClick);
            }),
                this.container.querySelectorAll(Bo).forEach((t) => {
                    t.addEventListener("click", this.hideFiltersDrawer);
                }),
                this.container.querySelectorAll(zo).forEach((t) => {
                    t.addEventListener("click", this.showFiltersDrawer);
                }),
                null === (t = this.container.querySelector(_o)) ||
                    void 0 === t ||
                    t.addEventListener("keyup", this.onKeyUpHandler);
        }
        onTabHandler(t) {
            if (
                t.code === theme.keyboardKeys.SPACE ||
                t.code === theme.keyboardKeys.ENTER ||
                t.code === theme.keyboardKeys.NUMPADENTER
            ) {
                const e = t.target.previousElementSibling.value;
                this.filtersForm.querySelectorAll(No).forEach((t) => {
                    t.checked && (t.checked = !1), t.value === e && (t.checked = !0);
                }),
                    this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 })),
                    t.target.dispatchEvent(new Event("click", { bubbles: !0 }));
            }
        }
        onKeyUpHandler(t) {
            t.code === theme.keyboardKeys.ESCAPE && this.hideFiltersDrawer();
        }
        onFilterToggleClick(t) {
            t.preventDefault(), U();
            this.filters.classList.contains(An) ? this.hideFiltersDrawer() : this.showFiltersDrawer();
        }
        sortDropdownToggle() {
            this.collectionSortOptions && this.collectionSortOptions.classList.toggle(Cn);
        }
        bodyClick(t) {
            if (!this.collectionSortOptions) return;
            const e = this.sortToggle.contains(t.target);
            this.collectionSortOptions.classList.contains(Cn) && !e && this.sortDropdownToggle();
        }
        updateCollectionFormSort(t) {
            const e = t.target,
                i = e.value,
                s = e.closest(Vo);
            this.container.querySelectorAll(No).forEach((t) => {
                t.value === i && (t.checked = !0);
            }),
                null !== s && this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 }));
        }
        showFiltersDrawer() {
            (this.a11y.state.trigger = document.querySelector(Oo)),
                this.a11y.trapFocus({ container: this.filters }),
                this.mobileFiltersScrollLock();
        }
        mobileFiltersScrollLock() {
            if (window.innerWidth < theme.sizes.small) {
                const t = document.querySelector(Uo);
                this.filters.classList.contains(An) || this.filters.classList.add(An),
                    document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: t }));
            }
        }
        hideFiltersOnMobile() {
            const t = this.container.querySelectorAll(`${$o}:not(${fn})`);
            window.innerWidth < theme.sizes.small &&
                requestAnimationFrame(() => {
                    t.forEach((t) => {
                        const e = "true" === t.getAttribute(qn);
                        t.classList.contains(Sn) && !e && t.dispatchEvent(new Event("click"));
                    });
                });
        }
        showFiltersOnDesktop() {
            const t = this.container.querySelectorAll(`${$o}:not(${fn})`),
                e = this.container.getAttribute(Pn),
                i = "first-open" === e,
                s = "open" === e,
                o = "closed" === e,
                n = this.enableSorting ? 1 : 0;
            t.forEach((t, e) => {
                const r = t.classList.contains(Sn),
                    a = "true" === t.getAttribute(qn),
                    l = a && !r && s;
                (a && !l) ||
                    (((o && r) || (i && !r && e === n) || (i && r && e !== n) || (s && !r) || l) &&
                        t.dispatchEvent(new Event("click")));
            });
        }
        hideFiltersDrawer() {
            let t = this.filters.classList.contains(An),
                e = this.container.classList.contains(Ln);
            t && (this.filters.classList.remove(An), this.a11y.removeTrapFocus()),
                e || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: Do }));
        }
        filtersResizeEvents() {
            window.innerWidth >= theme.sizes.small
                ? (this.showFiltersOnDesktop(), this.hideFiltersDrawer())
                : this.hideFiltersOnMobile();
        }
        filterShowMore() {
            (this.showMore = this.container.querySelectorAll(pn)),
                0 !== this.showMore.length &&
                    this.showMore.forEach((t) => {
                        const e = t.querySelector($o),
                            i = t.querySelector(mn);
                        if (!i) return;
                        const s = i.querySelector(fn),
                            o = i.querySelector(gn),
                            n = o.querySelectorAll(window.theme.focusable);
                        "true" === o.getAttribute(In) ||
                            n.forEach((t) => {
                                t.setAttribute(xn, "-1");
                            }),
                            s.addEventListener("keyup", (t) => {
                                (t.code !== theme.keyboardKeys.SPACE &&
                                    t.code !== theme.keyboardKeys.ENTER &&
                                    t.code !== theme.keyboardKeys.NUMPADENTER) ||
                                    this.updateShowMoreFocusableElements(t, n);
                            }),
                            s.addEventListener("click", (t) => {
                                this.updateShowMoreFocusableElements(t, n);
                            }),
                            e.addEventListener("keyup", (t) => {
                                (t.code !== theme.keyboardKeys.SPACE &&
                                    t.code !== theme.keyboardKeys.ENTER &&
                                    t.code !== theme.keyboardKeys.NUMPADENTER) ||
                                    this.updateCollapsedContainerFocusableElements(e, s, n);
                            }),
                            e.addEventListener("click", () => {
                                this.updateCollapsedContainerFocusableElements(e, s, n);
                            });
                    });
        }
        updateCollapsedContainerFocusableElements(t, e, i) {
            requestAnimationFrame(() => {
                const s = "true" === t.getAttribute(In),
                    o = "true" === e.getAttribute(In);
                i.forEach((t) => {
                    !s && o && t.setAttribute(xn, "-1"), s && o && t.removeAttribute(xn);
                });
            });
        }
        updateShowMoreFocusableElements(t, e) {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    const i = "true" === t.target.getAttribute(In);
                    e.forEach((t, e) => {
                        if (i) return t.removeAttribute(xn), void (0 === e && t.focus());
                        t.setAttribute(xn, "-1");
                    });
                });
            });
        }
        initTagFilters() {
            ("tag" != this.filterMode && "group" != this.filterMode) ||
                !this.enableFilters ||
                ((this.tags = this.container.dataset.tags.split("+").filter((t) => t)),
                this.bindFilterTagButtonsEvents(),
                this.bindSortChangeEvent());
        }
        renderTagFiltersProducts(t) {
            this.startLoading(),
                "object" == typeof this.endlessCollection && this.endlessCollection.unload(),
                fetch(t)
                    .then((t) => t.text())
                    .then((e) => {
                        const i = e,
                            s = new DOMParser().parseFromString(i, "text/html"),
                            o = s.querySelector(tn).innerHTML,
                            n = s.querySelector(Wo).innerHTML;
                        (this.productGrid.innerHTML = o),
                            (this.filters.innerHTML = n),
                            (this.inputSort = this.container.querySelectorAll(No)),
                            (this.filtersForm = document.querySelector(Xo)),
                            (this.filterData = [...this.filterData, { html: i, url: t }]),
                            (this.alreadyClicked = !1),
                            this.bindFilterTagButtonsEvents(),
                            this.bindFilterButtonsEvents(),
                            this.bindSortChangeEvent(),
                            this.bindToggleButtonsEvents(),
                            this.initProductGridEvents(theme.settings.enableInfinityScroll),
                            this.updateProductsCount(i),
                            this.mobileFiltersScrollLock(),
                            this.hideFiltersOnMobile(),
                            to(this.container),
                            (this.collapsible = new Re(this.container)),
                            this.filterShowMore(),
                            history.replaceState && window.history.pushState({ path: t }, "", t);
                    })
                    .catch((t) => {
                        this.finishLoading(), console.log(`Error: ${t}`);
                    });
        }
        bindFilterTagButtonsEvents() {
            this.container.querySelectorAll(Qo).forEach((t) => {
                t.addEventListener("click", this.onFilterTagButtonClick.bind(this));
            }),
                this.container.querySelectorAll(Jo).forEach((t) => {
                    t.addEventListener("click", this.onFilterTagClearClick);
                }),
                this.container.querySelectorAll(Yo).forEach((t) => {
                    t.addEventListener("click", this.onFilterTagResetClick);
                });
        }
        bindSortChangeEvent() {
            this.container.querySelectorAll(No).forEach((t) => {
                t.addEventListener("input", this.debouncedSortEvent.bind(this));
            });
        }
        onFilterTagButtonClick(t) {
            if ((t.preventDefault(), this.alreadyClicked)) return;
            this.alreadyClicked = !0;
            const e = t.currentTarget,
                i = e.dataset.tag;
            if (e.parentNode.classList.contains(wn)) {
                let t = this.tags.indexOf(i);
                e.parentNode.classList.remove(wn), t > -1 && this.tags.splice(t, 1);
            } else e.parentNode.classList.add(wn), this.tags.push(i);
            let s = this.collectionHandle + "/" + this.tags.join("+") + "?sort_by=" + this.getSortValue();
            this.container.querySelector(Go).classList.remove(Sn),
                this.container.querySelector(Go).setAttribute(In, !1),
                this.container.setAttribute("data-tags", "[" + this.tags + "]"),
                this.renderTagFiltersProducts(s);
        }
        onFilterTagClearClick(t) {
            if ((t.preventDefault(), this.alreadyClicked)) return;
            this.alreadyClicked = !0;
            const e = t.currentTarget.dataset.tag,
                i = this.tags.indexOf(e);
            i > -1 && this.tags.splice(i, 1);
            const s = this.collectionHandle + "/" + this.tags.join("+") + "?sort_by=" + this.getSortValue();
            this.container.setAttribute("data-tags", "[" + this.tags + "]"), this.renderTagFiltersProducts(s);
        }
        onSortChange() {
            let t = this.collectionHandle + "/" + this.tags.join("+") + "?sort_by=" + this.getSortValue();
            this.renderTagFiltersProducts(t);
        }
        getSortValue() {
            let t = "";
            return (
                this.inputSort.forEach((e) => {
                    e.checked && (t = e.value);
                }),
                t
            );
        }
        onFilterTagResetClick(t) {
            if ((null == t || t.preventDefault(), this.alreadyClicked)) return;
            (this.alreadyClicked = !0),
                this.container.querySelectorAll(Ko).forEach((t) => {
                    t.classList.remove(wn);
                }),
                this.container.querySelectorAll(Go).forEach((t) => {
                    t.classList.remove(Sn), t.setAttribute(In, !1);
                }),
                (this.tags = []),
                this.container.setAttribute("data-tags", "");
            let e = this.collectionHandle + "/?sort_by=" + this.getSortValue();
            this.renderTagFiltersProducts(e);
        }
        getProductsOffsetTop() {
            return (
                this.productGrid.getBoundingClientRect().top -
                document.body.getBoundingClientRect().top -
                this.filtersStickyBar.offsetHeight
            );
        }
        getStickyBarOffsetTop() {
            return this.filtersStickyBar.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
        }
        initProductGridEvents(t) {
            if (t) return this.initInfinityScroll(), void this.initProductGridEvents(!1);
            (this.productGridEvents = new go(this.container)),
                this.initTooltips(),
                setTimeout(() => {
                    this.finishLoading();
                }, 1.5 * Do);
        }
        initInfinityScroll() {
            if (this.isSearchPage) {
                if (!this.enableFilters) return;
                document.dispatchEvent(new CustomEvent("theme:tab:ajaxinate", { bubbles: !0, detail: "product" }));
            } else
                "object" == typeof this.endlessCollection && this.endlessCollection.unload(),
                    (this.endlessCollection = new Fo(this.container)),
                    0 !== this.endlessCollection.endlessScroll.length &&
                        (this.endlessCollection.endlessScroll[0].settings.callback = () =>
                            this.initProductGridEvents(!1));
        }
        startLoading() {
            this.container.classList.add(Ln),
                window.innerWidth >= theme.sizes.small &&
                    document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
            let t = this.getProductsOffsetTop();
            window.scrollTo({ top: t, left: 0, behavior: "smooth" });
        }
        finishLoading() {
            const t = document.querySelectorAll(`${Zo} .${kn}`),
                e = t.length > 0;
            if ((this.container.classList.remove(Ln), e)) {
                let e = 0;
                [...t].forEach((t) => {
                    t.hasAttribute(Tn) && (e += 1);
                }),
                    e === t.length &&
                        document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: Do }));
            } else
                window.innerWidth >= theme.sizes.small &&
                    document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: Do }));
        }
        onDeselect() {
            this.productGridEvents && this.productGridEvents.onDeselect();
        }
        onUnload() {
            "object" == typeof this.endlessCollection && this.endlessCollection.unload(),
                this.productGridEvents && this.productGridEvents.onUnload(),
                this.collapsible && this.collapsible.onUnload(),
                this.rangeSlider && this.rangeSlider.unload(),
                this.filters && document.removeEventListener("theme:resize:width", this.resizeEvent),
                document.removeEventListener("click", this.bodyClickEvent),
                this.groupTagFilters.length > 0 && this.onFilterTagResetClick(),
                this.finishLoading();
        }
        constructor(t) {
            var e;
            (this.container = t),
                (this.sectionId = t.dataset.sectionId),
                (this.enableFilters = "true" === t.dataset.enableFilters),
                (this.enableSorting = "true" === t.dataset.enableSorting),
                (this.filterMode = t.dataset.filterMode),
                (this.collectionHandle = this.container.dataset.collection),
                (this.isSearchPage = null != t.closest(yn)),
                (this.productGrid = this.container.querySelector(tn)),
                (this.productsCount = this.container.querySelector(en)),
                (this.groupTagFilters = this.container.querySelectorAll(Go)),
                (this.filters = this.container.querySelector(Wo)),
                (this.filterTriggers = this.container.querySelectorAll($o)),
                (this.filtersStickyBar = this.container.querySelector(jo)),
                (this.filtersForm = this.container.querySelector(Xo)),
                (this.inputSort = this.container.querySelectorAll(No)),
                (this.sortToggle = this.container.querySelector(Ro)),
                (this.collectionSortOptions = this.container.querySelector(Vo)),
                (this.a11y = Ye),
                (this.filterData = []),
                (this.rangeSlider = null),
                (this.sortDropdownEvent = () => this.sortDropdownToggle()),
                (this.onTabHandlerEvent = (t) => this.onTabHandler(t)),
                (this.updateCollectionFormSortEvent = (t) => this.updateCollectionFormSort(t)),
                (this.bodyClickEvent = (t) => this.bodyClick(t)),
                (this.onFilterResetClick = this.onFilterResetClick.bind(this)),
                (this.onFilterTagResetClick = this.onFilterTagResetClick.bind(this)),
                (this.onFilterTagClearClick = this.onFilterTagClearClick.bind(this)),
                (this.onFilterToggleClick = this.onFilterToggleClick.bind(this)),
                (this.onKeyUpHandler = this.onKeyUpHandler.bind(this)),
                (this.updateRangeEvent = this.updateRange.bind(this)),
                (this.debouncedSubmitEvent = o((t) => {
                    this.onSubmitHandler(t);
                }, 500)),
                (this.debouncedSortEvent = o((t) => {
                    this.onSortChange(t);
                }, 500)),
                (this.productGridEvents = {}),
                this.filters &&
                    ((this.hideFiltersDrawer = this.hideFiltersDrawer.bind(this)),
                    (this.showFiltersDrawer = this.showFiltersDrawer.bind(this)),
                    (this.resizeEvent = o(() => {
                        this.filtersResizeEvents();
                    }, 500)),
                    this.filtersResizeEvents(),
                    document.addEventListener("theme:resize:width", this.resizeEvent)),
                this.initTagFilters(),
                this.initFacetedFilters(),
                this.bindToggleButtonsEvents(),
                this.bindFilterButtonsEvents(),
                this.initProductGridEvents(theme.settings.enableInfinityScroll),
                to(this.container),
                (this.collapsible = new Re(this.container)),
                U(),
                window.addEventListener("popstate", this.onHistoryChange.bind(this)),
                null === (e = this.sortToggle) || void 0 === e || e.addEventListener("click", this.sortDropdownEvent),
                document.addEventListener("click", this.bodyClickEvent),
                this.filterShowMore();
        }
    };
    const Dn = {
            onLoad() {
                Fn[this.id] = new Mn(this.container);
            },
            onDeselect() {
                Fn[this.id].onDeselect();
            },
            onUnload() {
                Fn[this.id].onUnload();
            },
        },
        On = "[data-aos]",
        Bn = "[data-aos-anchor]",
        zn = "[data-tabs-link]",
        _n = "[data-tab]",
        $n = "[data-tab-ref]",
        Rn = "[data-custom-scrollbar]",
        Vn = "[data-custom-scrollbar-holder]",
        Nn = "[data-slider]",
        Wn = "[data-tabs-contents]",
        Un = "[data-search-form]",
        jn = "[data-all-types-container]",
        Gn = "[data-collection-filters-form]",
        Kn = "[data-current-page]",
        Qn = "[data-tooltip]",
        Xn = "[data-collection-products]",
        Yn = "#AjaxinateLoop",
        Jn = "current",
        Zn = "hide",
        tr = "alt",
        er = "aos-animate",
        ir = "is-loaded",
        sr = "data-tabs-link",
        or = "data-tab",
        nr = "data-tab-ref",
        rr = "data-start-index",
        ar = "data-search-performed",
        lr = "data-type",
        cr = "data-current-type",
        hr = "data-all-types",
        dr = "data-current-page",
        ur = "data-ajaxinate-id",
        pr = {};
    let mr = class {
        assignSearchPageArguments() {
            this.isSearchPage &&
                ((this.searchForm = this.container.querySelector(Un)),
                (this.searchFormData = new FormData(this.searchForm)),
                (this.searchTerm = encodeURIComponent(this.searchFormData.get("q"))),
                (this.currentType = this.container.getAttribute(cr)),
                (this.sectionId = this.container.dataset.sectionId),
                (this.searchForAllTypes = "true" === this.container.getAttribute(hr)),
                (this.fetchURL = ""),
                (this.searchParams = ""),
                (this.cachedResults = {}),
                this.handleTabsHistory(),
                this.infiniteScrollListener(),
                this.initInfinityScroll(this.currentType));
        }
        init() {
            const t = this.container.querySelectorAll(zn),
                e = this.container.querySelector(
                    `[${sr}="${this.container.hasAttribute(rr) ? this.container.getAttribute(rr) : 0}"]`
                ),
                i = this.container.querySelector(
                    `[${or}="${this.container.hasAttribute(rr) ? this.container.getAttribute(rr) : 0}"]`
                );
            null == i || i.classList.add(Jn),
                null == e || e.classList.add(Jn),
                this.checkVisibleTabsLinks(),
                t.forEach((t) => {
                    this.handleTabsNavListeners(t);
                });
        }
        handleTabsHistory() {
            window.addEventListener("popstate", this.onHistoryChange.bind(this)),
                (this.openTabFromHistoryEvent = (t) => this.openTabFromHistory(t)),
                this.tabsLink.forEach((t) => {
                    t.addEventListener("theme:tab:open-from-history", this.openTabFromHistoryEvent);
                });
        }
        handleTabsNavListeners(t) {
            const e = t.getAttribute(sr),
                i = this.container.querySelector(`[${or}="${e}"]`);
            i &&
                (t.addEventListener("click", (e) => {
                    this.isSearchPage && this.handleURLSearchParams(e, !0), this.tabChange(t, i);
                }),
                t.addEventListener("keyup", (e) => {
                    (e.code !== theme.keyboardKeys.SPACE &&
                        e.code !== theme.keyboardKeys.ENTER &&
                        e.code !== theme.keyboardKeys.NUMPADENTER) ||
                        (this.isSearchPage && this.handleURLSearchParams(e, !0), this.tabChange(t, i));
                }));
        }
        openTabFromHistory(t) {
            const e = t.target,
                i = this.container.querySelector(t.detail.element).getAttribute(sr),
                s = this.container.querySelector(`[${or}="${i}"]`);
            s && (this.handleURLSearchParams(t, !1), this.tabChange(e, s));
        }
        handleURLSearchParams(t, e = !0) {
            const i = t.target.matches(zn) ? t.target : t.target.closest(zn),
                s = i.getAttribute(lr),
                o = i.getAttribute(sr),
                n = this.container.querySelector(`[${or}="${o}"]`).querySelector(Kn),
                r = document.querySelector(Gn);
            let a = n ? `&page=${n.getAttribute(dr)}` : "";
            if (((this.searchParams = Oi(this.searchForm, r, [], s)), "product" === s)) {
                const t = this.searchParams.replace("&type=product", "");
                this.searchParams = `${t}&type=product`;
            } else this.searchParams = `q=${this.searchTerm}&type=${s}`;
            theme.settings.enableInfinityScroll || "" === a || (this.searchParams += a),
                (this.fetchURL = `${theme.routes.searchUrl}?${this.searchParams}&section_id=${this.sectionId}`),
                e &&
                    history.pushState(
                        { searchParams: this.searchParams },
                        "",
                        `${window.location.pathname}${this.searchParams && "?".concat(this.searchParams)}`
                    );
        }
        tabChangeFetchContent(t, e) {
            const i = t.getAttribute(lr),
                s = t.getAttribute(sr),
                o = this.container.querySelector(`[${or}="${s}"]`),
                n = this.currentType === i;
            if (this.cachedResults[s] || n)
                return (
                    "product" !== i || this.searchFilters || (this.searchFilters = new Mn(this.container)),
                    void requestAnimationFrame(() => {
                        this.handleActiveTabClasses(t, e),
                            this.scrollToCurrentTabLink(t),
                            this.triggerTabAnimations(e),
                            this.checkVisibleTabsLinks(),
                            this.updateAjaxify(e, i);
                    })
                );
            fetch(this.fetchURL)
                .then((t) => {
                    if (!t.ok) {
                        throw new Error(t.status);
                    }
                    return t.text();
                })
                .then((n) => {
                    const r = new DOMParser().parseFromString(n, "text/html").querySelector(`[${or}="${s}"]`).innerHTML;
                    var a;
                    this.searchForAllTypes &&
                        (null === (a = this.container.querySelector(jn)) || void 0 === a || a.remove());
                    (this.cachedResults[s] = r),
                        (o.innerHTML = r),
                        "product" !== i || this.searchFilters || (this.searchFilters = new Mn(this.container)),
                        requestAnimationFrame(() => {
                            this.handleActiveTabClasses(t, e),
                                this.scrollToCurrentTabLink(t),
                                this.triggerTabAnimations(e),
                                this.checkVisibleTabsLinks(),
                                this.initInfinityScroll(i);
                        });
                })
                .catch((t) => {
                    throw t;
                });
        }
        onHistoryChange(t) {
            var e;
            const i = (null === (e = t.state) || void 0 === e ? void 0 : e.searchParams) || window.location.search,
                s = i.indexOf("type=product") > -1,
                o = i.indexOf("type=article") > -1,
                n = i.indexOf("type=page") > -1,
                r = s || o || n,
                a = this.container.querySelector(`${zn}[${lr}="product"]`),
                l = this.container.querySelector(`${zn}[${lr}="article"]`),
                c = this.container.querySelector(`${zn}[${lr}="page"]`);
            r
                ? (s &&
                      (null == a ||
                          a.dispatchEvent(
                              new CustomEvent("theme:tab:open-from-history", {
                                  bubbles: !0,
                                  detail: { element: `[${lr}="product"]` },
                              })
                          )),
                  o &&
                      (null == l ||
                          l.dispatchEvent(
                              new CustomEvent("theme:tab:open-from-history", {
                                  bubbles: !0,
                                  detail: { element: `[${lr}="article"]` },
                              })
                          )),
                  n &&
                      (null == c ||
                          c.dispatchEvent(
                              new CustomEvent("theme:tab:open-from-history", {
                                  bubbles: !0,
                                  detail: { element: `[${lr}="page"]` },
                              })
                          )))
                : (window.location = i);
        }
        initCustomScrollbar() {
            this.scrollable && !this.customScrollbar && (this.customScrollbar = new Ri(this.container));
        }
        infiniteScrollListener() {
            theme.settings.enableInfinityScroll &&
                ((this.ajaxifyFromFiltersEvent = (t) => this.ajaxifyFromFilters(t)),
                document.addEventListener("theme:tab:ajaxinate", this.ajaxifyFromFiltersEvent));
        }
        ajaxifyFromFilters(t) {
            this.initInfinityScroll(t.detail);
        }
        initInfinityScroll(t) {
            if (!theme.settings.enableInfinityScroll) return;
            if (0 === this.container.querySelectorAll(Yn).length) return;
            const e = this.container.querySelector(`${_n}.${Jn}`),
                i = null == e ? void 0 : e.querySelector(Yn),
                s = null == i ? void 0 : i.classList.contains(ir);
            e
                ? (!i && this.endlessCollection && this.updateAjaxinateInstancesSettings(t),
                  i && !s && this.initAjaxyfy(t))
                : this.initAjaxyfy(t);
        }
        updateAjaxinateInstancesSettings(t) {
            setTimeout(() => {
                if (0 === this.endlessCollection.endlessScroll.length) return;
                [...this.endlessCollection.endlessScroll].forEach((t) => {
                    const e = t.containerElement,
                        i = [...this.tab].find((t) => t.classList.contains(Jn));
                    !(null !== e.closest(`${_n}.${Jn}`)) && i && (t.settings.method = "click");
                });
                const e = () => this.initProductGridEvents();
                if ("product" === t || "all" === t) {
                    const t = (t) =>
                            t.settings.container.indexOf("resultsProducts") > -1 ||
                            t.settings.container.indexOf("allTypes") > -1,
                        i = [...this.endlessCollection.endlessScroll].find(t);
                    if (!i) return;
                    i.settings.callback = e;
                }
            });
        }
        initAjaxyfy(t) {
            if ("object" != typeof this.endlessCollection)
                return (this.endlessCollection = new Fo(this.container)), void this.updateAjaxinateInstancesSettings(t);
            this.endlessCollection.endlessScroll.length > 0 &&
                (this.endlessCollection.unload(),
                (this.endlessCollection = new Fo(this.container)),
                this.updateAjaxinateInstancesSettings(t));
        }
        updateAjaxify(t, e) {
            var i;
            if (0 === (null === (i = this.endlessCollection) || void 0 === i ? void 0 : i.endlessScroll.length)) return;
            const s = t.querySelector(Yn),
                o = `${Yn}[${ur}="${null == s ? void 0 : s.dataset.ajaxinateId}"]`;
            s && (this.endlessCollection.update(o), this.updateAjaxinateInstancesSettings(e));
        }
        initProductGridEvents() {
            (this.productGridEvents = new go(this.container)), this.initTooltips();
        }
        initTooltips() {
            var t, e;
            ((this.tooltips = this.container.querySelectorAll(Qn)),
            (this.productGrid = this.container.querySelector(Xn)),
            window.innerWidth < theme.sizes.small) &&
                (this.tooltips = null === (e = this.productGrid) || void 0 === e ? void 0 : e.querySelectorAll(Qn));
            null === (t = this.tooltips) ||
                void 0 === t ||
                t.forEach((t) => {
                    new es(t);
                });
        }
        tabChange(t, e) {
            t.classList.contains(Jn) ||
                (this.isSearchPage
                    ? this.tabChangeFetchContent(t, e)
                    : (this.handleActiveTabClasses(t, e),
                      this.scrollToCurrentTabLink(t),
                      this.triggerTabAnimations(e),
                      this.handleTabSliders(e),
                      this.checkVisibleTabsLinks()));
        }
        handleActiveTabClasses(t, e) {
            var i;
            const s = this.container.querySelector(`${_n}.${Jn}`),
                o = this.container.querySelector(`${zn}.${Jn}`);
            null == s || s.classList.remove(Jn),
                null == o || o.classList.remove(Jn),
                t.classList.add(Jn),
                e.classList.add(Jn),
                t.classList.contains(Zn) && e.classList.add(Zn),
                null === (i = this.tabRef) ||
                    void 0 === i ||
                    i.forEach((t) => {
                        const i = t.classList.contains(Jn),
                            s = t.getAttribute(nr) === e.getAttribute(or);
                        t.classList.toggle(Jn, !i && s);
                    });
        }
        scrollToCurrentTabLink(t) {
            const e = t.closest(Vn) ? t.closest(Vn) : t.parentElement,
                i = parseInt(window.getComputedStyle(e).getPropertyValue("padding-left"));
            e.scrollTo({ top: 0, left: t.offsetLeft - e.offsetWidth / 2 + t.offsetWidth / 2 + i, behavior: "smooth" }),
                t.dispatchEvent(
                    new CustomEvent("theme:custom-scrollbar:change", { bubbles: !0, detail: { element: t } })
                );
        }
        triggerTabAnimations(t) {
            if ("false" == theme.settings.animationsEnabled) return;
            document.dispatchEvent(new CustomEvent("theme:scroll"));
            const e = this.tabsContents.querySelector(`[${or}="resultsProducts"]`);
            if (e && e.classList.contains(Jn)) {
                ve(this.tabsContents.querySelectorAll(Bn));
            } else
                this.tabsContents.querySelectorAll(On).forEach((t) => {
                    t.classList.remove(er);
                }),
                    this.animateElementsTimer && clearTimeout(this.animateElementsTimer),
                    (this.animateElementsTimer = setTimeout(() => {
                        t.querySelectorAll(On).forEach((t) => {
                            t.classList.add(er);
                        });
                    }, 150));
        }
        handleInactiveTabsAnimations() {
            this.tab.forEach((t) => {
                t.classList.contains(Jn) ||
                    t.querySelectorAll(On).forEach((t) => {
                        requestAnimationFrame(() => t.classList.remove(er));
                    });
            });
        }
        handleTabSliders(t) {
            const e = t.querySelector(Nn);
            e && e.dispatchEvent(new CustomEvent("theme:tab:change", { bubbles: !1 }));
        }
        checkVisibleTabsLinks() {
            const t = this.container.querySelectorAll(zn),
                e = this.container.querySelectorAll(`${zn}.${Zn}`);
            t.length - e.length < 2 ? this.container.classList.add(tr) : this.container.classList.remove(tr);
        }
        onBlockSelect(t) {
            const e = t.target;
            e &&
                (e.dispatchEvent(new Event("click")),
                e.parentNode.scrollTo({ top: 0, left: e.offsetLeft - e.clientWidth, behavior: "smooth" }));
        }
        onUnload() {
            this.customScrollbar && this.customScrollbar.unload(),
                this.isSearchPage &&
                    theme.settings.enableInfinityScroll &&
                    document.removeEventListener("theme:tab:ajaxinate", this.ajaxifyFromFiltersEvent),
                document.removeEventListener("theme:scroll", this.inactiveTabsAnimationsCallback);
        }
        constructor(t) {
            (this.container = t),
                (this.tabsContents = t.querySelector(Wn)),
                (this.animateElementsTimer = null),
                (this.isSearchPage = null != t.closest(`[${ar}="true"]`)),
                this.container &&
                    ((this.scrollable = this.container.querySelector(Rn)),
                    (this.tabRef = this.container.querySelectorAll($n)),
                    (this.tabsLink = this.container.querySelectorAll(zn)),
                    (this.tab = this.container.querySelectorAll(_n)),
                    this.assignSearchPageArguments(),
                    this.init(),
                    this.initCustomScrollbar(),
                    this.isSearchPage || this.initTooltips(),
                    (this.inactiveTabsAnimationsCallback = o(() => this.handleInactiveTabsAnimations(), 200)),
                    document.addEventListener("theme:scroll", this.inactiveTabsAnimationsCallback),
                    this.container.addEventListener("mouseenter", () => {
                        this.handleInactiveTabsAnimations();
                    }));
        }
    };
    const gr = {
            onLoad() {
                pr[this.id] = new mr(this.container);
            },
            onBlockSelect(t) {
                pr[this.id].onBlockSelect(t);
            },
            onUnload() {
                pr[this.id].onUnload();
            },
        },
        fr = "[data-drawer]",
        yr = "[data-drawer-toggle]",
        vr = "[data-scroll]",
        br = "[data-quick-view-item]",
        wr = "is-open",
        Sr = "js-drawer-open",
        Er = "js-drawer-open--size",
        Lr = "cv-h",
        kr = "site-header",
        Ar = "product-single",
        Cr = "aria-expanded",
        qr = "aria-controls";
    let Tr = {},
        Pr = class {
            initListeners() {
                this.drawerToggleButtons.forEach((t) => {
                    t.addEventListener("click", this.drawerToggleEvent);
                }),
                    this.drawers.forEach((t) => {
                        t.addEventListener("keyup", this.keyPressCloseEvent),
                            (this.collapsible = new Re(t)),
                            (this.tabs = new mr(t));
                    }),
                    document.addEventListener("click", this.drawerCloseEvent),
                    document.addEventListener("theme:drawer:closing", this.drawerCloseEvent);
            }
            toggle(t) {
                t.preventDefault();
                const e = document.querySelector(`#${t.target.getAttribute(qr)}`);
                if (!e) return;
                e.classList.contains(wr) ? this.close() : this.open(t);
            }
            open(t) {
                const e = t.target,
                    i = document.querySelector(`#${t.target.getAttribute(qr)}`);
                if (!i) return;
                const s = i.querySelector(vr) || i;
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: s })),
                    document.dispatchEvent(new CustomEvent("theme:drawer:open"), { bubbles: !0 }),
                    this.body.classList.add(Sr),
                    this.container.classList.contains(Ar) && this.body.classList.add(Er),
                    i.classList.add(wr),
                    i.classList.remove(Lr),
                    e.setAttribute(Cr, !0),
                    setTimeout(() => {
                        (this.a11y.state.trigger = e), this.a11y.trapFocus({ container: i });
                    });
            }
            close() {
                if (!this.body.classList.contains(Sr)) return;
                const t = document.querySelector(`${fr}.${wr}`);
                this.drawerToggleButtons.forEach((t) => {
                    t.setAttribute(Cr, !1);
                }),
                    this.a11y.removeTrapFocus({ container: t }),
                    t.classList.remove(wr);
                const e = (i) => {
                    i.target === t &&
                        (requestAnimationFrame(() => {
                            t.classList.add(Lr),
                                document.dispatchEvent(new CustomEvent("theme:drawer:close"), { bubbles: !0 }),
                                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                        }),
                        t.removeEventListener("transitionend", e));
                };
                t.addEventListener("transitionend", e), this.body.classList.remove(Sr), this.body.classList.remove(Er);
            }
            onUnload() {
                this.close(),
                    this.drawerToggleButtons.forEach((t) => {
                        t.removeEventListener("click", this.drawerToggleEvent);
                    }),
                    this.drawers.forEach((t) => {
                        t.removeEventListener("keyup", this.keyPressCloseEvent);
                    }),
                    document.removeEventListener("click", this.drawerCloseEvent),
                    document.removeEventListener("theme:drawer:closing", this.drawerCloseEvent),
                    this.collapsible && this.collapsible.onUnload(),
                    this.tabs && this.tabs.onUnload();
            }
            constructor(t) {
                (this.container = t),
                    (this.body = document.body),
                    (this.drawers = this.container.querySelectorAll(fr)),
                    (this.drawerToggleButtons = this.container.querySelectorAll(yr)),
                    (this.a11y = Ye),
                    (this.drawerToggleEvent = Pe((t) => {
                        this.toggle(t);
                    }, 150)),
                    (this.keyPressCloseEvent = Pe((t) => {
                        t.code === theme.keyboardKeys.ESCAPE && this.close(t);
                    }, 150)),
                    (this.drawerCloseEvent = (t) => {
                        const e = document.querySelector(`${fr}.${wr}`);
                        let i = !1;
                        if (!e) return;
                        "click" === t.type && (i = t.target.matches(yr));
                        const s = !!e && e.contains(t.target),
                            o = e.closest(br),
                            n = !!o && o.contains(t.target);
                        i || s || n || this.close();
                    }),
                    this.initListeners();
            }
        };
    const xr = {
            onLoad() {
                this.container.classList.contains(kr) && (this.container = this.container.parentNode),
                    (Tr[this.id] = new Pr(this.container));
            },
            onUnload() {
                Tr[this.id].onUnload();
            },
        },
        Ir = (t, e = !1, i = "block") => {
            t && (e ? t.style.removeProperty("display") : (t.style.display = i));
        },
        Hr = (t) => {
            t && (t.style.display = "none");
        },
        Fr = (t) => {
            const { stickyHeaderHeight: e } = N();
            window.scrollTo({ top: t + Math.round(window.scrollY) - e, left: 0, behavior: "smooth" });
        },
        Mr = "[data-store-availability-list]",
        Dr = {
            close: ".js-modal-close",
            open: ".js-modal-open-store-availability-modal",
            openClass: "modal--is-active",
            openBodyClass: "modal--is-visible",
            closeModalOnClick: !1,
            scrollIntoView: !1,
        };
    const Or = "body",
        Br = "[data-store-availability-modal]",
        zr = "[data-store-availability-modal-open]",
        _r = "[data-store-availability-modal-close]",
        $r = "[data-store-availability-modal-product__title]",
        Rr = "store-availabilities-modal--active";
    const Vr = "[data-product-form]",
        Nr = "[data-option-position]",
        Wr = '[name^="options"], [data-popout-option]',
        Ur = "sold-out",
        jr = "unavailable",
        Gr = "data-option-position",
        Kr = "data-value";
    const Qr = 1,
        Xr = "data-notification-popup",
        Yr = { history: !1, focus: !1, mainClass: "pswp--notification pswp--not-close-btn", closeOnVerticalDrag: !1 };
    let Jr = class {
        init() {
            const t = [{ html: this.notificationPopupHtml }];
            (this.a11y.state.trigger = this.button), new Mc(t, Yr, Qr);
        }
        constructor(t) {
            (this.button = t),
                (this.a11y = Ye),
                (this.notificationPopupHtml = this.button.getAttribute(Xr)),
                "" !== this.notificationPopupHtml.trim() && this.init();
        }
    };
    const Zr = "[data-product]",
        ta = "[data-product-form]",
        ea = "[data-add-to-cart]",
        ia = "[data-add-to-cart-text]",
        sa = "[data-buy-it-now]",
        oa = "[data-compare-price]",
        na = "[data-form-wrapper]",
        ra = "[data-site-header]",
        aa = "[data-product-select]",
        la = "_preorder",
        ca = "[data-price-wrapper]",
        ha = "[data-price-off]",
        da = "[data-price-off-type]",
        ua = "[data-price-off-amount]",
        pa = "[data-product-slide]",
        ma = "[data-product-image]",
        ga = "[data-product-single-media-slider]",
        fa = "[data-product-json]",
        ya = "[data-product-price]",
        va = "[data-product-unit-price]",
        ba = "[data-product-base]",
        wa = "[data-product-unit]",
        Sa = "[data-subscription-watch-price]",
        Ea = "[data-subscription-selectors]",
        La = "[data-toggles-group]",
        ka = "data-group-toggle",
        Aa = "[data-plan-description]",
        Ca = "[data-remaining-count]",
        qa = "[data-remaining-wrapper]",
        Ta = "[data-product-remaining-json]",
        Pa = "[data-store-availability-container]",
        xa = "[data-upsell-btn]",
        Ia = ".shopify-section",
        Ha = "[data-quick-view-item]",
        Fa = "[data-notification-button-text]",
        Ma = "[data-swatches-container]",
        Da = "[data-swatches-more]",
        Oa = "[data-option-position]",
        Ba = "[data-variant-buttons]",
        za = "[data-variant-option-image]",
        _a = "hidden",
        $a = "variant--soldout",
        Ra = "variant--unavailabe",
        Va = "product__price--sale",
        Na = "product__price--hidden",
        Wa = "count-is-low",
        Ua = "count-is-in",
        ja = "count-is-out",
        Ga = "count-is-unavailable",
        Ka = "selector-wrapper--visible",
        Qa = "data-image-id",
        Xa = "data-tall-layout",
        Ya = "data-enable-history-state",
        Ja = "data-notification-popup",
        Za = "data-swatch-variant",
        tl = "data-atc-button";
    let el = {},
        il = class {
            init() {
                let t = null;
                const e = this.container.querySelector(fa);
                e && (t = e.innerHTML),
                    t
                        ? ((this.productJSON = JSON.parse(t)),
                          this.linkForm(),
                          (this.sellout = new (class {
                              init() {
                                  this.update();
                              }
                              update() {
                                  this.getCurrentState(),
                                      this.optionElements.forEach((t) => {
                                          const e = t.value || t.getAttribute(Kr),
                                              i = t.closest(Nr);
                                          if (!i) return;
                                          const s = i.getAttribute(Gr),
                                              o = parseInt(s, 10) - 1;
                                          let n = [...this.selections];
                                          n[o] = e;
                                          const r = this.productJSON.variants.find((t) => {
                                              let e = !0;
                                              for (let i = 0; i < n.length; i++) t.options[i] !== n[i] && (e = !1);
                                              return e;
                                          });
                                          t.parentElement.classList.remove(Ur, jr),
                                              void 0 === r
                                                  ? t.parentElement.classList.add(jr)
                                                  : !1 === (null == r ? void 0 : r.available) &&
                                                    t.parentElement.classList.add(Ur);
                                      });
                              }
                              getCurrentState() {
                                  for (var t of ((this.formData = new FormData(this.form)),
                                  (this.selections = []),
                                  this.formData.entries()))
                                      t[0].includes("options[") && this.selections.push(t[1]);
                              }
                              constructor(t, e) {
                                  (this.container = t),
                                      (this.productJSON = e),
                                      (this.form = this.container.querySelector(Vr)),
                                      (this.formData = new FormData(this.form)),
                                      (this.optionElements = this.container.querySelectorAll(Wr)),
                                      this.productJSON && this.form && this.init();
                              }
                          })(this.container, this.productJSON)))
                        : console.error("Missing product JSON"),
                    this.hasVariantOptionWithImage &&
                        ((this.variantButtonsContainer = this.variantOptionImages[0].closest(Ba)),
                        this.equalizeImageOptionContainers());
            }
            resizeEvents() {
                this.hasVariantOptionWithImage && this.equalizeImageOptionContainers();
            }
            linkForm() {
                this.productForm = new (class {
                    destroy() {
                        this._listeners.removeAll();
                    }
                    options() {
                        return this._serializeInputValues(this.optionInputs, function (t) {
                            return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t;
                        });
                    }
                    variant() {
                        const t = this.options();
                        return t.length ? vs(this.product, t) : this.product.variants[0];
                    }
                    plan(t) {
                        let e = { allocation: null, group: null, detail: null };
                        const i = new FormData(this.form).get("selling_plan");
                        return (
                            i &&
                                t &&
                                (e.allocation = t.selling_plan_allocations.find(function (t) {
                                    return t.selling_plan_id.toString() === i.toString();
                                })),
                            e.allocation &&
                                (e.group = this.product.selling_plan_groups.find(function (t) {
                                    return t.id.toString() === e.allocation.selling_plan_group_id.toString();
                                })),
                            e.group &&
                                (e.detail = e.group.selling_plans.find(function (t) {
                                    return t.id.toString() === i.toString();
                                })),
                            e && e.allocation && e.detail && e.allocation ? e : null
                        );
                    }
                    properties() {
                        return this._serializeInputValues(this.propertyInputs, function (t) {
                            return (t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]), t;
                        });
                    }
                    quantity() {
                        return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
                    }
                    getFormState() {
                        const t = this.variant();
                        return {
                            options: this.options(),
                            variant: t,
                            properties: this.properties(),
                            quantity: this.quantity(),
                            plan: this.plan(t),
                        };
                    }
                    _setIdInputValue(t) {
                        t && t.id ? (this.variantElement.value = t.id.toString()) : (this.variantElement.value = ""),
                            this.variantElement.dispatchEvent(new Event("change"));
                    }
                    _onSubmit(t, e) {
                        (e.dataset = this.getFormState()), t.onFormSubmit && t.onFormSubmit(e);
                    }
                    _onOptionChange(t) {
                        this._setIdInputValue(t.dataset.variant);
                    }
                    _onFormEvent(t) {
                        return void 0 === t
                            ? Function.prototype.bind()
                            : function (e) {
                                  (e.dataset = this.getFormState()), this._setIdInputValue(e.dataset.variant), t(e);
                              }.bind(this);
                    }
                    _initInputs(t, e) {
                        return Array.prototype.slice.call(this.element.querySelectorAll(t)).map(
                            function (t) {
                                return this._listeners.add(t, "change", this._onFormEvent(e)), t;
                            }.bind(this)
                        );
                    }
                    _serializeInputValues(t, e) {
                        return t.reduce(function (t, i) {
                            return (
                                (i.checked || ("radio" !== i.type && "checkbox" !== i.type)) &&
                                    t.push(e({ name: i.name, value: i.value })),
                                t
                            );
                        }, []);
                    }
                    _validateProductObject(t) {
                        if ("object" != typeof t) throw new TypeError(t + " is not an object.");
                        if (void 0 === t.variants[0].options)
                            throw new TypeError(
                                "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
                            );
                        return t;
                    }
                    constructor(t, e, i) {
                        (this.element = t),
                            (this.form =
                                "FORM" == this.element.tagName ? this.element : this.element.querySelector("form")),
                            (this.product = this._validateProductObject(e)),
                            (this.variantElement = this.element.querySelector(ws)),
                            (i = i || {}),
                            (this._listeners = new ys()),
                            this._listeners.add(this.element, "submit", this._onSubmit.bind(this, i)),
                            (this.optionInputs = this._initInputs(Es, i.onOptionChange)),
                            (this.planInputs = this._initInputs(Ss, i.onPlanChange)),
                            (this.quantityInputs = this._initInputs(Ls, i.onQuantityChange)),
                            (this.propertyInputs = this._initInputs(ks, i.onPropertyChange));
                    }
                })(this.productForm, this.productJSON, {
                    onOptionChange: this.onOptionChange.bind(this),
                    onPlanChange: this.onPlanChange.bind(this),
                    onQuantityChange: this.onQuantityChange.bind(this),
                });
                const t = this.productForm.getFormState();
                if ((this.pushState(t, !0), this.subsToggleListeners(), this.swatchesContainer)) {
                    this.observeSwatch(t);
                    const e = this.swatchesContainer.closest(Oa),
                        i = e.querySelector(Da);
                    null == i ||
                        i.addEventListener("click", (t) => {
                            t.preventDefault(), e.classList.contains(Ka) ? e.classList.remove(Ka) : e.classList.add(Ka);
                        });
                }
            }
            onOptionChange(t) {
                this.pushState(t.dataset), this.updateProductImage(t);
            }
            onPlanChange(t) {
                this.subPrices && this.pushState(t.dataset);
            }
            onQuantityChange(t) {
                this.pushState(t.dataset);
            }
            pushState(t, e = !1) {
                var i;
                (this.productState = this.setProductState(t)),
                    this.updateAddToCartState(t),
                    this.updateProductPrices(t),
                    this.updateSaleText(t),
                    this.updateSubscriptionText(t),
                    this.fireHookEvent(t),
                    this.updateRemaining(t),
                    null === (i = this.sellout) || void 0 === i || i.update(t),
                    this.enableHistoryState && !e && this.updateHistoryState(t),
                    this.storeAvailability &&
                        (t.variant
                            ? this.storeAvailability.updateContent(t.variant.id, this.productForm.product.title)
                            : this.storeAvailability.clearContent());
            }
            updateAddToCartState(t) {
                const e = t.variant,
                    i = this.container.querySelectorAll(ca),
                    s = this.container.querySelectorAll(ea),
                    o = this.container.querySelectorAll(ia),
                    n = this.container.querySelectorAll(na),
                    r = this.container.querySelector(sa);
                let a = theme.strings.add_to_cart;
                theme.settings.atcButtonShowPrice &&
                    (a = `${a}<span data-product-price class="product__price--regular"></span>`),
                    this.productJSON.tags.includes(la) && (a = theme.strings.preorder),
                    null == i ||
                        i.forEach((t) => {
                            t.hasAttribute(tl) || t.classList.toggle(Na, !e);
                        }),
                    null == s ||
                        s.forEach((t) => {
                            var i;
                            if (t.matches(xa)) return;
                            if (((t.disabled = !0), null == r || r.classList.add(_a), !e)) return;
                            if (
                                ((t.disabled = !1),
                                e.available && (null == r || r.classList.remove(_a)),
                                !t.hasAttribute(Ja))
                            )
                                return;
                            const s = t.id.replace("AddToCart", "NotificationForm"),
                                o = this.sessionStorage.getItem("notification_form_id");
                            let n = !1,
                                a = e.id,
                                l = e.title;
                            if (o) {
                                const t = o.substring(0, o.lastIndexOf("--")),
                                    e = o.split("--").slice(-1)[0];
                                (n = s === t),
                                    n &&
                                        ((this.latestVariantId = a),
                                        (this.latestVariantTitle = l),
                                        (a = Number(e)),
                                        this.productJSON.variants.forEach((t) => {
                                            t.id === a && (l = t.title);
                                        }));
                            }
                            let c = t.getAttribute(Ja);
                            const h =
                                null === (i = new DOMParser().parseFromString(c, "text/html").querySelector(Fa)) ||
                                void 0 === i
                                    ? void 0
                                    : i.innerHTML;
                            if ("" != this.latestVariantId && "" != this.latestVariantTitle) {
                                var d;
                                (c = c.replaceAll(this.latestVariantId, a)),
                                    (c = c.replaceAll(
                                        `<p class='product__notification__subtitle'>${this.latestVariantTitle}</p>`,
                                        `<p class='product__notification__subtitle'>${l}</p>`
                                    ));
                                const t =
                                    null === (d = new DOMParser().parseFromString(c, "text/html").querySelector(Fa)) ||
                                    void 0 === d
                                        ? void 0
                                        : d.innerHTML;
                                c = c.replace(t, h);
                            }
                            t.setAttribute(Ja, c),
                                n && (this.scrollToForm(this.product.closest(Ia)), new Jr(t)),
                                (this.latestVariantId = a),
                                (this.latestVariantTitle = l);
                        }),
                    null == o ||
                        o.forEach((t) => {
                            if (e) {
                                if (e.available) t.innerHTML = a;
                                else if (((t.innerHTML = theme.strings.sold_out), t.parentNode.hasAttribute(Ja))) {
                                    if (t.closest(Ha)) return;
                                    t.innerHTML = `${theme.strings.sold_out} - ${theme.strings.newsletter_product_availability}`;
                                }
                            } else t.innerHTML = theme.strings.unavailable;
                        }),
                    null == n ||
                        n.forEach((t) => {
                            if (!e) return t.classList.add(Ra), void t.classList.remove($a);
                            const i = t.querySelector(aa);
                            if ((i && (i.value = e.id), !e.available))
                                return t.classList.add($a), void t.classList.remove(Ra);
                            t.classList.remove($a, Ra);
                        });
            }
            updateHistoryState(t) {
                const e = t.variant,
                    i = t.plan,
                    s = window.location.href;
                if (e && s.includes("/product")) {
                    const t = new window.URL(s),
                        o = t.searchParams;
                    o.set("variant", e.id),
                        i && i.detail && i.detail.id && this.productState.hasPlan
                            ? o.set("selling_plan", i.detail.id)
                            : o.delete("selling_plan"),
                        (t.search = o.toString());
                    const n = t.toString();
                    window.history.replaceState({ path: n }, "", n);
                }
            }
            updateRemaining(t) {
                const e = t.variant,
                    i = [Ua, ja, Ga, Wa];
                if (e && this.remainingWrapper && this.remainingJSON) {
                    const t = this.remainingJSON[e.id];
                    ("out" === t || t < 1) &&
                        (this.remainingWrapper.classList.remove(...i), this.remainingWrapper.classList.add(ja)),
                        ("in" === t || t >= this.remainingMaxInt) &&
                            (this.remainingWrapper.classList.remove(...i), this.remainingWrapper.classList.add(Ua)),
                        ("low" === t || (t > 0 && t < this.remainingMaxInt)) &&
                            (this.remainingWrapper.classList.remove(...i),
                            this.remainingWrapper.classList.add(Wa),
                            this.remainingCount && (this.remainingCount.innerHTML = t));
                } else
                    !e &&
                        this.remainingWrapper &&
                        (this.remainingWrapper.classList.remove(...i), this.remainingWrapper.classList.add(Ga));
            }
            equalizeImageOptionContainers() {
                if (this.variantOptionImages.length <= 1) return;
                const t = [...this.variantOptionImages].map((t) => Math.floor(t.offsetHeight)),
                    e = [...this.variantOptionImages].map((t) => Math.floor(t.offsetWidth)),
                    i = Math.max(...e),
                    s = Math.max(...t);
                this.variantButtonsContainer.style.setProperty("--option-image-width", i + "px"),
                    this.variantButtonsContainer.style.setProperty("--option-image-height", s + "px");
            }
            getBaseUnit(t) {
                return 1 === t.unit_price_measurement.reference_value
                    ? t.unit_price_measurement.reference_unit
                    : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit;
            }
            subsToggleListeners() {
                this.container.querySelectorAll(La).forEach((t) => {
                    t.addEventListener(
                        "change",
                        function (t) {
                            const e = t.target.value.toString(),
                                i = this.container.querySelector(`[${ka}="${e}"]`),
                                s = this.container.querySelectorAll(`[${ka}]`);
                            if (i) {
                                i.classList.remove(_a);
                                const t = i.querySelector('[name="selling_plan"]');
                                (t.checked = !0), t.dispatchEvent(new Event("change"));
                            }
                            s.forEach((t) => {
                                if (t !== i) {
                                    t.classList.add(_a);
                                    t.querySelectorAll('[name="selling_plan"]').forEach((t) => {
                                        (t.checked = !1), t.dispatchEvent(new Event("change"));
                                    });
                                }
                            });
                        }.bind(this)
                    );
                });
            }
            updateSaleText(t) {
                this.productState.planSale
                    ? this.updateSaleTextSubscription(t)
                    : this.productState.onSale
                      ? this.updateSaleTextStandard(t)
                      : this.priceOffWrap && this.priceOffWrap.classList.add(_a);
            }
            updateSaleTextStandard(t) {
                if (!this.priceOffType) return;
                this.priceOffType.innerHTML = window.theme.strings.sale_badge_text || "sale";
                const e = t.variant;
                if (window.theme.settings.savingBadgeType && "percentage" === window.theme.settings.savingBadgeType) {
                    const t = (e.compare_at_price - e.price) / e.compare_at_price,
                        i = Math.floor(100 * t);
                    this.priceOffAmount.innerHTML = `${i}%`;
                } else {
                    const t = e.compare_at_price - e.price;
                    this.priceOffAmount.innerHTML = i.formatMoney(t, theme.moneyFormat);
                }
                this.priceOffWrap.classList.remove(_a);
            }
            updateSaleTextSubscription(t) {
                const e = t.variant,
                    s = this.productForm.product.selling_plan_groups.find(
                        (t) => t.id === e.selling_plan_allocations[0].selling_plan_group_id
                    ),
                    o = t.plan ? t.plan.detail.price_adjustments[0] : s.selling_plans[0].price_adjustments[0],
                    n = o.value || 0,
                    r = "percentage" === o.value_type ? `${n}%` : i.formatMoney(e.price - n, theme.moneyFormat);
                (this.priceOffType.innerHTML = window.theme.strings.subscription || "subscripton"),
                    (this.priceOffAmount.innerHTML = r),
                    this.priceOffWrap.classList.remove(_a);
            }
            updateSubscriptionText(t) {
                t.plan && this.planDecription && null !== t.plan.detail.description
                    ? ((this.planDecription.innerHTML = t.plan.detail.description),
                      this.planDecription.classList.remove(_a))
                    : this.planDecription && this.planDecription.classList.add(_a);
            }
            updateProductPrices(t) {
                const e = t.variant,
                    s = t.plan;
                this.container.querySelectorAll(ca).forEach((t) => {
                    const o = t.querySelector(oa),
                        n = t.querySelector(ya);
                    let r = "",
                        a = "";
                    if (
                        (this.productState.available && ((r = e.compare_at_price), (a = e.price)),
                        this.productState.hasPlan)
                    ) {
                        a = s ? s.allocation.price : e.selling_plan_allocations[0].per_delivery_price;
                    }
                    if (this.productState.planSale) {
                        const t = s ? s.allocation.price : e.selling_plan_allocations[0].per_delivery_price;
                        (r = s ? s.allocation.compare_at_price : e.selling_plan_allocations[0].compare_at_price),
                            (a = t);
                    }
                    if (
                        (o &&
                            (this.productState.onSale || this.productState.planSale
                                ? (o.classList.remove(_a), n.classList.add(Va))
                                : (o.classList.add(_a), n.classList.remove(Va)),
                            (o.innerHTML = theme.settings.currency_code_enable
                                ? i.formatMoney(r, theme.moneyWithCurrencyFormat)
                                : i.formatMoney(r, theme.moneyFormat))),
                        n)
                    ) {
                        if (t.hasAttribute(tl)) {
                            a *= this.productForm.quantity();
                        }
                        n.innerHTML =
                            0 === a
                                ? window.theme.strings.free
                                : theme.settings.currency_code_enable
                                  ? i.formatMoney(a, theme.moneyWithCurrencyFormat)
                                  : i.formatMoney(a, theme.moneyFormat);
                    }
                }),
                    this.hasUnitPricing && this.updateProductUnits(t);
            }
            updateProductUnits(t) {
                const e = t.variant,
                    s = t.plan;
                let o = null;
                if (
                    (((e && e.unit_price) || (!s && !e.requires_selling_plan)) && (o = e.unit_price),
                    s &&
                        (null == s ? void 0 : s.allocation) &&
                        (null == s ? void 0 : s.allocation.unit_price) &&
                        (o = s.allocation.unit_price),
                    !s &&
                        e.requires_selling_plan &&
                        e.selling_plan_allocations &&
                        e.selling_plan_allocations.length > 0)
                ) {
                    o = e.selling_plan_allocations[0].unit_price;
                }
                if (o) {
                    const t = this.getBaseUnit(e),
                        s = 0 === o ? window.theme.strings.free : i.formatMoney(o, theme.moneyFormat);
                    (this.container.querySelector(va).innerHTML = s),
                        (this.container.querySelector(ba).innerHTML = t),
                        Ir(this.container.querySelector(wa));
                } else Hr(this.container.querySelector(wa));
            }
            fireHookEvent(t) {
                const e = t.variant;
                this.container.dispatchEvent(
                    new CustomEvent("theme:variant:change", { detail: { variant: e }, bubbles: !0 })
                );
            }
            setProductState(t) {
                const e = t.variant,
                    i = t.plan,
                    s = {
                        available: !0,
                        soldOut: !1,
                        onSale: !1,
                        showUnitPrice: !1,
                        requiresPlan: !1,
                        hasPlan: !1,
                        planPerDelivery: !1,
                        planSale: !1,
                    };
                if (e) {
                    const t = e.requires_selling_plan || !1;
                    e.available || (s.soldOut = !0),
                        e.compare_at_price > e.price && (s.onSale = !0),
                        e.unit_price && (s.showUnitPrice = !0),
                        this.product && this.product.requires_selling_plan && (s.requiresPlan = !0),
                        i &&
                            this.subPrices &&
                            ((s.hasPlan = !0),
                            i.allocation.per_delivery_price !== i.allocation.price && (s.planPerDelivery = !0),
                            e.price > i.allocation.price && (s.planSale = !0)),
                        !i &&
                            t &&
                            ((s.hasPlan = !0),
                            e.selling_plan_allocations[0].per_delivery_price !== e.selling_plan_allocations[0].price &&
                                (s.planPerDelivery = !0),
                            e.price > e.selling_plan_allocations[0].price && (s.planSale = !0));
                } else s.available = !1;
                return s;
            }
            updateProductImage(t) {
                const i = t.dataset.variant;
                if (!i || !(null == i ? void 0 : i.featured_media)) return;
                const s = this.container.querySelector(`${ma}[${Qa}="${i.featured_media.id}"]`),
                    o = null == s ? void 0 : s.closest(pa);
                if (o) {
                    const t = parseInt([...o.parentElement.children].indexOf(o)),
                        n = this.container.querySelector(ga),
                        r = e.data(n);
                    if (r && r.isActive) {
                        const t = n.querySelector(`[data-id="${i.featured_media.id}"]`);
                        if (t) {
                            const e = parseInt([...t.parentNode.children].indexOf(t));
                            r.select(e);
                        }
                        return;
                    }
                    if (this.tallLayout) {
                        const e = s.getBoundingClientRect().top;
                        if (0 === t && e + window.scrollY > window.pageYOffset) return;
                        document.dispatchEvent(
                            new CustomEvent("theme:tooltip:close", { bubbles: !1, detail: { hideTransition: !1 } })
                        ),
                            Fr(e);
                    }
                }
            }
            observeSwatch(t) {
                const e = this.swatchesContainer.querySelector(`[${Za}*="${t.variant.id}"]`);
                this.swatchesContainer.closest(Oa).classList.remove(Ka),
                    new IntersectionObserver(
                        (t, e) => {
                            t.forEach((t) => {
                                0 == t.intersectionRatio && this.swatchesContainer.closest(Oa).classList.add(Ka);
                            });
                        },
                        { root: this.container, threshold: [0.95, 1] }
                    ).observe(e);
            }
            scrollToForm(t) {
                var e;
                const i = null === (e = document.querySelector(ra)) || void 0 === e ? void 0 : e.dataset.height;
                visibilityHelper.isElementPartiallyVisible(t) ||
                    visibilityHelper.isElementTotallyVisible(t) ||
                    setTimeout(() => {
                        const e = t.getBoundingClientRect().top - i;
                        window.scrollTo({ top: e, left: 0, behavior: "smooth" });
                    }, 400);
            }
            onUnload() {
                this.productForm && this.productForm.destroy(),
                    this.hasVariantOptionWithImage &&
                        window.removeEventListener("theme:resize:width", this.onResizeCallback);
            }
            constructor(t) {
                if (
                    ((this.container = t),
                    (this.product = this.container.querySelector(Zr)),
                    (this.productForm = this.container.querySelector(ta)),
                    (this.tallLayout = "true" === this.container.getAttribute(Xa)),
                    (this.addToCartButton = this.container.querySelector(ea)),
                    (this.variantOptionImages = this.container.querySelectorAll(za)),
                    (this.hasVariantOptionWithImage = this.variantOptionImages.length > 0),
                    !this.product || !this.productForm)
                ) {
                    return void new Xe(this.container).init();
                }
                (this.storeAvailabilityContainer = this.container.querySelector(Pa)),
                    (this.enableHistoryState = "true" === this.container.getAttribute(Ya)),
                    (this.hasUnitPricing = this.container.querySelector(wa)),
                    (this.subSelectors = this.container.querySelector(Ea)),
                    (this.subPrices = this.container.querySelector(Sa)),
                    (this.priceOffWrap = this.container.querySelector(ha)),
                    (this.priceOffAmount = this.container.querySelector(ua)),
                    (this.priceOffType = this.container.querySelector(da)),
                    (this.planDecription = this.container.querySelector(Aa)),
                    (this.swatchesContainer = this.container.querySelector(Ma)),
                    (this.latestVariantId = ""),
                    (this.latestVariantTitle = ""),
                    (this.sellout = null),
                    (this.sessionStorage = window.sessionStorage),
                    (this.remainingWrapper = this.container.querySelector(qa)),
                    this.remainingWrapper &&
                        ((this.remainingMaxInt = parseInt(this.remainingWrapper.dataset.remainingMax, 10)),
                        (this.remainingCount = this.container.querySelector(Ca)),
                        (this.remainingJSONWrapper = this.container.querySelector(Ta)),
                        (this.remainingJSON = null),
                        this.remainingJSONWrapper &&
                            "" !== this.remainingJSONWrapper.innerHTML &&
                            (this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML))),
                    this.storeAvailabilityContainer &&
                        (this.storeAvailability = new (class {
                            updateContent(t, e) {
                                this._fetchStoreAvailabilities(t, e);
                            }
                            clearContent() {
                                this.container.innerHTML = "";
                            }
                            _initModal() {
                                return new (class {
                                    init() {
                                        this.openElement.addEventListener("click", this.open.bind(this)),
                                            this.modal
                                                .querySelector(this.config.close)
                                                .addEventListener("click", this.closeModal.bind(this));
                                    }
                                    open(t) {
                                        let e = !1;
                                        if ((t ? t.preventDefault() : (e = !0), this.modalIsOpen && !e))
                                            return void this.closeModal();
                                        this.modal.classList.add(this.config.openClass),
                                            this.nodes.parents.forEach((t) => {
                                                t.classList.add(this.config.openBodyClass);
                                            }),
                                            (this.modalIsOpen = !0);
                                        const i = document.querySelector(Mr);
                                        document.dispatchEvent(
                                            new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: i })
                                        ),
                                            this.config.scrollIntoView && this.scrollIntoView(),
                                            this.bindEvents(),
                                            this.a11y.trapFocus({ container: this.modal });
                                    }
                                    closeModal() {
                                        if (this.modalIsOpen) {
                                            document.activeElement.blur(),
                                                this.modal.classList.remove(this.config.openClass);
                                            var t = this;
                                            this.nodes.parents.forEach(function (e) {
                                                e.classList.remove(t.config.openBodyClass);
                                            }),
                                                (this.modalIsOpen = !1),
                                                this.openElement.focus(),
                                                this.unbindEvents(),
                                                this.a11y.removeTrapFocus({ container: this.modal }),
                                                document.dispatchEvent(
                                                    new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: 400 })
                                                );
                                        }
                                    }
                                    bindEvents() {
                                        (this.keyupHandler = this.keyupHandler.bind(this)),
                                            (this.clickHandler = this.clickHandler.bind(this)),
                                            document.body.addEventListener("keyup", this.keyupHandler),
                                            document.body.addEventListener("click", this.clickHandler);
                                    }
                                    unbindEvents() {
                                        document.body.removeEventListener("keyup", this.keyupHandler),
                                            document.body.removeEventListener("click", this.clickHandler);
                                    }
                                    keyupHandler(t) {
                                        t.code === theme.keyboardKeys.ESCAPE && this.closeModal();
                                    }
                                    clickHandler(t) {
                                        !this.config.closeModalOnClick ||
                                            this.modal.contains(t.target) ||
                                            t.target.matches(this.config.open) ||
                                            this.closeModal();
                                    }
                                    scrollIntoView() {
                                        this.focusOnOpen.scrollIntoView({ behavior: "smooth" });
                                    }
                                    constructor(t, e) {
                                        if (((this.modal = document.getElementById(t)), !this.modal)) return !1;
                                        (this.nodes = { parents: [document.querySelector("html"), document.body] }),
                                            (this.config = Object.assign(Dr, e)),
                                            (this.modalIsOpen = !1),
                                            (this.focusOnOpen = this.config.focusOnOpen
                                                ? document.getElementById(this.config.focusOnOpen)
                                                : this.modal),
                                            (this.openElement = document.querySelector(this.config.open)),
                                            (this.a11y = Ye),
                                            this.init();
                                    }
                                })("StoreAvailabilityModal", {
                                    close: _r,
                                    open: zr,
                                    closeModalOnClick: !0,
                                    openClass: Rr,
                                    scrollIntoView: !1,
                                });
                            }
                            _fetchStoreAvailabilities(t, e) {
                                const i = "/variants/" + t + "/?section_id=store-availability";
                                this.clearContent();
                                const s = this;
                                fetch(i)
                                    .then(function (t) {
                                        return t.text();
                                    })
                                    .then(function (t) {
                                        const i = document.querySelector(Or);
                                        let o = i.querySelector(Br);
                                        o && o.remove(),
                                            (s.container.innerHTML = t),
                                            (s.container.innerHTML = s.container.firstElementChild.innerHTML),
                                            "" !== s.container.firstElementChild.innerHTML.trim()
                                                ? s.container.querySelector(zr) &&
                                                  ((s.modal = s._initModal()),
                                                  s._updateProductTitle(e),
                                                  (o = s.container.querySelector(Br)),
                                                  o && i.appendChild(o))
                                                : s.clearContent();
                                    });
                            }
                            _updateProductTitle(t) {
                                this.container.querySelector($r).textContent = t;
                            }
                            constructor(t) {
                                this.container = t;
                            }
                        })(this.storeAvailabilityContainer));
                new Xe(this.container).init(),
                    this.init(),
                    this.hasVariantOptionWithImage &&
                        ((this.onResizeCallback = () => this.resizeEvents()),
                        window.addEventListener("theme:resize:width", this.onResizeCallback));
            }
        };
    const sl = {
            onLoad() {
                el[this.id] = new il(this.container);
            },
            onUnload() {
                el[this.id].onUnload();
            },
        },
        ol = "form",
        nl = "[data-popout]",
        rl = "[data-popout-list]",
        al = "[data-popout-toggle]",
        ll = "[data-popout-input]",
        cl = "[data-popout-option]",
        hl = "[data-popout-text]",
        dl = "[aria-current]",
        ul = "[data-product-image]",
        pl = "[data-product-grid-item]",
        ml = "select-popout__list--visible",
        gl = "select-popout--alt",
        fl = "--current",
        yl = "is-visible",
        vl = "aria-current",
        bl = "aria-expanded",
        wl = "data-value",
        Sl = "data-popout-prevent",
        El = "data-quantity-field",
        Ll = "data-quick-view-item",
        kl = "data-popout-initialized";
    let Al = {},
        Cl = class {
            unload() {
                this.popoutOptions.length &&
                    this.popoutOptions.forEach((t) => {
                        t.removeEventListener("theme:popout:click", this.popupOptionsClickEvent),
                            t.removeEventListener("click", this._connectOptionsDispatchEvent);
                    }),
                    this.popoutToggle.removeEventListener("click", this.popupToggleClickEvent),
                    this.popoutToggle.removeEventListener("focusout", this.popupToggleFocusoutEvent),
                    this.popoutList.removeEventListener("focusout", this.popupListFocusoutEvent),
                    this.popout.removeEventListener("keyup", this.popoutKeyupEvent),
                    document.body.removeEventListener("click", this.bodyClick);
            }
            popupToggleClick(t) {
                const e = "true" === t.currentTarget.getAttribute(bl);
                if (this.popoutList.closest(pl)) {
                    const t = this.popoutList.closest(pl).querySelector(ul);
                    t && t.classList.toggle(yl, !e);
                }
                t.currentTarget.setAttribute(bl, !e), this.popoutList.classList.toggle(ml);
            }
            popupToggleFocusout(t) {
                if (!t.relatedTarget) return;
                const e = this.popout.contains(t.relatedTarget),
                    i = t.relatedTarget.hasAttribute(Ll);
                e || i || this._hideList();
            }
            popupListFocusout(t) {
                const e = t.currentTarget.contains(t.relatedTarget);
                this.popoutList.classList.contains(ml) && !e && this._hideList();
            }
            popupOptionsClick(t) {
                if ("#" === t.target.closest(cl).attributes.href.value) {
                    t.preventDefault();
                    let e = "";
                    if (
                        (t.currentTarget.getAttribute(wl) && (e = t.currentTarget.getAttribute(wl)),
                        (this.popoutInput.value = e),
                        this.popoutPrevent)
                    ) {
                        this.popoutInput.dispatchEvent(new Event("change")),
                            this.switchQuantityInputBehavior(t.detail.preventTrigger);
                        const i = this.popoutList.querySelector(`[class*="${fl}"]`);
                        let s = fl;
                        if (i && i.classList.length)
                            for (const t of i.classList)
                                if (t.includes(fl)) {
                                    s = t;
                                    break;
                                }
                        const o = this.popoutList.querySelector(`.${s}`);
                        o && (o.classList.remove(`${s}`), t.currentTarget.parentElement.classList.add(`${s}`));
                        const n = this.popoutList.querySelector(dl);
                        n && (n.removeAttribute(vl), t.currentTarget.setAttribute(vl, "true")),
                            "" !== e && (this.popoutText.textContent = e),
                            this.popupToggleFocusout(t),
                            this.popupListFocusout(t);
                    } else this._submitForm(e);
                }
            }
            switchQuantityInputBehavior(t = !0) {
                if (t || !this.popoutInput.hasAttribute(El)) return;
                const e = this.popoutList.querySelector(`[${wl}="${this.popoutInput.value}"]`);
                e && (e.parentElement.nextSibling || this.popout.classList.add(gl));
            }
            popoutKeyup(t) {
                t.code === theme.keyboardKeys.ESCAPE && (this._hideList(), this.popoutToggle.focus());
            }
            bodyClick(t) {
                const e = this.popout.contains(t.target);
                this.popoutList.classList.contains(ml) && !e && this._hideList();
            }
            _connectToggle() {
                this.popout.setAttribute(kl, ""),
                    this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
            }
            _connectOptions() {
                this.popoutOptions.length &&
                    this.popoutOptions.forEach((t) => {
                        t.addEventListener("theme:popout:click", this.popupOptionsClickEvent),
                            t.addEventListener("click", this._connectOptionsDispatchEvent);
                    });
            }
            _connectOptionsDispatch(t) {
                const e = new CustomEvent("theme:popout:click", {
                    cancelable: !0,
                    bubbles: !0,
                    detail: { preventTrigger: !1 },
                });
                t.target.dispatchEvent(e) || t.preventDefault();
            }
            _onFocusOut() {
                this.popoutToggle.addEventListener("focusout", this.popupToggleFocusoutEvent),
                    this.popoutList.addEventListener("focusout", this.popupListFocusoutEvent),
                    this.popout.addEventListener("keyup", this.popoutKeyupEvent),
                    document.body.addEventListener("click", this.bodyClick);
            }
            _submitForm() {
                const t = this.popout.closest(ol);
                t && t.submit();
            }
            _hideList() {
                this.popoutList.classList.remove(ml), this.popoutToggle.setAttribute(bl, !1);
            }
            constructor(t) {
                (this.popout = t),
                    (this.popoutList = this.popout.querySelector(rl)),
                    (this.popoutToggle = this.popout.querySelector(al)),
                    (this.popoutText = this.popout.querySelector(hl)),
                    (this.popoutInput = this.popout.querySelector(ll)),
                    (this.popoutOptions = this.popout.querySelectorAll(cl)),
                    (this.popoutPrevent = "true" === this.popout.getAttribute(Sl)),
                    (this.popupToggleFocusoutEvent = (t) => this.popupToggleFocusout(t)),
                    (this.popupListFocusoutEvent = (t) => this.popupListFocusout(t)),
                    (this.popupToggleClickEvent = (t) => this.popupToggleClick(t)),
                    (this.popoutKeyupEvent = (t) => this.popoutKeyup(t)),
                    (this.popupOptionsClickEvent = (t) => this.popupOptionsClick(t)),
                    (this._connectOptionsDispatchEvent = (t) => this._connectOptionsDispatch(t)),
                    (this.bodyClick = this.bodyClick.bind(this)),
                    this._connectOptions(),
                    this._connectToggle(),
                    this._onFocusOut();
            }
        };
    const ql = {
            onLoad() {
                Al[this.id] = [];
                this.container.querySelectorAll(nl).forEach((t) => {
                    t.hasAttribute(kl) || Al[this.id].push(new Cl(t));
                });
            },
            onUnload() {
                Al[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        Tl = "[data-add-to-cart]",
        Pl = "[data-deferred-media]",
        xl = "[data-deferred-media-button]",
        Il = "[data-popup-close]",
        Hl = "[data-popout]",
        Fl = "[data-quick-view-inner]",
        Ml = "[data-quick-view-item-holder]",
        Dl = "[data-product]",
        Ol = "[data-product-form]",
        Bl = "[data-product-single-media-slider]",
        zl = "[data-product-single-media-wrapper]",
        _l = "[data-model]",
        $l = "[data-product-json]",
        Rl = "[data-quick-view-foot-inner]",
        Vl = "[data-shop-the-look-thumb]",
        Nl = "[data-tooltip]",
        Wl = "[data-drawer-toggle]",
        Ul = "has-media-active",
        jl = "is-active",
        Gl = "is-loading",
        Kl = "media--hidden",
        Ql = "no-outline",
        Xl = "notification-popup-visible",
        Yl = "popup-quick-view--animate-in",
        Jl = "popup-quick-view--animate-out",
        Zl = "popup-quick-view--animated",
        tc = "popup-quick-view",
        ec = "js-quick-view-visible",
        ic = "js-quick-view-from-cart",
        sc = "js-drawer-open",
        oc = "id",
        nc = "data-media-id",
        rc = "data-section-id",
        ac = "loaded",
        lc = "tabindex",
        cc = "data-quick-view-onboarding",
        hc = "data-hotspot",
        dc = "data-hotspot-ref",
        uc = "AddToCartForm--",
        pc = "AddToCart--";
    const mc = 400,
        gc = ".pswp",
        fc = ".pswp__custom-close",
        yc = "iframe, video",
        vc = ".pswp__custom-iframe",
        bc = ".pswp__thumbs",
        wc = ".pswp__button, .pswp__caption-close",
        Sc = "is-current",
        Ec = "pswp--custom-loader",
        Lc = "pswp--custom-opening",
        kc = "pswp__loader",
        Ac = "pswp--open",
        Cc = "pswp__button--close",
        qc = "pswp--notification",
        Tc = "popup-quick-view",
        Pc = "js-drawer-open-cart",
        xc = "popup-quick-view--animate-out",
        Ic = "data-pswp-option-classes",
        Hc = "data-video-type",
        Fc = `<div class="${kc}"><div class="loader loader--image"><div class="loader__image"></div></div></div>`;
    let Mc = class {
        init() {
            document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
                this.pswpElement.classList.add(Lc),
                this.initLoader(),
                Ze({ url: window.theme.assets.photoswipe })
                    .then(() => this.loadPopup())
                    .catch((t) => console.error(t));
        }
        initLoader() {
            if (this.pswpElement.classList.contains(Ec) && "" !== this.options && this.options.mainClass) {
                this.pswpElement.setAttribute(Ic, this.options.mainClass);
                let t = document.createElement("div");
                (t.innerHTML = Fc), (t = t.firstChild), this.pswpElement.appendChild(t);
            } else this.pswpElement.setAttribute(Ic, "");
        }
        loadPopup() {
            const t = window.themePhotoswipe.PhotoSwipe.default,
                e = window.themePhotoswipe.PhotoSwipeUI.default;
            this.pswpElement.classList.remove(Lc),
                (this.popup = new t(this.pswpElement, e, this.items, this.options)),
                this.popup.listen("afterInit", this.dispatchPopupInitEventCallback),
                this.popup.listen("imageLoadComplete", this.setCurrentThumbCallback),
                this.popup.listen("imageLoadComplete", this.loadingStateCallback),
                this.popup.listen("beforeChange", this.setCurrentThumbCallback),
                this.popup.listen("close", this.onCloseCallback),
                this.popup.init(),
                this.initPopupCallback();
        }
        loadingState(t) {
            t === this.options.index &&
                this.pswpElement.classList.contains(Ec) &&
                this.pswpElement.classList.remove(Ec);
        }
        initPopupCallback() {
            this.isVideo && this.hideUnusedButtons(),
                this.initVideo(),
                this.thumbsActions(),
                this.a11y.trapFocus({ container: this.pswpElement }),
                this.pswpElement.classList.contains(Tc) &&
                    new (class {
                        initTooltips() {
                            (this.tooltips = this.pswpElement.querySelectorAll(Nl)),
                                this.tooltips.forEach((t) => {
                                    new es(t);
                                });
                        }
                        initPopouts() {
                            var t;
                            (this.popoutElements = this.pswpElement.querySelectorAll(Hl)),
                                (this.popouts = {}),
                                null === (t = this.popoutElements) ||
                                    void 0 === t ||
                                    t.forEach((t, e) => {
                                        this.popouts[e] = new Cl(t);
                                    });
                        }
                        handleDraggable(t, e) {
                            t && ((t.options.draggable = Boolean(e)), t.updateDraggable());
                        }
                        initItems(t, e) {
                            this.addFormSuffix(t),
                                this.initProductSlider(t, e),
                                this.initProductVideo(t),
                                this.initProductModel(t),
                                this.initShopifyXrLaunch(t),
                                to(t),
                                this.pswpElement.querySelectorAll(Wl).length && new Pr(t),
                                pt(t);
                            const i = new il(t.parentNode);
                            this.productForms.push(i),
                                Shopify.PaymentButton && Shopify.PaymentButton.init(),
                                t.classList.remove(Gl);
                        }
                        init() {
                            document.addEventListener("submit", this.prevent3dModelSubmitEvent),
                                this.popupCloseButtons.forEach((t) => {
                                    t.addEventListener("keyup", (t) => {
                                        (t.code !== theme.keyboardKeys.ENTER &&
                                            t.code !== theme.keyboardKeys.NUMPADENTER &&
                                            t.code !== theme.keyboardKeys.SPACE) ||
                                            this.closePopup(t);
                                    }),
                                        t.addEventListener("click", (t) => {
                                            this.closePopup(t);
                                        });
                                }),
                                this.pswpElement.addEventListener("click", this.outerCloseEvent),
                                document.dispatchEvent(new CustomEvent("theme:popup:open", { bubbles: !0 })),
                                this.popup.listen("preventDragEvent", (t, e, i) => {
                                    i.prevent = !1;
                                }),
                                this.pswpElement.addEventListener("mousedown", () => {
                                    this.popup.framework.unbind(
                                        window,
                                        "pointermove pointerup pointercancel",
                                        this.popup
                                    );
                                }),
                                this.popup.listen("initialZoomInEnd", () => {
                                    document.body.classList.add(ec),
                                        this.a11y.trapFocus({ container: this.quickViewInner });
                                }),
                                this.pswpElement.addEventListener("animationend", this.closeOnAnimationEndEvent),
                                this.popup.listen("destroy", () => {
                                    this.flkty.length > 0 &&
                                        requestAnimationFrame(() => {
                                            this.flkty.forEach((t) => t.pausePlayer());
                                        }),
                                        document.body.classList.remove(ec),
                                        document.removeEventListener("keyup", this.closeOnEscapeEvent),
                                        document.addEventListener("keyup", this.closeOnEscapeEvent),
                                        this.pswpElement.removeEventListener("click", this.outerCloseEvent),
                                        this.pswpElement.removeEventListener(
                                            "animationend",
                                            this.closeOnAnimationEndEvent
                                        ),
                                        document.removeEventListener("submit", this.prevent3dModelSubmitEvent),
                                        this.deferredMedias.forEach((t) => {
                                            t.removeAttribute(ac);
                                            const e = t.closest(zl);
                                            e.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }),
                                                e.classList.add(Kl);
                                        });
                                }),
                                document.addEventListener("keyup", this.closeOnEscapeEvent),
                                document.addEventListener("theme:cart:added", () => {
                                    this.pswpElement.classList.contains(tc) && this.pswpElement.classList.add(Jl);
                                }),
                                this.animateInQuickview(),
                                this.initShopTheLookListeners();
                        }
                        initShopTheLookListeners() {
                            var t;
                            null === (t = this.buttonsShopTheLookThumb) ||
                                void 0 === t ||
                                t.forEach((t) => {
                                    t.addEventListener("click", (t) => {
                                        t.preventDefault();
                                        const e = t.target.matches(Vl) ? t.target : t.target.closest(Vl),
                                            i = this.pswpElement.querySelector(`[${hc}="${e.getAttribute(dc)}"]`);
                                        !e.classList.contains(jl) &&
                                            i &&
                                            (this.flkty.length > 0 &&
                                                requestAnimationFrame(() => {
                                                    this.flkty.forEach((t) => {
                                                        t.resize();
                                                        const e = this.quickViewInner.querySelectorAll(zl);
                                                        e.length &&
                                                            e.forEach((t) => {
                                                                t.dispatchEvent(new CustomEvent("theme:media:hidden"), {
                                                                    bubbles: !0,
                                                                }),
                                                                    t.classList.add(Kl);
                                                            });
                                                    });
                                                }),
                                            i.classList.add(jl),
                                            this.quickViewItemHolders.forEach((t) => {
                                                t !== i && t.classList.remove(jl);
                                            }));
                                    });
                                });
                        }
                        prevent3dModelSubmit(t) {
                            t.submitter.closest(Pl) && t.submitter.closest(Ol) && t.preventDefault();
                        }
                        closeQuickviewOnMobile() {
                            window.innerWidth < window.theme.sizes.large &&
                                document.body.classList.contains(ec) &&
                                this.popup.close();
                        }
                        animateInQuickview() {
                            this.pswpElement.classList.add(Yl),
                                this.quickViewFoot.addEventListener("animationend", (t) => {
                                    this.handleAnimatedState(t);
                                }),
                                this.pswpElement.addEventListener("animationend", (t) => {
                                    this.handleAnimatedState(t, !0);
                                });
                        }
                        handleAnimatedState(t, e = !1) {
                            if ("quickViewAnimateInUp" == t.animationName) {
                                if (e && window.innerWidth >= window.theme.sizes.small) return;
                                this.pswpElement.classList.add(Zl),
                                    this.pswpElement.classList.remove(Yl),
                                    document.body.classList.remove(ic),
                                    ft(this.pswpElement);
                            }
                        }
                        closePopup(t) {
                            null == t || t.preventDefault(),
                                document.body.classList.contains(sc) &&
                                    document.dispatchEvent(new CustomEvent("theme:drawer:closing", { bubbles: !0 })),
                                this.pswpElement.classList.add(Jl),
                                this.swatchesContainer.onUnload();
                        }
                        closeOnAnimationEnd(t) {
                            ("quickViewAnimateOutRight" != t.animationName &&
                                "quickViewAnimateOutDown" != t.animationName) ||
                                (this.popup.template.classList.remove(Jl, Zl),
                                this.popup.close(),
                                this.productForms.length > 0 && this.productForms.forEach((t) => t.onUnload()));
                        }
                        closeOnEscape(t) {
                            const e = document.body.classList.contains(ec),
                                i = document.body.classList.contains(Xl);
                            t.code === theme.keyboardKeys.ESCAPE && e && !i && this.closePopup(t);
                        }
                        initProductSlider(t, i) {
                            const s = t.querySelector(Bl),
                                o = t.querySelectorAll(zl);
                            if (o.length > 1) {
                                const n = new e(s, {
                                    wrapAround: !0,
                                    cellAlign: "left",
                                    pageDots: !1,
                                    prevNextButtons: !0,
                                    adaptiveHeight: !1,
                                    pauseAutoPlayOnHover: !1,
                                    selectedAttraction: 0.2,
                                    friction: 1,
                                    autoPlay: !1,
                                    on: {
                                        ready: () => {
                                            s.setAttribute(lc, "-1"),
                                                requestAnimationFrame(() => {
                                                    n.resize();
                                                });
                                        },
                                        settle: () => {
                                            const e = n.selectedElement,
                                                i = e.getAttribute(nc);
                                            e.setAttribute(lc, "0"),
                                                n.cells.forEach((t) => {
                                                    t.element !== e && t.element.setAttribute(lc, "-1");
                                                }),
                                                this.switchMedia(t, i);
                                        },
                                    },
                                });
                                this.flkty.push(n),
                                    o.length &&
                                        o.forEach((t) => {
                                            t.addEventListener("theme:media:play", () => {
                                                this.handleDraggable(this.flkty[i], !1),
                                                    t.closest(Bl).classList.add(Ul);
                                            }),
                                                t.addEventListener("theme:media:pause", () => {
                                                    this.handleDraggable(this.flkty[i], !0),
                                                        t.closest(Bl).classList.remove(Ul);
                                                });
                                        }),
                                    Si(s);
                            }
                        }
                        switchMedia(t, e) {
                            const i = this.quickViewInner.querySelectorAll(zl),
                                s = t.querySelector(`${zl}[${nc}="${e}"]`),
                                o = !document.body.classList.contains(Ql);
                            i.length &&
                                i.forEach((t) => {
                                    t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }),
                                        t.classList.add(Kl);
                                }),
                                o && s.focus(),
                                s.closest(Bl).classList.remove(Ul),
                                s.classList.remove(Kl),
                                s.dispatchEvent(new CustomEvent("theme:media:visible"), { bubbles: !0 });
                            const n = s.querySelector(Pl);
                            n && "true" !== n.getAttribute(ac) && s.querySelector(xl).dispatchEvent(new Event("click"));
                        }
                        initProductVideo(t) {
                            const e = new Di(t);
                            this.videos.push(e);
                        }
                        initProductModel(t) {
                            const e = t.getAttribute(rc),
                                i = t.querySelectorAll(_l);
                            i.length &&
                                i.forEach((t) => {
                                    theme.ProductModel.init(t, e);
                                });
                        }
                        initShopifyXrLaunch(t) {
                            document.addEventListener("shopify_xr_launch", () => {
                                t.querySelector(`${_l}:not(.${Kl})`).dispatchEvent(new CustomEvent("xrLaunch"));
                            });
                        }
                        addFormSuffix(t) {
                            const e = `${t.getAttribute(rc)}-${JSON.parse(t.querySelector($l).innerHTML).handle}`,
                                i = t.querySelector(Ol),
                                s = t.querySelector(Tl);
                            i.setAttribute(oc, uc + e), s.setAttribute(oc, pc + e);
                        }
                        constructor(t, e) {
                            (this.popup = t),
                                (this.pswpElement = e),
                                (this.quickViewFoot = this.pswpElement.querySelector(Rl)),
                                (this.quickViewInner = this.pswpElement.querySelector(Fl)),
                                (this.product = this.pswpElement.querySelectorAll(Dl)),
                                (this.flkty = []),
                                (this.videos = []),
                                (this.productForms = []),
                                (this.deferredMedias = this.pswpElement.querySelectorAll(Pl)),
                                (this.buttonsShopTheLookThumb = this.pswpElement.querySelectorAll(Vl)),
                                (this.quickViewItemHolders = this.pswpElement.querySelectorAll(Ml)),
                                (this.popupCloseButtons = this.quickViewInner.querySelectorAll(Il)),
                                (this.a11y = Ye),
                                (this.prevent3dModelSubmitEvent = (t) => this.prevent3dModelSubmit(t)),
                                (this.closeOnAnimationEndEvent = (t) => this.closeOnAnimationEnd(t)),
                                (this.closeOnEscapeEvent = (t) => this.closeOnEscape(t)),
                                (this.outerCloseEvent = (t) => {
                                    if (!this.quickViewInner.contains(t.target)) {
                                        const e = this.quickViewInner.nextElementSibling;
                                        if (e && e.contains(t.target)) return;
                                        this.closePopup(t);
                                    }
                                }),
                                this.product.forEach((t, e) => {
                                    t.hasAttribute(cc) || this.initItems(t, e);
                                }),
                                this.init(),
                                this.initTooltips(),
                                this.initPopouts(),
                                (this.swatchesContainer = new Zs(this.pswpElement));
                        }
                    })(this.popup, this.pswpElement),
                this.pswpElement.classList.contains(qc) &&
                    new (class {
                        init() {
                            this.popup.listen("preventDragEvent", (t, e, i) => {
                                i.prevent = !1;
                            });
                            const t = -1 !== window.location.search.indexOf("?customer_posted=true");
                            this.notificationForm = this.pswpElement.querySelector(fi);
                            const e = this.pswpElement.querySelector(vi);
                            document.body.classList.add(wi),
                                this.pswpElement.addEventListener("mousedown", () => {
                                    this.popup.framework.unbind(
                                        window,
                                        "pointermove pointerup pointercancel",
                                        this.popup
                                    );
                                }),
                                t && this.pswpElement.classList.add(bi),
                                this.notificationForm.addEventListener("submit", (t) =>
                                    this.notificationSubmitEvent(t)
                                ),
                                this.pswpElement.addEventListener("click", this.outerCloseEvent),
                                e.addEventListener("click", () => {
                                    this.popup.close();
                                }),
                                this.popup.listen("destroy", () => {
                                    this.notificationRemoveStorage(),
                                        this.pswpElement.removeEventListener("click", this.outerCloseEvent),
                                        document.body.classList.remove(wi);
                                });
                        }
                        notificationSubmitEvent(t) {
                            this.notificationStopSubmit &&
                                (t.preventDefault(),
                                this.notificationRemoveStorage(),
                                this.notificationWriteStorage(),
                                (this.notificationStopSubmit = !1),
                                this.notificationForm.submit());
                        }
                        notificationWriteStorage() {
                            void 0 !== this.sessionStorage &&
                                this.sessionStorage.setItem("notification_form_id", this.notificationForm.id);
                        }
                        notificationRemoveStorage() {
                            this.sessionStorage.removeItem("notification_form_id");
                        }
                        constructor(t, e) {
                            (this.popup = t),
                                (this.pswpElement = e),
                                (this.notificationForm = null),
                                (this.notificationStopSubmit = !0),
                                (this.sessionStorage = window.sessionStorage);
                            const i = this.pswpElement.querySelector(yi);
                            (this.outerCloseEvent = (t) => {
                                i.contains(t.target) || this.popup.close();
                            }),
                                this.init();
                        }
                    })(this.popup, this.pswpElement),
                (this.closePopup = () => {
                    this.pswpElement.classList.contains(Tc) ? this.pswpElement.classList.add(xc) : this.popup.close();
                }),
                this.closeBtn && this.closeBtn.addEventListener("click", this.closePopup),
                document.addEventListener("theme:cart:added", this.closePopup);
        }
        dispatchPopupInitEvent() {
            this.triggerBtn && this.triggerBtn.dispatchEvent(new CustomEvent("theme:popup:init", { bubbles: !0 }));
        }
        initVideo() {
            const t = this.pswpElement.querySelector(vc);
            if (t) {
                const e = t.getAttribute(Hc);
                (this.isVideo = !0),
                    "youtube" == e
                        ? new (class {
                              init() {
                                  window.isYoutubeAPILoaded
                                      ? this.loadYoutubePlayer()
                                      : Ze({ url: "https://www.youtube.com/iframe_api" }).then(() =>
                                            this.loadYoutubePlayer()
                                        );
                              }
                              loadYoutubePlayer() {
                                  const t = {
                                      height: "720",
                                      width: "1280",
                                      playerVars: this.videoOptionsVars,
                                      events: {
                                          onReady: (t) => {
                                              const e = t.target.getIframe().id;
                                              "true" === document.querySelector(`#${e}`).getAttribute(hi)
                                                  ? t.target.unMute()
                                                  : t.target.mute(),
                                                  t.target.playVideo(),
                                                  this.checkPlayerVisibilityFlag &&
                                                      (this.checkPlayerVisibility(e),
                                                      window.addEventListener(
                                                          "scroll",
                                                          Pe(() => {
                                                              this.checkPlayerVisibility(e);
                                                          }, 150)
                                                      ));
                                          },
                                          onStateChange: (t) => {
                                              0 == t.data && t.target.playVideo(),
                                                  1 == t.data && t.target.getIframe().parentElement.classList.add(mi);
                                          },
                                      },
                                  };
                                  (t.videoId = this.videoID),
                                      this.videoID.length &&
                                          YT.ready(() => {
                                              gi[this.playerID] = new YT.Player(this.playerID, t);
                                          }),
                                      (window.isYoutubeAPILoaded = !0);
                              }
                              checkPlayerVisibility(t) {
                                  let e;
                                  if ("string" == typeof t) e = t;
                                  else {
                                      if (null == t.data) return;
                                      e = t.data.id;
                                  }
                                  const i = document.getElementById(e + "-container");
                                  if (!i) return;
                                  const s = gi[e],
                                      o = i.getBoundingClientRect();
                                  let n =
                                      visibilityHelper.isElementPartiallyVisible(i) ||
                                      visibilityHelper.isElementTotallyVisible(i);
                                  o.top < 0 && i.clientHeight + o.top >= 0 && (n = !0),
                                      n && s && "function" == typeof s.playVideo
                                          ? s.playVideo()
                                          : !n && s && "function" == typeof s.pauseVideo && s.pauseVideo();
                              }
                              onUnload() {
                                  const t = "youtube-" + this.container.getAttribute(ci);
                                  gi[t] && gi[t].destroy();
                              }
                              constructor(t) {
                                  (this.container = t),
                                      (this.player = this.container.querySelector(li.videoIframe)),
                                      this.player &&
                                          ((this.videoOptionsVars = {}),
                                          (this.videoID = this.player.getAttribute(ui)),
                                          (this.videoType = this.player.getAttribute(pi)),
                                          "youtube" == this.videoType &&
                                              ((this.checkPlayerVisibilityFlag =
                                                  "true" === this.player.getAttribute(di)),
                                              (this.playerID = this.player.querySelector(li.youtubeWrapper)
                                                  ? this.player.querySelector(li.youtubeWrapper).id
                                                  : this.player.id),
                                              this.player.hasAttribute(li.dataHideOptions) &&
                                                  (this.videoOptionsVars = {
                                                      cc_load_policy: 0,
                                                      iv_load_policy: 3,
                                                      modestbranding: 1,
                                                      playsinline: 1,
                                                      autohide: 0,
                                                      controls: 0,
                                                      branding: 0,
                                                      showinfo: 0,
                                                      rel: 0,
                                                      fs: 0,
                                                      wmode: "opaque",
                                                  }),
                                              this.init(),
                                              this.container.addEventListener(
                                                  "touchstart",
                                                  function (t) {
                                                      if (
                                                          t.target.matches(li.videoWrapper) ||
                                                          t.target.closest(li.videoWrapper)
                                                      ) {
                                                          const e = t.target.querySelector(li.videoIframe).id;
                                                          gi[e].playVideo();
                                                      }
                                                  },
                                                  { passive: !0 }
                                              )));
                              }
                          })(t.parentElement)
                        : "vimeo" == e &&
                          new (class {
                              init() {
                                  this.loadVimeoPlayer();
                              }
                              loadVimeoPlayer() {
                                  const t = "https://vimeo.com/" + this.videoID;
                                  let e = "";
                                  const i = this.player,
                                      s = {
                                          url: t,
                                          background: this.enableBackground,
                                          muted: this.disableSound,
                                          autoplay: this.enableAutoplay,
                                          loop: this.enableLoop,
                                      };
                                  for (let t in s) e += encodeURIComponent(t) + "=" + encodeURIComponent(s[t]) + "&";
                                  fetch(`https://vimeo.com/api/oembed.json?${e}`)
                                      .then((t) => t.json())
                                      .then(function (t) {
                                          (i.innerHTML = t.html),
                                              setTimeout(function () {
                                                  i.parentElement.classList.add(ei);
                                              }, 1e3);
                                      })
                                      .catch(function () {
                                          console.log("error");
                                      });
                              }
                              constructor(t) {
                                  (this.container = t),
                                      (this.player = this.container.querySelector(ti)),
                                      this.player &&
                                          ((this.videoID = this.player.getAttribute(ri)),
                                          (this.videoType = this.player.getAttribute(ai)),
                                          (this.enableBackground = "true" === this.player.getAttribute(si)),
                                          (this.disableSound = "false" === this.player.getAttribute(ii)),
                                          (this.enableAutoplay = "false" !== this.player.getAttribute(oi)),
                                          (this.enableLoop = "false" !== this.player.getAttribute(ni)),
                                          "vimeo" == this.videoType && this.init());
                              }
                          })(t.parentElement);
            }
        }
        thumbsActions() {
            this.popupThumbsContainer &&
                this.popupThumbsContainer.firstChild &&
                (this.popupThumbsContainer.addEventListener("wheel", (t) => this.stopDisabledScroll(t)),
                this.popupThumbsContainer.addEventListener("mousewheel", (t) => this.stopDisabledScroll(t)),
                this.popupThumbsContainer.addEventListener("DOMMouseScroll", (t) => this.stopDisabledScroll(t)),
                (this.popupThumbs = this.pswpElement.querySelectorAll(`${bc} > *`)),
                this.popupThumbs.forEach((t, e) => {
                    t.addEventListener("click", (i) => {
                        i.preventDefault(),
                            t.parentElement.querySelector(`.${Sc}`).classList.remove(Sc),
                            t.classList.add(Sc),
                            this.popup.goTo(e);
                    });
                }));
        }
        hideUnusedButtons() {
            this.pswpElement.querySelectorAll(wc).forEach((t) => {
                t.classList.contains(Cc) || (t.style.display = "none");
            });
        }
        stopDisabledScroll(t) {
            t.stopPropagation();
        }
        onClose() {
            const t = this.pswpElement.querySelector(yc);
            if ((t && t.parentNode.removeChild(t), this.popupThumbsContainer && this.popupThumbsContainer.firstChild))
                for (; this.popupThumbsContainer.firstChild; )
                    this.popupThumbsContainer.removeChild(this.popupThumbsContainer.firstChild);
            this.pswpElement.setAttribute(Ic, "");
            const e = this.pswpElement.querySelector(`.${kc}`);
            e && this.pswpElement.removeChild(e),
                document.body.classList.contains(Pc) || this.a11y.removeTrapFocus(),
                document.removeEventListener("theme:cart:added", this.closePopup),
                setTimeout(() => {
                    const t = this.recentlyOpenedPopupsCount(),
                        e = document.body.classList.contains(Pc);
                    0 !== t || e || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                }, mc);
        }
        recentlyOpenedPopupsCount() {
            let t = 0;
            return (
                this.pswpElements.forEach((e) => {
                    e.classList.contains(Ac) && (t += 1);
                }),
                t
            );
        }
        setCurrentThumb() {
            if (this.popupThumbsContainer && this.popupThumbsContainer.firstChild) return;
            const t = this.pswpElement.querySelector(`${bc} > .${Sc}`);
            if ((t && t.classList.remove(Sc), !this.popupThumbs)) return;
            const e = this.popupThumbs[this.popup.getCurrentIndex()];
            e.classList.add(Sc), this.scrollThumbs(e);
        }
        scrollThumbs(t) {
            const e = this.popupThumbsContainer.scrollLeft + this.popupThumbsContainer.offsetWidth,
                i = t.offsetLeft;
            if (e <= i + t.offsetWidth || e > i) {
                const e = parseInt(window.getComputedStyle(t).marginLeft);
                this.popupThumbsContainer.scrollTo({ top: 0, left: i - e, behavior: "smooth" });
            }
        }
        constructor(t, e = "", i = 0, s = null) {
            (this.items = t),
                (this.triggerBtn = s),
                (this.pswpElements = document.querySelectorAll(gc)),
                (this.pswpElement = this.pswpElements[i]),
                (this.popup = null),
                (this.popupThumbs = null),
                (this.popupThumbsContainer = this.pswpElement.querySelector(bc)),
                (this.closeBtn = this.pswpElement.querySelector(fc));
            (this.options = "" !== e ? e : { history: !1, focus: !1, mainClass: "" }),
                (this.onCloseCallback = () => this.onClose()),
                (this.dispatchPopupInitEventCallback = () => this.dispatchPopupInitEvent()),
                (this.setCurrentThumbCallback = () => this.setCurrentThumb()),
                (this.loadingStateCallback = (t) => this.loadingState(t)),
                (this.a11y = Ye),
                this.init();
        }
    };
    const Dc = 0,
        Oc = "[data-button-quick-view]",
        Bc = "[data-quick-view-items-template]",
        zc = "[data-cart-drawer]",
        _c = "[data-shop-the-look-quick-view-button]",
        $c = "[data-shop-the-look-thumb]",
        Rc = "[data-quick-view-item-holder]",
        Vc = "is-loading",
        Nc = "is-active",
        Wc = "js-quick-view-from-cart",
        Uc = "popup-quick-view pswp--not-close-btn",
        jc = "popup-quick-view popup-quick-view--shop-the-look pswp--not-close-btn",
        Gc = "data-handle",
        Kc = "data-variant-id",
        Qc = "data-shop-the-look-quick-view",
        Xc = "data-hotspot",
        Yc = "data-initialized",
        Jc = {
            history: !1,
            focus: !1,
            mainClass: Uc,
            showHideOpacity: !1,
            closeOnVerticalDrag: !1,
            closeOnScroll: !1,
            modal: !1,
            escKey: !1,
        };
    let Zc = class {
        popupInit(t) {
            var e, i;
            const s = this.loadPhotoswipe.pswpElement.querySelector(`[${Xc}="${t.getAttribute(Xc)}"]`),
                o = this.loadPhotoswipe.pswpElement.querySelectorAll(Rc);
            s.classList.add(Nc),
                o.forEach((t) => {
                    t !== s && t.classList.remove(Nc);
                }),
                this.toggleQuickViewButtonsLoadingClasses(!0),
                this.toggleQuickViewThumbsLoadingClasses(!0);
            const n = (t) => {
                "quickViewAnimateInUp" === t.animationName &&
                    requestAnimationFrame(() => {
                        this.toggleQuickViewThumbsLoadingClasses(!1);
                    }),
                    "quickViewAnimateOutDown" === t.animationName &&
                        this.loadPhotoswipe.pswpElement.removeEventListener("animationend", n);
            };
            this.loadPhotoswipe.pswpElement.addEventListener("animationend", n),
                null === (e = this.loadPhotoswipe) ||
                    void 0 === e ||
                    null === (i = e.popup) ||
                    void 0 === i ||
                    i.listen("destroy", () => {
                        this.toggleQuickViewButtonsLoadingClasses(!1), this.toggleQuickViewThumbsLoadingClasses(!1);
                    });
        }
        toggleQuickViewButtonsLoadingClasses(t = !0) {
            var e, i;
            t
                ? null === (i = this.buttonsQuickView) ||
                  void 0 === i ||
                  i.forEach((t) => {
                      t.classList.add(Vc);
                  })
                : null === (e = this.buttonsQuickView) ||
                  void 0 === e ||
                  e.forEach((t) => {
                      t.classList.remove(Vc);
                  });
        }
        toggleQuickViewThumbsLoadingClasses(t = !0) {
            var e, i, s;
            ((this.buttonsShopTheLookThumb =
                null === (e = this.loadPhotoswipe) || void 0 === e ? void 0 : e.pswpElement.querySelectorAll($c)),
            t)
                ? null === (s = this.buttonsShopTheLookThumb) ||
                  void 0 === s ||
                  s.forEach((t) => {
                      t.classList.add(Vc);
                  })
                : null === (i = this.buttonsShopTheLookThumb) ||
                  void 0 === i ||
                  i.forEach((t) => {
                      t.classList.remove(Vc);
                  });
        }
        initPhotoswipe(t) {
            t.preventDefault();
            const e = t.target.matches(Oc) ? t.target : t.target.closest(Oc),
                i = window.innerWidth < theme.sizes.small;
            let s = "",
                o = !1;
            if (e.hasAttribute(Qc)) {
                if (!i) return;
                o = !0;
            }
            (Jc.mainClass = Uc),
                e.classList.add(Vc),
                e.closest(zc) && document.body.classList.add(Wc),
                (this.a11y.state.trigger = e),
                e.hasAttribute(Kc) && (s = `&variant=${e.getAttribute(Kc)}`);
            const n = `${theme.routes.root}products/${e.getAttribute(Gc)}?section_id=api-quickview${s}`;
            if (o) {
                (Jc.mainClass = jc),
                    this.buttonsQuickView.forEach((t) => {
                        t.classList.add(Vc);
                    });
                const t = new XMLSerializer(),
                    i = this.container.querySelector(Bc).content.firstElementChild.cloneNode(!0),
                    s = t.serializeToString(i);
                this.loadPhotoswipeWithTemplate(s, e);
            } else this.loadPhotoswipeFromFetch(n, e);
        }
        loadPhotoswipeWithTemplate(t, e) {
            const i = [{ html: t }];
            this.loadPhotoswipe = new Mc(i, Jc, Dc, e);
        }
        loadPhotoswipeFromFetch(t, e) {
            fetch(t)
                .then((t) => t.text())
                .then((t) => {
                    const i = [{ html: t }];
                    this.loadPhotoswipe = new Mc(i, Jc, Dc, e);
                })
                .catch((t) => console.log("error: ", t));
        }
        constructor(t) {
            var e, i;
            (this.container = t),
                (this.a11y = Ye),
                (this.buttonsQuickView = this.container.querySelectorAll(Oc)),
                (this.buttonsShopTheLookQuickView = this.container.querySelectorAll(_c)),
                (this.popupInitCallback = (t) => this.popupInit(t)),
                null === (e = this.buttonsQuickView) ||
                    void 0 === e ||
                    e.forEach((t) => {
                        t.hasAttribute(Yc) ||
                            (t.addEventListener("click", (t) => this.initPhotoswipe(t)),
                            t.addEventListener("theme:popup:init", () => {
                                t.classList.remove(Vc), t.hasAttribute(Qc) && this.popupInitCallback(t);
                            }),
                            t.setAttribute(Yc, ""));
                    }),
                null === (i = this.buttonsShopTheLookQuickView) ||
                    void 0 === i ||
                    i.forEach((t) => {
                        t.addEventListener("click", () => {
                            var t;
                            null === (t = this.buttonsQuickView[0]) ||
                                void 0 === t ||
                                t.dispatchEvent(new Event("click"));
                        });
                    });
        }
    };
    const th = {
            cartDrawerEnabled: "drawer" === window.theme.settings.cartType,
            timers: { addProductTimeout: 1e3 },
            animations: { data: "data-aos", method: "fade-up" },
        },
        eh = {
            outerSection: "[data-section-id]",
            aos: "[data-aos]",
            additionalCheckoutButtons: "[data-additional-checkout-button]",
            apiContent: "[data-api-content]",
            apiLineItems: "[data-api-line-items]",
            apiUpsellItems: "[data-api-upsell-items]",
            apiCartPrice: "[data-api-cart-price]",
            buttonAddToCart: "[data-add-to-cart]",
            upsellButtonByHandle: "[data-handle]",
            cartCloseError: "[data-cart-error-close]",
            cartDrawer: "[data-cart-drawer]",
            cartDrawerTemplate: "[data-cart-drawer-template]",
            cartDrawerToggle: "[data-cart-drawer-toggle]",
            cartDrawerBody: "[data-cart-drawer-body]",
            cartErrors: "[data-cart-errors]",
            cartForm: "[data-cart-form]",
            cartTermsCheckbox: "[data-cart-acceptance-checkbox]",
            cartCheckoutButtonWrapper: "[data-cart-checkout-buttons]",
            cartCheckoutButton: "[data-cart-checkout-button]",
            cartItemRemove: "[data-item-remove]",
            cartItemsQty: "[data-cart-items-qty]",
            cartTotal: "[data-cart-total]",
            cartTotalPrice: "[data-cart-total-price]",
            cartMessage: "[data-cart-message]",
            cartMessageDefault: "[data-message-default]",
            cartPage: "[data-cart-page]",
            cartProgress: "[data-cart-message-progress]",
            emptyMessage: "[data-empty-message]",
            emptyMessageBottom: "[data-empty-message-bottom]",
            buttonHolder: "[data-foot-holder]",
            item: "[data-cart-item]",
            itemsHolder: "[data-items-holder]",
            itemsWrapper: "[data-items-wrapper]",
            formCloseError: "[data-close-error]",
            formErrorsContainer: "[data-cart-errors-container]",
            upsellHolder: "[data-upsell-holder]",
            errorMessage: "[data-error-message]",
            termsErrorMessage: "[data-terms-error-message]",
            pairProductsHolder: "[data-pair-products-holder]",
            cartNoteHolder: "[data-cart-notes-holder]",
            pairProducts: "[data-pair-products]",
            priceHolder: "[data-cart-price-holder]",
            leftToSpend: "[data-left-to-spend]",
            quickBuyForm: "[data-quickbuy-form]",
            qtyInput: "[data-quantity-field]",
            productMediaContainer: "[data-product-media-container]",
            formWrapper: "[data-form-wrapper]",
            productForm: "[data-product-form], [data-product-form-upsell]",
            popupQuickView: ".popup-quick-view",
            popupClose: "[data-popup-close]",
            error: "[data-error]",
            quickViewOnboarding: "[data-quick-view-onboarding]",
            flickityEnabled: ".flickity-enabled",
            noscript: "noscript",
        },
        ih = "hidden",
        sh = "is-hidden",
        oh = "js-drawer-open-cart",
        nh = "is-open",
        rh = "is-visible",
        ah = "is-expanded",
        lh = "is-loading",
        ch = "is-disabled",
        hh = "is-success",
        dh = "cart__toggle--has-items",
        uh = "variant--soldout",
        ph = "is-removed",
        mh = "aos-animate",
        gh = "is-updated",
        fh = "no-outline",
        yh = "product-grid-item__image--error",
        vh = "cv-h",
        bh = "data-limit",
        wh = "data-cart-message",
        Sh = "data-cart-total",
        Eh = "aria-expanded",
        Lh = "disabled",
        kh = "name",
        Ah = "value",
        Ch = "data-id",
        qh = "data-item",
        Th = "data-item-index",
        Ph = "data-item-title",
        xh = "data-atc-trigger",
        Ih = "data-notification-popup",
        Hh = "data-recipient-errors";
    let Fh = {},
        Mh = class {
            init() {
                var t;
                (this.cartToggleButtons = document.querySelectorAll(eh.cartDrawerToggle)),
                    (this.cartPage = document.querySelector(eh.cartPage)),
                    (this.cartDrawer = document.querySelector(eh.cartDrawer)),
                    (this.cart = this.cartDrawer || this.cartPage),
                    (this.cartCount = this.getCartItemCount()),
                    this.assignArguments(),
                    (this.recipientErrors =
                        "true" === (null === (t = this.form) || void 0 === t ? void 0 : t.getAttribute(Hh))),
                    (this.flktyUpsell = null),
                    (this.form = null),
                    (this.collapsible = null),
                    (this.a11y = Ye),
                    (this.build = this.build.bind(this)),
                    (this.addToCart = this.addToCart.bind(this)),
                    (this.updateCart = this.updateCart.bind(this)),
                    (this.openCartDrawer = this.openCartDrawer.bind(this)),
                    (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
                    (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
                    (this.formSubmitHandler = Pe(this.formSubmitHandler.bind(this), 50)),
                    (this.closeCartError = () => {
                        this.cartErrorHolder.classList.remove(ah);
                    }),
                    (this.cartDrawerCloseEvent = null),
                    (this.hasItemsInCart = this.hasItemsInCart.bind(this)),
                    (this.isCartPage = Boolean(this.cart && null === this.cartDrawer)),
                    (this.toggleClassesOnContainers = this.toggleClassesOnContainers.bind(this)),
                    (this.totalItems = 0),
                    (this.isCartDrawerOpen = !1),
                    (this.isCartDrawerLoaded = !1),
                    (this.cartDiscounts = 0),
                    (this.cartDrawerEnabled = th.cartDrawerEnabled),
                    (this.cartUpdateFailed = !1),
                    this.cartEvents(),
                    this.cartAddEvent(),
                    this.cartDrawerToggleEvents(),
                    this.initQuantity(),
                    this.buttonHolder && (this.collapsible = new Re(this.buttonHolder)),
                    this.isCartPage && this.renderPairProducts(),
                    document.addEventListener("theme:popup:open", this.closeCartDrawer);
            }
            assignArguments() {
                var t;
                (this.outerSection = null === (t = this.cart) || void 0 === t ? void 0 : t.closest(eh.outerSection)),
                    (this.cartDrawerBody = document.querySelector(eh.cartDrawerBody)),
                    (this.emptyMessage = document.querySelector(eh.emptyMessage)),
                    (this.emptyMessageBottom = document.querySelector(eh.emptyMessageBottom)),
                    (this.buttonHolder = document.querySelector(eh.buttonHolder)),
                    (this.itemsHolder = document.querySelector(eh.itemsHolder)),
                    (this.cartItemsQty = document.querySelector(eh.cartItemsQty)),
                    (this.itemsWrapper = document.querySelector(eh.itemsWrapper)),
                    (this.items = document.querySelectorAll(eh.item)),
                    (this.cartTotal = document.querySelector(eh.cartTotal)),
                    (this.cartTotalPrice = document.querySelector(eh.cartTotalPrice)),
                    (this.cartMessage = document.querySelectorAll(eh.cartMessage)),
                    (this.cartOriginalTotal = document.querySelector(eh.cartOriginalTotal)),
                    (this.cartErrorHolder = document.querySelector(eh.cartErrors)),
                    (this.cartCloseErrorMessage = document.querySelector(eh.cartCloseError)),
                    (this.pairProductsHolder = document.querySelector(eh.pairProductsHolder)),
                    (this.cartNoteHolder = document.querySelector(eh.cartNoteHolder)),
                    (this.pairProducts = document.querySelector(eh.pairProducts)),
                    (this.priceHolder = document.querySelector(eh.priceHolder)),
                    (this.upsellHolders = document.querySelectorAll(eh.upsellHolder)),
                    (this.cartTermsCheckbox = document.querySelector(eh.cartTermsCheckbox)),
                    (this.cartCheckoutButtonWrapper = document.querySelector(eh.cartCheckoutButtonWrapper)),
                    (this.cartCheckoutButton = document.querySelector(eh.cartCheckoutButton)),
                    (this.cartForm = document.querySelector(eh.cartForm)),
                    (this.cartItemCount = 0),
                    (this.subtotal = window.theme.subtotal),
                    (this.button = null);
                const { headerInitialHeight: e, announcementBarHeight: i } = N();
                (this.headerInitialHeight = e),
                    (this.announcementBarHeight = i),
                    this.cartMessage.length > 0 &&
                        (this.cartFreeLimitShipping =
                            100 * Number(this.cartMessage[0].getAttribute(bh)) * window.Shopify.currency.rate),
                    this.updateProgress();
            }
            initQuantity() {
                var t;
                (this.items = document.querySelectorAll(eh.item)),
                    null === (t = this.items) ||
                        void 0 === t ||
                        t.forEach((t) => {
                            new Xe(t, !0).init(), this.cartUpdateEvent(t);
                        });
            }
            cartUpdateEvent(t) {
                t.addEventListener("theme:cart:update", (e) => {
                    this.updateCart({ id: e.detail.id, quantity: e.detail.quantity }, t);
                });
            }
            cartEvents() {
                const t = document.querySelectorAll(eh.cartItemRemove);
                (this.totalItems = t.length),
                    null == t ||
                        t.forEach((t) => {
                            const e = t.closest(eh.item);
                            t.addEventListener("click", (i) => {
                                i.preventDefault(),
                                    t.classList.contains(ch) ||
                                        this.updateCart({ id: e.getAttribute(Ch), quantity: 0 }, e);
                            });
                        }),
                    this.cartCloseErrorMessage &&
                        (this.cartCloseErrorMessage.removeEventListener("click", this.closeCartError),
                        this.cartCloseErrorMessage.addEventListener("click", this.closeCartError)),
                    this.cartTermsCheckbox &&
                        (this.cartTermsCheckbox.removeEventListener("change", this.formSubmitHandler),
                        this.cartCheckoutButtonWrapper.removeEventListener("click", this.formSubmitHandler),
                        this.cartForm.removeEventListener("submit", this.formSubmitHandler),
                        this.cartTermsCheckbox.addEventListener("change", this.formSubmitHandler),
                        this.cartCheckoutButtonWrapper.addEventListener("click", this.formSubmitHandler),
                        this.cartForm.addEventListener("submit", this.formSubmitHandler));
            }
            cartAddEvent() {
                document.addEventListener("click", (t) => {
                    const e = t.target,
                        i = null == e ? void 0 : e.matches(eh.buttonAddToCart),
                        s = null == e ? void 0 : e.closest(eh.buttonAddToCart);
                    if (i || s) {
                        var o, n, r;
                        t.preventDefault(),
                            (this.button = i ? e : s),
                            (this.form = e.closest("form")),
                            (this.recipientErrors =
                                "true" === (null === (o = this.form) || void 0 === o ? void 0 : o.getAttribute(Hh))),
                            (this.formWrapper = this.button.closest(eh.formWrapper));
                        const a = null === (n = this.formWrapper) || void 0 === n ? void 0 : n.classList.contains(uh),
                            l = this.button.hasAttribute(Lh),
                            c = this.button.closest(eh.quickViewOnboarding),
                            h = this.button.hasAttribute(xh),
                            d = this.button.hasAttribute(Ih),
                            u = null === (r = this.form) || void 0 === r ? void 0 : r.querySelector('[type="file"]');
                        if (l || u || c) return;
                        if (a && d) return void new Jr(this.button);
                        h && (this.a11y.state.trigger = this.button);
                        let p = new FormData(this.form);
                        [...this.form.elements].some((t) => t.closest(eh.noscript)) &&
                            (p = this.handleFormDataDuplicates([...this.form.elements], p)),
                            this.addToCart(p),
                            document.dispatchEvent(
                                new CustomEvent("theme:cart:add", { bubbles: !0, detail: { selector: e } })
                            );
                    }
                });
            }
            handleFormDataDuplicates(t, e) {
                return t.length && "object" == typeof e
                    ? (t.forEach((t) => {
                          if (t.closest(eh.noscript)) {
                              const i = t.getAttribute(kh),
                                  s = t.value;
                              if (i) {
                                  const t = e.getAll(i);
                                  t.length > 1 && t.splice(t.indexOf(s), 1), e.delete(i), e.set(i, t[0]);
                              }
                          }
                      }),
                      e)
                    : e;
            }
            getCart() {
                if (this.cartDrawer && !this.isCartDrawerLoaded) {
                    const t = !1;
                    this.renderCartDrawer(t);
                }
                fetch(theme.routes.cart_url + "?section_id=api-cart-items")
                    .then(this.handleErrors)
                    .then((t) => t.text())
                    .then((t) => {
                        const e = document.createElement("div");
                        e.innerHTML = t;
                        const i = e.querySelector(eh.apiContent);
                        this.build(i);
                    })
                    .catch((t) => console.log(t));
            }
            addToCart(t) {
                this.cartDrawerEnabled &&
                    this.button &&
                    (this.button.classList.add(lh), this.button.setAttribute(Lh, !0)),
                    fetch(theme.routes.cart_add_url, {
                        method: "POST",
                        headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/javascript" },
                        body: t,
                    })
                        .then((t) => t.json())
                        .then((t) => {
                            if (((this.button.disabled = !0), this.addLoadingClass(), t.status))
                                return this.addToCartError(t), this.removeLoadingClass(), void this.scrollToCartTop();
                            this.hideAddToCartErrorMessage(),
                                this.cartDrawerEnabled ? this.getCart() : (window.location = theme.routes.cart_url);
                        })
                        .catch((t) => console.log(t));
            }
            updateCart(t = {}, e = null) {
                let i = t.quantity;
                null !== e && (i ? e.classList.add(lh) : e.classList.add(ph)),
                    this.disableCartButtons(),
                    this.addLoadingClass();
                const s = this.cart.querySelector(`[${qh}="${t.id}"]`) || e,
                    o = (null == s ? void 0 : s.hasAttribute(Th)) ? parseInt(s.getAttribute(Th)) : 0,
                    n = (null == s ? void 0 : s.hasAttribute(Ph)) ? s.getAttribute(Ph) : null;
                if (0 === o) return;
                const r = { line: o, quantity: i };
                fetch(theme.routes.cart_change_url, {
                    method: "post",
                    headers: { "Content-Type": "application/json", Accept: "application/json" },
                    body: JSON.stringify(r),
                })
                    .then((t) => {
                        if (400 === t.status) {
                            const e = new Error(t.status);
                            throw (
                                (this.cartDrawerEnabled ? this.getCart() : (window.location = theme.routes.cart_url), e)
                            );
                        }
                        return t.text();
                    })
                    .then((t) => {
                        if (JSON.parse(t).errors)
                            return (
                                (this.cartUpdateFailed = !0),
                                this.updateErrorText(n),
                                this.toggleErrorMessage(),
                                this.resetLineItem(e),
                                this.enableCartButtons(),
                                this.removeLoadingClass(),
                                void this.scrollToCartTop()
                            );
                        this.getCart();
                    })
                    .catch((t) => {
                        console.log(t), this.enableCartButtons(), this.removeLoadingClass();
                    });
            }
            resetLineItem(t) {
                const e = t.querySelector(eh.qtyInput),
                    i = e.getAttribute("value");
                (e.value = i), t.classList.remove(lh);
            }
            disableCartButtons() {
                const t = this.cart.querySelectorAll("input"),
                    e = this.cart.querySelectorAll(`button, ${eh.cartItemRemove}`);
                t.length &&
                    t.forEach((t) => {
                        t.classList.add(ch), t.blur(), (t.disabled = !0);
                    }),
                    e.length &&
                        e.forEach((t) => {
                            t.setAttribute(Lh, !0);
                        });
            }
            enableCartButtons() {
                const t = this.cart.querySelectorAll("input"),
                    e = this.cart.querySelectorAll(`button, ${eh.cartItemRemove}`);
                t.length &&
                    t.forEach((t) => {
                        t.classList.remove(ch), (t.disabled = !1);
                    }),
                    e.length &&
                        e.forEach((t) => {
                            t.removeAttribute(Lh);
                        });
            }
            updateErrorText(t) {
                this.cartErrorHolder.querySelector(eh.errorMessage).innerText = t;
            }
            toggleErrorMessage() {
                if (this.cartErrorHolder) {
                    if ((this.cartErrorHolder.classList.toggle(ah, this.cartUpdateFailed), this.cartUpdateFailed)) {
                        const t = this.cartErrorHolder.querySelector(eh.cartCloseError);
                        this.focusOnErrorMessage(this.cartErrorHolder, t);
                    }
                    this.cartUpdateFailed = !1;
                }
            }
            handleErrors(t) {
                return t.ok
                    ? t
                    : t.json().then(function (e) {
                          throw new xe({ status: t.statusText, headers: t.headers, json: e });
                      });
            }
            addToCartError(t) {
                const e = this.button.closest(eh.quickBuyForm),
                    i = this.button.closest(eh.upsellHolder),
                    s = !document.body.classList.contains(fh);
                let o = (
                    this.button.closest(eh.productForm)
                        ? this.button.closest(eh.productForm)
                        : this.button.closest(eh.upsellHolder)
                ).querySelector(eh.formErrorsContainer);
                i && (o = i.querySelector(eh.formErrorsContainer)),
                    this.cartDrawerEnabled &&
                        this.button &&
                        null !== this.button.closest(eh.cartDrawer) &&
                        !this.button.closest(eh.cartDrawer) &&
                        this.closeCartDrawer(),
                    this.button.classList.remove(lh),
                    this.button.removeAttribute(Lh);
                const n = e
                    ? ""
                    : `\n      <button type="button" class="errors__button-close" data-close-error>\n        ${theme.icons.close}\n      </button>\n    `;
                let r = `${t.message}: ${t.description}`;
                if (
                    (t.message === t.description && (r = t.message),
                    this.recipientErrors &&
                        t.description &&
                        "object" == typeof t.description &&
                        (r = Object.entries(t.description)
                            .map(([t, e]) => `${e}`)
                            .join("<br>")),
                    (o.innerHTML = `\n      <div class="errors" data-error autofocus>\n        ${r}\n        ${n}\n      </div>\n    `),
                    e)
                ) {
                    const t = o.closest(eh.productMediaContainer);
                    t.classList.add(yh),
                        o.querySelector(eh.error).addEventListener("animationend", () => {
                            t.classList.remove(yh), (o.innerHTML = ""), s || document.activeElement.blur();
                        });
                } else
                    o.classList.add(rh),
                        o.addEventListener("transitionend", () => {
                            this.resizeSliders(o);
                        }),
                        this.handleCloseErrorMessages(o);
            }
            handleCloseErrorMessages(t) {
                const e = t.querySelector(eh.formCloseError);
                null == e ||
                    e.addEventListener("click", (e) => {
                        const i = e.target;
                        (i.matches(eh.formCloseError) || i.closest(eh.formCloseError)) &&
                            (e.preventDefault(),
                            t.classList.remove(rh),
                            t.querySelector(eh.error).addEventListener("transitionend", () => {
                                (t.innerHTML = ""), this.resizeSliders(i);
                            }));
                    }),
                    this.focusOnErrorMessage(t, e);
            }
            focusOnErrorMessage(t, e) {
                !document.body.classList.contains(fh) &&
                    t.addEventListener("transitionend", () => {
                        requestAnimationFrame(() => (null == e ? void 0 : e.focus({ focusVisible: !0 })));
                    });
            }
            hideAddToCartErrorMessage() {
                const t = this.button.closest(eh.upsellHolder)
                        ? this.button.closest(eh.upsellHolder)
                        : this.button.closest(eh.productForm),
                    e = null == t ? void 0 : t.querySelector(eh.formErrorsContainer);
                null == e || e.classList.remove(rh);
            }
            resizeSliders(t) {
                const i = t.closest(eh.flickityEnabled);
                if (!i) return;
                const s = e.data(i);
                requestAnimationFrame(() => s.resize());
            }
            renderCartDrawer(t = !0) {
                const e = document.querySelector(eh.cartDrawerTemplate);
                e &&
                    ((this.cartDrawer.innerHTML = e.innerHTML),
                    this.assignArguments(),
                    this.initQuantity(),
                    this.cartEvents(),
                    this.cartDrawerBody && (this.collapsible = new Re(this.cartDrawerBody)),
                    (this.cartDrawerToggle = this.cartDrawer.querySelector(eh.cartDrawerToggle)),
                    this.cartDrawerToggle.addEventListener("click", this.cartDrawerToggleClickEvent),
                    (this.isCartDrawerLoaded = !0),
                    this.renderPairProducts(),
                    document.dispatchEvent(new CustomEvent("theme:cart:loaded", { bubbles: !0 })),
                    t && this.openCartDrawer());
            }
            openCartDrawer() {
                this.isCartDrawerOpen ||
                    (this.isCartDrawerLoaded
                        ? (document.dispatchEvent(new CustomEvent("theme:cart:open", { bubbles: !0 })),
                          document.dispatchEvent(
                              new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.cartDrawer })
                          ),
                          document.dispatchEvent(
                              new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.cartDrawerBody })
                          ),
                          this.scrollToCartTop(),
                          document.body.classList.add(oh),
                          this.cartDrawer.classList.add(nh),
                          this.cartDrawer.classList.remove(vh),
                          requestAnimationFrame(() => this.animateCartItems("in")),
                          this.cartToggleButtons.forEach((t) => {
                              t.setAttribute(Eh, !0);
                          }),
                          this.a11y.trapFocus({ container: this.cartDrawer }),
                          this.observeAdditionalCheckoutButtons(),
                          (this.isCartDrawerOpen = !0))
                        : this.renderCartDrawer());
            }
            animateCartItems(t = "in") {
                const e = this.cart.querySelectorAll(eh.aos);
                "in" === t && e.forEach((t) => requestAnimationFrame(() => t.classList.add(mh))),
                    "out" === t && e.forEach((t) => t.classList.remove(mh));
            }
            closeCartDrawer() {
                if (!this.isCartDrawerOpen) return;
                document.dispatchEvent(new CustomEvent("theme:cart:close", { bubbles: !0 })),
                    this.cartErrorHolder.classList.remove(ah),
                    this.a11y.removeTrapFocus(),
                    this.cartToggleButtons.forEach((t) => {
                        t.setAttribute(Eh, !1);
                    }),
                    document.body.classList.remove(oh),
                    this.cartDrawer.classList.remove(nh),
                    this.itemsHolder.classList.remove(gh);
                const t = (e) => {
                    e.target === this.cartDrawer &&
                        (this.animateCartItems("out"), this.cartDrawer.removeEventListener("transitionend", t));
                };
                this.cartDrawer.addEventListener("transitionend", t);
                !document.body.classList.contains(fh) ||
                    requestAnimationFrame(() => {
                        document.activeElement.blur();
                    });
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: 400 })),
                    (this.isCartDrawerOpen = !1);
            }
            toggleCartDrawer() {
                this.isCartDrawerOpen ? this.closeCartDrawer() : this.openCartDrawer();
            }
            cartDrawerToggleEvents() {
                this.cartDrawer &&
                    (this.cartDrawer.addEventListener("keyup", (t) => {
                        t.code === theme.keyboardKeys.ESCAPE && this.closeCartDrawer();
                    }),
                    (this.cartDrawerToggleClickEvent = (t) => {
                        t.preventDefault();
                        const e = t.target;
                        "false" === e.getAttribute(Eh) && (this.a11y.state.trigger = e), this.toggleCartDrawer();
                    }),
                    (this.cartDrawerCloseEvent = (t) => {
                        const e = t.target.matches(eh.cartDrawerToggle),
                            i = document.querySelector(eh.cartDrawer).contains(t.target),
                            s = t.target.closest(eh.popupQuickView);
                        e || i || s || this.closeCartDrawer();
                    }),
                    this.cartToggleButtons.forEach((t) => {
                        t.addEventListener("click", this.cartDrawerToggleClickEvent);
                    }),
                    document.addEventListener("mousedown", this.cartDrawerCloseEvent));
            }
            toggleClassesOnContainers() {
                const t = this;
                this.isCartPage
                    ? this.buttonHolder.classList.toggle(ih, !t.hasItemsInCart())
                    : (this.pairProductsHolder.classList.toggle(ih, !t.hasItemsInCart()),
                      this.cartForm.classList.toggle(ih, !t.hasItemsInCart()),
                      this.emptyMessageBottom.classList.toggle(ih, t.hasItemsInCart()),
                      this.cartNoteHolder.classList.toggle(ih, !t.hasItemsInCart())),
                    this.emptyMessage.classList.toggle(ih, t.hasItemsInCart()),
                    this.itemsHolder.classList.toggle(ih, !t.hasItemsInCart()),
                    this.cartItemsQty.classList.toggle(ih, !t.hasItemsInCart());
            }
            build(t) {
                const e = t.querySelector(eh.apiLineItems),
                    s = t.querySelector(eh.apiUpsellItems),
                    o = Boolean(null === e && null === s),
                    n = t.querySelector(eh.apiCartPrice),
                    r = t.querySelector(eh.cartTotal);
                this.priceHolder && n && (this.priceHolder.innerHTML = n.innerHTML),
                    this.animateCartItems("out"),
                    o
                        ? ((this.itemsHolder.innerHTML = ""),
                          this.pairProductsHolder && (this.pairProductsHolder.innerHTML = ""))
                        : ((this.itemsHolder.innerHTML = e.innerHTML),
                          this.pairProductsHolder && (this.pairProductsHolder.innerHTML = s.innerHTML),
                          this.renderPairProducts()),
                    (this.newTotalItems =
                        e && e.querySelectorAll(eh.item).length ? e.querySelectorAll(eh.item).length : 0),
                    (this.subtotal = r && r.hasAttribute(Sh) ? parseInt(r.getAttribute(Sh)) : 0),
                    (this.cartCount = this.getCartItemCount()),
                    this.cartMessage.length > 0 && this.updateProgress(),
                    this.cartToggleButtons.forEach((t) => {
                        t.classList.remove(dh), this.newTotalItems > 0 && t.classList.add(dh);
                    }),
                    this.toggleErrorMessage(),
                    this.updateItemsQuantity(this.cartCount),
                    (this.cartTotalPrice.innerHTML =
                        0 === this.subtotal
                            ? window.theme.strings.free
                            : i.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat)),
                    this.totalItems !== this.newTotalItems &&
                        ((this.totalItems = this.newTotalItems), this.toggleClassesOnContainers()),
                    (this.isCartDrawerOpen || this.isCartPage) && this.itemsHolder.classList.add(gh),
                    this.cartEvents(),
                    this.initQuantity(),
                    this.enableCartButtons(),
                    this.resetButtonClasses(),
                    this.removeLoadingClass(),
                    document.dispatchEvent(new CustomEvent("theme:cart:added", { bubbles: !0 })),
                    this.cartDrawer && this.openCartDrawer(),
                    requestAnimationFrame(() => this.animateCartItems("in"));
            }
            getCartItemCount() {
                return this.cart
                    ? Array.from(this.cart.querySelectorAll(eh.qtyInput)).reduce((t, e) => t + parseInt(e.value), 0)
                    : 0;
            }
            hasItemsInCart() {
                return this.totalItems > 0;
            }
            freeShippingMessageHandle(t) {
                this.cartMessage.length > 0 &&
                    document.querySelectorAll(eh.cartMessage).forEach((e) => {
                        const i = e.hasAttribute(wh) && "true" === e.getAttribute(wh) && 0 !== t,
                            s = e.querySelector(eh.cartMessageDefault);
                        e.classList.toggle(hh, t >= this.cartFreeLimitShipping && i),
                            e.classList.toggle(sh, 0 === t),
                            s.classList.toggle(sh, t >= this.cartFreeLimitShipping);
                    });
            }
            updateProgress() {
                const t = (this.subtotal / this.cartFreeLimitShipping) * 100,
                    e = theme.settings.currency_code_enable
                        ? i.formatMoney(this.cartFreeLimitShipping - this.subtotal, theme.moneyWithCurrencyFormat)
                        : i.formatMoney(this.cartFreeLimitShipping - this.subtotal, theme.moneyFormat);
                this.cartMessage.length > 0 &&
                    document.querySelectorAll(eh.cartMessage).forEach((i) => {
                        const s = i.querySelectorAll(eh.cartProgress),
                            o = i.querySelector(eh.leftToSpend);
                        o && (o.innerHTML = e.replace(".00", "").replace(",00", "")),
                            s.length &&
                                s.forEach((e, i) => {
                                    e.classList.toggle(sh, this.subtotal / this.cartFreeLimitShipping >= 1),
                                        e.style.setProperty("--progress-width", `${t}%`),
                                        0 === i && e.setAttribute(Ah, t);
                                }),
                            this.freeShippingMessageHandle(this.subtotal);
                    });
            }
            renderPairProducts() {
                if (
                    ((this.flktyUpsell = null),
                    (this.pairProductsHolder = document.querySelector(eh.pairProductsHolder)),
                    (this.pairProducts = document.querySelector(eh.pairProducts)),
                    (this.upsellHolders = document.querySelectorAll(eh.upsellHolder)),
                    null === this.pairProductsHolder || void 0 === this.pairProductsHolder)
                )
                    return;
                const t = this;
                this.upsellHolders.length > 1
                    ? (this.flktyUpsell = new e(this.pairProducts, {
                          wrapAround: !0,
                          pageDots: !0,
                          adaptiveHeight: !0,
                          prevNextButtons: !1,
                          on: {
                              ready: function () {
                                  new Zc(t.cart), this.reloadCells(), requestAnimationFrame(() => this.resize());
                              },
                          },
                      }))
                    : new Zc(this.cart);
            }
            updateItemsQuantity(t) {
                let e = theme.strings.cart_items_one,
                    i = theme.strings.cart_items_many;
                (e = e.split("}}")[1]),
                    (i = i.split("}}")[1]),
                    this.cartItemsQty && (this.cartItemsQty.textContent = 1 === t ? `${t} ${e}` : `${t} ${i}`);
            }
            observeAdditionalCheckoutButtons() {
                const t = this.cart.querySelector(eh.additionalCheckoutButtons);
                if (t) {
                    const e = new MutationObserver(() => {
                        this.a11y.removeTrapFocus(), this.a11y.trapFocus({ container: this.cart }), e.disconnect();
                    });
                    e.observe(t, { subtree: !0, childList: !0 });
                }
            }
            formSubmitHandler() {
                const t = document.querySelector(eh.cartTermsCheckbox).checked,
                    e = document.querySelector(eh.termsErrorMessage);
                if (t) e.classList.remove(ah), this.cartCheckoutButton.removeAttribute(Lh);
                else {
                    if (document.querySelector(eh.termsErrorMessage).length > 0) return;
                    (e.innerText = theme.strings.cart_acceptance_error),
                        this.cartCheckoutButton.setAttribute(Lh, !0),
                        e.classList.add(ah);
                }
            }
            resetButtonClasses() {
                const t = document.querySelectorAll(eh.buttonAddToCart);
                t &&
                    t.forEach((t) => {
                        t.classList.contains(lh) &&
                            (t.classList.remove(lh),
                            t.classList.add(hh),
                            setTimeout(() => {
                                t.removeAttribute(Lh), t.classList.remove(hh);
                            }, th.timers.addProductTimeout));
                    });
            }
            addLoadingClass() {
                this.cartDrawer
                    ? this.cartDrawer.classList.add(lh)
                    : this.itemsWrapper && this.itemsWrapper.classList.add(lh);
            }
            removeLoadingClass() {
                this.cartDrawer
                    ? this.cartDrawer.classList.remove(lh)
                    : this.itemsWrapper && this.itemsWrapper.classList.remove(lh);
            }
            scrollToCartTop() {
                var t;
                this.cartDrawer
                    ? this.cartDrawerBody.scrollTo({ top: 0, left: 0, behavior: "instant" })
                    : window.scrollTo({
                          top:
                              (null === (t = this.outerSection) || void 0 === t ? void 0 : t.offsetTop) -
                              this.headerInitialHeight -
                              this.announcementBarHeight,
                          left: 0,
                          behavior: "smooth",
                      });
            }
            unload() {
                this.cartDrawerToggle &&
                    this.cartDrawerToggle.removeEventListener("click", this.cartDrawerToggleClickEvent),
                    this.cartToggleButtons.forEach((t) => {
                        t.removeEventListener("click", this.cartDrawerToggleClickEvent);
                    }),
                    document.removeEventListener("mousedown", this.cartDrawerCloseEvent),
                    null !== this.collapsible && this.collapsible.onUnload();
            }
            constructor() {
                "/password" !== window.location.pathname && this.init();
            }
        };
    I("cart-template", {
        onLoad() {
            Fh[this.id] = new Mh();
        },
        onUnload() {
            "function" == typeof Fh[this.id].unload && Fh[this.id].unload();
        },
    });
    const Dh = "is-visible",
        Oh = document.querySelector("[data-scroll-top-button]");
    Oh &&
        (Oh.addEventListener("click", () => {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }),
        document.addEventListener(
            "scroll",
            Pe(() => {
                Oh.classList.toggle(Dh, window.pageYOffset > window.innerHeight);
            }, 150)
        ));
    const Bh = "details",
        zh = "[data-popdown-body]",
        _h = "[data-popdown-close]",
        $h = "[data-popdown-toggle]",
        Rh = "[data-search-form-inner]",
        Vh = "[data-popular-searches-link]",
        Nh = "[data-site-header]",
        Wh = "[data-nav]",
        Uh = "[data-nav-items-compress]",
        jh = "[data-nav-icons]",
        Gh = "[data-mobile-menu]",
        Kh = "predictive-search",
        Qh = "search-form",
        Xh = "data-popdown-in-header",
        Yh = "data-popdown-in-page",
        Jh = "data-search-performed",
        Zh = "aria-activedescendant",
        td = "aria-expanded",
        ed = "open",
        id = "role",
        sd = "search-opened",
        od = "site-header--menu-opened",
        nd = "site-header--compress",
        rd = "is-open";
    let ad = class extends HTMLElement {
        connectedCallback() {
            this.isPopdownInHeader &&
                (this.searchFormInner.addEventListener("transitionend", this.popdownTransitionCallbackEvent),
                this.details.addEventListener("keyup", (t) => "ESCAPE" === t.code.toUpperCase() && this.close()),
                this.details.addEventListener("toggle", this.detailsToggleCallbackEvent),
                this.popdownClose.addEventListener("click", (t) => this.close(t)),
                this.popdownToggle.addEventListener("click", (t) => this.onPopdownToggleClick(t)),
                this.popdownToggle.setAttribute(id, "button")),
                this.isPopdownInPage &&
                    (this.popdownClose.addEventListener("click", () => this.triggerPopdownClose()),
                    this.searchFormWrapper.addEventListener("focusout", () => this.onFocusOut()),
                    this.searchFormWrapper.input.addEventListener("click", (t) => this.triggerPopdownOpen(t))),
                this.popularSearchesLink.forEach((t) => {
                    t.addEventListener("click", (t) => {
                        t.preventDefault();
                        const e = t.target.textContent;
                        (this.searchFormWrapper.input.value = e), this.searchFormWrapper.submit();
                    });
                });
        }
        onPopdownToggleClick(t) {
            const e = navigator.userAgent.includes("Chrome"),
                i = /iPhone|iPad|iPod/i.test(navigator.userAgent);
            e && !i && t.target.closest(Bh).setAttribute(ed, ""),
                t.target.closest(Bh).hasAttribute(ed) && (t.preventDefault(), this.close());
        }
        detailsToggleCallback(t) {
            t.target.hasAttribute(ed) && this.open();
        }
        popdownTransitionCallback(t) {
            t.target === this.searchFormInner &&
                (this.details.classList.contains(rd)
                    ? "transform" === t.propertyName && this.a11y.trapFocus({ container: this.searchFormInner })
                    : this.onClose());
        }
        onBodyClick(t) {
            var e;
            const i = this.contains(t.target);
            (null === (e = this.header) || void 0 === e ? void 0 : e.classList.contains(od)) || i || i || this.close();
        }
        onFocusOut() {
            this.predictiveSearch &&
                requestAnimationFrame(() => {
                    this.searchFormWrapper.contains(document.activeElement) || this.searchFormWrapper.close();
                });
        }
        triggerPopdownOpen(t) {
            const e = this.closest(`[${Jh}="false"]`);
            let i = matchMedia("(pointer:coarse)").matches;
            const s = window.innerWidth < theme.sizes.small,
                o = i || s,
                n = null != e;
            if ((s && window.Shopify.designMode && (i = !0), this.nav && this.mobileMenu && (o || n))) {
                t.preventDefault();
                const e = this.header.classList.contains(nd);
                let s = this.mobileMenu.querySelector($h);
                i || (s = e ? this.nav.querySelector(`${Uh} ${$h}`) : this.nav.querySelector(`${jh} ${$h}`)),
                    setTimeout(() => {
                        null == s || s.dispatchEvent(new Event("click", { bubbles: !0 }));
                    }, 300);
            }
        }
        open() {
            (this.onBodyClickEvent = (t) => this.onBodyClick(t)),
                this.searchFormWrapper.input.setAttribute(td, !0),
                document.body.classList.add(sd),
                document.body.addEventListener("click", this.onBodyClickEvent),
                document.addEventListener("theme:resize", this.ensureClosingOnResizeEvent),
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
                requestAnimationFrame(() => {
                    this.details.classList.add(rd);
                });
        }
        close(t) {
            const e = this.searchFormWrapper.input.getAttribute(Zh);
            (t && t.target === this.popdownClose && e && "" !== e) ||
                (this.a11y.removeTrapFocus(),
                this.details.classList.remove(rd),
                this.predictiveSearch && this.searchFormWrapper.close(),
                this.searchFormWrapper.handleFocusableDescendants(!0));
        }
        triggerPopdownClose() {
            this.predictiveSearch && this.searchFormWrapper.close(),
                this.searchFormWrapper.popularSearches && requestAnimationFrame(() => document.activeElement.blur());
        }
        onClose() {
            this.details.removeAttribute(ed),
                document.dispatchEvent(new CustomEvent("theme:search:close", { bubbles: !0 })),
                document.body.classList.remove(sd),
                document.body.removeEventListener("click", this.onBodyClickEvent),
                document.removeEventListener("theme:resize", this.ensureClosingOnResizeEvent),
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
        }
        ensureClosingOnResize() {
            null === this.offsetParent && this.onClose();
        }
        constructor() {
            var t, e, i;
            super(),
                (this.isPopdownInHeader = this.hasAttribute(Xh)),
                (this.isPopdownInPage = this.hasAttribute(Yh)),
                (this.popdownBody = this.querySelector(zh)),
                (this.popdownClose = this.querySelector(_h)),
                (this.searchFormInner = this.querySelector(Rh)),
                (this.popularSearchesLink = this.querySelectorAll(Vh)),
                (this.searchFormWrapper = this.querySelector(Qh) ? this.querySelector(Qh) : this.querySelector(Kh)),
                (this.predictiveSearch = this.searchFormWrapper.matches(Kh)),
                (this.header = document.querySelector(Nh)),
                (this.headerSection = null === (t = this.header) || void 0 === t ? void 0 : t.parentNode),
                (this.nav = null === (e = this.header) || void 0 === e ? void 0 : e.querySelector(Wh)),
                (this.mobileMenu = null === (i = this.headerSection) || void 0 === i ? void 0 : i.querySelector(Gh)),
                (this.a11y = Ye),
                (this.ensureClosingOnResizeEvent = () => this.ensureClosingOnResize()),
                (this.popdownTransitionCallbackEvent = (t) => this.popdownTransitionCallback(t)),
                (this.detailsToggleCallbackEvent = (t) => this.detailsToggleCallback(t)),
                this.isPopdownInHeader &&
                    ((this.details = this.querySelector(Bh)), (this.popdownToggle = this.querySelector($h)));
        }
    };
    customElements.define("search-popdown", ad),
        (Shopify.Products = (function () {
            const t = {
                howManyToShow: 4,
                howManyToStoreInMemory: 10,
                wrapperId: "recently-viewed-products",
                section: null,
                onComplete: null,
            };
            let e = [],
                i = null,
                s = null;
            const o = new Date(),
                n = new Date();
            n.setTime(o.getTime() + 7776e6);
            const r = {
                    configuration: {
                        expires: n.toGMTString(),
                        path: "/",
                        domain: window.location.hostname,
                        sameSite: "none",
                        secure: !0,
                    },
                    name: "shopify_recently_viewed",
                    write: function (t) {
                        const e = t.join(" ");
                        document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
                    },
                    read: function () {
                        let t = [],
                            e = null;
                        return (
                            -1 !== document.cookie.indexOf("; ") &&
                                document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
                                (e = document.cookie
                                    .split("; ")
                                    .find((t) => t.startsWith(this.name))
                                    .split("=")[1]),
                            null !== e && (t = e.split(" ")),
                            t
                        );
                    },
                    destroy: function () {
                        document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
                    },
                    remove: function (t) {
                        const e = this.read(),
                            i = e.indexOf(t);
                        -1 !== i && (e.splice(i, 1), this.write(e));
                    },
                },
                a = (e, i, o, n) => {
                    i.length && e < t.howManyToShow
                        ? fetch(`${window.theme.routes.root}products/${i[0]}?section_id=api-product-grid-item`)
                              .then((t) => t.text())
                              .then((t) => {
                                  const s = 150 * e,
                                      l = o.id ? `#${o.id}` : "",
                                      c = document.createElement("div");
                                  let h = t;
                                  if (h.includes("data-unpublished"))
                                      return r.remove(i[0]), i.shift(), void a(e, i, o, n);
                                  (h = h.includes("||itemAosDelay||") ? h.replaceAll("||itemAosDelay||", s) : h),
                                      (h = h.includes("||itemAosAnchor||") ? h.replaceAll("||itemAosAnchor||", l) : h),
                                      (c.innerHTML = h),
                                      (o.innerHTML += c.querySelector("[data-api-content]").innerHTML),
                                      i.shift(),
                                      e++,
                                      a(e, i, o, n);
                              })
                              .catch(() => {
                                  r.remove(i[0]), i.shift(), a(e, i, o, n);
                              })
                        : ((e, i) => {
                              Ir(e, !0);
                              const o = r.read().length;
                              if (Shopify.recentlyViewed && s && o && o < s && e.children.length) {
                                  let t = [],
                                      i = [],
                                      s = 0;
                                  for (const e in Shopify.recentlyViewed) {
                                      s += 1;
                                      const o = Shopify.recentlyViewed[e].split(" "),
                                          n = parseInt(e.split("_")[1]);
                                      (t = [...t, ...o]),
                                          (r.read().length === n ||
                                              (s === Object.keys(Shopify.recentlyViewed).length && !i.length)) &&
                                              (i = [...i, ...o]);
                                  }
                                  for (let s = 0; s < e.children.length; s++) {
                                      const o = e.children[s];
                                      t.length && o.classList.remove(...t), i.length && o.classList.add(...i);
                                  }
                              }
                              if (t.onComplete)
                                  try {
                                      t.onComplete(e, i);
                                  } catch (t) {
                                      console.log(t);
                                  }
                          })(o, n);
                };
            return {
                showRecentlyViewed: function (o) {
                    const n = o || {};
                    Object.assign(t, n),
                        (e = r.read()),
                        (i = document.querySelector(`#${t.wrapperId}`)),
                        (s = t.howManyToShow),
                        (t.howManyToShow = Math.min(e.length, t.howManyToShow)),
                        t.howManyToShow && i && a(0, e, i, t.section);
                },
                getConfig: function () {
                    return t;
                },
                clearList: function () {
                    r.destroy();
                },
                recordRecentlyViewed: function (e) {
                    const i = e || {};
                    Object.assign(t, i);
                    let s = r.read();
                    if (-1 !== window.location.pathname.indexOf("/products/")) {
                        let e = decodeURIComponent(window.location.pathname)
                            .match(
                                /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
                            )[0]
                            .split("/products/")[1];
                        t.handle && (e = t.handle);
                        const i = s.indexOf(e);
                        -1 === i
                            ? (s.unshift(e), (s = s.splice(0, t.howManyToStoreInMemory)))
                            : (s.splice(i, 1), s.unshift(e)),
                            r.write(s);
                    }
                },
                hasProducts: r.read().length > 0,
            };
        })()),
        (theme.ProductModel = (function () {
            let t = {},
                e = {},
                i = {};
            const s = {
                    productMediaWrapper: "[data-product-single-media-wrapper]",
                    mediaGroup: "[data-product-single-media-group]",
                    productXr: "[data-shopify-xr]",
                    mediaId: "data-media-id",
                    model3d: "data-shopify-model3d-id",
                    modelViewer: "model-viewer",
                    modelJson: "#ModelJson-",
                    deferredMedia: "[data-deferred-media]",
                    deferredMediaButton: "[data-deferred-media-button]",
                },
                o = { isLoading: "is-loading", mediaHidden: "media--hidden" };
            function n(t, n) {
                if (t.querySelector(s.deferredMedia).getAttribute("loaded")) return;
                t.classList.add(o.isLoading);
                const l = document.createElement("div");
                l.appendChild(t.querySelector("template").content.firstElementChild.cloneNode(!0));
                const c = l.querySelector("model-viewer"),
                    h = t.querySelector(s.deferredMedia);
                h.appendChild(c), h.setAttribute("loaded", !0);
                const d = t.dataset.mediaId,
                    u = c.dataset.modelId,
                    p = t.closest(s.mediaGroup).parentElement.querySelector(s.productXr);
                (i[n] = { element: p, defaultId: u }),
                    (e[d] = { modelId: u, mediaId: d, sectionId: n, container: t, element: c }),
                    window.ShopifyXR
                        ? a()
                        : window.Shopify.loadFeatures([
                              { name: "shopify-xr", version: "1.0", onLoad: r },
                              { name: "model-viewer-ui", version: "1.0", onLoad: a },
                          ]);
            }
            function r(e) {
                if (e) console.warn(e);
                else if (window.ShopifyXR) {
                    for (const e in t)
                        if (t.hasOwnProperty(e)) {
                            const i = t[e];
                            if (i.loaded) continue;
                            const o = document.querySelector(`${s.modelJson}${e}`);
                            o && (window.ShopifyXR.addModels(JSON.parse(o.innerHTML)), (i.loaded = !0));
                        }
                    window.ShopifyXR.setupXRElements();
                } else
                    document.addEventListener("shopify_xr_initialized", function () {
                        r();
                    });
            }
            function a(t) {
                if (t) console.warn(t);
                else
                    for (const t in e)
                        if (e.hasOwnProperty(t)) {
                            const i = e[t];
                            i.modelViewerUi || ((i.modelViewerUi = new Shopify.ModelViewerUI(i.element)), l(i));
                        }
            }
            function l(t) {
                const e = i[t.sectionId];
                t.container.addEventListener("theme:media:visible", function () {
                    e.element.setAttribute(s.model3d, t.modelId),
                        window.theme.touch ||
                            (t.modelViewerUi.play(),
                            t.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 }));
                }),
                    t.container.addEventListener("theme:media:hidden", function () {
                        t.modelViewerUi.pause();
                    }),
                    t.container.addEventListener("xrLaunch", function () {
                        t.modelViewerUi.pause();
                    }),
                    t.element.addEventListener("load", () => {
                        e.element.setAttribute(s.model3d, t.modelId),
                            t.container.classList.remove(o.isLoading),
                            t.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
                    }),
                    t.element.addEventListener("shopify_model_viewer_ui_toggle_play", function () {
                        c(t.mediaId),
                            setTimeout(() => {
                                t.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
                            }, 50);
                    }),
                    t.element.addEventListener("shopify_model_viewer_ui_toggle_pause", function () {
                        t.container.dispatchEvent(new CustomEvent("theme:media:pause"), { bubbles: !0 });
                    }),
                    c(t.mediaId);
            }
            function c(t) {
                const e = `[${s.mediaId}="${t}"]`,
                    i = document.querySelectorAll(`${s.productMediaWrapper}:not(${e})`);
                i.length &&
                    i.forEach((t) => {
                        t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }),
                            t.classList.add(o.mediaHidden);
                    });
            }
            return {
                init: function (e, i) {
                    t[i] = { loaded: !1 };
                    const o = e.querySelector(s.deferredMediaButton);
                    o && o.addEventListener("click", n.bind(this, e, i));
                },
                loadContent: n,
                removeSectionModels: function (i) {
                    for (const t in e)
                        if (e.hasOwnProperty(t)) {
                            e[t].sectionId === i && delete e[t];
                        }
                    delete t[i], delete theme.mediaInstances[i];
                },
            };
        })()),
        I("collection-template", Dn);
    const ld = ".template-customers-addresses",
        cd = "[data-form]",
        hd = "[data-form-new]",
        dd = "[data-button-new]",
        ud = "[data-button-edit]",
        pd = "[data-button-delete]",
        md = "[data-button-cancel]",
        gd = "data-form-edit",
        fd = "AddressCountryNew",
        yd = "AddressProvinceNew",
        vd = "AddressProvinceContainerNew",
        bd = "[data-country-option]",
        wd = "AddressCountry",
        Sd = "AddressProvince",
        Ed = "AddressProvinceContainer",
        Ld = 'input[type="text"]:not(.optional)',
        kd = "data-form-id",
        Ad = "is-hidden",
        Cd = "validation--showup";
    const qd = document.querySelector(ld);
    qd &&
        new (class {
            init() {
                if (this.addressNewForm) {
                    const t = this.section,
                        e = this.addressNewForm;
                    this.customerAddresses();
                    const i = t.querySelectorAll(dd);
                    i.length &&
                        i.forEach((t) => {
                            t.addEventListener("click", function (i) {
                                i.preventDefault(), t.classList.add(Ad), e.classList.remove(Ad);
                            });
                        });
                    const s = t.querySelectorAll(ud);
                    s.length &&
                        s.forEach((e) => {
                            e.addEventListener("click", function (e) {
                                e.preventDefault();
                                const i = this.getAttribute(kd);
                                t.querySelector(`[${gd}="${i}"]`).classList.toggle(Ad);
                            });
                        });
                    const o = t.querySelectorAll(pd);
                    o.length &&
                        o.forEach((t) => {
                            t.addEventListener("click", function (t) {
                                t.preventDefault();
                                const e = this.getAttribute(kd);
                                confirm(theme.strings.delete_confirm) &&
                                    Shopify.postLink("/account/addresses/" + e, { parameters: { _method: "delete" } });
                            });
                        });
                    const n = t.querySelectorAll(md);
                    n.length &&
                        n.forEach((t) => {
                            t.addEventListener("click", function (t) {
                                t.preventDefault(),
                                    this.closest(cd).classList.add(Ad),
                                    document.querySelector(dd).classList.remove(Ad);
                            });
                        });
                }
            }
            customerAddresses() {
                Shopify.CountryProvinceSelector && new Shopify.CountryProvinceSelector(fd, yd, { hideElement: vd }),
                    this.section.querySelectorAll(bd).forEach((t) => {
                        const e = t.getAttribute(kd),
                            i = `${wd}_${e}`,
                            s = `${Sd}_${e}`,
                            o = `${Ed}_${e}`;
                        new Shopify.CountryProvinceSelector(i, s, { hideElement: o });
                    });
            }
            validate() {
                this.accountForms.forEach((t) => {
                    const e = t.querySelector("form"),
                        i = e.querySelectorAll(Ld);
                    e.addEventListener("submit", (t) => {
                        let e = !1;
                        i.forEach((t) => {
                            t.value
                                ? t.nextElementSibling.classList.remove(Cd)
                                : (t.nextElementSibling.classList.add(Cd), (e = !0));
                        }),
                            e && t.preventDefault();
                    });
                });
            }
            constructor(t) {
                (this.section = t),
                    (this.addressNewForm = this.section.querySelector(hd)),
                    (this.accountForms = this.section.querySelectorAll(cd)),
                    this.init(),
                    this.validate();
            }
        })(qd);
    const Td = "[data-account-form]",
        Pd = "[data-show-reset]",
        xd = "[data-hide-reset]",
        Id = "[data-recover-password]",
        Hd = "[data-login-form]",
        Fd = "[data-recover-success]",
        Md = "[data-recover-success-text]",
        Dd = "#recover",
        Od = "is-hidden";
    const Bd = document.querySelector(Td);
    Bd &&
        new (class {
            init() {
                window.location.hash == Dd ? this.showRecoverPasswordForm() : this.hideRecoverPasswordForm(),
                    this.success && this.successText.classList.remove(Od),
                    this.showButton.addEventListener(
                        "click",
                        (t) => {
                            t.preventDefault(), this.showRecoverPasswordForm();
                        },
                        !1
                    ),
                    this.hideButton.addEventListener(
                        "click",
                        (t) => {
                            t.preventDefault(), this.hideRecoverPasswordForm();
                        },
                        !1
                    );
            }
            showRecoverPasswordForm() {
                return this.recover.classList.remove(Od), this.login.classList.add(Od), (window.location.hash = Dd), !1;
            }
            hideRecoverPasswordForm() {
                return this.login.classList.remove(Od), this.recover.classList.add(Od), (window.location.hash = ""), !1;
            }
            constructor(t) {
                (this.form = t),
                    (this.showButton = t.querySelector(Pd)),
                    (this.hideButton = t.querySelector(xd)),
                    (this.recover = t.querySelector(Id)),
                    (this.login = t.querySelector(Hd)),
                    (this.success = t.querySelector(Fd)),
                    (this.successText = t.querySelector(Md)),
                    this.init();
            }
        })(Bd),
        I("search-template", [Dn, gr]);
    const zd = "[data-ticker-scale]",
        _d = "[data-ticker-text]",
        $d = "data-clone",
        Rd = "data-marquee-speed",
        Vd = "ticker--animated",
        Nd = "ticker--unloaded",
        Wd = "ticker__comparitor",
        Ud = 1.63,
        jd = 100;
    const Gd = "[data-parallax]",
        Kd = ".shopify-section",
        Qd = "[data-main]",
        Xd = "is-disabled",
        Yd = "main-content",
        Jd = "shopify-section",
        Zd = "section-footer--visible",
        tu = "card-scrolling-hidden",
        eu = "sticky-top-zero",
        iu = "data-parallax",
        su = "data-parallax-intensity",
        ou = "data-parallax-static",
        nu = "data-parallax-single",
        ru = "data-parallax-disable-on-mobile",
        au = "data-parallax-rounded-corners",
        lu = "data-parallax-rounded-corners-large",
        cu = {};
    let hu = class {
        assignFooterArguments() {
            this.animations.includes("footer") &&
                ((this.shopifySection = this.container.closest(Kd)),
                (this.footerPrevSectionOffset = 0),
                this.container.hasAttribute(au) &&
                    ((this.footerPrevSectionOffset = 8),
                    this.container.hasAttribute(lu) && (this.footerPrevSectionOffset = 34)),
                (this.prevSection = this.container.parentNode.previousElementSibling),
                !this.prevSection ||
                    this.prevSection.classList.contains(Jd) ||
                    this.prevSection.classList.contains(Yd) ||
                    (this.prevSection = this.main),
                requestAnimationFrame(() => {
                    (this.containerHeight = this.container.offsetHeight),
                        (this.footerOffset = 0.15 * this.containerHeight),
                        (this.cachedPosition = this.footerOffset),
                        (this.cachedPercentage = 0);
                }));
        }
        assignCardScrollingArguments() {
            if (!this.animations.includes("card-scrolling")) return;
            let { stickyHeaderHeight: t } = N();
            if (
                ((this.headerHeight = t || 0),
                (this.shopifySection = this.container.closest(Kd)),
                (this.nextSection = this.shopifySection.nextElementSibling),
                (this.cardScrollingStickyTop = this.headerHeight || 0),
                (this.cardScrollingMarginTop = this.nextSection
                    ? parseInt(window.getComputedStyle(this.nextSection).getPropertyValue("margin-top"))
                    : 0),
                (this.after = !1),
                (this.prevSection = this.shopifySection.previousElementSibling),
                this.prevSection)
            ) {
                const t = this.firstSection.id,
                    e = this.prevSection.matches(`#${t}`),
                    i = this.prevSection.offsetHeight;
                this.shopifySection.classList.toggle(eu, e && i <= 2 * this.headerHeight);
            }
            this.opacityValue = (t) =>
                t
                    ? Boolean(t <= 0)
                        ? 0
                        : Boolean(t > 0 && t <= 100)
                          ? Number(t / 100).toFixed(4)
                          : Boolean(t > 100)
                            ? 1
                            : void 0
                    : 0;
        }
        init() {
            this.updateParallax(),
                document.addEventListener("theme:scroll", this.scrollEvent),
                document.addEventListener("theme:resize", this.resizeEvent);
        }
        updateParallax() {
            this.container.classList.contains(Xd) ||
                (this.disableOnMobile && de()) ||
                ((this.scrollTop = Math.round(window.scrollY)),
                (this.scrollBottom = this.scrollTop + this.viewportHeight),
                (this.elementOffsetTopPoint = Math.round(this.container.getBoundingClientRect().top + this.scrollTop)),
                window.Shopify.designMode &&
                    (this.assignCardScrollingArguments(), (this.containerHeight = this.container.offsetHeight)),
                (this.elementOffsetBottomPoint = this.elementOffsetTopPoint + this.containerHeight),
                (this.isBottomOfElementPassed = this.elementOffsetBottomPoint < this.scrollTop),
                (this.isTopOfElementReached = this.elementOffsetTopPoint < this.scrollBottom),
                (this.isInView = this.isTopOfElementReached && !this.isBottomOfElementPassed),
                this.adjustCalculations(),
                this.toggleVisibility(),
                this.isInView &&
                    ((this.scrollProgress = this.scrollBottom - this.elementOffsetTopPoint),
                    (this.percentage = (100 * (this.scrollProgress - this.containerHeight / 2)) / this.viewportHeight),
                    (this.percentageFull = Number(this.scrollProgress / this.containerHeight).toFixed(2)),
                    (this.percentageVisible = Number(
                        (100 * this.scrollProgress) / (this.viewportHeight + this.containerHeight)
                    ).toFixed(2)),
                    this.animations.includes("circle") && this.animateCircleText(),
                    (this.animations.includes("horizontal") ||
                        this.animations.includes("vertical") ||
                        this.animations.includes("diagonal")) &&
                        this.animateOverlappingImages(),
                    (this.animations.includes("offset-ltr") || this.animations.includes("offset-rtl")) &&
                        this.offsetX(),
                    this.animations.includes("card-scrolling") && this.cardScrollingEffect(),
                    this.animations.includes("zoom-on-scroll") && this.zoomInOut(),
                    this.animations.includes("footer") && this.animateFooter()));
        }
        adjustCalculations() {
            var t;
            (this.animations.includes("card-scrolling") &&
                ((this.currentSectionTop = this.shopifySection.getBoundingClientRect().top),
                this.nextSection
                    ? ((this.nextSectionTop = this.nextSection.getBoundingClientRect().top),
                      (this.offsetTop = this.nextSectionTop - this.containerHeight - this.cardScrollingMarginTop))
                    : ((this.nextSectionTop = this.currentSectionTop + this.containerHeight),
                      (this.offsetTop = this.currentSectionTop)),
                (this.distance = Math.floor(this.currentSectionTop - this.headerHeight)),
                (this.after = Boolean(
                    Math.round(
                        this.nextSectionTop -
                            this.headerHeight -
                            this.cardScrollingMarginTop +
                            0.1 * this.viewportHeight
                    ) < 0
                )),
                (this.isInView = this.isTopOfElementReached && !this.after)),
            this.animations.includes("footer")) &&
                ((this.elementOffsetTopPoint = Math.round(
                    (null === (t = this.prevSection) || void 0 === t ? void 0 : t.getBoundingClientRect().bottom) -
                        this.footerPrevSectionOffset +
                        this.scrollTop
                )),
                (this.elementOffsetBottomPoint = this.elementOffsetTopPoint + this.containerHeight),
                (this.isBottomOfElementPassed = this.elementOffsetBottomPoint < this.scrollTop),
                (this.isTopOfElementReached = this.elementOffsetTopPoint < this.scrollBottom),
                (this.isInView = this.isTopOfElementReached && !this.isBottomOfElementPassed),
                (this.isApproaching =
                    Math.round(this.elementOffsetTopPoint - this.viewportHeight / 2) < this.scrollBottom));
        }
        toggleVisibility() {
            this.animations.includes("card-scrolling") && this.shopifySection.classList.toggle(tu, this.after),
                this.animations.includes("footer") &&
                    (Boolean(this.isApproaching || this.isInView)
                        ? this.shopifySection.classList.add(Zd)
                        : this.shopifySection.classList.remove(Zd));
        }
        cardScrollingEffect() {
            const t = (this.offsetTop / this.containerHeight) * -100;
            this.container.style.setProperty("--card-scrolling-overlay", this.opacityValue(t));
        }
        zoomInOut() {
            if (this.animations.includes("card-scrolling") && this.nextSection) {
                const t = this.nextSectionTop - this.headerHeight - this.cardScrollingMarginTop - this.containerHeight,
                    e = Math.round(t + this.scrollTop),
                    i = this.scrollBottom - e;
                this.percentageVisible = Number(
                    (100 * i) / (this.viewportHeight + this.containerHeight + this.cardScrollingMarginTop)
                ).toFixed(2);
            }
            const t = (0.2 * this.percentageVisible) / 100;
            let e = Number(1 + t).toFixed(4);
            (e = e > 1 ? e : 1), this.container.style.setProperty("--scale", e);
        }
        offsetX() {
            const t = this.container.hasAttribute(ou),
                e = this.container.getAttribute(su) || 100;
            let i = this.animations.includes("offset-ltr") ? e : 0;
            t && (i = e / 2);
            const s = this.animations.includes("offset-ltr") ? 1 : -1,
                o = (e * this.percentageVisible) / 100 - i,
                n = Number(o * s).toFixed(2);
            this.container.style.setProperty("--offsetX", `${n}%`);
        }
        updateHeight() {
            if (this.animations.includes("card-scrolling")) {
                let { stickyHeaderHeight: t } = N();
                if (
                    ((this.headerHeight = t || 0),
                    (this.cardScrollingStickyTop = this.headerHeight || 0),
                    (this.cardScrollingMarginTop = this.nextSection
                        ? parseInt(window.getComputedStyle(this.nextSection).getPropertyValue("margin-top"))
                        : 0),
                    (this.containerHeight = this.container.offsetHeight),
                    (this.prevSection = this.shopifySection.previousElementSibling),
                    this.prevSection)
                ) {
                    const t = this.firstSection.id,
                        e = this.prevSection.matches(`#${t}`),
                        i = this.prevSection.offsetHeight;
                    this.shopifySection.classList.toggle(eu, e && i <= 2 * this.headerHeight);
                }
            }
            const t = matchMedia("(min-width: 1024px)").matches;
            (this.orientation !== X() || t) &&
                ((this.viewportHeight = Math.round(
                    Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
                )),
                (this.containerHeight = this.container.offsetHeight),
                (this.orientation = X()));
        }
        animateCircleText() {
            const t = ((70 * this.percentage) / 100) * -1;
            this.percentage > 0 && this.container.style.setProperty("--rotate", `${35 + t}deg`);
        }
        animateOverlappingImages() {
            const t = 0.25 * this.container.getAttribute(su),
                e = t / 2,
                i = this.container.hasAttribute(nu),
                s = (t * this.percentage) / 100;
            let o = 0,
                n = 0,
                r = 0,
                a = 0;
            (this.animations.includes("horizontal") || this.animations.includes("diagonal")) &&
                ((o = -1 * e + s), (r = e - s)),
                (this.animations.includes("vertical") || this.animations.includes("diagonal")) &&
                    ((n = e - s), (a = -1 * e + s)),
                this.container.style.setProperty("--transformX-primary", `${o}%`),
                this.container.style.setProperty("--transformY-primary", `${n}%`),
                i ||
                    (this.container.style.setProperty("--transformX-secondary", `${r}%`),
                    this.container.style.setProperty("--transformY-secondary", `${a}%`));
        }
        animateFooter() {
            const t = this.footerOffset * this.percentageFull,
                e = Number((t / this.footerOffset) * 100).toFixed(2),
                i = new WebKitCSSMatrix(window.getComputedStyle(this.container).transform),
                s = Number(i.m42).toFixed(2);
            let o = Number(this.footerOffset - t).toFixed(2);
            this.percentageFull >= 1 && (o = 0),
                s !== o &&
                    this.cachedPercentage !== e &&
                    (this.container.style.setProperty("--transformY", `${o}`),
                    (this.cachedPercentage = e),
                    (this.cachedPosition = o));
        }
        unload() {
            document.removeEventListener("theme:scroll", this.scrollEvent),
                document.removeEventListener("theme:resize", this.resizeEvent);
        }
        constructor(t) {
            (this.container = t),
                (this.percentage = 0),
                (this.percentageFull = 0),
                (this.animation = this.container.getAttribute(iu)),
                (this.animations = this.animation.split(",")),
                (this.disableOnMobile = this.container.hasAttribute(ru)),
                (this.viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)),
                (this.containerHeight = this.container.offsetHeight),
                (this.main = document.querySelector(Qd)),
                (this.firstSection = this.main.children[0]),
                (this.orientation = X()),
                (this.scrollEvent = () => this.updateParallax()),
                (this.resizeEvent = () => this.updateHeight()),
                this.assignFooterArguments(),
                this.assignCardScrollingArguments(),
                requestAnimationFrame(() => this.init());
        }
    };
    const du = {
            onLoad() {
                cu[this.id] = [];
                this.container.querySelectorAll(Gd).forEach((t) => {
                    cu[this.id].push(new hu(t));
                });
            },
            onUnload() {
                cu[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        uu = "[data-announcement]",
        pu = "[data-announcement-slide]",
        mu = "[data-ticker-frame]",
        gu = "[data-slide]",
        fu = "[data-slider]",
        yu = "[data-static]",
        vu = "[data-ticker-scale]",
        bu = "[data-ticker-text]",
        wu = "[data-parallax]",
        Su = "text-highlight",
        Eu = "data-slide",
        Lu = "data-slider-speed",
        ku = "data-slider-arrows",
        Au = "data-stop",
        Cu = "style",
        qu = "data-target-referrer",
        Tu = "clip-path",
        Pu = "desktop",
        xu = "mobile",
        Iu = "ticker--animated",
        Hu = "is-disabled",
        Fu = "clipPath",
        Mu = {};
    const Du = {
        onLoad() {
            Mu[this.id] = [];
            const t = this.container.querySelector(uu);
            t &&
                Mu[this.id].push(
                    new (class {
                        init() {
                            this.removeAnnouncement(),
                                this.slider &&
                                    (this.initSlider(),
                                    document.addEventListener("theme:resize:width", this.initSlider.bind(this))),
                                this.static && (this.initTickers(), this.tickerAnimationPause()),
                                this.slider || this.static || (this.initTickers(!0), this.tickerAnimationPause()),
                                this.updateSVGClipPathIDs();
                        }
                        removeAnnouncement() {
                            for (let t = 0; t < this.slides.length; t++) {
                                const e = this.slides[t];
                                e.hasAttribute(qu) &&
                                    (-1 !== this.locationPath.indexOf(e.getAttribute(qu)) ||
                                        window.Shopify.designMode ||
                                        e.parentNode.removeChild(e));
                            }
                        }
                        checkSlidesClasses(t, e) {
                            if (0 !== t.length) {
                                const i = e.querySelectorAll(`${gu}.${xu}`),
                                    s = e.querySelectorAll(`${gu}.${Pu}`);
                                t.length === i.length
                                    ? e.parentNode.classList.add(xu)
                                    : t.length === s.length && e.parentNode.classList.add(Pu);
                            }
                        }
                        initSlider() {
                            const t = this.slider.querySelectorAll(gu),
                                i = this.slider.hasAttribute(ku);
                            if ((this.checkSlidesClasses(t, this.barHolder), t)) {
                                let t = `${gu}`;
                                (t = window.innerWidth < theme.sizes.small ? `${gu}:not(.${Pu})` : `${gu}:not(.${xu})`),
                                    null != this.flkty && this.flkty.destroy(),
                                    (this.flkty = new e(this.slider, {
                                        cellSelector: t,
                                        pageDots: !1,
                                        prevNextButtons: i,
                                        wrapAround: !0,
                                        autoPlay: parseInt(this.slider.getAttribute(Lu), 10),
                                        on: {
                                            ready: () => {
                                                setTimeout(() => {
                                                    this.slider.dispatchEvent(
                                                        new CustomEvent("slider-is-loaded", {
                                                            bubbles: !0,
                                                            detail: { slider: this },
                                                        })
                                                    );
                                                }, 10);
                                            },
                                            change: (t) => {
                                                this.flkty.cells.forEach((e, i) => {
                                                    e.element.querySelectorAll(Su).forEach((e) => {
                                                        e.setTriggerAttribute(Boolean(i === t));
                                                    });
                                                });
                                            },
                                        },
                                    })),
                                    this.flkty.reposition();
                            }
                            this.slider.addEventListener("slider-is-loaded", () => {
                                this.initTickers(), this.updateSVGClipPathIDs();
                            });
                        }
                        initTickers(t = !1) {
                            this.barHolder.querySelectorAll(mu).forEach((e) => {
                                const i = new (class {
                                    listen() {
                                        document.addEventListener("theme:resize:width", this.resizeEvent),
                                            this.checkWidth();
                                    }
                                    checkWidth() {
                                        const t = 2 * window.getComputedStyle(this.frame).paddingLeft.replace("px", "");
                                        if (
                                            this.frame.clientWidth - t < this.comparitor.clientWidth ||
                                            this.stopClone
                                        ) {
                                            if (1 === this.scale.childElementCount) {
                                                if (
                                                    (this.text.classList.add(Vd),
                                                    (this.clone = this.text.cloneNode(!0)),
                                                    this.clone.setAttribute($d, ""),
                                                    this.scale.appendChild(this.clone),
                                                    this.stopClone)
                                                )
                                                    for (let t = 0; t < 10; t++) {
                                                        const t = this.text.cloneNode(!0);
                                                        t.setAttribute($d, ""), this.scale.appendChild(t);
                                                    }
                                                let t = this.frame.getAttribute(Rd);
                                                null === t && (t = 100);
                                                const e = Ud * (100 / parseInt(t, 10)),
                                                    i = (this.text.clientWidth / jd) * e;
                                                this.scale.style.setProperty("--animation-time", `${i}s`);
                                            }
                                        } else {
                                            this.text.classList.add(Vd);
                                            let t = this.scale.querySelector(`[${$d}]`);
                                            t && this.scale.removeChild(t), this.text.classList.remove(Vd);
                                        }
                                    }
                                    unload() {
                                        document.removeEventListener("theme:resize:width", this.resizeEvent);
                                    }
                                    constructor(t, e = !1) {
                                        (this.frame = t),
                                            (this.stopClone = e),
                                            (this.scale = this.frame.querySelector(zd)),
                                            (this.text = this.frame.querySelector(_d)),
                                            (this.comparitor = this.text.cloneNode(!0)),
                                            this.comparitor.classList.add(Wd),
                                            this.frame.appendChild(this.comparitor),
                                            this.scale.classList.remove(Nd),
                                            (this.resizeEvent = o(() => this.checkWidth(), 100)),
                                            this.listen();
                                    }
                                })(e, t);
                                this.tickers.push(i);
                                const s = e.querySelectorAll(gu);
                                this.checkSlidesClasses(s, this.barHolder);
                            });
                        }
                        toggleTicker(t, e) {
                            const i = t.target.closest(vu),
                                s = document.querySelector(`[${Eu}="${t.detail.blockId}"]`);
                            e &&
                                s &&
                                (i.setAttribute(Au, ""),
                                i.querySelectorAll(bu).forEach((t) => {
                                    t.classList.remove(Iu),
                                        (t.style.transform = `translate3d(${-(s.offsetLeft - parseInt(getComputedStyle(s).marginLeft, 10))}px, 0, 0)`);
                                })),
                                !e &&
                                    s &&
                                    (i.querySelectorAll(bu).forEach((t) => {
                                        t.classList.add(Iu), t.removeAttribute(Cu);
                                    }),
                                    i.removeAttribute(Au),
                                    this.static &&
                                        document.dispatchEvent(new CustomEvent("theme:resize:width", { bubbles: !0 })));
                        }
                        tickerAnimationPause() {
                            let t = 0,
                                e = !1;
                            const i = this.barHolder.querySelector(pu);
                            i.addEventListener("mouseenter", () => {
                                (e = !0),
                                    (t = setTimeout(() => {
                                        e &&
                                            i.querySelectorAll(bu).forEach((t) => {
                                                t.style.animationPlayState = "paused";
                                            }),
                                            clearTimeout(t);
                                    }, 500));
                            }),
                                i.addEventListener("mouseleave", () => {
                                    (e = !1),
                                        i.querySelectorAll(bu).forEach((t) => {
                                            t.style.animationPlayState = "running";
                                        });
                                });
                        }
                        updateSVGClipPathIDs() {
                            this.barHolder.querySelectorAll(gu).forEach((t, e) => {
                                const i = t.querySelector(Fu);
                                if (i) {
                                    const s = `${i.id}_${e}`;
                                    i.id = s;
                                    const o = t.querySelector(`g[${Tu}]`);
                                    o && o.setAttribute(Tu, `url(#${s})`);
                                }
                            });
                        }
                        onBlockSelect(t) {
                            const e = parseInt([...t.target.parentNode.children].indexOf(t.target));
                            this.slider && null !== this.flkty && (this.flkty.select(e), this.flkty.pausePlayer()),
                                this.slider || this.toggleTicker(t, !0),
                                this.parallax &&
                                    (this.parallax.style.setProperty("--offsetX", "0%"),
                                    this.parallax.classList.add(Hu));
                        }
                        onBlockDeselect(t) {
                            this.slider && null !== this.flkty && this.flkty.unpausePlayer(),
                                this.slider || this.toggleTicker(t, !1),
                                this.parallax &&
                                    (this.parallax.classList.remove(Hu),
                                    document.dispatchEvent(new CustomEvent("theme:scroll")));
                        }
                        onUnload() {
                            document.removeEventListener("theme:resize:width", this.initSlider.bind(this)),
                                this.tickers.length > 0 &&
                                    this.tickers.forEach((t) => {
                                        t.unload();
                                    });
                        }
                        constructor(t) {
                            (this.barHolder = t),
                                (this.locationPath = location.href),
                                (this.slides = this.barHolder.querySelectorAll(gu)),
                                (this.slider = this.barHolder.querySelector(fu)),
                                (this.static = this.barHolder.querySelector(yu)),
                                (this.parallax = this.barHolder.querySelector(wu)),
                                (this.tickers = []),
                                (this.flkty = null),
                                this.init();
                        }
                    })(t)
                );
        },
        onBlockSelect(t) {
            Mu[this.id].length &&
                Mu[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
        },
        onBlockDeselect(t) {
            Mu[this.id].length &&
                Mu[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockDeselect(t);
                });
        },
        onUnload() {
            Mu[this.id].forEach((t) => {
                "function" == typeof t.onUnload && t.onUnload();
            });
        },
    };
    I("announcement-bar", Du), I("marquee", [Du, du]);
    const Ou = "[data-hover-disclosure]",
        Bu = "[data-site-header]",
        zu = "[data-top-link]",
        _u = "[data-header-background]",
        $u = "[data-nav-item]",
        Ru = "is-visible",
        Vu = "grandparent",
        Nu = "site-header--menu-opened",
        Wu = "has-scrolled",
        Uu = "site-header--hovered",
        ju = "megamenu-opened",
        Gu = "data-hover-disclosure-toggle",
        Ku = "aria-haspopup",
        Qu = "aria-expanded",
        Xu = "aria-controls";
    let Yu = {};
    const Ju = {
            onLoad() {
                Yu[this.id] = [];
                this.container.querySelectorAll(Ou).forEach((t) => {
                    Yu[this.id].push(
                        new (class {
                            setBackgroundHeight() {
                                (this.hasScrolled = this.body.classList.contains(Wu)),
                                    (this.headerHeight = this.hasScrolled
                                        ? window.stickyHeaderHeight
                                        : this.header.offsetHeight),
                                    this.grandparent
                                        ? ((this.dropdown.style.height = "auto"),
                                          (this.dropdownHeight = this.dropdown.offsetHeight + this.headerHeight))
                                        : (this.dropdownHeight = this.headerHeight),
                                    this.background.style.setProperty(
                                        "--header-background-height",
                                        `${this.dropdownHeight}px`
                                    ),
                                    window.innerWidth < theme.sizes.small && this.hideDisclosure();
                            }
                            showDisclosure() {
                                this.setBackgroundHeight(),
                                    document.addEventListener("theme:resize", this.setBackgroundHeightEvent),
                                    this.trigger.setAttribute(Qu, !0),
                                    this.trigger.classList.add(Ru),
                                    this.header.classList.add(Nu),
                                    this.trigger.classList.contains(Vu) && this.body.classList.add(ju),
                                    this.updateHeaderHover();
                            }
                            hideDisclosure() {
                                this.background.style.removeProperty("--header-background-height"),
                                    document.removeEventListener("theme:resize", this.setBackgroundHeightEvent),
                                    this.trigger.classList.remove(Ru),
                                    this.trigger.setAttribute(Qu, !1),
                                    this.header.classList.remove(Nu),
                                    this.body.classList.remove(ju);
                            }
                            updateHeaderHover() {
                                requestAnimationFrame(() => {
                                    const t = this.header.matches(":hover"),
                                        e = this.header.classList.contains(Uu);
                                    t && !e && this.header.classList.add(Uu);
                                });
                            }
                            handleTablets() {
                                this.trigger.addEventListener("touchstart", (t) => {
                                    if (!this.trigger.classList.contains(Ru)) {
                                        t.preventDefault();
                                        const e = this.header.querySelectorAll(`.${Ru}${$u}`);
                                        if (e.length > 0)
                                            return void e.forEach((t) => {
                                                if (t !== this.trigger) {
                                                    t.dispatchEvent(new Event("mouseleave", { bubbles: !0 }));
                                                    const e = () => {
                                                        requestAnimationFrame(() => {
                                                            this.showDisclosure();
                                                        }),
                                                            t.removeEventListener("transitionend", e);
                                                    };
                                                    t.addEventListener("transitionend", e);
                                                }
                                            });
                                        this.showDisclosure();
                                    }
                                });
                            }
                            connectHoverToggle() {
                                this.trigger.addEventListener("mouseenter", () => this.showDisclosure()),
                                    this.link.addEventListener("focus", () => this.showDisclosure()),
                                    this.trigger.addEventListener("mouseleave", () => this.hideDisclosure()),
                                    this.trigger.addEventListener("focusout", (t) => {
                                        this.trigger.contains(t.relatedTarget) || this.hideDisclosure();
                                    }),
                                    this.disclosure.addEventListener("keyup", (t) => {
                                        t.code === theme.keyboardKeys.ESCAPE && this.hideDisclosure();
                                    });
                            }
                            onBlockSelect(t) {
                                this.disclosure.contains(t.target) && this.showDisclosure(t);
                            }
                            onBlockDeselect(t) {
                                this.disclosure.contains(t.target) && this.hideDisclosure();
                            }
                            constructor(t) {
                                (this.disclosure = t),
                                    (this.body = document.body),
                                    (this.header = t.closest(Bu)),
                                    (this.key = this.disclosure.id),
                                    (this.trigger = document.querySelector(`[${Gu}='${this.key}']`)),
                                    (this.link = this.trigger.querySelector(zu)),
                                    (this.grandparent = this.trigger.classList.contains(Vu)),
                                    (this.background = document.querySelector(_u)),
                                    this.trigger.setAttribute(Ku, !0),
                                    this.trigger.setAttribute(Qu, !1),
                                    this.trigger.setAttribute(Xu, this.key),
                                    (this.dropdown = this.trigger.querySelector(Ou)),
                                    (this.setBackgroundHeightEvent = () => this.setBackgroundHeight()),
                                    this.connectHoverToggle(),
                                    this.handleTablets();
                            }
                        })(t)
                    );
                });
            },
            onBlockSelect(t) {
                Yu[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
            onBlockDeselect(t) {
                Yu[this.id].forEach((e) => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
                });
            },
        },
        Zu = "[data-site-header]",
        tp = "[data-announcement-wrapper]",
        ep = "[data-collection-filters]",
        ip = "[data-logo-text-link]",
        sp = "[data-collapsible-trigger]",
        op = "#nav-drawer",
        np = "[data-drawer]",
        rp = "[data-drawer-toggle]",
        ap = "[data-popdown-toggle]",
        lp = "[data-mobile-menu]",
        cp = "[data-nav]",
        hp = "[data-nav-icons]",
        dp = "[data-nav-item]",
        up = "[data-nav-link-mobile]",
        pp = "[data-nav-search-open]",
        mp = "[data-wrapper]",
        gp = "[data-header-background]",
        fp = "[data-cart-page]",
        yp = "[data-takes-space]",
        vp = {
            jsDrawerOpenAll: [
                "js-drawer-open",
                "js-drawer-open-cart",
                "js-quick-view-visible",
                "js-quick-view-from-cart",
            ],
            headerTransparent: "site-header--transparent",
            headerHovered: "site-header--hovered",
            headerMenuOpened: "site-header--menu-opened",
            hasScrolled: "has-scrolled",
            hasStickyHeader: "has-sticky-header",
            hideHeader: "hide-header",
            headerCompress: "site-header--compress",
            isVisible: "is-visible",
            isOpen: "is-open",
            searchOpened: "search-opened",
            noOutline: "no-outline",
            cloneClass: "js__header__clone",
        },
        bp = "data-nav-alignment",
        wp = "data-header-sticky",
        Sp = {};
    const Ep = {
        onLoad() {
            Sp[this.id] = new (class {
                updateHeaderHover() {
                    requestAnimationFrame(() => {
                        const t = this.header.matches(":hover"),
                            e = this.header.classList.contains(vp.headerHovered);
                        t && !e && this.header.classList.add(vp.headerHovered);
                    });
                }
                handleTouchstart(t) {
                    const e = this.header.contains(t.target),
                        i = this.header.querySelector(`.${vp.isVisible}${dp}`);
                    !e && i && i.dispatchEvent(new Event("mouseleave", { bubbles: !0 }));
                }
                handleTextLinkLogos() {
                    if (null === this.logoTextLink) return;
                    const t = this.header.offsetHeight;
                    document.documentElement.style.setProperty("--header-height", `${t}px`),
                        document.documentElement.style.setProperty("--header-sticky-height", `${t}px`);
                }
                initStickyHeader() {
                    if (
                        ((this.headerSticky = this.header.hasAttribute(wp)),
                        CSS.supports("(selector(:has(*)))") ||
                            document.body.classList.toggle(vp.hasStickyHeader, this.headerSticky),
                        (this.hasScrolled = !1),
                        (this.hasCollectionFilters = document.querySelector(ep)),
                        (this.position = this.header.dataset.position),
                        "fixed" === this.position && !this.hasCollectionFilters)
                    )
                        return (
                            this.headerState(), void document.addEventListener("theme:scroll", this.headerStateEvent)
                        );
                    document.body.classList.remove(vp.hasScrolled),
                        window.isHeaderTransparent && this.header.classList.add(vp.headerTransparent);
                }
                headerState(t) {
                    const e = parseInt(this.header.dataset.height || this.header.offsetHeight),
                        i = document.querySelector(tp),
                        s = e + (i ? i.offsetHeight : 0),
                        o = window.pageYOffset || document.documentElement.scrollTop,
                        n = t && t.detail && t.detail.up;
                    (this.hasScrolled = o > s), document.body.classList.toggle(vp.hasScrolled, this.hasScrolled);
                    const r = o < s + window.stickyHeaderHeight && n;
                    if ((document.body.classList.toggle(vp.hideHeader, r), window.isHeaderTransparent)) {
                        const t = !this.hasScrolled || r;
                        this.header.classList.toggle(vp.headerTransparent, t);
                    }
                    if (this.header.classList.contains(vp.headerHovered)) {
                        const t = this.hasScrolled ? window.stickyHeaderHeight : e;
                        this.background.style.setProperty("--header-background-height", `${t}px`);
                        const i = this.header.querySelector(`.${vp.isVisible}${dp}`);
                        i && i.dispatchEvent(new Event("mouseenter", { bubbles: !0 }));
                    }
                }
                handleBackgroundEvents() {
                    this.headerWrapper.addEventListener("mouseenter", this.updateBackgroundHeightEvent),
                        this.headerWrapper.addEventListener("mouseleave", this.updateBackgroundHeightEvent),
                        this.header.addEventListener("focusout", this.updateBackgroundHeightEvent),
                        document.addEventListener("theme:cart:close", this.updateBackgroundHeightEvent),
                        document.addEventListener("theme:search:close", this.updateBackgroundHeightEvent);
                }
                updateBackgroundHeight(t) {
                    const e = matchMedia("(pointer:fine)").matches,
                        i = !document.body.classList.contains(vp.noOutline),
                        s = e && !i;
                    if (!t) return;
                    let o = vp.jsDrawerOpenAll.some((t) => document.body.classList.contains(t));
                    ("mouseenter" === t.type || o) &&
                        ((this.headerHeight = this.hasScrolled ? window.stickyHeaderHeight : this.header.offsetHeight),
                        this.header.classList.add(vp.headerHovered),
                        this.header.classList.contains(vp.headerMenuOpened) ||
                            this.background.style.setProperty("--header-background-height", `${this.headerHeight}px`)),
                        "mouseenter" !== t.type &&
                            requestAnimationFrame(() => {
                                if (((o = vp.jsDrawerOpenAll.some((t) => document.body.classList.contains(t))), o))
                                    return;
                                if ("focusout" === t.type && !e) return;
                                if ("theme:search:close" === t.type && !s) return;
                                if (this.hasScrolled) return;
                                const n = null === document.activeElement.closest(Zu),
                                    r = document.body.classList.contains(vp.searchOpened),
                                    a = this.header.classList.contains(vp.headerMenuOpened);
                                r ||
                                    a ||
                                    (("focusout" !== t.type || n) &&
                                        (this.header.classList.remove(vp.headerHovered),
                                        this.background.style.setProperty("--header-background-height", "0px"),
                                        i || document.activeElement.blur()));
                            });
                }
                listenWidth() {
                    document.addEventListener("theme:resize", this.checkWidthEvent), this.checkWidth();
                }
                checkWidth() {
                    window.innerWidth < this.minWidth
                        ? this.header.classList.add(vp.headerCompress)
                        : this.header.classList.remove(vp.headerCompress);
                }
                getMinWidth() {
                    const t = this.headerWrapper.currentStyle || window.getComputedStyle(this.headerWrapper),
                        e = 2 * parseInt(t.paddingLeft),
                        i = this.header.cloneNode(!0);
                    i.classList.add(vp.cloneClass), document.body.appendChild(i);
                    const s = i.querySelectorAll(yp),
                        o = (function (t, e) {
                            let i = [];
                            t.forEach((t) => {
                                i.push(t.clientWidth);
                            });
                            let [s, o, n] = i;
                            if ("left" === e) {
                                const t = s;
                                (s = o), (o = t);
                            }
                            return "right" !== e && (s > n ? (n = s) : (s = n)), s + o + n;
                        })(s, this.header.getAttribute(bp));
                    return document.body.removeChild(i), o + 20 * s.length + e;
                }
                initMobileNav() {
                    var t;
                    if (
                        ((this.mobileMenu = this.headerSection.querySelector(lp)),
                        (this.navDrawer = this.headerSection.querySelector(op)),
                        (this.drawerToggle = this.navDrawer.querySelector(rp)),
                        (this.navSearchOpen = this.navDrawer.querySelectorAll(pp)),
                        null === (t = this.navSearchOpen) ||
                            void 0 === t ||
                            t.forEach((t) => {
                                t.addEventListener("click", (t) => {
                                    t.preventDefault();
                                    const e = this.drawerToggle.closest(`${np}.${vp.isOpen}`),
                                        i = matchMedia("(pointer:coarse)").matches
                                            ? this.mobileMenu.querySelector(ap)
                                            : this.nav.querySelector(ap);
                                    this.drawerToggle.dispatchEvent(new Event("click", { bubbles: !0 }));
                                    const s = (t) => {
                                        t.target === e &&
                                            (requestAnimationFrame(() =>
                                                i.dispatchEvent(new Event("click", { bubbles: !0 }))
                                            ),
                                            e.removeEventListener("transitionend", s));
                                    };
                                    e.addEventListener("transitionend", s);
                                });
                            }),
                        "link" === theme.settings.mobileMenuBehaviour)
                    )
                        return;
                    const e = this.headerSection.querySelectorAll(up);
                    e.length &&
                        e.forEach((t) => {
                            t.addEventListener("click", (e) => {
                                const i = t.parentNode.querySelectorAll(sp).length,
                                    s = t.nextElementSibling;
                                i && (e.preventDefault(), s.dispatchEvent(new Event("click"), { bubbles: !0 }));
                            });
                        });
                }
                onUnload() {
                    document.documentElement.style.removeProperty("--header-height"),
                        document.documentElement.style.removeProperty("--header-sticky-height"),
                        this.initStickyHeader(),
                        document.body.classList.remove(...vp.jsDrawerOpenAll),
                        document.removeEventListener("theme:scroll", this.headerStateEvent),
                        document.removeEventListener("theme:resize", this.checkWidthEvent),
                        document.removeEventListener("theme:cart:close", this.updateBackgroundHeightEvent),
                        document.removeEventListener("theme:search:close", this.updateBackgroundHeightEvent),
                        document.body.removeEventListener("touchstart", this.handleTouchstartEvent),
                        document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
                        "function" == typeof window.cart.unload && window.cart.unload();
                }
                constructor(t) {
                    (this.container = t),
                        (this.background = document.querySelector(gp)),
                        (this.header = t),
                        (this.headerSection = t.parentNode),
                        (this.headerWrapper = t.querySelector(mp)),
                        (this.logoTextLink = t.querySelector(ip)),
                        (this.nav = t.querySelector(cp)),
                        (this.navIcons = t.querySelector(hp)),
                        (this.headerStateEvent = (t) => this.headerState(t)),
                        (this.handleTouchstartEvent = (t) => this.handleTouchstart(t)),
                        (this.updateBackgroundHeightEvent = (t) => this.updateBackgroundHeight(t)),
                        p(),
                        (this.minWidth = this.getMinWidth()),
                        (this.checkWidthEvent = () => this.checkWidth()),
                        this.listenWidth(),
                        this.initMobileNav(),
                        this.handleTextLinkLogos(),
                        this.initStickyHeader(),
                        this.handleBackgroundEvents(),
                        document.querySelector(fp) || (window.cart = new Mh()),
                        document.body.addEventListener("touchstart", this.handleTouchstartEvent, { passive: !0 }),
                        this.updateHeaderHover();
                }
            })(this.container);
        },
        onUnload() {
            Sp[this.id].onUnload();
        },
    };
    I("header", [Ep, Ju, xr]);
    const Lp = "[data-collapsible-trigger]",
        kp = "is-expanded";
    I("accordions", [
        {
            onBlockSelect(t) {
                const e = t.target.querySelector(Lp);
                requestAnimationFrame(() => {
                    e.classList.contains(kp) || e.dispatchEvent(new Event("click"));
                });
            },
        },
        Ve,
    ]);
    const Ap = "[data-share-button]",
        Cp = "[data-share-button-tooltip]",
        qp = "is-visible",
        Tp = "is-hiding",
        Pp = {};
    const xp = {
        onLoad() {
            Pp[this.id] = new (class {
                init() {
                    this.button &&
                        this.button.addEventListener("click", () => {
                            let t = window.location.href;
                            this.button.dataset.shareLink && (t = this.button.dataset.shareLink),
                                this.tooltip.classList.contains(qp) ||
                                    navigator.clipboard.writeText(t).then(() => {
                                        this.tooltip.classList.add(qp),
                                            setTimeout(() => {
                                                this.tooltip.classList.add(Tp),
                                                    this.tooltip.classList.remove(qp),
                                                    this.hideTransitionTimeout &&
                                                        clearTimeout(this.hideTransitionTimeout),
                                                    (this.hideTransitionTimeout = setTimeout(() => {
                                                        this.tooltip.classList.remove(Tp);
                                                    }, this.transitionSpeed));
                                            }, 1500);
                                    });
                        });
                }
                constructor(t) {
                    (this.container = t),
                        (this.button = this.container.querySelector(Ap)),
                        (this.tooltip = this.container.querySelector(Cp)),
                        (this.transitionSpeed = 200),
                        (this.hideTransitionTimeout = 0),
                        this.init();
                }
            })(this.container);
        },
    };
    I("article", [xp]);
    const Ip = "[data-video-play]",
        Hp = "data-video-play";
    const Fp = {
            onLoad() {
                new (class {
                    init() {
                        this.videoPlay.length &&
                            this.videoPlay.forEach((t) => {
                                t.addEventListener("click", (e) => {
                                    if (t.hasAttribute(Hp) && "" !== t.getAttribute(Hp).trim()) {
                                        e.preventDefault();
                                        const i = [{ html: t.getAttribute(Hp) }],
                                            s = { mainClass: "pswp--video" };
                                        (this.a11y.state.trigger = t), new Mc(i, s);
                                    }
                                });
                            });
                    }
                    constructor(t) {
                        (this.container = t),
                            (this.videoPlay = this.container.querySelectorAll(Ip)),
                            (this.a11y = Ye),
                            this.init();
                    }
                })(this.container);
            },
        },
        Mp = "[data-banner-image]",
        Dp = ".lazy-image",
        Op =
            '[data-parallax="zoom-on-scroll"],[data-parallax="card-scrolling"],[data-parallax="zoom-on-scroll,card-scrolling"]',
        Bp = "banner--no-cached-images",
        zp = "banner--img-loaded",
        _p = "img-in",
        $p = {};
    I("banner-image", [
        {
            onLoad() {
                $p[this.id] = new (class {
                    init() {
                        this.handleImageAnimation(!0),
                            this.container.matches(Op) && (this.parallax = new hu(this.container));
                    }
                    handleImageAnimation(t = !1) {
                        if (!t) return this.container.classList.remove(Bp), void this.container.classList.remove(zp);
                        const e = this.container.querySelector(Mp).querySelectorAll(Dp),
                            i = this.container.classList.contains(_p);
                        if (e.length && !i) {
                            this.container.classList.add(Bp);
                            const t = (i) => {
                                requestAnimationFrame(() => this.container.classList.add(zp)),
                                    e[0].removeEventListener("transitionend", t);
                            };
                            e[0].addEventListener("transitionend", t);
                        }
                    }
                    onReorder() {
                        this.handleImageAnimation(!1);
                    }
                    onUnload() {
                        this.handleImageAnimation(!1),
                            this.parallax && (this.parallax.unload(), (this.parallax = null));
                    }
                    constructor(t) {
                        (this.container = t.container), (this.parallax = null), this.init();
                    }
                })(this);
            },
            onReorder(t) {
                $p[this.id].onReorder(t);
            },
            onUnload(t) {
                $p[this.id].onUnload(t);
            },
        },
        Fp,
    ]);
    const Rp = "[data-scroll-spy]",
        Vp = "is-selected",
        Np = "is-full-height",
        Wp = "data-scroll-spy",
        Up = "data-scroll-spy-prevent",
        jp = "data-scroll-spy-mobile",
        Gp = "data-scroll-spy-desktop",
        Kp = {};
    const Qp = {
            onLoad() {
                Kp[this.id] = [];
                this.container.querySelectorAll(Rp).forEach((t) => {
                    const e = this.container.querySelector(t.getAttribute(Wp));
                    Kp[this.id].push(
                        new (class {
                            init() {
                                this.onScroll(),
                                    document.addEventListener("theme:scroll", this.scrollCallback),
                                    document.addEventListener("theme:resize:width", this.scrollCallback);
                            }
                            isEligible() {
                                return (
                                    !this.container.hasAttribute(Up) &&
                                    ((de() && this.anchor.hasAttribute(jp)) ||
                                        (he() && this.anchor.hasAttribute(Gp)) ||
                                        (!this.anchor.hasAttribute(Gp) && !this.anchor.hasAttribute(jp)))
                                );
                            }
                            onScroll() {
                                if (!this.isEligible()) return;
                                (this.top = this.element.getBoundingClientRect().top),
                                    (this.bottom = this.element.getBoundingClientRect().bottom);
                                const t = Math.round(window.innerHeight),
                                    e = Math.round(window.scrollY),
                                    i = e + t,
                                    s = Math.round(this.top + e),
                                    o = this.element.offsetHeight;
                                if (!(s < i) || s + o < e) return;
                                this.anchor.parentNode.offsetHeight <= o
                                    ? this.container.style.setProperty(
                                          "--sticky-position",
                                          window.innerHeight / 2 - o / 2 + "px"
                                      )
                                    : this.container.classList.add(Np),
                                    (this.anchorTop = this.anchor.getBoundingClientRect().top),
                                    (this.anchorBottom = this.anchor.getBoundingClientRect().bottom);
                                const n = this.top < this.anchorTop,
                                    r = this.bottom < this.anchorBottom;
                                n &&
                                    !r &&
                                    (this.anchors.forEach((t) => {
                                        t.matches(this.anchorSelector) || t.classList.remove(Vp);
                                    }),
                                    this.anchor.classList.add(Vp));
                            }
                            onUnload() {
                                document.removeEventListener("theme:scroll", this.scrollCallback),
                                    document.removeEventListener("theme:resize:width", this.scrollCallback);
                            }
                            constructor(t, e) {
                                (this.container = t),
                                    (this.element = e),
                                    this.element &&
                                        ((this.anchorSelector = `[${Wp}="#${this.element.id}"]`),
                                        (this.anchor = this.container.querySelector(this.anchorSelector)),
                                        (this.anchors = this.container.querySelectorAll(`[${Wp}]`)),
                                        this.anchor && ((this.scrollCallback = () => this.onScroll()), this.init()));
                            }
                        })(this.container, e)
                    );
                });
            },
            onUnload() {
                Kp[this.id].forEach((t) => {
                    "function" == typeof t.onUnload && t.onUnload();
                });
            },
        },
        Xp = "[data-banner]",
        Yp = "[data-slider-content]",
        Jp = "[data-slider-media]",
        Zp = "a, button",
        tm = "data-index",
        em = "tabindex",
        im = "data-slider-single-image",
        sm = "data-scroll-spy-prevent",
        om = "is-selected",
        nm = "row",
        rm = "columns";
    let am = {};
    I("banner-with-text-columns", [
        {
            onLoad() {
                am[this.id] = new (class {
                    listen() {
                        document.addEventListener("theme:resize:width", this.onResizeCallback),
                            this.links.forEach((t) => {
                                t.addEventListener("focus", () => {
                                    const e = Number(t.closest(Xp).getAttribute(tm));
                                    window.innerWidth >= theme.sizes.small && this.sync(e);
                                });
                            }),
                            this.banners.forEach((t) => {
                                t.addEventListener("mouseenter", () => {
                                    const e = Number(t.getAttribute(tm));
                                    window.innerWidth >= theme.sizes.small && !window.theme.touch && this.sync(e);
                                }),
                                    t.addEventListener("pointerup", () => {
                                        const e = Number(t.getAttribute(tm));
                                        window.innerWidth >= theme.sizes.small && window.theme.touch && this.sync(e);
                                    });
                            });
                    }
                    handleColumnsLayout() {
                        if (this.sliderContent.children.length <= 1) return;
                        let t = window.innerWidth < window.theme.sizes.small;
                        this.sliderMedia.children.length > 1 &&
                            ((this.flktyMedia = new e(this.sliderMedia, {
                                draggable: !1,
                                wrapAround: !1,
                                fade: !0,
                                prevNextButtons: !1,
                                adaptiveHeight: !1,
                                pageDots: !1,
                                setGallerySize: !1,
                                on: {
                                    change: (t) => {
                                        this.handleGroupItemsNavigation(t, this.flktyContent);
                                    },
                                },
                            })),
                            Si(this.sliderMedia)),
                            (this.flktyContent = new e(this.sliderContent, {
                                draggable: t,
                                prevNextButtons: !1,
                                pageDots: !0,
                                cellAlign: "left",
                                adaptiveHeight: !1,
                                imagesLoaded: !0,
                                on: {
                                    ready: () => {
                                        this.listen(), this.slidesTabIndex();
                                    },
                                    change: (t) => {
                                        window.innerWidth < theme.sizes.small &&
                                            !this.singleImageEnabled &&
                                            this.flktyMedia.select(t),
                                            this.slidesTabIndex(),
                                            this.handleGroupItemsNavigation(t, this.flktyMedia);
                                    },
                                },
                            })),
                            Si(this.sliderContent);
                    }
                    handleRowLayout() {
                        if (this.sliderMedia.children.length <= 1 || de())
                            return this.updateState(0), void this.listen();
                        this.initMediaSlider();
                    }
                    initMediaSlider() {
                        (this.flktyMedia = new e(this.sliderMedia, {
                            draggable: !0,
                            wrapAround: !1,
                            fade: !0,
                            prevNextButtons: !1,
                            adaptiveHeight: !1,
                            pageDots: !1,
                            setGallerySize: !1,
                            on: {
                                ready: () => {
                                    this.updateState(0), this.listen();
                                },
                                change: (t) => {
                                    this.updateState(t);
                                },
                            },
                        })),
                            Si(this.sliderMedia);
                    }
                    handleGroupItemsNavigation(t, e = null) {
                        null !== e &&
                            requestAnimationFrame(() => {
                                t !== e.selectedIndex && e.select(t);
                            });
                    }
                    slidesTabIndex() {
                        this.sliderContent &&
                            e.data(this.sliderContent).cells.forEach((t) => {
                                let e = "-1";
                                t.element.classList.contains(om) && (e = "0"),
                                    t.element.querySelectorAll(Zp).forEach((t) => {
                                        t.setAttribute(em, e);
                                    });
                            });
                    }
                    sync(t = 0) {
                        this.appearance === rm ? this.flktyContent.selectCell(t) : this.updateState(t),
                            this.flktyMedia && this.flktyMedia.selectCell(t);
                    }
                    updateState(t = 0) {
                        this.banners.forEach((e) => {
                            const i = Number(e.getAttribute(tm));
                            e.classList.toggle(om, i === t);
                        });
                    }
                    handleSlidersOnResize() {
                        if (this.appearance === nm) {
                            if (de() && this.flktyMedia)
                                return this.flktyMedia.destroy(), void (this.flktyMedia = null);
                            if (he() && !this.flktyMedia) return void this.initMediaSlider();
                        }
                        this.flktyContent && (this.flktyContent.resize(), this.toggleDraggable()),
                            this.flktyMedia && this.flktyMedia.resize();
                    }
                    toggleDraggable() {
                        (this.flktyContent.options.draggable = window.innerWidth < window.theme.sizes.small),
                            this.flktyContent.updateDraggable();
                    }
                    onBlockSelect(t) {
                        const e = parseInt([...t.target.parentNode.children].indexOf(t.target));
                        if ((this.sync(e), this.appearance === nm)) {
                            const t = this.sliderMedia.children[e],
                                i = Math.round(t.getBoundingClientRect().top);
                            this.container.setAttribute(sm, ""),
                                setTimeout(() => Fr(i), 400),
                                setTimeout(() => this.container.removeAttribute(sm), 1e3);
                        }
                    }
                    onUnload() {
                        document.removeEventListener("theme:resize:width", this.onResizeCallback);
                    }
                    constructor(t) {
                        var e;
                        (this.container = t.container),
                            (this.sliderContent = this.container.querySelector(Yp)),
                            (this.singleImageEnabled =
                                null === (e = this.sliderContent) || void 0 === e ? void 0 : e.hasAttribute(im)),
                            (this.banners = this.container.querySelectorAll(Xp)),
                            (this.links = this.container.querySelectorAll("a")),
                            (this.sliderMedia = this.container.querySelector(Jp)),
                            (this.flktyContent = null),
                            (this.flktyMedia = null),
                            (this.onResizeCallback = () => this.handleSlidersOnResize()),
                            (this.appearance = this.container.dataset.appearance),
                            this.appearance === rm ? this.handleColumnsLayout() : this.handleRowLayout();
                    }
                })(this);
            },
            onBlockSelect(t) {
                am[this.id].onBlockSelect(t);
            },
        },
        Qp,
    ]),
        I("blog-posts", Mo);
    const lm = "[data-slider]",
        cm = "[data-slider-item]",
        hm = "[data-media-container]",
        dm = "a, button",
        um = ".flickity-button",
        pm = "carousel--inactive",
        mm = "carousel--resize",
        gm = "tabindex",
        fm = {};
    const ym = {
        onLoad() {
            fm[this.id] = new (class {
                initSlider() {
                    this.slider.classList.remove(pm),
                        (this.flkty = new e(this.slider, {
                            pageDots: !1,
                            cellAlign: "left",
                            groupCells: !0,
                            contain: !0,
                            on: {
                                ready: () => {
                                    this.setSliderArrowsPosition(this.slider),
                                        setTimeout(() => {
                                            this.changeTabIndex(), this.flkty.resize();
                                        }, 0);
                                },
                                change: () => {
                                    this.changeTabIndex();
                                },
                            },
                        })),
                        (e.prototype._createResizeClass = function () {
                            this.element.classList.add(mm);
                        }),
                        e.createMethods.push("_createResizeClass");
                    const t = e.prototype.resize;
                    e.prototype.resize = function () {
                        this.element.classList.remove(mm), t.call(this), this.element.classList.add(mm);
                    };
                }
                destroySlider() {
                    this.slider.classList.add(pm), null !== this.flkty && (this.flkty.destroy(), (this.flkty = null));
                }
                checkSlidesSize() {
                    const t =
                        this.container.querySelector(cm).currentStyle ||
                        window.getComputedStyle(this.container.querySelector(cm));
                    this.gutter = parseInt(t.marginRight);
                    const e = this.slider.offsetWidth < this.getItemsWidth();
                    window.innerWidth >= theme.sizes.small && e ? this.initSlider() : this.destroySlider();
                }
                changeTabIndex() {
                    const t = this.flkty.selectedIndex;
                    this.flkty.slides.forEach((e, i) => {
                        e.cells.forEach((e) => {
                            e.element.querySelectorAll(dm).forEach((e) => {
                                e.setAttribute(gm, t === i ? "0" : "-1");
                            });
                        });
                    });
                }
                getItemsWidth() {
                    let t = 0;
                    const e = this.slider.querySelectorAll(cm);
                    return (
                        e.length &&
                            e.forEach((e) => {
                                t += e.offsetWidth + this.gutter;
                            }),
                        t
                    );
                }
                listen() {
                    this.slider &&
                        (this.checkSlidesSize(),
                        document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize));
                }
                setSliderArrowsPosition(t) {
                    const e = t.querySelectorAll(um),
                        i = t.querySelector(hm);
                    e.length &&
                        i &&
                        e.forEach((t) => {
                            t.style.top = i.offsetHeight / 2 + "px";
                        });
                }
                onBlockSelect(t) {
                    if (null !== this.flkty) {
                        const e = parseInt([...t.target.parentNode.children].indexOf(t.target)),
                            i = parseInt(this.flkty.slides[0].cells.length),
                            s = Math.floor(e / i);
                        this.flkty.select(s);
                    } else {
                        const e = this.slider.currentStyle || window.getComputedStyle(this.slider),
                            i = parseInt(e.paddingLeft),
                            s = t.target.offsetLeft - i;
                        this.slider.scrollTo({ top: 0, left: s, behavior: "smooth" });
                    }
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize);
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.slider = this.container.querySelector(lm)),
                        (this.flkty = null),
                        (this.gutter = 0),
                        (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
                        this.listen();
                }
            })(this);
        },
        onUnload(t) {
            fm[this.id].onUnload(t);
        },
        onBlockSelect(t) {
            fm[this.id].onBlockSelect(t);
        },
    };
    I("columns-with-image", [ym, Fp]);
    const vm = "[data-form-message-close]",
        bm = "[data-form-message]",
        wm = "hide-down",
        Sm = "notification-visible";
    let Em = {};
    I("contact-form", {
        onLoad() {
            Em[this.id] = new (class {
                hidePopups() {
                    document.body.classList.add(Sm);
                }
                showPopups() {
                    document.body.classList.remove(Sm);
                }
                closeFormMessage() {
                    this.closeButton.addEventListener("click", this.closeMessage.bind(this));
                }
                closeMessage(t) {
                    t.preventDefault(), this.messageWrapper.classList.add(wm), this.showPopups();
                }
                autoHideMessage() {
                    setTimeout(() => {
                        this.messageWrapper.classList.add(wm), this.showPopups();
                    }, 1e4);
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.closeButton = this.container.querySelector(vm)),
                        (this.messageWrapper = this.container.querySelector(bm)),
                        this.messageWrapper && (this.hidePopups(), this.closeFormMessage(), this.autoHideMessage());
                }
            })(this);
        },
    });
    const Lm = "time",
        km = "[data-days]",
        Am = "[data-hours]",
        Cm = "[data-minutes]",
        qm = "[data-seconds]",
        Tm = "[data-section-type]",
        Pm = ".shopify-section",
        xm = "[data-aos]",
        Im = "countdown-timer--show-message",
        Hm = "hide-countdown",
        Fm = "aos-animate",
        Mm = "countdown",
        Dm = "data-expiration-behavior",
        Om = "data-leading-zero",
        Bm = "hide",
        zm = "show-message";
    let _m = class extends HTMLElement {
        connectedCallback() {
            this.init();
        }
        disconnectedCallback() {
            this.stopTimer();
        }
        init() {
            isNaN(this.endDate) || this.endDate <= Date.now()
                ? this.onComplete()
                : (this.section.classList.contains(Mm) && this.onLoad(!0),
                  (this.interval = setInterval(this.update, 1e3)));
        }
        stopTimer() {
            clearInterval(this.interval);
        }
        convertTime(t) {
            const e = this.formatDigits(parseInt(t / this.daysInMs, 10));
            t -= e * this.daysInMs;
            const i = this.formatDigits(parseInt(t / this.hoursInMs, 10));
            t -= i * this.hoursInMs;
            const s = this.formatDigits(parseInt(t / this.minutesInMs, 10));
            t -= s * this.minutesInMs;
            return { days: e, hours: i, minutes: s, seconds: this.formatDigits(parseInt(t / this.secondsInMs, 10)) };
        }
        formatDigits(t) {
            return t < 10 && this.leadingZero && (t = "0" + t), t;
        }
        render(t) {
            (this.days.textContent = t.days),
                (this.hours.textContent = t.hours),
                (this.minutes.textContent = t.minutes),
                (this.seconds.textContent = t.seconds);
        }
        onComplete() {
            this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 }),
                this.shouldHideOnComplete && this.shopifySection.classList.add(Hm),
                this.shouldShowMessage && this.classList.add(Im);
        }
        triggerAnimations() {
            "false" != theme.settings.animations &&
                this.section.querySelectorAll(xm).forEach((t) => {
                    this.isAnimated && t.classList.add(Fm);
                });
        }
        removeAnimations() {
            this.section.querySelectorAll(xm).forEach((t) => {
                requestAnimationFrame(() => {
                    t.classList.contains(Fm) && (t.classList.remove(Fm), (this.isAnimated = !0));
                });
            });
        }
        onLoad(t) {
            t ? this.removeAnimations() : ((this.isLoading = !1), this.triggerAnimations());
        }
        update() {
            const t = Date.now(),
                e = this.endDate - t;
            if (e <= 0) return this.stopTimer(), void this.onComplete();
            const i = this.convertTime(e);
            this.render(i), this.isLoading && this.onLoad(!1);
        }
        constructor() {
            super(),
                (this.section = this.closest(Tm)),
                (this.shopifySection = this.closest(Pm)),
                (this.expirationBehavior = this.getAttribute(Dm)),
                (this.leadingZero = this.hasAttribute(Om)),
                (this.time = this.querySelector(Lm)),
                (this.endDate = Date.parse(this.time.dateTime)),
                (this.days = this.querySelector(km)),
                (this.hours = this.querySelector(Am)),
                (this.minutes = this.querySelector(Cm)),
                (this.seconds = this.querySelector(qm)),
                (this.daysInMs = 864e5),
                (this.hoursInMs = this.daysInMs / 24),
                (this.minutesInMs = this.hoursInMs / 60),
                (this.secondsInMs = this.minutesInMs / 60),
                (this.isLoading = !0),
                (this.shouldHideOnComplete = this.expirationBehavior === Bm),
                (this.shouldShowMessage = this.expirationBehavior === zm),
                (this.isAnimated = !1),
                (this.update = this.update.bind(this));
        }
    };
    I("countdown", [Fp, du]), customElements.get("countdown-timer") || customElements.define("countdown-timer", _m);
    const $m = "[data-video-id]",
        Rm = "[data-video-player]",
        Vm = "[data-video-template]",
        Nm = "[data-video-autoplay]",
        Wm = "[data-video-wrapper]",
        Um = "[data-video-bg-play]",
        jm = "is-loading",
        Gm = "is-paused",
        Km = {};
    const Qm = {
        onLoad() {
            Km[this.id] = [];
            this.container.querySelectorAll(Wm).forEach((t) => {
                Km[this.id].push(
                    new (class {
                        init() {
                            this.videoId &&
                                (new IntersectionObserver(
                                    (t, e) => {
                                        t.forEach((t) => {
                                            if (t.isIntersecting) {
                                                const i = this.videoTemplate.innerHTML;
                                                (this.videoPlayer.innerHTML = i),
                                                    (this.video = this.container.querySelector(Nm)),
                                                    this.videoPlayer.classList.remove(jm),
                                                    this.container.classList.add(Gm),
                                                    this.listen(),
                                                    e.unobserve(t.target);
                                            }
                                        });
                                    },
                                    { root: null, rootMargin: "300px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
                                ).observe(this.videoPlayer),
                                this.videoPlayButton.addEventListener("click", (t) => {
                                    var e;
                                    t.preventDefault(), null === (e = this.video) || void 0 === e || e.play();
                                }));
                        }
                        listen() {
                            this.video.addEventListener("play", () => {
                                this.container.classList.remove(Gm);
                            }),
                                this.container.addEventListener(
                                    "touchstart",
                                    () => {
                                        this.video.play();
                                    },
                                    { passive: !0 }
                                );
                        }
                        constructor(t) {
                            (this.container = t),
                                (this.videoId = this.container.querySelector($m)),
                                (this.videoPlayer = this.container.querySelector(Rm)),
                                (this.videoTemplate = this.container.querySelector(Vm)),
                                (this.videoPlayButton = this.container.querySelector(Um)),
                                this.init();
                        }
                    })(t)
                );
            });
        },
    };
    let Xm = class {
        write() {
            ((-1 !== document.cookie.indexOf("; ") &&
                !document.cookie.split("; ").find((t) => t.startsWith(this.name))) ||
                -1 === document.cookie.indexOf("; ")) &&
                (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
        }
        read() {
            if (
                -1 !== document.cookie.indexOf("; ") &&
                document.cookie.split("; ").find((t) => t.startsWith(this.name))
            ) {
                return document.cookie
                    .split("; ")
                    .find((t) => t.startsWith(this.name))
                    .split("=")[1];
            }
            return !1;
        }
        destroy() {
            document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
                (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
        }
        constructor(t, e) {
            (this.configuration = {
                expires: null,
                path: "/",
                domain: window.location.hostname,
                sameSite: "none",
                secure: !0,
            }),
                (this.name = t),
                (this.value = e);
        }
    };
    const Ym = "[data-newsletter-form]",
        Jm = "[data-popup]",
        Zm = "has-success",
        tg = "has-error",
        eg = "newsletter_form_id",
        ig = {};
    const sg = {
            onLoad() {
                ig[this.id] = [];
                this.container.querySelectorAll(Ym).forEach((t) => {
                    ig[this.id].push(
                        new (class {
                            init() {
                                this.newsletter.addEventListener("submit", this.newsletterSubmit), this.showMessage();
                            }
                            newsletterSubmitEvent(t) {
                                this.stopSubmit &&
                                    (t.preventDefault(),
                                    this.removeStorage(),
                                    this.writeStorage(),
                                    (this.stopSubmit = !1),
                                    this.newsletter.submit());
                            }
                            checkForChallengePage() {
                                this.isChallengePage = window.location.pathname === theme.routes.root + "challenge";
                            }
                            writeStorage() {
                                void 0 !== this.sessionStorage && this.sessionStorage.setItem(eg, this.newsletter.id);
                            }
                            readStorage() {
                                this.formID = this.sessionStorage.getItem(eg);
                            }
                            removeStorage() {
                                this.sessionStorage.removeItem(eg);
                            }
                            showMessage() {
                                if ((this.readStorage(), this.newsletter.id === this.formID)) {
                                    const t = document.getElementById(this.formID),
                                        e = -1 !== window.location.search.indexOf("?customer_posted=true"),
                                        i = -1 !== window.location.search.indexOf("accepts_marketing");
                                    e
                                        ? (t.classList.remove(tg),
                                          t.classList.add(Zm),
                                          this.popup &&
                                              ((this.cookie = new Xm(this.popup.dataset.cookieName, "user_has_closed")),
                                              this.cookie.write()))
                                        : i && (t.classList.remove(Zm), t.classList.add(tg)),
                                        (e || i) && this.scrollToForm(t);
                                }
                            }
                            scrollToForm(t) {
                                const e = t.getBoundingClientRect();
                                visibilityHelper.isElementPartiallyVisible(t) ||
                                    visibilityHelper.isElementTotallyVisible(t) ||
                                    setTimeout(() => {
                                        window.scrollTo({ top: e.top, left: 0, behavior: "smooth" });
                                    }, 400);
                            }
                            onUnload() {
                                this.newsletter.removeEventListener("submit", this.newsletterSubmit);
                            }
                            constructor(t) {
                                (this.newsletter = t),
                                    (this.sessionStorage = window.sessionStorage),
                                    (this.popup = this.newsletter.closest(Jm)),
                                    (this.stopSubmit = !0),
                                    (this.isChallengePage = !1),
                                    (this.formID = null),
                                    (this.formIdSuccess = null),
                                    this.checkForChallengePage(),
                                    (this.newsletterSubmit = (t) => this.newsletterSubmitEvent(t)),
                                    this.isChallengePage || this.init();
                            }
                        })(t)
                    );
                });
            },
            onUnload() {
                ig[this.id].forEach((t) => {
                    "function" == typeof t.onUnload && t.onUnload();
                });
            },
        },
        og = "[data-product]",
        ng = "[data-slider]",
        rg = "[data-slide]",
        ag = "[data-product-media-container]",
        lg = ".flickity-button",
        cg = "a, button",
        hg = "tabindex",
        dg = {};
    const ug = {
        onLoad() {
            dg[this.id] = new (class {
                checkSlider() {
                    window.innerWidth >= theme.sizes.small
                        ? this.productSlider.forEach((t) => {
                              this.initProductSlider(t);
                          })
                        : this.productSlider.forEach((t) => {
                              this.destroyProductSlider(t);
                          });
                }
                initProductSlider(t) {
                    const i = t.querySelectorAll(rg).length,
                        s = t.dataset.slider;
                    i > 1 &&
                        (void 0 !== this.flkty[s] && this.flkty[s].isActive
                            ? this.setSliderArrowsPosition(t)
                            : (this.flkty[s] = new e(t, {
                                  prevNextButtons: !0,
                                  adaptiveHeight: !0,
                                  pageDots: !0,
                                  wrapAround: !0,
                                  on: {
                                      ready: () => {
                                          this.setSliderArrowsPosition(t);
                                      },
                                      change: (t) => {
                                          this.flkty[s].cells.forEach((e, i) => {
                                              e.element.querySelectorAll(cg).forEach((e) => {
                                                  e.setAttribute(hg, i === t ? "0" : "-1");
                                              });
                                          });
                                      },
                                  },
                              })));
                }
                destroyProductSlider(t) {
                    const e = t.dataset.slider;
                    "object" == typeof this.flkty[e] && this.flkty[e].destroy();
                }
                setSliderArrowsPosition(t) {
                    const e = t.querySelectorAll(lg),
                        i = t.querySelector(ag);
                    e.length &&
                        i &&
                        e.forEach((t) => {
                            t.style.top = i.offsetHeight / 2 + "px";
                        });
                }
                resizeSlider(t) {
                    const i = t.target,
                        s = e.data(i) || null;
                    s && s.resize();
                }
                listen() {
                    this.checkSlider(),
                        document.addEventListener("theme:resize:width", this.checkSliderOnResize),
                        this.productSlider.forEach((t) => {
                            t.addEventListener("theme:slider:resize", this.resizeSliderEvent);
                        });
                }
                onUnload() {
                    if (this.flkty) for (const t in this.flkty) this.flkty.hasOwnProperty(t) && this.flkty[t].destroy();
                    document.removeEventListener("theme:resize:width", this.checkSliderOnResize),
                        this.productSlider.forEach((t) => {
                            t.removeEventListener("theme:slider:resize", this.resizeSliderEvent);
                        });
                }
                constructor(t) {
                    (this.container = t),
                        (this.product = this.container.querySelectorAll(og)),
                        (this.productSlider = this.container.querySelectorAll(ng)),
                        (this.checkSliderOnResize = () => this.checkSlider()),
                        (this.resizeSliderEvent = (t) => this.resizeSlider(t)),
                        (this.flkty = []),
                        (this.videoObj = []),
                        (this.quickViewObj = []),
                        this.listen();
                }
            })(this.container);
        },
        onUnload(t) {
            dg[this.id].onUnload(t);
        },
    };
    I("custom-content", [ug, sg, Fp, is, Qm, fo]);
    const pg = "[data-slider]",
        mg = "[data-slide]",
        gg = "[data-product-media-container]",
        fg = "a, button",
        yg = ".flickity-button",
        vg = "[data-promo]",
        bg = "[data-product-block]",
        wg = "carousel",
        Sg = "carousel--inactive",
        Eg = "is-last-slide-visible",
        Lg = "featured-collection",
        kg = "collection-promo--full",
        Ag = "collection-promo--two-columns",
        Cg = "data-slider-id",
        qg = "data-slider-show-image",
        Tg = "tabindex",
        Pg = {};
    let xg = class {
        initSlider(t) {
            const i = t.getAttribute(Cg);
            t.classList.remove(Sg),
                void 0 !== this.flkty[i] && this.flkty[i].isActive
                    ? this.setSliderArrowsPosition(t)
                    : ((this.flkty[i] = new e(t, {
                          pageDots: !1,
                          cellSelector: mg,
                          cellAlign: "left",
                          groupCells: !0,
                          contain: !0,
                          wrapAround: !1,
                          adaptiveHeight: !1,
                          on: {
                              ready: () => {
                                  this.setSliderArrowsPosition(t),
                                      setTimeout(() => {
                                          this.changeTabIndex(t);
                                      }, 0);
                              },
                              change: () => {
                                  this.changeTabIndex(t);
                              },
                          },
                      })),
                      this.handleLastSlideOverlayOnTablet(t));
        }
        destroySlider(t) {
            const e = t.getAttribute(Cg);
            t.classList.contains(wg) && t.classList.add(Sg),
                "object" == typeof this.flkty[e] && this.flkty[e].destroy();
        }
        resetSlider(t) {
            const e = t.target,
                i = e.getAttribute(Cg);
            "object" == typeof this.flkty[i]
                ? this.flkty[i].select(0, !1, !0)
                : e.scrollTo({ left: 0, behavior: "instant" });
        }
        resizeSlider(t) {
            const i = t.target,
                s = e.data(i) || null;
            s && s.resize();
        }
        checkSlidesSize() {
            this.sliders.length &&
                this.sliders.forEach((t) => {
                    const e = this.columns,
                        i = window.innerWidth >= theme.sizes.large,
                        s = window.innerWidth >= theme.sizes.small && window.innerWidth < theme.sizes.large;
                    let o = t.querySelectorAll(mg).length;
                    const n = t.querySelectorAll(vg);
                    n.length &&
                        i &&
                        n.forEach((t) => {
                            t.classList.contains(kg) ? (o += e - 1) : t.classList.contains(Ag) && (o += 1);
                        }),
                        t.hasAttribute(qg) && (o += 1),
                        (i && o > e) || (s && o > 2)
                            ? (this.initSlider(t), this.getTallestProductGridItem(t))
                            : this.destroySlider(t);
                });
        }
        changeTabIndex(t) {
            const e = t.getAttribute(Cg),
                i = this.flkty[e].selectedIndex;
            this.flkty[e].slides.forEach((t, e) => {
                t.cells.forEach((t) => {
                    t.element.querySelectorAll(fg).forEach((t) => {
                        t.setAttribute(Tg, i === e ? "0" : "-1");
                    });
                });
            });
        }
        setSliderArrowsPosition(t) {
            const e = t.querySelectorAll(yg),
                i = t.querySelector(gg);
            e.length &&
                i &&
                e.forEach((t) => {
                    t.style.top = i.offsetHeight / 2 + "px";
                });
        }
        handleLastSlideOverlayOnTablet(t) {
            const e = t.getAttribute(Cg);
            this.flkty[e].on("select", () => {
                if (!(window.innerWidth >= theme.sizes.small && window.innerWidth < theme.sizes.large)) return;
                const i = this.flkty[e].selectedIndex,
                    s = this.flkty[e].slides.length - 1 === i;
                t.parentNode.classList.toggle(Eg, s);
            });
        }
        getTallestProductGridItem(t) {
            if (t.querySelectorAll(vg).length) {
                const e = t.querySelectorAll(bg),
                    i = Math.max(...Array.from(e).map((t) => t.offsetHeight));
                t.style.setProperty("--carousel-promo-height", `${i}px`);
            }
        }
        handleLastSlideOverlayOnMobile() {
            this.sliders.forEach((t) => {
                t.addEventListener("scroll", (e) => {
                    if (!(window.innerWidth < theme.sizes.small)) return;
                    const i = e.target.offsetWidth,
                        s = Array.from(t.children).pop().getBoundingClientRect().left + 80 < i;
                    t.parentNode.classList.toggle(Eg, s);
                });
            });
        }
        listen() {
            this.sliders.length &&
                (this.checkSlidesSize(),
                document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize),
                this.sliders.forEach((t) => {
                    t.addEventListener("theme:tab:change", this.resetSliderEvent),
                        t.addEventListener("theme:slider:resize", this.resizeSliderEvent);
                }));
        }
        onBlockSelect(t) {
            const i = t.target.closest(pg),
                s = e.data(i) || null;
            if (!i) return;
            let o = t.target.parentNode,
                n = t.target;
            if (
                (this.container.classList.contains(Lg) && ((o = o.parentNode), (n = n.parentNode)),
                null !== s && s.isActive)
            ) {
                const t = parseInt([...o.children].indexOf(n)),
                    e = parseInt(s.slides[0].cells.length),
                    i = Math.floor(t / e);
                s.select(i);
            } else {
                const t = i.currentStyle || window.getComputedStyle(i),
                    e = parseInt(t.paddingLeft),
                    s = n.offsetLeft - e;
                i.scrollTo({ top: 0, left: s, behavior: "smooth" });
            }
        }
        onUnload() {
            if (this.flkty) for (const t in this.flkty) this.flkty.hasOwnProperty(t) && this.flkty[t].destroy();
            document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize),
                this.sliders.length &&
                    this.sliders.forEach((t) => {
                        t.removeEventListener("theme:tab:change", this.resetSliderEvent),
                            t.removeEventListener("theme:slider:resize", this.resizeSliderEvent);
                    });
        }
        constructor(t) {
            (this.container = t),
                (this.columns = parseInt(this.container.dataset.columns)),
                (this.sliders = this.container.querySelectorAll(pg)),
                (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
                (this.resetSliderEvent = (t) => this.resetSlider(t)),
                (this.resizeSliderEvent = (t) => this.resizeSlider(t)),
                (this.flkty = []),
                this.listen(),
                this.handleLastSlideOverlayOnMobile();
        }
    };
    const Ig = {
        onLoad() {
            Pg[this.id] = [];
            this.container.querySelectorAll(pg).forEach((t) => {
                Pg[this.id].push(new xg(this.container));
            });
        },
        onUnload() {
            Pg[this.id].forEach((t) => {
                "function" == typeof t.onUnload && t.onUnload();
            });
        },
        onBlockSelect(t) {
            Pg[this.id].forEach((e) => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
            });
        },
    };
    I("featured-collection", [fo, is, Ig]), I("featured-video", [Fp, Qm]);
    const Hg = "[data-shop-pay-wrapper]",
        Fg = "shop-login-button",
        Mg = "shop-follow-button",
        Dg = "follow-on-shop-button",
        Og = "heart-icon",
        Bg = "shop-logo",
        zg = {};
    const _g = {
            onLoad() {
                zg[this.id] = new (class {
                    init() {
                        if (!this.shopLoginButton || !this.shopPayWrapper) return;
                        const t = this.shopPayWrapper.dataset.bg || "transparent",
                            e = this.shopPayWrapper.dataset.text || "#fff",
                            i = this.shopPayWrapper.dataset.hover || "#fff";
                        (this.mainButtonStyles = `\n      :host {\n        --bg-color: ${t};\n        --text-color: ${e};\n        --hover-color: ${i};\n      }\n\n      .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--text-color);\n        transition: border 0.3s ease;\n      }\n\n      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,\n      .button:not(.button--following):hover .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--hover-color);\n      }\n\n      .button {\n        background: transparent;\n        color: var(--text-color);\n      }\n\n      .following-text {\n        color: var(--text-color);\n      }\n\n      .button--following:focus-visible,\n      .button--following:hover {\n        background: var(--bg-color);\n      }\n\n      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,\n      .button:not(.button--following):hover .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--hover-color);\n      }\n    `),
                            (this.svgIconsStyles = `\n      :host {\n        color: ${e};\n      }\n    `),
                            customElements.whenDefined(Fg).then((t) => {
                                requestAnimationFrame(() => {
                                    const t = this.shopLoginButton.shadowRoot,
                                        e = null == t ? void 0 : t.querySelector(Mg),
                                        i = null == e ? void 0 : e.shadowRoot,
                                        s = null == i ? void 0 : i.querySelector(Dg),
                                        o = null == s ? void 0 : s.shadowRoot;
                                    o && this.overwriteStyles(o.host.shadowRoot, this.mainButtonStyles);
                                    const n = o.querySelector(Og),
                                        r = null == n ? void 0 : n.shadowRoot,
                                        a = o.querySelector(Bg),
                                        l = null == a ? void 0 : a.shadowRoot;
                                    r && this.overwriteStyles(r.host.shadowRoot, this.svgIconsStyles),
                                        l && this.overwriteStyles(l.host.shadowRoot, this.svgIconsStyles);
                                });
                            });
                    }
                    overwriteStyles(t, e) {
                        let i = document.createElement("style");
                        (i.innerHTML = e), t.appendChild(i);
                    }
                    constructor(t) {
                        (this.container = t),
                            (this.shopPayWrapper = document.querySelector(Hg)),
                            (this.shopLoginButton = document.querySelector(Fg)),
                            this.init();
                    }
                })(this.container);
            },
        },
        $g = ":scope > [data-wave]",
        Rg = "[data-main]",
        Vg = "[data-collapsible-trigger-mobile]",
        Ng = '[data-parallax="footer"]',
        Wg = "is-expanded",
        Ug = "wavy",
        jg = "parallax-shadow",
        Gg = "parallax-rounded-corners",
        Kg = "main-content--parallax",
        Qg = "section-footer--parallax",
        Xg = "section-footer--visible",
        Yg = "main-content",
        Jg = "shopify-section",
        Zg = "body--rounded-corners-large",
        tf = "--bg",
        ef = "--footer-bg",
        sf = "data-parallax",
        of = "data-parallax-wavy",
        nf = "data-parallax-rounded-corners",
        rf = "data-parallax-rounded-corners-large",
        af = "data-parallax-disable-on-safari",
        lf = {};
    I("footer", [
        ql,
        sg,
        Ve,
        {
            onLoad() {
                lf[this.id] = new (class {
                    init() {
                        const t =
                                /^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
                                this.container.hasAttribute(af),
                            e = this.isViewportSmaller() || window.innerWidth < theme.sizes.small || t,
                            i = document.body;
                        i.classList.remove(Zg);
                        const s = getComputedStyle(this.container).getPropertyValue(tf);
                        this.parentContainer.style.setProperty("--footer-parallax-height", "auto");
                        let o = this.parentContainer.previousElementSibling;
                        if (o) {
                            if (
                                (o.classList.contains(Jg) || o.classList.contains(Yg) || (o = this.main),
                                this.wavyEnabled && !e)
                            ) {
                                [...o.querySelectorAll($g)].map((t) => t.remove());
                                const t = this.container.querySelector($g);
                                o.append(t.cloneNode(!0)), o.classList.add(Ug), this.container.classList.remove(Ug);
                            } else
                                this.container.hasAttribute(nf) && !this.wavyEnabled
                                    ? (o.classList.toggle(Gg, !e),
                                      o.classList.toggle(jg, !e),
                                      this.container.hasAttribute(rf) && i.classList.toggle(Zg, !e))
                                    : e || o.classList.add(jg);
                            o.style.setProperty(ef, s);
                        }
                        e ||
                            (this.main.classList.add(Kg),
                            this.parentContainer.classList.add(Qg),
                            this.parentContainer.style.setProperty(
                                "--footer-parallax-height",
                                `${this.container.clientHeight}px`
                            ),
                            (this.footerParallax = new hu(this.container)));
                    }
                    resize() {
                        this.parentContainer.style.setProperty("--footer-parallax-height", "auto"),
                            (this.isViewportSmaller() ||
                                window.innerWidth < theme.sizes.small ||
                                !this.footerParallax) &&
                                this.onUnload(!0),
                            this.parentContainer.style.setProperty(
                                "--footer-parallax-height",
                                `${this.container.clientHeight}px`
                            );
                    }
                    isViewportSmaller() {
                        const t = Math.round(Math.max(document.documentElement.clientHeight, window.innerHeight || 0)),
                            e = this.container.clientHeight;
                        let i = 0;
                        return this.wavyEnabled && (i = 50), t < e + i;
                    }
                    onBlockSelect(t) {
                        const e = t.target.querySelector(Vg);
                        requestAnimationFrame(() => {
                            e && !e.classList.contains(Wg) && e.dispatchEvent(new Event("click"));
                        });
                    }
                    onBlockDeselect(t) {
                        const e = t.target.querySelector(Vg);
                        requestAnimationFrame(() => {
                            e && e.classList.contains(Wg) && e.dispatchEvent(new Event("click"));
                        });
                    }
                    onUnload(t = !1) {
                        document.removeEventListener("theme:resize", this.resizeEvent),
                            document.removeEventListener("theme:footer:unload", this.unloadEvent),
                            this.footerParallax && (this.footerParallax.unload(), t && A(this.parentContainer)),
                            (this.footerParallax || t) &&
                                setTimeout(() => {
                                    const t = Shopify.theme.sections.instances,
                                        e = document.querySelectorAll(Ng),
                                        i = t.filter((t) => t.container === e[0]);
                                    this.main.classList.remove(Kg),
                                        this.parentContainer.classList.remove(Qg),
                                        this.parentContainer.classList.remove(Xg),
                                        i[0] && i[0].onLoad();
                                });
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.main = document.querySelector(Rg)),
                            (this.footerParallax = null),
                            (this.wavyEnabled = this.container.hasAttribute(of)),
                            (this.parentContainer = this.container.parentNode),
                            (this.resizeEvent = () => this.resize()),
                            (this.unloadEvent = () => this.onUnload()),
                            requestIdleCallback(() => {
                                this.container.hasAttribute(sf) &&
                                    !this.main.classList.contains(Kg) &&
                                    (this.init(),
                                    document.addEventListener("theme:resize", this.resizeEvent),
                                    document.addEventListener("theme:footer:unload", this.unloadEvent));
                            });
                    }
                })(this);
            },
            onBlockSelect(t) {
                lf[this.id].onBlockSelect(t);
            },
            onBlockDeselect(t) {
                lf[this.id].onBlockDeselect(t);
            },
            onReorder() {
                lf[this.id].onUnload();
            },
            onUnload() {
                lf[this.id].onUnload();
            },
        },
        _g,
    ]);
    const cf = "[data-slider]";
    let hf = {};
    I("icons-row", {
        onLoad() {
            hf[this.id] = new (class {
                onBlockSelect(t) {
                    const e = this.slider.currentStyle || window.getComputedStyle(this.slider),
                        i = parseInt(e.paddingLeft),
                        s = t.target.offsetLeft - i;
                    this.slider.scrollTo({ top: 0, left: s, behavior: "smooth" });
                }
                constructor(t) {
                    (this.container = t.container), (this.slider = this.container.querySelector(cf));
                }
            })(this);
        },
        onBlockSelect(t) {
            hf[this.id].onBlockSelect(t);
        },
    });
    const df = "[data-accordion-item]",
        uf = "[data-accordion-button]",
        pf = "is-active",
        mf = "to-animate",
        gf = "is-animating",
        ff = {};
    I("image-accordions", {
        onLoad() {
            ff[this.id] = new (class {
                init() {
                    this.triggerLoadingAnimation(),
                        this.imageAccordionsItems.forEach((t) => {
                            t.addEventListener("mouseenter", this.accordionExpandEvent.bind(this, t));
                        }),
                        this.buttons.forEach((t) => {
                            t.addEventListener("focusin", this.accordionFocusEvent.bind(this, t));
                        });
                }
                triggerLoadingAnimation() {
                    if ("false" == theme.settings.animationsEnabled || de()) return;
                    const t = (e) => {
                            "expandAccordion" === e.animationName &&
                                (this.accordionExpand(this.imageAccordionsItems[0]),
                                this.container.classList.remove(mf),
                                this.container.classList.remove(gf),
                                this.container.removeEventListener("animationend", t));
                        },
                        e = (t) => {
                            requestAnimationFrame(() => {
                                t.target === this.container &&
                                    (this.container.classList.add(gf),
                                    this.container.removeEventListener("transitionend", e));
                            });
                        };
                    this.container.addEventListener("transitionend", e, { signal: this.controller.signal }),
                        this.container.addEventListener("animationend", t, { signal: this.controller.signal });
                }
                accordionExpand(t) {
                    t.classList.contains(pf) ||
                        (this.imageAccordionsItems.forEach((t) => {
                            t.classList.remove(pf);
                        }),
                        t.classList.add(pf));
                }
                accordionFocus(t) {
                    t.closest(df).dispatchEvent(new Event("mouseenter"));
                }
                onBlockSelect(t) {
                    const e = t.target;
                    e &&
                        (this.controller.abort(),
                        this.container.classList.remove(mf, gf),
                        this.accordionExpand(e),
                        de() && e.parentNode.scrollTo({ top: 0, left: e.offsetLeft, behavior: "smooth" }));
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.controller = new AbortController()),
                        (this.imageAccordionsItems = this.container.querySelectorAll(df)),
                        (this.buttons = this.container.querySelectorAll(uf)),
                        (this.accordionExpandEvent = (t) => this.accordionExpand(t)),
                        (this.accordionFocusEvent = (t) => this.accordionFocus(t)),
                        this.init();
                }
            })(this);
        },
        onBlockSelect(t) {
            ff[this.id].onBlockSelect(t);
        },
    }),
        I("image-with-text", Fp),
        I("list-collections", Ig);
    const yf = {},
        vf = "[data-slider-gallery]",
        bf = "[data-slider-info]",
        wf = "[data-slide-item]";
    I("locations", {
        onLoad() {
            yf[this.id] = new (class {
                initSlider() {
                    const t = this.container.querySelectorAll(wf).length;
                    let i = e.data(this.slider) || null,
                        s = e.data(this.sliderNav) || null;
                    t <= 1 ||
                        ((i = new e(this.slider, {
                            fade: !0,
                            wrapAround: !0,
                            adaptiveHeight: !0,
                            prevNextButtons: !1,
                            pageDots: !1,
                        })),
                        Si(this.slider),
                        (s = new e(this.sliderNav, {
                            fade: !0,
                            wrapAround: !0,
                            imagesLoaded: !0,
                            asNavFor: this.slider,
                            prevNextButtons: !0,
                            pageDots: !1,
                        })),
                        s.on("change", () => {
                            i.selectCell(s.selectedIndex);
                        }),
                        i.on("change", () => {
                            s.selectCell(i.selectedIndex);
                        }));
                }
                onBlockSelect(t) {
                    const i = e.data(this.slider) || null,
                        s = e.data(this.sliderNav) || null,
                        o = parseInt([...t.target.parentNode.children].indexOf(t.target));
                    null !== i && i.select(o), null !== s && s.select(o);
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.slider = this.container.querySelector(vf)),
                        (this.sliderNav = this.container.querySelector(bf)),
                        this.initSlider();
                }
            })(this);
        },
        onBlockSelect(t) {
            yf[this.id].onBlockSelect(t);
        },
    });
    const Sf = {},
        Ef = "[data-slider]",
        Lf = "[data-slide-item]",
        kf = "[data-pointer]",
        Af = "[data-product-media-container]",
        Cf = "[data-quick-view-item-holder]",
        qf = ".flickity-button",
        Tf = "a, button",
        Pf = "[data-tooltip]",
        xf = "data-pointer",
        If = "data-hotspot",
        Hf = "tabindex",
        Ff = "product-grid-item__image--hovered",
        Mf = "pointer--selected",
        Df = "is-selected",
        Of = "is-active",
        Bf = "pswp--open";
    const zf = {
        onLoad() {
            Sf[this.id] = new (class {
                listen() {
                    this.slider &&
                        (this.checkSlidesSize(),
                        document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize),
                        this.slider.addEventListener("theme:slider:resize", this.resizeSliderEvent)),
                        this.pointers.length > 0 &&
                            this.pointers.forEach((t) => {
                                t.addEventListener("click", this.pointersInit),
                                    t.addEventListener("mouseover", this.pointersOver),
                                    t.addEventListener("mouseleave", this.pointersOut);
                            });
                }
                checkSlidesSize() {
                    const t = window.innerWidth >= theme.sizes.small;
                    this.initTooltips(),
                        t
                            ? this.slides.length > 1
                                ? this.initSlider()
                                : (this.destroySlider(), this.slidesTabIndex())
                            : !t && this.slides.length > 1
                              ? this.initSlider()
                              : this.destroySlider();
                }
                initTooltips() {
                    (this.tooltips = this.container.querySelectorAll(Pf)),
                        this.tooltips.forEach((t) => {
                            new es(t);
                        });
                }
                initSlider() {
                    null !== this.flkty
                        ? this.setSliderArrowsPosition()
                        : (this.flkty = new e(this.slider, {
                              prevNextButtons: !0,
                              wrapAround: !0,
                              adaptiveHeight: !1,
                              cellAlign: "left",
                              groupCells: !1,
                              contain: !0,
                              on: {
                                  ready: () => {
                                      this.slidesTabIndex(), this.setSliderArrowsPosition(), this.dotPointers();
                                  },
                                  change: () => {
                                      this.slidesTabIndex(), this.dotPointers();
                                  },
                              },
                          }));
                }
                setSliderArrowsPosition() {
                    if (!(window.innerWidth >= theme.sizes.small)) return;
                    const t = this.slider.querySelectorAll(qf),
                        e = this.slider.querySelector(Af);
                    t.length &&
                        e &&
                        t.forEach((t) => {
                            t.style.top = e.offsetHeight / 2 + "px";
                        });
                }
                slidesTabIndex() {
                    this.slides.length < 3
                        ? this.slider.querySelectorAll(Tf).forEach((t) => {
                              t.setAttribute(Hf, "0");
                          })
                        : e.data(this.slider).cells.forEach((t) => {
                              let e = "-1";
                              t.element.classList.contains(Df) && (e = "0"),
                                  t.element.querySelectorAll(Tf).forEach((t) => {
                                      t.setAttribute(Hf, e);
                                  });
                          });
                }
                destroySlider() {
                    "object" == typeof this.flkty && null !== this.flkty && (this.flkty.destroy(), (this.flkty = null));
                }
                resizeSlider(t) {
                    const i = t.target,
                        s = e.data(i) || null;
                    s && s.resize();
                }
                dotPointers(t) {
                    if (0 === this.pointers.length) return;
                    if (
                        (this.pointers.forEach((t) => {
                            t.classList.remove(Mf);
                        }),
                        t)
                    ) {
                        var e;
                        const i = t.target.getAttribute(xf);
                        return void (null === (e = this.flkty) || void 0 === e || e.select(i));
                    }
                    const i = null == this.flkty ? 0 : this.flkty.selectedIndex;
                    i >= 0 && this.pointers[i].classList.add(Mf);
                }
                dotPointerIn(t) {
                    const e = t.target.getAttribute(xf),
                        i = this.slides[e].querySelector(Af),
                        s = matchMedia("(pointer:coarse)").matches;
                    window.innerWidth < theme.sizes.small || s || this.observeImage(i),
                        this.pointers.forEach((t) => {
                            t.style.setProperty("--look-animation", "none");
                        });
                }
                dotPointerOut(t) {
                    const e = t.target.getAttribute(xf),
                        i = this.slides[e].querySelector(Af);
                    i.classList.remove(Ff),
                        i.dispatchEvent(new Event("mouseleave")),
                        this.observer && this.observer.disconnect(),
                        this.pointers.forEach((t) => {
                            t.style.removeProperty("--look-animation");
                        });
                }
                observeImage(t) {
                    (this.observer = new IntersectionObserver(
                        (t, e) => {
                            t.forEach((t) => {
                                const e = t.target;
                                0 == t.intersectionRatio ||
                                    (e.dispatchEvent(new Event("mouseenter")), e.classList.add(Ff));
                            });
                        },
                        { root: this.slider, threshold: [0.95, 1] }
                    )),
                        this.observer.observe(t);
                }
                triggerClick(t) {
                    requestAnimationFrame(() => t.dispatchEvent(new Event("click")));
                }
                destroyQuickViewPopup() {
                    var t, e;
                    const i =
                        null === (t = this.quickViewPopup) ||
                        void 0 === t ||
                        null === (e = t.loadPhotoswipe) ||
                        void 0 === e
                            ? void 0
                            : e.pswpElement;
                    i && i.classList.contains(Bf) && this.quickViewPopup.loadPhotoswipe.popup.close();
                }
                onBlockSelect(t) {
                    this.debouncedBlockSelectCallback(t);
                }
                debouncedBlockSelect(t) {
                    var e, i;
                    const s =
                        null === (e = this.quickViewPopup) ||
                        void 0 === e ||
                        null === (i = e.loadPhotoswipe) ||
                        void 0 === i
                            ? void 0
                            : i.pswpElement;
                    s
                        ? setTimeout(() => {
                              if (s.classList.contains(Bf)) {
                                  const e = this.quickViewPopup.loadPhotoswipe.pswpElement.querySelector(
                                          `[${If}="${t.target.getAttribute(If)}"]`
                                      ),
                                      i = this.quickViewPopup.loadPhotoswipe.pswpElement.querySelectorAll(Cf);
                                  e.classList.add(Of),
                                      i.forEach((t) => {
                                          t !== e && t.classList.remove(Of);
                                      });
                              } else this.triggerClick(t.target);
                          })
                        : setTimeout(() => this.triggerClick(t.target), 400);
                }
                onUnload() {
                    this.destroyQuickViewPopup(),
                        document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize),
                        this.slider && this.slider.removeEventListener("theme:slider:resize", this.resizeSliderEvent);
                }
                onDeselect() {
                    this.destroyQuickViewPopup();
                }
                constructor(t) {
                    (this.container = t),
                        (this.slider = this.container.querySelector(Ef)),
                        (this.slides = this.container.querySelectorAll(Lf)),
                        (this.pointers = this.container.querySelectorAll(kf)),
                        (this.flkty = null),
                        (this.observer = null),
                        (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
                        (this.resizeSliderEvent = (t) => this.resizeSlider(t)),
                        (this.pointersInit = (t) => this.dotPointers(t)),
                        (this.pointersOver = (t) => this.dotPointerIn(t)),
                        (this.pointersOut = (t) => this.dotPointerOut(t)),
                        (this.debouncedBlockSelectCallback = o((t) => this.debouncedBlockSelect(t), 500)),
                        (this.quickViewPopup = new Zc(this.container)),
                        this.listen();
                }
            })(this.container);
        },
        onUnload() {
            Sf[this.id].onUnload();
        },
        onBlockSelect(t) {
            Sf[this.id].onBlockSelect(t);
        },
        onDeselect() {
            Sf[this.id].onDeselect();
        },
    };
    I("look", [zf]);
    const _f = "[data-grid]",
        $f = "[data-item]",
        Rf = "[data-item-content-inner]",
        Vf = ".carousel--mobile",
        Nf = "[data-aos], [data-aos-anchor]",
        Wf = "data-aos-anchor",
        Uf = "data-aos-trigger",
        jf = "data-slider-mobile",
        Gf = "aos-animate";
    let Kf = {};
    I("mosaic", {
        onLoad() {
            Kf[this.id] = new (class {
                onResize() {
                    this.updateAOSAnchors();
                }
                updateAOSAnchors() {
                    if (
                        "false" != theme.settings.animationsEnabled &&
                        de() &&
                        this.hasSliderMobile &&
                        this.carouselMobile &&
                        this.items.length > 1
                    ) {
                        const t = this.items[0],
                            e = t.querySelector(Rf),
                            i = t.id,
                            s = e ? e.id : i;
                        t.setAttribute(Uf, `#${i}`),
                            null == e || e.setAttribute(Uf, `#${s}`),
                            this.items.forEach((t) => {
                                const e = t.querySelectorAll(Nf),
                                    o = t.querySelector(Rf);
                                t.setAttribute(Wf, `#${i}`),
                                    null == o || o.setAttribute(Wf, `#${s}`),
                                    e.forEach((t) => t.setAttribute(Wf, `#${s}`));
                            });
                    }
                }
                triggerAOS(t) {
                    "false" != theme.settings.animationsEnabled &&
                        t &&
                        ([...t.querySelectorAll(Nf)].some((t) => t.classList.contains(Gf)) ||
                            this.items.forEach((t) => {
                                const e = t.querySelectorAll(Nf);
                                t.classList.add(Gf), e.forEach((t) => t.classList.add(Gf));
                            }));
                }
                onBlockSelect(t) {
                    const e = t.target,
                        i = e.closest(_f),
                        s = i.currentStyle || window.getComputedStyle(i),
                        o = parseInt(s.paddingLeft),
                        n = e.offsetLeft - o,
                        r = this.items[0];
                    e.matches(`#${r.id}`) || this.triggerAOS(e),
                        setTimeout(() => {
                            i.scrollTo({ top: 0, left: n, behavior: "smooth" });
                        }, 500);
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.onResizeCallback);
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.hasSliderMobile = this.container.hasAttribute(jf)),
                        (this.carouselMobile = this.container.querySelector(Vf)),
                        (this.items = this.container.querySelectorAll($f)),
                        (this.onResizeCallback = () => this.onResize()),
                        this.updateAOSAnchors(),
                        document.addEventListener("theme:resize:width", this.onResizeCallback);
                }
            })(this);
        },
        onUnload() {
            Kf[this.id].onUnload();
        },
        onBlockSelect(t) {
            Kf[this.id].onBlockSelect(t);
        },
    }),
        I("newsletter", sg),
        I("overlapping-images", [Fp, du]);
    const Qf = "[data-toggle-admin]",
        Xf = "[data-toggle-newsletter]",
        Yf = "[data-form-admin]",
        Jf = "[data-form-newsletter]";
    let Zf = {};
    I("password-template", {
        onLoad() {
            Zf[this.id] = new (class {
                init() {
                    this.toggleAdmin.addEventListener("click", (t) => {
                        t.preventDefault(), this.showPasswordForm();
                    }),
                        this.toggleNewsletter.addEventListener("click", (t) => {
                            t.preventDefault(), this.hidePasswordForm();
                        }),
                        "#login" == window.location.hash || this.adminErrors
                            ? this.showPasswordForm()
                            : this.hidePasswordForm();
                }
                showPasswordForm() {
                    Ir(this.adminForm), Hr(this.newsletterForm), (window.location.hash = "#login");
                }
                hidePasswordForm() {
                    Ir(this.newsletterForm), Hr(this.adminForm), (window.location.hash = "");
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.toggleAdmin = this.container.querySelector(Qf)),
                        (this.toggleNewsletter = this.container.querySelector(Xf)),
                        (this.adminForm = this.container.querySelector(Yf)),
                        (this.newsletterForm = this.container.querySelector(Jf)),
                        (this.adminErrors = this.adminForm.querySelector(".errors")),
                        (this.newsletterErrors = this.newsletterForm.querySelector(".errors")),
                        this.init();
                }
            })(this);
        },
    });
    const ty = "[data-large-promo]",
        ey = "[data-large-promo-inner]",
        iy = "[data-tracking-consent]",
        sy = "[data-tracking-consent-inner]",
        oy = "[data-confirm-cookies]",
        ny = "[data-popup-bar]",
        ry = "[data-popup-bar-holder]",
        ay = "[data-popup-bar-toggle]",
        ly = "[data-popup-body]",
        cy = "[data-popup-close]",
        hy = "[data-popup-underlay]",
        dy = "[data-newsletter-form]",
        uy = "data-target-referrer",
        py = "data-prevent-scroll-lock",
        my = "has-success",
        gy = "has-error",
        fy = "selected",
        yy = "has-block-selected",
        vy = "popup--expanded",
        by = "popup--visible",
        wy = "mobile",
        Sy = "desktop",
        Ey = "popup--bar",
        Ly = "popup-bar-is-visible";
    let ky = {},
        Ay = 0,
        Cy = 0,
        qy = [],
        Ty = class {
            always() {
                this.showPopup();
            }
            delayed(t = 10) {
                setTimeout(() => {
                    this.showPopup();
                }, 1e3 * t);
            }
            bottom() {
                document.addEventListener("theme:scroll", this.showPopupOnScrollEvent);
            }
            idle() {
                if (!(!0 === this.checkPopupTarget())) return;
                let t = 0;
                const e = [
                        "mousemove",
                        "mousedown",
                        "click",
                        "touchmove",
                        "touchstart",
                        "touchend",
                        "keydown",
                        "keypress",
                    ],
                    i = ["load", "resize", "scroll"],
                    s = () => {
                        (t = setTimeout(() => {
                            (t = 0), this.showPopup();
                        }, 6e4)),
                            e.forEach((t) => {
                                document.addEventListener(t, o);
                            }),
                            i.forEach((t) => {
                                window.addEventListener(t, o);
                            });
                    },
                    o = () => {
                        t && clearTimeout(t),
                            e.forEach((t) => {
                                document.removeEventListener(t, o);
                            }),
                            i.forEach((t) => {
                                window.removeEventListener(t, o);
                            }),
                            s();
                    };
                s();
            }
            showPopup() {
                const t = { id: this.popup.id, body: this.popupBody };
                qy.push(t);
                if (!0 === this.checkPopupTarget()) {
                    if (
                        ((Cy += 1),
                        this.popup.classList.add(by),
                        this.popup.classList.contains(Ey) && document.body.classList.add(Ly),
                        this.a11y.trapFocus({ container: this.popupBody }),
                        this.popup.hasAttribute(py))
                    )
                        return !1;
                    this.scrollLock();
                }
            }
            checkPopupTarget() {
                const t = this.popup.parentNode.classList.contains(wy),
                    e = this.popup.parentNode.classList.contains(Sy);
                return !((t && window.innerWidth >= theme.sizes.small) || (e && window.innerWidth < theme.sizes.small));
            }
            scrollLock() {
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.popupBody }));
            }
            showPopupOnScroll() {
                window.scrollY + window.innerHeight >= document.body.clientHeight &&
                    (this.showPopup(), document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent));
            }
            onUnload() {
                document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent);
            }
            constructor(t, e) {
                if (
                    ((this.popupContainer = t),
                    (this.popup = e),
                    (this.popupBody = e.querySelector(ly)),
                    (this.delay = t.dataset.popupDelay),
                    (this.isSubmitted =
                        -1 !== window.location.href.indexOf("accepts_marketing") ||
                        -1 !== window.location.href.indexOf("customer_posted=true")),
                    (this.a11y = Ye),
                    (this.showPopupOnScrollEvent = () => this.showPopupOnScroll()),
                    ("always" === this.delay || this.isSubmitted) && this.always(),
                    this.delay && this.delay.includes("delayed") && !this.isSubmitted)
                ) {
                    const t = this.delay.includes("_") ? parseInt(this.delay.split("_")[1]) : 10;
                    this.delayed(t);
                }
                "bottom" !== this.delay || this.isSubmitted || this.bottom(),
                    "idle" !== this.delay || this.isSubmitted || this.idle();
            }
        },
        Py = class {
            constructor(t) {
                if (
                    ((this.popupContainer = t),
                    (this.locationPath = location.href),
                    !this.popupContainer.hasAttribute(uy))
                )
                    return !1;
                -1 !== this.locationPath.indexOf(this.popupContainer.getAttribute(uy)) ||
                    window.Shopify.designMode ||
                    this.popupContainer.parentNode.removeChild(this.popupContainer);
            }
        };
    I("popups", [
        {
            onLoad() {
                (ky[this.id] = []), window.Shopify.designMode && (Cy = 0);
                const t = this.container.querySelectorAll(ty);
                t.length &&
                    t.forEach((t) => {
                        ky[this.id].push(
                            new (class {
                                init() {
                                    (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
                                        (window.Shopify.designMode
                                            ? this.showPopup()
                                            : new Ty(this.popupContainer, this.popup),
                                        this.form &&
                                            setTimeout(() => {
                                                this.form.classList.contains(my) &&
                                                    (this.showPopupIfNoCookie(), (Cy -= 1));
                                            }),
                                        this.initClosers());
                                }
                                checkPopupTarget() {
                                    const t = this.popup.parentNode.classList.contains(wy),
                                        e = this.popup.parentNode.classList.contains(Sy);
                                    return !(
                                        (t && window.innerWidth >= theme.sizes.small) ||
                                        (e && window.innerWidth < theme.sizes.small)
                                    );
                                }
                                showPopupIfNoCookie() {
                                    this.showPopup();
                                }
                                initClosers() {
                                    this.close.addEventListener("click", this.closePopup.bind(this)),
                                        this.underlay.addEventListener("click", this.closePopup.bind(this)),
                                        this.popupContainer.addEventListener("keyup", (t) => {
                                            t.code === theme.keyboardKeys.ESCAPE && this.closePopup(t);
                                        });
                                }
                                closePopup(t) {
                                    t.preventDefault(), this.hidePopup(), this.cookie.write();
                                }
                                scrollLock() {
                                    this.resetScrollUnlock(),
                                        this.a11y.trapFocus({ container: this.popupBody }),
                                        document.dispatchEvent(
                                            new CustomEvent("theme:scroll:lock", {
                                                bubbles: !0,
                                                detail: this.popupBody,
                                            })
                                        );
                                }
                                scrollUnlock() {
                                    this.resetScrollUnlock(),
                                        (Ay = setTimeout(() => {
                                            document.dispatchEvent(
                                                new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                                            );
                                        }, 300));
                                }
                                resetScrollUnlock() {
                                    Ay && clearTimeout(Ay);
                                }
                                showPopup() {
                                    const t = !0 === this.checkPopupTarget(),
                                        e = { id: this.popupId, body: this.popup };
                                    qy.push(e), t && ((Cy += 1), this.popup.classList.add(by), this.scrollLock());
                                }
                                hidePopup() {
                                    this.popup.classList.remove(by);
                                    const t = qy.findIndex((t) => t.id === this.popupId);
                                    if (((Cy -= 1), qy.splice(t, 1), 1 == Cy && document.body.classList.contains(Ly)))
                                        this.scrollUnlock();
                                    else if (Cy < 1) this.scrollUnlock(), this.a11y.removeTrapFocus();
                                    else if (qy.length > 0) {
                                        const t = qy[qy.length - 1].body;
                                        this.a11y.trapFocus({ container: t });
                                    }
                                }
                                onBlockSelect(t) {
                                    this.popupContainer.contains(t.target) &&
                                        !this.popup.classList.contains(by) &&
                                        (this.popup.classList.add(fy),
                                        this.popupContainer.classList.add(yy),
                                        this.showPopup());
                                }
                                onBlockDeselect(t) {
                                    this.popupContainer.contains(t.target) &&
                                        (this.popup.classList.remove(fy),
                                        this.popupContainer.classList.remove(yy),
                                        this.hidePopup());
                                }
                                onUnload() {
                                    this.scrollUnlock();
                                }
                                onDeselect() {
                                    this.popup.classList.remove(fy),
                                        this.popupContainer.classList.remove(yy),
                                        this.hidePopup();
                                }
                                constructor(t) {
                                    (this.popupContainer = t),
                                        (this.popup = this.popupContainer.querySelector(ey)),
                                        (this.popupBody = this.popup.querySelector(ly)),
                                        (this.popupId = this.popup.id),
                                        (this.close = this.popup.querySelector(cy)),
                                        (this.underlay = this.popup.querySelector(hy)),
                                        (this.form = this.popup.querySelector(dy)),
                                        (this.cookie = new Xm(
                                            this.popupContainer.dataset.cookieName,
                                            "user_has_closed"
                                        )),
                                        (this.isTargeted = new Py(this.popupContainer)),
                                        (this.a11y = Ye),
                                        this.init();
                                }
                            })(t)
                        );
                    });
                const e = this.container.querySelectorAll(ny);
                e.length &&
                    e.forEach((t) => {
                        ky[this.id].push(
                            new (class {
                                init() {
                                    (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
                                        (window.Shopify.designMode
                                            ? this.showPopup()
                                            : new Ty(this.popupContainer, this.popup),
                                        this.initPopupToggleButton(),
                                        this.initClosers(),
                                        this.form &&
                                            setTimeout(() => {
                                                this.form.classList.contains(my) && this.showPopupIfNoCookie(),
                                                    this.form.classList.contains(gy) &&
                                                        this.toggle.dispatchEvent(new Event("click"));
                                            }));
                                }
                                checkPopupTarget() {
                                    const t = this.popup.parentNode.classList.contains(wy),
                                        e = this.popup.parentNode.classList.contains(Sy);
                                    return !(
                                        (t && window.innerWidth >= theme.sizes.small) ||
                                        (e && window.innerWidth < theme.sizes.small)
                                    );
                                }
                                showPopupIfNoCookie() {
                                    this.showPopup(), this.toggle.dispatchEvent(new Event("click"));
                                }
                                initPopupToggleButton() {
                                    this.toggle.addEventListener("click", (t) => {
                                        t.preventDefault(),
                                            this.popup.classList.toggle(vy),
                                            this.popup.classList.contains(vy) ? this.scrollLock() : this.scrollUnlock();
                                    });
                                }
                                showPopup() {
                                    const t = { id: this.popupId, body: this.popup };
                                    qy.push(t),
                                        this.a11y.trapFocus({ container: this.popupBody }),
                                        !0 === this.checkPopupTarget() &&
                                            ((Cy += 1), document.body.classList.add(Ly), this.popup.classList.add(by));
                                }
                                hidePopup() {
                                    this.popup.classList.remove(by), document.body.classList.remove(Ly);
                                    const t = qy.findIndex((t) => t.id === this.popupId);
                                    if ((qy.splice(t, 1), Cy >= 1 && (Cy -= 1), Cy < 1))
                                        this.scrollUnlock(), this.a11y.removeTrapFocus();
                                    else if (qy.length > 0) {
                                        const t = qy[qy.length - 1].body;
                                        this.a11y.trapFocus({ container: t });
                                    }
                                }
                                initClosers() {
                                    this.close.addEventListener("click", this.closePopup.bind(this)),
                                        this.underlay.addEventListener("click", () =>
                                            this.toggle.dispatchEvent(new Event("click"))
                                        ),
                                        this.popupContainer.addEventListener("keyup", (t) => {
                                            t.code === theme.keyboardKeys.ESCAPE &&
                                                (this.popup.classList.remove(vy), this.scrollUnlock());
                                        });
                                }
                                closePopup(t) {
                                    t.preventDefault(), this.cookie.write(), this.hidePopup();
                                }
                                scrollLock() {
                                    document.dispatchEvent(
                                        new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.popupBody })
                                    );
                                }
                                scrollUnlock() {
                                    this.resetScrollUnlock(),
                                        (Ay = setTimeout(() => {
                                            document.dispatchEvent(
                                                new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                                            );
                                        }, 300));
                                }
                                resetScrollUnlock() {
                                    Ay && clearTimeout(Ay);
                                }
                                onBlockSelect(t) {
                                    this.popupContainer.contains(t.target) &&
                                        !this.popup.classList.contains(by) &&
                                        (this.showPopup(),
                                        this.popup.classList.add(vy),
                                        this.popup.classList.add(fy),
                                        this.popup.parentNode.classList.add(yy),
                                        this.resetScrollUnlock(),
                                        this.scrollLock());
                                }
                                onBlockDeselect(t) {
                                    this.popupContainer.contains(t.target) &&
                                        (this.popup.classList.remove(vy),
                                        this.popup.classList.remove(fy),
                                        this.popup.parentNode.classList.remove(yy),
                                        this.hidePopup());
                                }
                                onUnload() {
                                    this.scrollUnlock();
                                }
                                onDeselect() {
                                    this.popup.classList.remove(vy),
                                        this.popup.classList.remove(fy),
                                        this.popup.parentNode.classList.remove(yy),
                                        this.hidePopup();
                                }
                                constructor(t) {
                                    (this.popupContainer = t),
                                        (this.popup = this.popupContainer.querySelector(ry)),
                                        (this.popupBody = this.popup.querySelector(ly)),
                                        (this.popupId = this.popup.id),
                                        (this.close = this.popup.querySelector(cy)),
                                        (this.underlay = this.popup.querySelector(hy)),
                                        (this.toggle = this.popup.querySelector(ay)),
                                        (this.cookie = new Xm(
                                            this.popupContainer.dataset.cookieName,
                                            "user_has_closed"
                                        )),
                                        (this.form = this.popup.querySelector(dy)),
                                        (this.isTargeted = new Py(this.popupContainer)),
                                        (this.a11y = Ye),
                                        this.init();
                                }
                            })(t)
                        );
                    });
                const i = this.container.querySelectorAll(iy);
                i.length &&
                    i.forEach((t) => {
                        ky[this.id].push(
                            new (class {
                                init() {
                                    this.enableTracking && this.showPopup(), this.clickEvents();
                                }
                                clickEvents() {
                                    this.close.addEventListener("click", (t) => {
                                        t.preventDefault(),
                                            window.Shopify.customerPrivacy.setTrackingConsent(!1, () =>
                                                this.hidePopup()
                                            );
                                    }),
                                        this.acceptButton.addEventListener("click", (t) => {
                                            t.preventDefault(),
                                                window.Shopify.customerPrivacy.setTrackingConsent(!0, () =>
                                                    this.hidePopup()
                                                );
                                        }),
                                        document.addEventListener("trackingConsentAccepted", () => {
                                            console.log("trackingConsentAccepted event fired");
                                        });
                                }
                                showPopup() {
                                    const t = { id: this.popupId, body: this.popup };
                                    qy.push(t),
                                        this.popup.classList.add(by),
                                        this.a11y.trapFocus({ container: this.popup });
                                }
                                hidePopup() {
                                    this.popup.classList.remove(by);
                                    const t = qy.findIndex((t) => t.id === this.popupId);
                                    if ((qy.splice(t, 1), Cy < 1)) this.a11y.removeTrapFocus();
                                    else if (qy.length > 0) {
                                        const t = qy[qy.length - 1].body;
                                        this.a11y.trapFocus({ container: t });
                                    }
                                }
                                onBlockSelect(t) {
                                    this.popupContainer.contains(t.target) &&
                                        this.enableTracking &&
                                        !this.popup.classList.contains(by) &&
                                        (this.showPopup(),
                                        this.popup.classList.add(fy),
                                        this.popup.parentNode.classList.add(yy));
                                }
                                onBlockDeselect(t) {
                                    this.popupContainer.contains(t.target) &&
                                        (this.popup.classList.remove(fy),
                                        this.popupContainer.classList.remove(yy),
                                        this.hidePopup());
                                }
                                onDeselect() {
                                    this.popup.classList.remove(fy),
                                        this.popupContainer.classList.remove(yy),
                                        this.hidePopup();
                                }
                                constructor(t) {
                                    (this.popupContainer = t),
                                        (this.popup = this.popupContainer.querySelector(sy)),
                                        (this.popupId = this.popup.id),
                                        (this.close = this.popup.querySelector(cy)),
                                        (this.acceptButton = this.popup.querySelector(oy)),
                                        (this.enable = "true" === this.popupContainer.dataset.enable),
                                        (this.a11y = Ye),
                                        window.Shopify.loadFeatures(
                                            [{ name: "consent-tracking-api", version: "0.1" }],
                                            (t) => {
                                                if (t) throw t;
                                                const e = window.Shopify.customerPrivacy.userCanBeTracked(),
                                                    i = window.Shopify.customerPrivacy.getTrackingConsent();
                                                (this.enableTracking = !e && "no_interaction" === i && this.enable),
                                                    window.Shopify.designMode && (this.enableTracking = !0),
                                                    this.init();
                                            }
                                        );
                                }
                            })(t)
                        );
                    });
            },
            onDeselect() {
                ky[this.id].forEach((t) => {
                    "function" == typeof t.onDeselect && t.onDeselect();
                });
            },
            onBlockSelect(t) {
                ky[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
            onBlockDeselect(t) {
                ky[this.id].forEach((e) => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
                });
            },
            onUnload(t) {
                ky[this.id].forEach((e) => {
                    "function" == typeof e.onUnload && e.onUnload(t);
                });
            },
        },
        sg,
    ]);
    const xy = "[data-press-items]",
        Iy = "[data-logo-slider]",
        Hy = "[data-logo-slide]",
        Fy = "a, button",
        My = "data-logo-index",
        Dy = "tabindex";
    let Oy = {};
    const By = {
        onLoad() {
            Oy[this.id] = new (class {
                checkSlides() {
                    const t = this.container.offsetWidth,
                        i = this.container.querySelectorAll(Hy),
                        s = e.data(this.sliderNav) || null;
                    null !== s &&
                        ((s.options.draggable = !1),
                        (s.options.wrapAround = !1),
                        (s.options.contain = !0),
                        this.getSlidesWidth() > t &&
                            i.length > 2 &&
                            ((s.options.draggable = !0), (s.options.wrapAround = !0), (s.options.contain = !1)),
                        s.resize(),
                        s.updateDraggable());
                }
                getSlidesWidth() {
                    const t = this.container.querySelectorAll(Hy);
                    let e = 0;
                    return (
                        t.length &&
                            t.forEach((t) => {
                                e += t.offsetWidth;
                            }),
                        e
                    );
                }
                initSlider() {
                    let t = e.data(this.slider) || null,
                        i = e.data(this.sliderNav) || null;
                    const s = parseInt(this.container.dataset.duration),
                        o = "true" === this.container.dataset.autoplay && s;
                    (t = new e(this.slider, {
                        fade: !0,
                        wrapAround: !0,
                        adaptiveHeight: !1,
                        prevNextButtons: !1,
                        pageDots: !1,
                        autoPlay: o,
                    })),
                        (i = new e(this.sliderNav, {
                            draggable: !1,
                            wrapAround: !1,
                            contain: !0,
                            imagesLoaded: !0,
                            asNavFor: this.slider,
                            prevNextButtons: !1,
                            adaptiveHeight: !1,
                            pageDots: !1,
                            on: {
                                ready: () => {
                                    this.container.querySelectorAll(Hy).forEach((e) => {
                                        e.addEventListener("keyup", (i) => {
                                            if (
                                                i.code === theme.keyboardKeys.ENTER ||
                                                i.code === theme.keyboardKeys.NUMPADENTER ||
                                                i.code === theme.keyboardKeys.SPACE
                                            ) {
                                                const i = Number(e.getAttribute(My));
                                                t.selectCell(i);
                                            }
                                        });
                                    });
                                },
                            },
                        })),
                        Si(this.slider),
                        Si(this.sliderNav),
                        i.on("change", (e) => {
                            t.selectCell(e);
                        }),
                        t.on("change", (e) => {
                            i.selectCell(e),
                                t.cells.forEach((t, i) => {
                                    t.element.querySelectorAll(Fy).forEach((t) => {
                                        t.setAttribute(Dy, i === e ? "0" : "-1");
                                    });
                                });
                        });
                }
                resizeSlider() {
                    const t = e.data(this.slider);
                    t && t.resize();
                }
                onBlockSelect(t) {
                    const i = e.data(this.slider) || null,
                        s = e.data(this.sliderNav) || null,
                        o = parseInt([...t.target.parentNode.children].indexOf(t.target));
                    null !== i && (i.select(o), i.pausePlayer()), null !== s && s.select(o);
                }
                onBlockDeselect() {
                    const t = e.data(this.slider) || null;
                    "true" === this.container.dataset.autoplay && null !== t && t.playPlayer();
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.sliderResizeEvent);
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.slider = this.container.querySelector(xy)),
                        (this.sliderNav = this.container.querySelector(Iy)),
                        (this.sliderResizeEvent = () => this.checkSlides()),
                        this.initSlider(),
                        this.checkSlides(),
                        window.addEventListener("load", this.resizeSlider.bind(this)),
                        document.addEventListener("theme:resize:width", this.sliderResizeEvent);
                }
            })(this);
        },
        onUnload(t) {
            Oy[this.id].onUnload(t);
        },
        onBlockSelect(t) {
            Oy[this.id].onBlockSelect(t);
        },
        onBlockDeselect() {
            Oy[this.id].onBlockDeselect();
        },
    };
    I("press", By);
    const zy = "[data-product-single-media-slider]",
        _y = "[data-product-info]",
        $y = "[data-header-sticky]",
        Ry = "[data-header-height]",
        Vy = "is-sticky",
        Ny = "data-sticky-enabled";
    window.theme.variables = { productPageSticky: !1 };
    const Wy = {};
    const Uy = {
            onLoad() {
                Wy[this.id] = new (class {
                    init() {
                        this.stickyEnabled &&
                            (this.stickyScrollCheck(), document.addEventListener("theme:resize", this.resizeEvent)),
                            this.initSticky();
                    }
                    initSticky() {
                        theme.variables.productPageSticky &&
                            ((this.requestAnimationSticky = requestAnimationFrame(() =>
                                this.calculateStickyPosition()
                            )),
                            this.productInfo.addEventListener("theme:form:sticky", (t) => {
                                this.removeAnimationFrame(),
                                    (this.requestAnimationSticky = requestAnimationFrame(() =>
                                        this.calculateStickyPosition(t)
                                    ));
                            }),
                            document.addEventListener("theme:scroll", this.scrollEvent));
                    }
                    scrollEvents(t) {
                        null !== t.detail &&
                            ((this.scrollTop = t.detail.position), (this.scrollDirectionDown = t.detail.down)),
                            this.requestAnimationSticky ||
                                (this.requestAnimationSticky = requestAnimationFrame(() =>
                                    this.calculateStickyPosition()
                                ));
                    }
                    resizeEvents() {
                        this.stickyScrollCheck(),
                            document.removeEventListener("theme:scroll", this.scrollEvent),
                            this.initSticky();
                    }
                    stickyScrollCheck() {
                        const t =
                                (window.innerWidth ||
                                    document.documentElement.clientWidth ||
                                    document.body.clientWidth) >= window.theme.sizes.large,
                            e = this.container.querySelector(_y);
                        if (e)
                            if (t) {
                                const t = this.container.querySelector(_y),
                                    i = this.container.querySelector(zy);
                                if (!t || !i) return;
                                t.offsetHeight < i.offsetHeight
                                    ? ((theme.variables.productPageSticky = !0), e.classList.add(Vy))
                                    : ((theme.variables.productPageSticky = !1), e.classList.remove(Vy));
                            } else (theme.variables.productPageSticky = !1), e.classList.remove(Vy);
                    }
                    calculateStickyPosition(t = null) {
                        const e = Boolean(t && t.detail),
                            i = Boolean(e && t.detail.element && "accordion" === t.detail.element),
                            s = this.productInfo.offsetHeight,
                            o = window.innerHeight - s - this.defaultTopBottomSpacings,
                            n = Math.abs(this.scrollTop - this.scrollLastPosition);
                        this.scrollDirectionDown ? (this.stickyScrollTop -= n) : (this.stickyScrollTop += n),
                            this.stickyFormLoad &&
                                (document.querySelector($y) && document.querySelector(Ry)
                                    ? (this.stickyDefaultTop = parseInt(
                                          document.querySelector(Ry).getBoundingClientRect().height
                                      ))
                                    : (this.stickyDefaultTop = this.defaultTopBottomSpacings),
                                (this.stickyScrollTop = this.stickyDefaultTop)),
                            (this.stickyScrollTop = Math.min(Math.max(this.stickyScrollTop, o), this.stickyDefaultTop));
                        const r = this.stickyScrollTop - this.currentPoint;
                        (this.currentPoint = this.stickyFormLoad ? this.stickyScrollTop : this.currentPoint + 0.5 * r),
                            this.productInfo.style.setProperty("--sticky-top", `${this.currentPoint}px`),
                            (this.scrollLastPosition = this.scrollTop),
                            (this.stickyFormLoad = !1),
                            (i && this.onChangeCounter <= 10) ||
                            (i && this.stickyFormLastHeight !== s) ||
                            (this.stickyScrollTop !== this.currentPoint && this.requestAnimationSticky)
                                ? (i && (this.onChangeCounter += 1),
                                  i && this.stickyFormLastHeight !== s && (this.onChangeCounter = 11),
                                  (this.requestAnimationSticky = requestAnimationFrame(() =>
                                      this.calculateStickyPosition(t)
                                  )))
                                : this.requestAnimationSticky && this.removeAnimationFrame(),
                            (this.stickyFormLastHeight = s);
                    }
                    removeAnimationFrame() {
                        this.requestAnimationSticky &&
                            (cancelAnimationFrame(this.requestAnimationSticky),
                            (this.requestAnimationSticky = null),
                            (this.onChangeCounter = 0));
                    }
                    onUnload() {
                        this.stickyEnabled && document.removeEventListener("theme:resize", this.resizeEvent),
                            theme.variables.productPageSticky &&
                                document.removeEventListener("theme:scroll", this.scrollEvent);
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.stickyEnabled = "true" === this.container.getAttribute(Ny)),
                            (this.productInfo = this.container.querySelector(_y)),
                            (this.stickyScrollTop = 0),
                            (this.scrollLastPosition = 0),
                            (this.stickyDefaultTop = 0),
                            (this.currentPoint = 0),
                            (this.defaultTopBottomSpacings = 30),
                            (this.scrollTop = window.scrollY),
                            (this.scrollDirectionDown = !0),
                            (this.requestAnimationSticky = null),
                            (this.stickyFormLoad = !0),
                            (this.stickyFormLastHeight = null),
                            (this.onChangeCounter = 0),
                            (this.scrollEvent = (t) => this.scrollEvents(t)),
                            (this.resizeEvent = (t) => this.resizeEvents(t)),
                            this.init();
                    }
                })(this);
            },
            onUnload() {
                Wy[this.id].onUnload();
            },
        },
        jy = "[data-product-single-media-group]",
        Gy = "[data-product-single-media-slider]",
        Ky = "[data-zoom-wrapper]",
        Qy = "pswp-zoom-gallery",
        Xy = "pswp-zoom-gallery--single",
        Yy = "is-moving",
        Jy = "data-image-width",
        Zy = "data-image-height";
    const tv = "[data-complementary-products]",
        ev = "[data-button-quick-view]",
        iv = "data-url";
    let sv = class extends HTMLElement {
        connectedCallback() {
            new IntersectionObserver(
                ((t, e) => {
                    t[0].isIntersecting &&
                        (e.unobserve(this),
                        this.hasAttribute(iv) &&
                            "" !== this.getAttribute(iv) &&
                            fetch(this.getAttribute(iv))
                                .then((t) => t.text())
                                .then((t) => {
                                    const e = document.createElement("div");
                                    e.innerHTML = t;
                                    const i = e.querySelector(tv);
                                    i && i.innerHTML.trim().length && (this.innerHTML = i.innerHTML),
                                        e.querySelector(ev) && new Zc(this);
                                })
                                .catch((t) => {
                                    console.error(t);
                                }));
                }).bind(this),
                { rootMargin: "0px 0px 400px 0px" }
            ).observe(this);
        }
        constructor() {
            super();
        }
    };
    const ov = "[data-recipient-checkbox]",
        nv = "[data-recipient-email]",
        rv = "[data-recipient-name]",
        av = "[data-recipient-message]",
        lv = "[data-recipient-send-on]",
        cv = "[data-recipient-control]",
        hv = "[data-recipient-offset]",
        dv = "[data-product-form]",
        uv = "[data-cart-drawer]",
        pv = "js-quick-view-visible";
    let mv = class extends HTMLElement {
        connectedCallback() {
            this.recipientCheckbox &&
                (this.disableInputFields(),
                this.recipientCheckbox.addEventListener("change", this.onChangeEvent),
                document.addEventListener("theme:cart:added", this.onCartAddedEvent));
        }
        onChange(t) {
            if (!t.target.checked) return this.clearInputFields(), void this.disableInputFields();
            this.enableInputFields();
        }
        onCartAdded() {
            const t = this.closest(dv).offsetTop,
                e = document.body.classList.contains(pv);
            if (!(!0 === this.recipientCheckbox.checked)) return;
            e || window.scrollTo({ top: t, left: 0, behavior: "smooth" });
            const i = (t) => {
                t.target === this.cartDrawer &&
                    (requestAnimationFrame(() => {
                        (this.recipientCheckbox.checked = !1),
                            this.recipientCheckbox.dispatchEvent(new Event("change"));
                    }),
                    this.cartDrawer.removeEventListener("transitionend", i));
            };
            this.cartDrawer.addEventListener("transitionend", i);
        }
        inputFields() {
            return [this.recipientEmail, this.recipientName, this.recipientMessage, this.recipientSendOn];
        }
        disableableFields() {
            return [...this.inputFields(), this.recipientOffset];
        }
        clearInputFields() {
            this.inputFields().forEach((t) => (t.value = ""));
        }
        enableInputFields() {
            this.disableableFields().forEach((t) => (t.disabled = !1));
        }
        disableInputFields() {
            this.disableableFields().forEach((t) => (t.disabled = !0));
        }
        disconnectedCallback() {
            this.recipientCheckbox.removeEventListener("change", this.onChangeEvent),
                document.removeEventListener("theme:cart:added", this.onCartAddedEvent);
        }
        constructor() {
            super(),
                (this.recipientCheckbox = this.querySelector(ov)),
                (this.recipientControl = this.querySelector(cv)),
                (this.recipientControl.disabled = !0),
                (this.recipientEmail = this.querySelector(nv)),
                (this.recipientName = this.querySelector(rv)),
                (this.recipientMessage = this.querySelector(av)),
                (this.recipientSendOn = this.querySelector(lv)),
                (this.recipientOffset = this.querySelector(hv)),
                this.recipientOffset && (this.recipientOffset.value = new Date().getTimezoneOffset()),
                (this.cartDrawer = document.querySelector(uv)),
                (this.onChangeEvent = (t) => this.onChange(t)),
                (this.onCartAddedEvent = () => this.onCartAdded());
        }
    };
    const gv = "[data-product-single-media-slider]",
        fv = "[data-thumbnail-id]",
        yv = "[data-product-single-media-thumbs]",
        vv = "[data-product-single-media-wrapper]",
        bv = "[data-model]",
        wv = ".product-single__thumbnail-link",
        Sv = "[data-deferred-media]",
        Ev = "[data-deferred-media-button]",
        Lv = "a, button",
        kv = "[data-upsell-holder]",
        Av = "[data-upsell-slider]",
        Cv = "[data-slider]",
        qv = "[data-product-json]",
        Tv = "featured-product",
        Pv = "featured-product--onboarding",
        xv = "has-media-active",
        Iv = "is-selected",
        Hv = "media--hidden",
        Fv = "no-outline",
        Mv = "is-moving",
        Dv = "data-media-id",
        Ov = "data-section-id",
        Bv = "data-thumbnail-id",
        zv = "data-tall-layout",
        _v = "loaded",
        $v = "tabindex",
        Rv = {};
    const Vv = {
        onLoad() {
            Rv[this.id] = new (class {
                productSlider() {
                    this.checkSlider(), document.addEventListener("theme:resize:width", this.checkSliderOnResize);
                }
                checkSlider() {
                    !this.tallLayout || window.innerWidth < theme.sizes.large
                        ? this.initProductSlider()
                        : this.destroyProductSlider();
                }
                resizeFlickityNav() {
                    null !== this.flktyNav && this.flktyNav.resize();
                }
                initProductSlider() {
                    const t = this.container.querySelector(gv),
                        i = this.container.querySelector(yv),
                        s = this.container.querySelectorAll(vv);
                    if (
                        s.length > 1 &&
                        ((this.flkty = new e(t, {
                            wrapAround: !0,
                            pageDots: !1,
                            adaptiveHeight: !0,
                            on: {
                                ready: () => {
                                    t.setAttribute($v, "-1"),
                                        s.forEach((t) => {
                                            if (!t.classList.contains(Iv)) {
                                                const e = t.querySelectorAll(Lv);
                                                e.length &&
                                                    e.forEach((t) => {
                                                        t.setAttribute($v, "-1");
                                                    });
                                            }
                                        });
                                },
                                dragStart: () => {
                                    t.classList.add(Mv);
                                },
                                dragMove: () => {
                                    this.isFlickityDragging = !0;
                                },
                                staticClick: () => {
                                    this.isFlickityDragging = !1;
                                },
                                settle: (e) => {
                                    const i = this.flkty.selectedElement.getAttribute(Dv);
                                    this.flkty.cells.forEach((t, i) => {
                                        const s = t.element.querySelectorAll(Lv);
                                        s.length &&
                                            s.forEach((t) => {
                                                t.setAttribute($v, i === e ? "0" : "-1");
                                            });
                                    }),
                                        this.switchMedia(i),
                                        t.classList.remove(Mv);
                                },
                            },
                        })),
                        s.length &&
                            s.forEach((t) => {
                                t.addEventListener("theme:media:play", () => {
                                    (this.flkty.options.draggable = !1),
                                        this.flkty.updateDraggable(),
                                        t.closest(gv).classList.add(xv);
                                }),
                                    t.addEventListener("theme:media:pause", () => {
                                        (this.flkty.options.draggable = !0),
                                            this.flkty.updateDraggable(),
                                            t.closest(gv).classList.remove(xv);
                                    });
                            }),
                        Si(t),
                        null !== i)
                    ) {
                        (this.flktyNav = new e(i, {
                            asNavFor: t,
                            contain: !0,
                            pageDots: !1,
                            prevNextButtons: !1,
                            resize: !0,
                            on: {
                                ready: () => {
                                    i.setAttribute($v, "-1");
                                },
                            },
                        })),
                            null !== this.flktyNav &&
                                document.addEventListener("theme:resize:width", this.flktyNavOnResize),
                            Si(i);
                        const s = this.container.querySelectorAll(wv);
                        s.length &&
                            s.forEach((t) => {
                                t.addEventListener("click", (t) => {
                                    t.preventDefault();
                                });
                            });
                    }
                }
                destroyProductSlider() {
                    null !== this.flkty &&
                        (this.flkty.destroy(), this.flktyNav.destroy(), (this.flkty = null), (this.flktyNav = null));
                }
                initUpsellSlider() {
                    const t = this.container.querySelector(Av);
                    if (this.container.querySelectorAll(kv).length > 1) {
                        const i = new e(t, { wrapAround: !0, pageDots: !0, adaptiveHeight: !0, prevNextButtons: !1 });
                        i.on("change", (t) => {
                            i.cells.forEach((e, i) => {
                                const s = e.element.querySelectorAll(Lv);
                                s.length &&
                                    s.forEach((e) => {
                                        e.setAttribute($v, i === t ? "0" : "-1");
                                    });
                            });
                        });
                    }
                }
                initFeatureSlider() {
                    this.featureSliders.forEach((t) => {
                        Array.from(t.children).length > 1 &&
                            (this.flktyFeature = new e(t, {
                                wrapAround: !0,
                                pageDots: !0,
                                adaptiveHeight: !0,
                                prevNextButtons: !1,
                            }));
                    });
                }
                handleMediaFocus(t) {
                    if (t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.TAB) return;
                    const i = t.currentTarget.getAttribute(Bv),
                        s = this.container.querySelector(`[${Dv}="${i}"]`),
                        o = parseInt([...s.parentNode.children].indexOf(s)),
                        n = this.container.querySelector(gv),
                        r = this.container.querySelector(yv),
                        a = e.data(n) || null,
                        l = e.data(r) || null;
                    a &&
                        a.isActive &&
                        o > -1 &&
                        (t.code === theme.keyboardKeys.ENTER || t.code === theme.keyboardKeys.NUMPADENTER) &&
                        a.select(o),
                        l && l.isActive && o > -1 && l.select(o);
                }
                switchMedia(t) {
                    const e = document.querySelectorAll(`${vv}`),
                        i = this.container.querySelector(`${vv}[${Dv}="${t}"]`),
                        s = !document.body.classList.contains(Fv);
                    e.length &&
                        e.forEach((t) => {
                            t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }),
                                t.classList.add(Hv);
                        }),
                        s && i.focus(),
                        i.closest(gv).classList.remove(xv),
                        i.classList.remove(Hv),
                        i.dispatchEvent(new CustomEvent("theme:media:visible"), { bubbles: !0 });
                    const o = i.querySelector(Sv);
                    o && "true" !== o.getAttribute(_v) && i.querySelector(Ev).dispatchEvent(new Event("click"));
                }
                initMediaSwitch() {
                    const t = this.container.querySelectorAll(fv);
                    t.length &&
                        t.forEach((t) => {
                            t.addEventListener("keyup", this.handleMediaFocus.bind(this)),
                                t.addEventListener("click", (t) => {
                                    t.preventDefault();
                                });
                        });
                }
                initProductVideo() {
                    this.videos = new Di(this.container);
                }
                initProductModel() {
                    const t = this.container.querySelectorAll(bv);
                    t.length &&
                        t.forEach((t) => {
                            theme.ProductModel.init(t, this.sectionId);
                        });
                }
                initShopifyXrLaunch() {
                    document.addEventListener("shopify_xr_launch", () => {
                        this.container.querySelector(`${bv}:not(.${Hv})`).dispatchEvent(new CustomEvent("xrLaunch"));
                    });
                }
                onUnload() {
                    null !== this.flktyNav && document.removeEventListener("theme:resize:width", this.flktyNavOnResize),
                        document.removeEventListener("theme:resize:width", this.checkSliderOnResize);
                }
                onBlockSelect(t) {
                    const i = e.data(t.target.closest(Cv)),
                        s = parseInt([...t.target.parentNode.children].indexOf(t.target));
                    i && i.select(s);
                }
                constructor(t) {
                    if (
                        ((this.container = t.container),
                        (this.sectionId = this.container.getAttribute(Ov)),
                        (this.tallLayout = "true" === this.container.getAttribute(zv)),
                        (this.featureSliders = this.container.querySelectorAll(Cv)),
                        (this.flkty = null),
                        (this.flktyNav = null),
                        (this.isFlickityDragging = !1),
                        (this.enableHistoryState = !this.container.classList.contains(Tv)),
                        (this.checkSliderOnResize = () => this.checkSlider()),
                        (this.flktyNavOnResize = () => this.resizeFlickityNav()),
                        this.initUpsellSlider(),
                        this.initFeatureSlider(),
                        new Zc(this.container),
                        this.container.classList.contains(Pv))
                    )
                        return;
                    const e = this.container.querySelector(qv);
                    if (e && e.innerHTML) {
                        const t = JSON.parse(e.innerHTML).handle;
                        let i = {};
                        t && (i = { handle: t }), Shopify.Products.recordRecentlyViewed(i);
                    } else Shopify.Products.recordRecentlyViewed();
                    new (class {
                        init() {
                            this.zoomWrappers.length &&
                                this.zoomWrappers.forEach((t, e) => {
                                    t.addEventListener("click", (i) => {
                                        i.preventDefault(),
                                            (this.slider && this.slider.classList.contains(Yy)) ||
                                                ((this.a11y.state.trigger = t), this.createZoom(e));
                                    });
                                });
                        }
                        createZoom(t) {
                            const e = this;
                            let i = [],
                                s = 0;
                            this.zoomWrappers.forEach((o) => {
                                const n = o.getAttribute("href"),
                                    r = parseInt(o.getAttribute(Jy)),
                                    a = parseInt(o.getAttribute(Zy));
                                if ((i.push({ src: n, w: r, h: a, msrc: n }), (s += 1), e.zoomWrappers.length === s)) {
                                    let e = `${Qy}`;
                                    1 === s && (e = `${Qy} ${Xy}`),
                                        new Mc(i, {
                                            barsSize: { top: 60, bottom: 60 },
                                            history: !1,
                                            focus: !1,
                                            index: t,
                                            mainClass: e,
                                            showHideOpacity: !0,
                                            showAnimationDuration: 250,
                                            hideAnimationDuration: 250,
                                            closeOnScroll: !1,
                                            closeOnVerticalDrag: !1,
                                            captionEl: !1,
                                            closeEl: !0,
                                            closeElClasses: ["caption-close"],
                                            tapToClose: !1,
                                            clickToCloseNonZoomable: !1,
                                            maxSpreadZoom: 2,
                                            loop: !0,
                                            spacing: 0,
                                            allowPanToNext: !0,
                                            pinchToClose: !1,
                                        });
                                }
                            });
                        }
                        constructor(t) {
                            (this.container = t),
                                (this.mediaContainer = this.container.querySelector(jy)),
                                (this.slider = this.container.querySelector(Gy)),
                                (this.zoomWrappers = this.container.querySelectorAll(Ky)),
                                (this.zoomEnable = "true" === this.mediaContainer.dataset.gallery),
                                (this.a11y = Ye),
                                this.zoomEnable && this.init();
                        }
                    })(this.container),
                        this.productSlider(),
                        this.initMediaSwitch(),
                        this.initProductVideo(),
                        this.initProductModel(),
                        this.initShopifyXrLaunch();
                }
            })(this);
        },
        onUnload: function () {
            Rv[this.id].onUnload();
        },
        onBlockSelect(t) {
            Rv[this.id].onBlockSelect(t);
        },
    };
    I("product-template", [sl, Vv, eo, io, xp, Ve, is, ql, xr, Uy]),
        I("featured-product", [sl, Vv, eo, io, xp, Ve, is, ql, xr, Uy]),
        customElements.get("complementary-products") || customElements.define("complementary-products", sv),
        customElements.get("recipient-form") || customElements.define("recipient-form", mv);
    const Nv = "href",
        Wv = "data-media-id",
        Uv = "data-deferred-media-loaded",
        jv = "[data-product-content-wrapper]",
        Gv = "[data-product-single-media-wrapper]",
        Kv = "[data-model]",
        Qv = "[data-product-link]",
        Xv = "[data-product-single-media-image]",
        Yv = "[data-slider-contents]",
        Jv = "[data-slider-images]",
        Zv = "[data-tab-button]",
        tb = "[data-tab-item]",
        eb = "[data-circle-text]",
        ib = {
            aosAnimate: "aos-animate",
            tabButtonActive: "products-list__nav__button--active",
            tabItemActive: "products-list__item--active",
            mediaHidden: "media--hidden",
            isDisabled: "is-disabled",
        },
        sb = {};
    I("products-list", [
        {
            onLoad() {
                sb[this.id] = new (class {
                    listen() {
                        (this.slidersImages.length > 0 || this.slidersContents.length > 0) &&
                            document.addEventListener("theme:resize", this.sliderResizeEvent);
                    }
                    resizeSlider() {
                        this.flktyImages.length > 0 &&
                            requestAnimationFrame(() => {
                                this.flktyImages.forEach((t) => t.resize());
                            }),
                            this.flktyContent.length > 0 &&
                                requestAnimationFrame(() => {
                                    this.flktyContent.forEach((t) => t.resize());
                                });
                    }
                    initButtons() {
                        this.tabButtons.length &&
                            this.tabButtons.forEach((t) => {
                                t.addEventListener("click", (e) => {
                                    if (t.classList.contains(ib.tabButtonActive)) return;
                                    const i = t.getAttribute(Nv),
                                        s = this.container.querySelector(i),
                                        o = s.querySelector(Gv),
                                        n = o ? o.dataset.mediaId : null,
                                        r = s.querySelector(eb);
                                    this.tabButtons.forEach((t) => {
                                        t.classList.remove(ib.tabButtonActive);
                                    }),
                                        this.tabItems.forEach((t) => {
                                            const e = t.querySelector(eb);
                                            t.classList.remove(ib.tabItemActive),
                                                null == e || e.classList.add(ib.isDisabled),
                                                theme.settings.animationsEnabled &&
                                                    t.querySelectorAll(`.${ib.aosAnimate}`).forEach((t) => {
                                                        t.classList.remove(ib.aosAnimate),
                                                            setTimeout(() => {
                                                                t.classList.add(ib.aosAnimate);
                                                            });
                                                    });
                                        }),
                                        t.classList.add(ib.tabButtonActive),
                                        s.classList.add(ib.tabItemActive),
                                        document.dispatchEvent(new CustomEvent("theme:resize")),
                                        r &&
                                            (r.classList.remove(ib.isDisabled),
                                            document.dispatchEvent(new CustomEvent("theme:scroll"))),
                                        this.handleProductVideos(s, n),
                                        e.preventDefault();
                                });
                            });
                    }
                    initSliders() {
                        this.slidersImages.forEach((t, i) => {
                            const s = t.closest(tb).querySelector(Yv),
                                o = new e(t, {
                                    fade: !0,
                                    pageDots: !1,
                                    prevNextButtons: !0,
                                    wrapAround: !0,
                                    adaptiveHeight: !0,
                                    asNavFor: s,
                                    on: {
                                        change: (t) => {
                                            this.flktyContent.length > 0 && this.flktyContent[i].select(t);
                                        },
                                    },
                                });
                            o.on("settle", (e) => {
                                const i = t.querySelectorAll(Gv);
                                for (let t = 0; t < i.length; t++)
                                    t === e
                                        ? i[t].querySelector(Xv).removeAttribute("tabindex")
                                        : i[t].querySelector(Xv).setAttribute("tabindex", "-1");
                            }),
                                this.flktyImages.push(o);
                        }),
                            this.slidersContents.forEach((t) => {
                                const i = new e(t, {
                                    fade: !0,
                                    pageDots: !1,
                                    prevNextButtons: !1,
                                    wrapAround: !0,
                                    adaptiveHeight: !0,
                                });
                                i.on("settle", (e) => {
                                    const i = t.querySelectorAll(jv);
                                    for (let t = 0; t < i.length; t++)
                                        t === e
                                            ? i[t].querySelectorAll(Qv).forEach((t) => {
                                                  t.removeAttribute("tabindex");
                                              })
                                            : i[t].querySelectorAll(Qv).forEach((t) => {
                                                  t.setAttribute("tabindex", "-1");
                                              });
                                }),
                                    this.flktyContent.push(i);
                            });
                    }
                    initProductVideos() {
                        this.tabItems.forEach((t) => {
                            t.classList.contains(ib.tabItemActive) && this.handleProductVideos(t);
                        });
                    }
                    loadVideos(t, e = null) {
                        new IntersectionObserver(
                            (i, s) => {
                                i.forEach((i) => {
                                    if (i.isIntersecting) {
                                        const o = new Di(t);
                                        this.videos.push(o),
                                            t.setAttribute(Uv, ""),
                                            this.playToggle(e),
                                            s.unobserve(i.target);
                                    }
                                });
                            },
                            { root: null, rootMargin: "300px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
                        ).observe(t);
                    }
                    handleProductVideos(t, e = null) {
                        t.hasAttribute(Uv) ? this.playToggle(e) : this.loadVideos(t, e);
                    }
                    playToggle(t) {
                        this.videos.forEach((e) => {
                            "function" == typeof e.pauseContainerMedia &&
                                t &&
                                (e.pauseContainerMedia(t, this.container), this.switchMedia(t)),
                                t || 0 !== Object.keys(e.players).length || this.pauseContainerMedia(this.container);
                        });
                    }
                    switchMedia(t) {
                        const e = this.container.querySelector(`${Gv}[${Wv}="${t}"]`);
                        !document.body.classList.contains(ib.noOutline) && e.focus(),
                            e.classList.remove(ib.mediaHidden),
                            e.dispatchEvent(new CustomEvent("theme:media:visible"), { bubbles: !0 });
                    }
                    pauseContainerMedia(t) {
                        const e = t.querySelectorAll(Gv);
                        0 !== e.length &&
                            e.forEach((t) => {
                                t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }),
                                    t.classList.add(ib.mediaHidden);
                            });
                    }
                    initProductModel() {
                        const t = this.container.querySelectorAll(Kv);
                        t.length &&
                            t.forEach((t) => {
                                theme.ProductModel.init(t, this.sectionId);
                            });
                    }
                    initShopifyXrLaunch() {
                        document.addEventListener("shopify_xr_launch", () => {
                            this.container
                                .querySelector(`${Kv}:not(.${ib.mediaHidden})`)
                                .dispatchEvent(new CustomEvent("xrLaunch"));
                        });
                    }
                    onBlockSelect(t) {
                        t.target.dispatchEvent(new Event("click"));
                    }
                    onUnload() {
                        (this.slidersImages.length > 0 || this.slidersContents.length > 0) &&
                            document.removeEventListener("theme:resize", this.sliderResizeEvent);
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.sectionId = this.container.dataset.sectionId),
                            (this.tabButtons = this.container.querySelectorAll(Zv)),
                            (this.tabItems = this.container.querySelectorAll(tb)),
                            (this.slidersImages = this.container.querySelectorAll(Jv)),
                            (this.slidersContents = this.container.querySelectorAll(Yv)),
                            (this.videos = []),
                            (this.flktyImages = []),
                            (this.flktyContent = []),
                            (this.sliderResizeEvent = () => this.resizeSlider()),
                            this.initButtons(),
                            this.initSliders(),
                            this.initProductVideos(),
                            this.initProductModel(),
                            this.initShopifyXrLaunch(),
                            this.listen();
                    }
                })(this);
            },
            onUnload() {
                sb[this.id].onUnload();
            },
            onBlockSelect(t) {
                sb[this.id].onBlockSelect(t);
            },
        },
        du,
    ]);
    const ob = "[data-product-block]",
        nb = "[data-related-products]",
        rb = "[data-recent-wrapper]",
        ab = "[data-recently-viewed-wrapper]",
        lb = "[data-slider]",
        cb = "[data-slide]",
        hb = "[data-aos]",
        db = "[data-tabs-holder]",
        ub = "[data-tabs-link]",
        pb = "[data-tab]",
        mb = "[data-tooltip]",
        gb = "data-section-id",
        fb = "data-product-id",
        yb = "data-limit",
        vb = "data-minimum",
        bb = "data-tabs-link",
        wb = "data-column-mobile",
        Sb = "hidden",
        Eb = "aos-animate",
        Lb = "mobile--one-whole",
        kb = "mobile--one-half",
        Ab = {};
    const Cb = {
        onLoad() {
            Ab[this.id] = new (class {
                related() {
                    if (((this.relatedProducts = this.container.querySelector(nb)), !this.relatedProducts)) return;
                    const t = this.container.getAttribute(gb),
                        e = this.container.getAttribute(fb),
                        i = this.container.getAttribute(yb),
                        s = `${theme.routes.product_recommendations_url}?section_id=${t}&limit=${i}&product_id=${e}`;
                    fetch(s)
                        .then((t) => {
                            if (!t.ok) {
                                const e = new Error(t.status);
                                throw (this.hideRelated(), e);
                            }
                            return t.text();
                        })
                        .then((t) => {
                            const e = document.createElement("div");
                            e.innerHTML = t;
                            const i = e.querySelector(nb);
                            i &&
                                i.querySelectorAll(ob).length &&
                                ((this.relatedProducts.innerHTML = i.innerHTML),
                                (this.relatedProductGrid = new go(this.relatedProducts)),
                                (this.relatedGridSlider = new xg(this.container)),
                                this.initTooltips(this.relatedProducts));
                        });
                }
                recent() {
                    const t = this.container.querySelector(rb),
                        e = t ? parseInt(t.getAttribute(yb)) : 4;
                    Shopify.Products.showRecentlyViewed({
                        howManyToShow: e,
                        wrapperId: `recently-viewed-products-${this.sectionId}`,
                        section: this.section,
                        onComplete: (t, e) => {
                            const i = e.container,
                                s = i.querySelector(rb),
                                o = i.querySelector(ab),
                                n = t.querySelectorAll(ob),
                                r = s.querySelectorAll(hb),
                                a = s.querySelector(lb),
                                l = s.hasAttribute(vb) ? parseInt(s.getAttribute(vb)) : 1,
                                c = !o && n.length > 0,
                                h = o && n.length >= l,
                                d = a.getAttribute(wb);
                            if (c || h) {
                                (this.recentProductGrid = new go(s)),
                                    this.initTooltips(s),
                                    h && i.classList.remove(Sb),
                                    a &&
                                        ((this.recentGridSlider = new xg(i)),
                                        requestAnimationFrame(() => {
                                            this.recentGridSlider.sliders.forEach((t) => {
                                                t.dispatchEvent(
                                                    new CustomEvent("theme:slider:resize", { bubbles: !0 })
                                                ),
                                                    this.recentGridSlider.setSliderArrowsPosition(t);
                                            });
                                        }),
                                        a.querySelectorAll(cb).forEach((t) => {
                                            2 == d
                                                ? (t.classList.add(kb), t.classList.remove(Lb))
                                                : (t.classList.add(Lb), t.classList.remove(kb));
                                        }));
                                let t = [];
                                s.addEventListener("theme:target:animate", (e) => {
                                    t.push(e.detail),
                                        t.length === r.length &&
                                            requestAnimationFrame(() => r.forEach((t) => t.classList.add(Eb)));
                                });
                            }
                        },
                    });
                }
                hideRelated() {
                    const t = this.relatedProducts.closest(pb),
                        e = this.relatedProducts.closest(db),
                        i = e.querySelector(`[${bb}="${t.dataset.tab}"]`);
                    t.remove(),
                        i &&
                            (i.remove(),
                            e.querySelector(ub).dispatchEvent(new Event("click")),
                            this.tabs.customScrollbar.unload(),
                            requestAnimationFrame(() => {
                                this.tabs.customScrollbar = new Ri(this.tabs.container);
                            }));
                }
                initTooltips(t) {
                    (this.tooltips = t.querySelectorAll(mb)),
                        this.tooltips.forEach((t) => {
                            new es(t);
                        });
                }
                onDeselect() {
                    this.relatedProductGrid && this.relatedProductGrid.onDeselect(),
                        this.recentProductGrid && this.recentProductGrid.onDeselect();
                }
                onBlockSelect(t) {
                    const e = t.target,
                        i = this.container.querySelectorAll(pb);
                    !e ||
                        i.length < 2 ||
                        (e.dispatchEvent(new Event("click")),
                        e.parentNode.scrollTo({ top: 0, left: e.offsetLeft - e.clientWidth, behavior: "smooth" }));
                }
                onUnload() {
                    this.relatedProductGrid && this.relatedProductGrid.onUnload(),
                        this.relatedGridSlider && this.relatedGridSlider.onUnload(),
                        this.recentProductGrid && this.recentProductGrid.onUnload(),
                        this.recentGridSlider && this.recentGridSlider.onUnload();
                }
                constructor(t) {
                    (this.section = t),
                        (this.sectionId = t.id),
                        (this.container = t.container),
                        this.related(),
                        this.recent(),
                        (this.tabs = new mr(this.container));
                }
            })(this);
        },
        onDeselect() {
            Ab[this.id].onDeselect();
        },
        onBlockSelect(t) {
            Ab[this.id].onBlockSelect(t);
        },
        onUnload() {
            Ab[this.id].onUnload();
        },
    };
    I("related-products", Cb), I("recent-products", Cb);
    const qb = {},
        Tb = "[data-slider]",
        Pb = "[data-item]",
        xb = "[data-button-show]",
        Ib = "[data-button-hide]",
        Hb = "[data-item-products]",
        Fb = "[data-item-products-slider]",
        Mb = "[data-item-product]",
        Db = "a, button",
        Ob = "blog-item--active",
        Bb = "blog-item__products--visible",
        zb = "flickity-enabled",
        _b = "is-selected",
        $b = {
            slider: "data-slider",
            slidePosition: "data-slide-position",
            sectionId: "data-section-id",
            tabIndex: "tabindex",
        };
    const Rb = {
        onLoad() {
            qb[this.id] = new (class {
                initSlider() {
                    (this.flkty = new e(this.slider, {
                        prevNextButtons: !0,
                        pageDots: !1,
                        cellAlign: "left",
                        wrapAround: !1,
                        groupCells: !0,
                        contain: !0,
                        on: {
                            ready: () => {
                                this.handleFocus();
                            },
                        },
                    })),
                        this.flkty.on("change", () => {
                            const t = this.container.querySelectorAll(Pb);
                            this.handleFocus(),
                                t.length &&
                                    t.forEach((t) => {
                                        const e = t.querySelector(Hb);
                                        t.classList.remove(Ob), e && t.querySelector(Hb).classList.remove(Bb);
                                    }),
                                this.flkty &&
                                    !this.flkty.options.draggable &&
                                    ((this.flkty.options.draggable = !0), this.flkty.updateDraggable());
                        });
                }
                destroySlider() {
                    null !== this.flkty && (this.flkty.destroy(), (this.flkty = null));
                }
                checkSlidesSize() {
                    const t =
                        this.container.querySelector(Pb).currentStyle ||
                        window.getComputedStyle(this.container.querySelector(Pb));
                    this.gutter = parseInt(t.marginRight);
                    const e = this.slider.offsetWidth + this.gutter < this.getItemsWidth();
                    window.innerWidth >= theme.sizes.small && e ? this.initSlider() : this.destroySlider();
                }
                getItemsWidth() {
                    let t = 0;
                    const e = this.slider.querySelectorAll(Pb);
                    return (
                        e.length &&
                            e.forEach((e) => {
                                t += e.offsetWidth + this.gutter;
                            }),
                        t
                    );
                }
                bindButtons() {
                    const t = this.container.querySelectorAll(Fb),
                        i = this.container.querySelectorAll(xb),
                        s = this.container.querySelectorAll(Ib);
                    i.length &&
                        i.forEach((t) => {
                            t.addEventListener("click", (e) => {
                                e.preventDefault(),
                                    this.container.querySelectorAll(Pb).forEach((t) => {
                                        const e = t.querySelector(Hb);
                                        t.classList.remove(Ob), e && (e.classList.remove(Bb), this.changeTabIndex(e));
                                    });
                                const i = t.closest(Pb),
                                    s = i.querySelector(Hb);
                                if ((i.classList.add(Ob), s)) {
                                    s.classList.add(Bb), this.changeTabIndex(s, "enable");
                                    const t = s.querySelector(Fb),
                                        e = t.querySelectorAll(Mb);
                                    if (t.classList.contains(zb)) {
                                        const i = t.querySelector(`.${_b}`).getAttribute($b.slidePosition);
                                        e.forEach((t, e) => {
                                            t.setAttribute($b.tabIndex, e === i ? "0" : "-1");
                                        });
                                    }
                                }
                                null !== this.flkty &&
                                    ((this.flkty.options.draggable = !1), this.flkty.updateDraggable()),
                                    (this.a11y.state.trigger = t);
                            });
                        }),
                        s.length &&
                            s.forEach((t) => {
                                t.addEventListener("click", (e) => {
                                    e.preventDefault();
                                    const i = t.closest(Pb),
                                        s = i.querySelector(Hb);
                                    i.classList.remove(Ob),
                                        s && (s.classList.remove(Bb), this.changeTabIndex(s)),
                                        null !== this.flkty &&
                                            ((this.flkty.options.draggable = !0), this.flkty.updateDraggable()),
                                        this.a11y.state.trigger.focus();
                                });
                            }),
                        t.length &&
                            t.forEach((t) => {
                                if (t.querySelectorAll(Mb).length > 1) {
                                    const i = new e(t, {
                                        prevNextButtons: !0,
                                        contain: !0,
                                        pageDots: !1,
                                        wrapAround: !0,
                                        on: {
                                            change: (t) => {
                                                i.cells.forEach((e, i) => {
                                                    e.element.querySelectorAll(Db).forEach((e) => {
                                                        e.setAttribute($b.tabIndex, i === t ? "0" : "-1");
                                                    });
                                                });
                                            },
                                        },
                                    });
                                }
                            }),
                        this.slider.addEventListener("keyup", (t) => {
                            if (t.code === theme.keyboardKeys.ESCAPE) {
                                const e = t.target.hasAttribute($b.slider)
                                    ? t.target.querySelectorAll(Pb)
                                    : t.target.closest(Tb).querySelectorAll(Pb);
                                e.length &&
                                    (e.forEach((t) => {
                                        const e = t.querySelector(Hb);
                                        t.classList.remove(Ob), e && (e.classList.remove(Bb), this.changeTabIndex(e));
                                    }),
                                    this.flkty && ((this.flkty.options.draggable = !0), this.flkty.updateDraggable())),
                                    this.a11y.state.trigger.focus();
                            }
                        });
                }
                handleFocus() {
                    const t = this.container.querySelectorAll(Pb);
                    t.length &&
                        t.forEach((t) => {
                            const e = t.classList.contains(_b),
                                i = t.querySelector(Hb);
                            e
                                ? (this.changeTabIndex(t, "enable"), i && this.changeTabIndex(i))
                                : (this.changeTabIndex(t), i && i.classList.remove(Bb));
                        });
                }
                listen() {
                    this.slider &&
                        (this.checkSlidesSize(),
                        document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize)),
                        document.addEventListener("mousedown", this.clickOutsideItemEvent);
                }
                changeTabIndex(t, e = "") {
                    const i = "enable" === e ? "0" : "-1";
                    t.querySelectorAll(Db).forEach((t) => {
                        t.setAttribute($b.tabIndex, i);
                    });
                }
                onBlockSelect(t) {
                    if (null !== this.flkty) {
                        const e = parseInt([...t.target.parentNode.children].indexOf(t.target)),
                            i = parseInt(this.flkty.slides[0].cells.length),
                            s = Math.floor(e / i);
                        this.flkty.select(s);
                    } else {
                        const e = this.slider.currentStyle || window.getComputedStyle(this.slider),
                            i = parseInt(e.paddingLeft),
                            s = t.target.offsetLeft - i;
                        this.slider.scrollTo({ top: 0, left: s, behavior: "smooth" });
                    }
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize),
                        document.removeEventListener("mousedown", this.clickOutsideItemEvent);
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.flkty = null),
                        (this.slider = this.container.querySelector(Tb)),
                        (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
                        (this.isFullWidth = this.container.hasAttribute($b.fullWidth)),
                        (this.gutter = 0),
                        (this.a11y = Ye),
                        (this.clickOutsideItemEvent = (t) => {
                            if (!t.target.matches(Pb) && !t.target.closest(Pb)) {
                                const t = this.container.querySelectorAll(Pb);
                                t.length &&
                                    t.forEach((t) => {
                                        const e = t.querySelector(Hb);
                                        e && (e.classList.remove(Bb), this.changeTabIndex(e)), t.classList.remove(Ob);
                                    });
                            }
                        }),
                        this.bindButtons(),
                        this.listen();
                }
            })(this);
        },
        onUnload(t) {
            qb[this.id].onUnload(t);
        },
        onBlockSelect(t) {
            qb[this.id].onBlockSelect(t);
        },
    };
    I("shoppable-blog", Rb);
    const Vb = "[data-scroll-down]",
        Nb = "[data-site-header]",
        Wb = "[data-slide]",
        Ub = "a, button",
        jb = "[data-slider]",
        Gb = ".lazy-image",
        Kb = "text-highlight",
        Qb =
            '[data-parallax="zoom-on-scroll"],[data-parallax="card-scrolling"],[data-parallax="zoom-on-scroll,card-scrolling"]',
        Xb = "data-style",
        Yb = "data-current-style",
        Jb = "tabindex",
        Zb = "site-header--fixed",
        tw = "slider--no-cached-images",
        ew = "slider--img-loaded",
        iw = "img-in",
        sw = "original-height",
        ow = "original-height-mobile",
        nw = "has-mobile-height",
        rw = {};
    I("slider", [
        {
            onLoad() {
                rw[this.id] = new (class {
                    initSlider() {
                        const t = this.items.length,
                            i = parseInt(this.container.dataset.duration),
                            s = "true" === this.container.dataset.pageDots && t > 1,
                            o = "true" === this.container.dataset.navArrows && t > 1;
                        let n = "true" === this.container.dataset.autoplay;
                        if ((n && (n = i), t > 1))
                            (this.flkty = new e(this.container, {
                                fade: !0,
                                cellSelector: Wb,
                                autoPlay: n,
                                wrapAround: !0,
                                adaptiveHeight: !0,
                                setGallerySize: !0,
                                imagesLoaded: !0,
                                pageDots: s,
                                prevNextButtons: o,
                                dragThreshold: 25,
                                on: {
                                    ready: () => {
                                        const t = this.items[0].getAttribute(Xb);
                                        this.container.setAttribute(Yb, t),
                                            requestAnimationFrame(this.resizeEvent),
                                            document.addEventListener("theme:vars", this.resizeEvent),
                                            this.handleFirstSlideAnimation(!0);
                                    },
                                    change: (t) => {
                                        const e = this.flkty.selectedElement.getAttribute(Xb);
                                        this.container.setAttribute(Yb, e),
                                            this.handleFirstSlideAnimation(!1),
                                            this.flkty.cells.forEach((e, i) => {
                                                e.element.querySelectorAll(Ub).forEach((e) => {
                                                    e.setAttribute(Jb, i === t ? "0" : "-1");
                                                }),
                                                    e.element.querySelectorAll(Kb).forEach((e) => {
                                                        e.setTriggerAttribute(Boolean(i === t));
                                                    });
                                            });
                                    },
                                },
                            })),
                                Si(this.container);
                        else if (1 === t) {
                            const t = this.items[0].getAttribute(Xb);
                            this.container.setAttribute(Yb, t);
                        }
                    }
                    getTallestSlideItem() {
                        if (this.items.length <= 1) return;
                        this.container.style.removeProperty("--item-min-h");
                        const t = [...this.items].map((t) => Math.floor(t.offsetHeight)),
                            e = Math.max(...t),
                            i = [...this.items].some((t) => t.classList.contains(sw)),
                            s = [...this.items].some((t) => t.classList.contains(ow)),
                            o = this.container.classList.contains(nw);
                        ((he() && !i) || (de() && !s && o) || (de() && !i && !o)) &&
                            [...this.items].some((t) => Math.floor(t.offsetHeight) !== e) &&
                            this.container.style.setProperty("--item-min-h", `${e}px`);
                    }
                    handleFirstSlideAnimation(t = !1) {
                        if (!t) return this.container.classList.remove(tw), void this.container.classList.remove(ew);
                        const e = this.items[0].querySelectorAll(Gb),
                            i = this.container.classList.contains(iw);
                        if (e.length && !i) {
                            this.container.classList.add(tw);
                            const t = (i) => {
                                requestAnimationFrame(() => this.container.classList.add(ew)),
                                    e[0].removeEventListener("transitionend", t);
                            };
                            e[0].addEventListener("transitionend", t);
                        }
                    }
                    bindScrollButton() {
                        const t = this.container.querySelector(Vb);
                        t &&
                            t.addEventListener("click", (t) => {
                                t.preventDefault();
                                const e = this.header.classList.contains(Zb) ? 60 : 0,
                                    i = parseInt(Math.ceil(this.container.offsetTop + this.container.offsetHeight - e));
                                window.scrollTo({ top: i, left: 0, behavior: "smooth" });
                            });
                    }
                    onBlockSelect(t) {
                        const e = parseInt([...t.target.parentNode.children].indexOf(t.target));
                        null !== this.flkty && (this.flkty.select(e), this.flkty.pausePlayer());
                    }
                    onBlockDeselect(t) {
                        "true" === t.target.closest(jb).dataset.autoplay &&
                            null !== this.flkty &&
                            this.flkty.playPlayer();
                    }
                    onReorder() {
                        this.handleFirstSlideAnimation(!1), null !== this.flkty && this.flkty.resize();
                    }
                    onUnload() {
                        document.removeEventListener("theme:resize:width", this.getTallestSlideItemOnResize),
                            this.handleFirstSlideAnimation(!1),
                            null !== this.flkty &&
                                (document.removeEventListener("theme:vars", this.resizeEvent),
                                this.flkty.destroy(),
                                (this.flkty = null)),
                            this.parallax && (this.parallax.unload(), (this.parallax = null));
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.header = document.querySelector(Nb)),
                            (this.items = this.container.querySelectorAll(Wb)),
                            (this.flkty = null),
                            (this.parallax = null),
                            (this.resizeEvent = () => {
                                this.flkty.resize();
                            }),
                            this.getTallestSlideItem(),
                            this.initSlider(),
                            this.bindScrollButton(),
                            (this.getTallestSlideItemOnResize = () => this.getTallestSlideItem()),
                            document.addEventListener("theme:resize:width", this.getTallestSlideItemOnResize),
                            this.container.matches(Qb) && (this.parallax = new hu(this.container));
                    }
                })(this);
            },
            onReorder(t) {
                rw[this.id].onReorder(t);
            },
            onUnload(t) {
                rw[this.id].onUnload(t);
            },
            onBlockSelect(t) {
                rw[this.id].onBlockSelect(t);
            },
            onBlockDeselect(t) {
                rw[this.id].onBlockDeselect(t);
            },
        },
        Fp,
    ]);
    const aw = "[data-sticky-card-body]",
        lw = "[data-sticky-card-wrapper]",
        cw = "[data-sticky-card-content]",
        hw = "[data-sticky-card-aside]",
        dw = "[data-sticky-card-text]",
        uw = "[data-sticky-card-image]",
        pw = "[data-sticky-vh]",
        mw = "is-stuck-up",
        gw = "has-passed-sticky",
        fw = "spillover",
        yw = "data-sticky-card-layout-mobile",
        vw = {};
    I("sticky-image-cards", {
        onLoad() {
            vw[this.id] = new (class {
                init() {
                    requestAnimationFrame(() => {
                        this.calculateHeights(), this.onScroll();
                    }),
                        document.addEventListener("theme:scroll", this.onScrollCallback),
                        document.addEventListener("theme:resize", this.onResizeCallback);
                }
                onScroll() {
                    this.isEligible() && this.detectStickyPositions();
                }
                isEligible() {
                    const t = Math.round(this.container.getBoundingClientRect().top + window.scrollY),
                        e = t + this.container.offsetHeight < Math.round(window.scrollY);
                    return t < Math.round(window.scrollY + window.innerHeight) && !e;
                }
                detectStickyPositions() {
                    const t = Math.round(this.body.getBoundingClientRect().top - this.headerHeight - this.wrapperTop);
                    [...this.wrapper].forEach((e, i) => {
                        const s = Math.floor(e.getBoundingClientRect().top - this.headerHeight);
                        if (this.isMobile) {
                            if (i !== this.lastIndex) {
                                const t = Math.floor(
                                    this.wrapper[i + 1].getBoundingClientRect().top - this.headerHeight
                                );
                                e.classList.toggle(gw, t <= this.stickyTop);
                            }
                            this.container.classList.toggle(`checkpoint-${i + 1}`, t <= -1 * this.cumulativeHeights[i]);
                        }
                        e.classList.toggle(mw, s <= this.stickyTop);
                    });
                }
                calculateHeights() {
                    let { stickyHeaderHeight: t } = N();
                    (this.headerHeight = t || 0),
                        (this.spacingTop =
                            parseInt(window.getComputedStyle(this.container).getPropertyValue("--padding")) || 20),
                        (this.wrapperTop =
                            parseInt(window.getComputedStyle(this.wrapper[0]).getPropertyValue("top")) || 0),
                        (this.stickyTop = Math.floor(this.wrapperTop - this.headerHeight)),
                        (this.gap = parseInt(window.getComputedStyle(this.aside).getPropertyValue("gap")) || 0),
                        (this.viewportHeight = this.vh.offsetHeight),
                        (this.lastIndex = [...this.wrapper].length - 1),
                        (this.cumulativeHeights = []),
                        this.isMobile && ((this.wrapperTop = this.spacingTop), (this.stickyTop = this.spacingTop)),
                        this.textInContent &&
                            (this.isDesktop &&
                                this.textInContent.length > 0 &&
                                this.textInContent.forEach((t, e) => {
                                    t.style.setProperty("--row-height", "auto"),
                                        this.wrapper[e].style.setProperty("--row-height", "auto");
                                    const i = t.offsetHeight,
                                        s = this.image[e].offsetHeight,
                                        o = Math.max(i, s);
                                    t.style.setProperty("--row-height", `${o}px`),
                                        this.wrapper[e].style.setProperty("--row-height", `${o}px`);
                                }),
                            [...this.wrapper].forEach((t, e) => {
                                t.style.setProperty("--item-height", "auto"),
                                    t.style.setProperty("--item-double-height", "auto"),
                                    requestAnimationFrame(() => {
                                        const i = t.offsetHeight,
                                            s = i + this.wrapperTop + this.headerHeight > this.viewportHeight,
                                            o = [...this.wrapper].map((t) =>
                                                Number(t.dataset.index) >= e ? 0 : t.offsetHeight
                                            );
                                        this.cumulativeHeights.push(o.reduce((t, e) => t + e, 0)),
                                            t.classList.toggle(fw, s),
                                            s &&
                                                this.isMobile &&
                                                (t.style.setProperty("--item-height", `${i}px`),
                                                t.style.setProperty("--item-double-height", 2 * i + "px"));
                                    });
                            }));
                }
                onResize() {
                    requestAnimationFrame(() => {
                        (this.isDesktop = Boolean(ce() >= window.theme.sizes.large)), (this.isMobile = de());
                        const t = /iPhone|iPad|iPod/i.test(navigator.userAgent);
                        let e = this.isDesktop || (!t && this.isMobile);
                        this.orientation !== X() && t && ((e = !0), (this.orientation = X())),
                            e && this.calculateHeights();
                    });
                }
                onUnload() {
                    document.removeEventListener("theme:scroll", this.onScrollCallback),
                        document.removeEventListener("theme:resize", this.onResizeCallback);
                }
                onBlockSelect(t) {
                    requestAnimationFrame(() => {
                        const e = Number(t.target.dataset.index),
                            i =
                                Math.round(this.body.getBoundingClientRect().top + window.scrollY) +
                                [...this.wrapper]
                                    .map((t) => (Number(t.dataset.index) >= e ? 0 : t.offsetHeight))
                                    .reduce((t, e) => t + e, 0) -
                                (() =>
                                    this.isMobile && "stacked" === this.layoutMobile
                                        ? this.gap * e * -1 + this.gap / 2
                                        : this.stickyTop)() -
                                this.headerHeight;
                        setTimeout(() => {
                            window.scrollTo({ top: i, left: 0, behavior: "smooth" });
                        }, 400);
                    });
                }
                constructor(t) {
                    var e;
                    (this.container = t.container),
                        (this.body = this.container.querySelector(aw)),
                        (this.wrapper = this.container.querySelectorAll(lw)),
                        (this.content = this.container.querySelector(cw)),
                        (this.aside = this.container.querySelector(hw)),
                        (this.text = this.container.querySelectorAll(dw)),
                        (this.image = this.container.querySelectorAll(uw)),
                        (this.textInContent =
                            null === (e = this.content) || void 0 === e ? void 0 : e.querySelectorAll(dw)),
                        (this.vh = this.container.querySelector(pw)),
                        (this.layoutMobile = this.container.getAttribute(yw)),
                        (this.isDesktop = Boolean(ce() >= window.theme.sizes.large)),
                        (this.isMobile = de()),
                        (this.orientation = X()),
                        0 !== this.image.length &&
                            ((this.onScrollCallback = () => this.onScroll()),
                            (this.onResizeCallback = () => this.onResize()),
                            this.init());
                }
            })(this);
        },
        onUnload() {
            vw[this.id].onUnload();
        },
        onBlockSelect(t) {
            vw[this.id].onBlockSelect(t);
        },
    });
    const bw = "[data-sticky-wrapper]",
        ww = "[data-sticky-aside]",
        Sw = "[data-sticky-inner]",
        Ew = "[data-sticky-content]",
        Lw = ".js-only [data-sticky-text]",
        kw = ".js-only [data-sticky-text-inner]",
        Aw = ".js-only [data-sticky-image]",
        Cw = "[data-sticky-images]",
        qw = ".image-wrapper",
        Tw = "[data-sticky-dot]",
        Pw = "text-highlight",
        xw = "data-sticky-with-gaps",
        Iw = "data-sticky-single-text",
        Hw = "data-index",
        Fw = 0.5,
        Mw = {
            horizontal: "horizontal",
            horizontalReversed: "horizontal-reversed",
            vertical: "vertical",
            verticalReversed: "vertical-reversed",
        },
        Dw = {
            maxVisibility: "maximum-visibility-of-each-image-in-viewport",
            middleOfViewport: "image-in-the-middle-of-viewport",
        },
        Ow = "is-active",
        Bw = {};
    I("sticky-images-and-text", [
        {
            onLoad() {
                Bw[this.id] = new (class {
                    init() {
                        this.getTypeOfIntersecting(),
                            this.observeImagesIntersecting(),
                            this.calculateHeights(),
                            (this.performAnimation = requestAnimationFrame(this.calculateImagesOffsetCallback)),
                            requestAnimationFrame(() => {
                                requestAnimationFrame(() => this.calculateHeights());
                            }),
                            document.addEventListener("theme:scroll", this.onScrollCallback),
                            document.addEventListener("theme:resize:width", this.onResizeCallback),
                            this.syncDots();
                    }
                    getTypeOfIntersecting() {
                        (this.typeOfIntersecting = Dw.maxVisibility),
                            (this.fractionOfViewport = this.image[0].offsetHeight / window.innerHeight),
                            this.verticalScroll &&
                                !de() &&
                                this.fractionOfViewport < 0.6 &&
                                (this.typeOfIntersecting = Dw.middleOfViewport);
                    }
                    observeImagesIntersecting() {
                        (this.observersCollection = new Set()),
                            (this.compareIntersectionRatio = []),
                            (this.maxVisibility = 0),
                            (this.observer = new IntersectionObserver(
                                (t, e) => {
                                    t.forEach((t) => {
                                        const e = t.target.offsetHeight,
                                            i = t.intersectionRatio,
                                            s = t.isIntersecting,
                                            o = { target: t.target, intersectionRatio: t.intersectionRatio },
                                            n = this.typeOfIntersecting === Dw.maxVisibility;
                                        let r = Fw;
                                        this.windowHeight <= e && (r = 0),
                                            n &&
                                                s &&
                                                (this.observersCollection.forEach((e) => {
                                                    e.target === t.target && this.observersCollection.delete(e);
                                                }),
                                                this.observersCollection.add(o),
                                                (this.compareIntersectionRatio = [...this.observersCollection].map(
                                                    (t) => t.intersectionRatio
                                                )),
                                                (this.maxVisibility = Math.max(...this.compareIntersectionRatio))),
                                            s &&
                                                i > r &&
                                                n &&
                                                this.maxVisibility === i &&
                                                ((this.maxVisibilityItem = [...this.observersCollection].find(
                                                    (t) => t.intersectionRatio === this.maxVisibility
                                                )),
                                                (this.activeIndex = Number(
                                                    this.maxVisibilityItem.target.dataset.index
                                                )),
                                                this.lastActiveIndex !== this.activeIndex &&
                                                    (this.sync(), (this.lastActiveIndex = this.activeIndex)));
                                    });
                                },
                                {
                                    root: null,
                                    rootMargin: "0px",
                                    threshold: [0, 0.15, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.85, 1],
                                }
                            )),
                            this.image.forEach((t) => this.observer.observe(t));
                    }
                    onScroll() {
                        this.performAnimation ||
                            (this.performAnimation = requestAnimationFrame(this.calculateImagesOffsetCallback)),
                            this.typeOfIntersecting === Dw.middleOfViewport &&
                                this.image.forEach((t) => this.checkImagePositionInViewport(t));
                    }
                    removeAnimationFrame() {
                        this.performAnimation &&
                            (cancelAnimationFrame(this.performAnimation), (this.performAnimation = null));
                    }
                    checkImagePositionInViewport(t) {
                        if (!t) return;
                        const e = window.innerHeight,
                            i = window.scrollY,
                            s = i + e / 2,
                            o = i + e,
                            n = Math.round(t.getBoundingClientRect().top + i),
                            r = n + t.offsetHeight;
                        n < o &&
                            !(r < i) &&
                            s > n &&
                            r > s &&
                            ((this.activeIndex = Number(t.dataset.index)),
                            this.lastActiveIndex !== this.activeIndex &&
                                (this.sync(), (this.lastActiveIndex = this.activeIndex)));
                    }
                    calculateImagesOffset() {
                        const t = this.aside.getBoundingClientRect().top - this.headerHeight,
                            e = t - this.innerStickyTop;
                        let i = 0,
                            s = 0;
                        const o = this.hasShortImages ? e : t;
                        (i = o < 0 ? (o / this.bottomEndingPoint) * -1 * 100 : o >= 0 ? 0 : 100),
                            (s = i > 100 ? 100 : i),
                            (s *= this.image.length - 1),
                            (de() || this.horizontalScroll) &&
                                this.aside.style.setProperty(
                                    "--translateX",
                                    `${Number(s * this.direction).toFixed(2)}%`
                                ),
                            this.lastOffset !== s
                                ? (this.performAnimation = requestAnimationFrame(this.calculateImagesOffsetCallback))
                                : this.performAnimation && this.removeAnimationFrame(),
                            (this.lastOffset = s);
                    }
                    calculateHeights() {
                        let { stickyHeaderHeight: t, windowHeight: e } = N();
                        if (
                            ((this.headerHeight = t || 0),
                            (this.windowHeight = e || window.innerHeight),
                            this.text.length > 0)
                        ) {
                            const t = this.content
                                    ? parseInt(window.getComputedStyle(this.content).getPropertyValue("padding-top"))
                                    : 0,
                                e = this.content
                                    ? parseInt(window.getComputedStyle(this.content).getPropertyValue("padding-bottom"))
                                    : 0,
                                i = [...this.text].map((i) => i.offsetHeight + t + e),
                                s = [...this.textInner].map((t) => t.offsetHeight),
                                o = Math.max(...i),
                                n = Math.max(...s),
                                r = de() ? n : o,
                                a = i.reduce((t, e) => t + e, 0),
                                l = Math.floor(a / i.length) || this.text[0].offsetHeight;
                            this.container.style.removeProperty("--average-text-height"),
                                this.container.style.setProperty("--average-text-height", `${l}px`),
                                this.container.style.removeProperty("--highest-text"),
                                this.container.style.setProperty("--highest-text", `${r}px`);
                        }
                        (this.imagesHeight = this.images.offsetHeight),
                            (this.hasShortImages = !1),
                            this.image.length > 0 &&
                                ((this.imgHeight = this.image[0].querySelector(qw).offsetHeight),
                                (this.imgPadding = parseInt(
                                    window.getComputedStyle(this.image[0]).getPropertyValue("padding-top")
                                )),
                                this.container.style.removeProperty("--images-height"),
                                this.container.style.setProperty("--images-height", `${this.imagesHeight}px`),
                                this.container.style.removeProperty("--img-height"),
                                this.container.style.setProperty(
                                    "--img-height",
                                    `${this.imgHeight + 2 * this.imgPadding}px`
                                )),
                            (this.asideHeight = this.aside.offsetHeight),
                            (this.asidePadding = parseInt(
                                window.getComputedStyle(this.aside).getPropertyValue("padding-top")
                            )),
                            (this.breathingSpace = (this.windowHeight - this.imagesHeight) / 2 / 2),
                            (this.innerStickyTop =
                                parseInt(window.getComputedStyle(this.inner).getPropertyValue("top")) -
                                this.headerHeight -
                                this.breathingSpace),
                            (this.gutters = this.withGaps ? 2 * this.asidePadding : 0),
                            (this.additionalSpace = de()
                                ? this.withGaps
                                    ? this.asidePadding + 10
                                    : 10
                                : this.gutters),
                            (this.minHeightForEndingPoing = this.imagesHeight + this.additionalSpace),
                            !de() &&
                                this.horizontalScroll &&
                                ((this.minHeightForEndingPoing = this.windowHeight - this.headerHeight),
                                (this.hasShortImages = this.fractionOfViewport <= 0.6),
                                this.hasShortImages &&
                                    (this.minHeightForEndingPoing =
                                        this.imagesHeight - this.innerStickyTop + 3 * this.breathingSpace)),
                            (this.bottomEndingPoint = this.asideHeight - this.minHeightForEndingPoing);
                    }
                    refreshImagesOffsetValues() {
                        requestAnimationFrame(() => {
                            requestAnimationFrame(() => {
                                document.dispatchEvent(new CustomEvent("theme:scroll"));
                            });
                        });
                    }
                    onResize() {
                        this.calculateHeights(),
                            requestAnimationFrame(() => this.calculateHeights()),
                            this.getTypeOfIntersecting(),
                            this.refreshImagesOffsetValues();
                    }
                    sync() {
                        const t = this.singleText ? [] : this.text;
                        [...this.image, ...t, ...this.dot].forEach((t) => {
                            const e = Number(t.getAttribute(Hw));
                            t.classList.toggle(Ow, e === Number(this.activeIndex));
                        }),
                            this.textHighlight.forEach((t) => t.shouldAnimate());
                    }
                    syncDots() {
                        this.dot.forEach((t) => {
                            t.addEventListener("click", (t) => {
                                t.preventDefault();
                                const e = Number(t.target.dataset.index),
                                    i = this.image[e],
                                    s = Math.round(i.getBoundingClientRect().top + window.scrollY),
                                    o = i.offsetHeight;
                                let n = this.wrapper.offsetTop + this.images.offsetHeight * e - this.headerHeight;
                                this.verticalScroll &&
                                    he() &&
                                    ((n = s - this.headerHeight),
                                    this.typeOfIntersecting === Dw.middleOfViewport &&
                                        (n = s - window.innerHeight / 2 + o / 2 - this.headerHeight)),
                                    window.scrollTo({ top: n, left: 0, behavior: "smooth" });
                            });
                        });
                    }
                    onUnload() {
                        this.image.forEach((t) => this.observer.unobserve(t)),
                            document.removeEventListener("theme:scroll", this.onScrollCallback),
                            document.removeEventListener("theme:resize:width", this.onResizeCallback);
                    }
                    onBlockSelect(t) {
                        const e = Number(t.target.dataset.index),
                            i = Math.round(t.target.getBoundingClientRect().top + window.scrollY),
                            s = t.target.offsetHeight,
                            o = this.wrapper.offsetTop + this.images.offsetHeight * e,
                            n = de() ? Math.round(10 / (this.image.length - 1)) * e : 0;
                        let r = o - this.headerHeight - n;
                        this.verticalScroll &&
                            he() &&
                            ((r = i - this.headerHeight),
                            this.typeOfIntersecting === Dw.middleOfViewport &&
                                (r = i - window.innerHeight / 2 + s / 2 - this.headerHeight)),
                            setTimeout(() => {
                                window.scrollTo({ top: r, left: 0, behavior: "smooth" });
                            }, 500);
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.scrollDirection = this.container.dataset.scrollDirection),
                            (this.horizontalScroll =
                                this.scrollDirection === Mw.horizontal ||
                                this.scrollDirection === Mw.horizontalReversed),
                            (this.verticalScroll =
                                this.scrollDirection === Mw.vertical || this.scrollDirection === Mw.verticalReversed),
                            (this.reverseDirection =
                                this.scrollDirection === Mw.horizontalReversed ||
                                this.scrollDirection === Mw.verticalReversed),
                            (this.direction = this.reverseDirection ? 1 : -1),
                            (this.withGaps = this.container.hasAttribute(xw)),
                            (this.singleText = this.container.hasAttribute(Iw)),
                            (this.image = this.container.querySelectorAll(Aw)),
                            (this.text = this.container.querySelectorAll(Lw)),
                            (this.textInner = this.container.querySelectorAll(kw)),
                            (this.images = this.container.querySelector(Cw)),
                            (this.dot = this.container.querySelectorAll(Tw)),
                            (this.aside = this.container.querySelector(ww)),
                            (this.inner = this.container.querySelector(Sw)),
                            (this.content = this.container.querySelector(Ew)),
                            (this.wrapper = this.container.querySelector(bw)),
                            (this.textHighlight = this.container.querySelectorAll(Pw)),
                            (this.performAnimation = null),
                            (this.lastOffset = 0),
                            (this.activeIndex = 0),
                            (this.lastActiveIndex = this.activeIndex),
                            this.wrapper &&
                                ((this.onScrollCallback = () => this.onScroll()),
                                (this.onResizeCallback = () => this.onResize()),
                                (this.calculateImagesOffsetCallback = () => this.calculateImagesOffset()),
                                this.init());
                    }
                })(this);
            },
            onUnload() {
                Bw[this.id].onUnload();
            },
            onBlockSelect(t) {
                Bw[this.id].onBlockSelect(t);
            },
        },
        Fp,
    ]),
        I("subcollections", Ig),
        I("tab-collections", [fo, Ig, gr]);
    const zw = {},
        _w = "[data-slider]",
        $w = "[data-item]",
        Rw = ".flickity-button",
        Vw = "flickity-enabled",
        Nw = "has-arrows",
        Ww = "carousel--resize",
        Uw = "flickity-button-holder",
        jw = "data-section-id";
    I("testimonials", {
        onLoad() {
            zw[this.id] = new (class {
                init() {
                    this.checkSlideCount(), this.listen();
                }
                onResize() {
                    this.checkSlideCount(),
                        null !== this.flkty &&
                            (this.flkty.resize(),
                            this.flkty.size.width >= this.flkty.slideableWidth && this.destroySlider());
                }
                checkSlideCount() {
                    const t = Boolean(2 == this.slidesCount && window.innerWidth >= theme.sizes.small),
                        e = Boolean(1 == this.slidesCount);
                    if (!t && !e)
                        return this.flkty
                            ? void (
                                  this.flkty &&
                                  (this.flkty.isActive || this.initSlider(),
                                  this.flkty.slideableWidth > this.flkty.size.width
                                      ? this.initSlider()
                                      : this.destroySlider())
                              )
                            : (this.initSlider(), void this.onResize());
                    this.destroySlider();
                }
                initSlider() {
                    (this.flkty = new e(this.slider, {
                        cellSelector: $w,
                        prevNextButtons: !0,
                        pageDots: !0,
                        groupCells: !0,
                        cellAlign: this.alignment,
                        contain: !0,
                        adaptiveHeight: !1,
                        on: {
                            ready: () => {
                                requestAnimationFrame(() => {
                                    this.slider.querySelectorAll(Rw).forEach((t) => {
                                        ut(t, Uw);
                                    });
                                });
                            },
                        },
                    })),
                        de() ? this.container.classList.remove(Nw) : this.container.classList.add(Nw),
                        this.createResizeClass();
                }
                createResizeClass() {
                    if ("function" == typeof e.prototype._createResizeClass) return;
                    (e.prototype._createResizeClass = function () {
                        this.element.classList.add(Ww);
                    }),
                        e.createMethods.push("_createResizeClass");
                    const t = e.prototype.resize;
                    e.prototype.resize = function () {
                        this.element.classList.remove(Ww), t.call(this), this.element.classList.add(Ww);
                    };
                }
                destroySlider() {
                    var t;
                    this.slider.classList.contains(Vw) &&
                        (null !== this.flkty &&
                            (null === (t = this.slider.querySelectorAll(Rw)) ||
                                void 0 === t ||
                                t.forEach((t) => {
                                    const e = t.parentNode;
                                    e &&
                                        e.classList.contains(Uw) &&
                                        (e.parentNode.insertBefore(t, e), e.parentNode.removeChild(e));
                                }),
                            this.flkty.destroy()),
                        this.container.classList.remove(Nw));
                }
                listen() {
                    document.addEventListener("theme:resize:width", this.onResizeCallback);
                }
                onBlockSelect(t) {
                    if (null !== this.flkty && this.flkty.isActive) {
                        const e = parseInt([...t.target.parentNode.children].indexOf(t.target)),
                            i = parseInt(this.flkty.slides[0].cells.length),
                            s = Math.floor(e / i);
                        this.flkty.select(s);
                    }
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.onResizeCallback);
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.sectionId = this.container.getAttribute(jw)),
                        (this.slider = this.container.querySelector(_w)),
                        (this.alignment = this.slider.dataset.sliderAlignment),
                        this.slider &&
                            ((this.slidesCount = this.slider.querySelectorAll($w).length),
                            (this.flkty = null),
                            (this.onResizeCallback = () => this.onResize()),
                            this.init());
                }
            })(this);
        },
        onUnload(t) {
            zw[this.id].onUnload(t);
        },
        onBlockSelect(t) {
            zw[this.id].onBlockSelect(t);
        },
    });
    const Gw = "no-outline",
        Kw = "[data-skip-content]",
        Qw = 'a[href="#"]';
    document.documentElement.style.setProperty(
        "--scrollbar-width",
        `${(() => {
            const t = document.createElement("div");
            (t.style.visibility = "hidden"),
                (t.style.overflow = "scroll"),
                (t.style.msOverflowStyle = "scrollbar"),
                document.body.appendChild(t);
            const e = document.createElement("div");
            t.appendChild(e);
            const i = t.offsetWidth - e.offsetWidth;
            return t.parentNode.removeChild(t), i;
        })()}px`
    ),
        document.addEventListener("DOMContentLoaded", function () {
            H("*"),
                new (class {
                    init() {
                        (this.body = document.body),
                            (this.inPageLink = document.querySelector(Kw)),
                            (this.linkesWithOnlyHash = document.querySelectorAll(Qw)),
                            (this.isFocused = !1),
                            this.focusHash(),
                            this.bindInPageLinks(),
                            this.clickEvents(),
                            this.focusEvents(),
                            this.focusEventsOff();
                    }
                    clickEvents() {
                        this.inPageLink &&
                            this.inPageLink.addEventListener("click", (t) => {
                                t.preventDefault();
                            }),
                            this.linkesWithOnlyHash &&
                                this.linkesWithOnlyHash.forEach((t) => {
                                    t.addEventListener("click", (t) => {
                                        t.preventDefault();
                                    });
                                });
                    }
                    focusEvents() {
                        document.addEventListener("keyup", (t) => {
                            t.code === theme.keyboardKeys.TAB &&
                                (this.body.classList.remove(Gw), (this.isFocused = !0));
                        });
                    }
                    focusEventsOff() {
                        document.addEventListener("mousedown", () => {
                            this.body.classList.add(Gw), (this.isFocused = !1);
                        });
                    }
                    forceFocus(t, e) {
                        e = e || {};
                        var i = t.tabIndex;
                        (t.tabIndex = -1),
                            (t.dataset.tabIndex = i),
                            t.focus(),
                            void 0 !== e.className && t.classList.add(e.className),
                            t.addEventListener("blur", function s(o) {
                                o.target.removeEventListener(o.type, s),
                                    (t.tabIndex = i),
                                    delete t.dataset.tabIndex,
                                    void 0 !== e.className && t.classList.remove(e.className);
                            });
                    }
                    focusHash(t) {
                        t = t || {};
                        let e = window.location.hash;
                        void 0 !== theme.settings.newHash &&
                            ((e = theme.settings.newHash), (window.location.hash = `#${e}`));
                        const i = document.getElementById(e.slice(1));
                        if (i && t.ignore && i.matches(t.ignore)) return !1;
                        e && i && this.forceFocus(i, t);
                    }
                    bindInPageLinks(t) {
                        return (
                            (t = t || {}),
                            Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter((e) => {
                                if ("#" === e.hash || "" === e.hash) return !1;
                                if (t.ignore && e.matches(t.ignore)) return !1;
                                if (((i = e.hash.substr(1)), null === document.getElementById(i))) return !1;
                                var i,
                                    s = document.querySelector(e.hash);
                                return (
                                    !!s &&
                                    (e.addEventListener("click", () => {
                                        this.forceFocus(s, t);
                                    }),
                                    !0)
                                );
                            })
                        );
                    }
                    constructor() {
                        this.init();
                    }
                })(),
                customElements.get("product-grid-item-swatch") ||
                    "disabled" == window.theme.settings.colorSwatchesType ||
                    customElements.define("product-grid-item-swatch", Js);
            "scrollBehavior" in document.documentElement.style || Ze({ url: theme.assets.smoothscroll });
        });
})(themeVendor.ScrollLock, themeVendor.Flickity, themeVendor.themeCurrency, themeVendor.ajaxinate);
